(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 100);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(6);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMProperty = __webpack_require__(14);
var ReactDOMComponentFlags = __webpack_require__(64);

var invariant = __webpack_require__(0);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(16);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(62);
var PooledClass = __webpack_require__(12);
var ReactFeatureFlags = __webpack_require__(67);
var ReactReconciler = __webpack_require__(15);
var Transaction = __webpack_require__(27);

var invariant = __webpack_require__(0);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(12);

var emptyFunction = __webpack_require__(6);
var warning = __webpack_require__(1);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(36);
var setInnerHTML = __webpack_require__(29);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(44);
var setTextContent = __webpack_require__(80);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(170);
var ReactInstrumentation = __webpack_require__(7);

var warning = __webpack_require__(1);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactBaseClasses = __webpack_require__(86);
var ReactChildren = __webpack_require__(208);
var ReactDOMFactories = __webpack_require__(209);
var ReactElement = __webpack_require__(17);
var ReactPropTypes = __webpack_require__(210);
var ReactVersion = __webpack_require__(211);

var createReactClass = __webpack_require__(212);
var onlyChild = __webpack_require__(216);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactCurrentOwner = __webpack_require__(11);

var warning = __webpack_require__(1);
var canDefineProperty = __webpack_require__(90);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(88);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: true });
var SearchMode;
(function (SearchMode) {
    SearchMode[SearchMode["CEBUANO_TO_ENGLISH"] = 0] = "CEBUANO_TO_ENGLISH";
    SearchMode[SearchMode["ENGLISH_TO_CEBUANO"] = 1] = "ENGLISH_TO_CEBUANO";
})(SearchMode = exports.SearchMode || (exports.SearchMode = {}));
function makeUrl(_ref, limit, skip) {
    var query = _ref.query,
        searchMode = _ref.searchMode,
        roots = _ref.roots;

    var params = ["include_docs=true"];
    if (Number.isFinite(limit)) params.push("limit=" + limit);
    if (Number.isFinite(skip)) params.push("skip=" + skip);
    switch (searchMode) {
        case SearchMode.ENGLISH_TO_CEBUANO:
            return makeUrlFromEnglish(query, params);
        case SearchMode.CEBUANO_TO_ENGLISH:
        default:
            return makeUrlFromCebuano(query + roots.map(function (r) {
                return "%20OR%20" + r.root;
            }), params);
    }
}
exports.makeUrl = makeUrl;
var BASE_URL = "https://publicdomainreview.cloudant.com/cebuano_dictionary/_design/search/_search/";
function makeUrlFromCebuano(query, params) {
    var url = BASE_URL + "fromCebuano?";
    params.push("q=" + (query.trim().length === 0 || query === "*:*" ? "*:*" : query));
    return url + params.join("&");
}
exports.makeUrlFromCebuano = makeUrlFromCebuano;
function makeUrlFromEnglish(query, params) {
    var url = BASE_URL + "fromEnglish?";
    params.push("q=" + (query.trim().length === 0 || query === "*:*" ? "*:*" : query));
    return url + params.join("&");
}
exports.makeUrlFromEnglish = makeUrlFromEnglish;
function isSearchResult(json) {
    return typeof json.total_rows === "number" && typeof json.bookmark === "string" && _typeof(json.rows) === "object" && typeof json.rows.length === "number" && json.rows.push;
}
exports.isSearchResult = isSearchResult;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var EventPluginRegistry = __webpack_require__(37);
var EventPluginUtils = __webpack_require__(38);
var ReactErrorUtils = __webpack_require__(42);

var accumulateInto = __webpack_require__(73);
var forEachAccumulated = __webpack_require__(74);
var invariant = __webpack_require__(0);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(19);
var EventPluginUtils = __webpack_require__(38);

var accumulateInto = __webpack_require__(73);
var forEachAccumulated = __webpack_require__(74);
var warning = __webpack_require__(1);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

var getEventTarget = __webpack_require__(47);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var EventPluginRegistry = __webpack_require__(37);
var ReactEventEmitterMixin = __webpack_require__(162);
var ViewportMetrics = __webpack_require__(72);

var getVendorPrefixedEventName = __webpack_require__(194);
var isEventSupported = __webpack_require__(48);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(22);
var ViewportMetrics = __webpack_require__(72);

var getEventModifierState = __webpack_require__(46);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);
var DOMNamespaces = __webpack_require__(36);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(44);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(129);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(13);
var Danger = __webpack_require__(139);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstrumentation = __webpack_require__(7);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(44);
var setInnerHTML = __webpack_require__(29);
var setTextContent = __webpack_require__(80);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactErrorUtils = __webpack_require__(42);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactPropTypesSecret = __webpack_require__(168);
var propTypesFactory = __webpack_require__(58);

var React = __webpack_require__(16);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(11);
var ReactInstanceMap = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(7);
var ReactUpdates = __webpack_require__(9);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var emptyFunction = __webpack_require__(6);
var warning = __webpack_require__(1);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var fetch_search_results_1 = __webpack_require__(18);
exports.REQUEST_SUCCESS = "REQUEST_SUCCESS";
function isRequestStarted(x) {
    return x.type === "REQUEST_STARTED";
}
exports.isRequestStarted = isRequestStarted;
function isRequestSuccess(x) {
    return x.type === exports.REQUEST_SUCCESS;
}
exports.isRequestSuccess = isRequestSuccess;
function isRequestError(x) {
    return x.type === "REQUEST_ERROR";
}
exports.isRequestError = isRequestError;
function isResetSearch(x) {
    return x.type === "RESET_SEARCH";
}
exports.isResetSearch = isResetSearch;
function requestSuccess(result, request) {
    return {
        type: exports.REQUEST_SUCCESS,
        result: result,
        request: request
    };
}
exports.requestSuccess = requestSuccess;
function requestError(error, request) {
    return {
        type: "REQUEST_ERROR",
        error: error, request: request
    };
}
exports.requestError = requestError;
var fetchQuery = function fetchQuery(dispatch, searchParams, url) {
    var httpRequest = new XMLHttpRequest();
    if (!httpRequest) {
        alert("Please update your browser to something that supports XMLHttpRequest.");
    }
    dispatch(startFetchQuery(searchParams, httpRequest));
    httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
            if (httpRequest.status === 200) {
                var json = JSON.parse(httpRequest.responseText);
                if (fetch_search_results_1.isSearchResult(json)) {
                    dispatch(requestSuccess(json, httpRequest));
                } else {
                    dispatch(requestError(new Error("Could not understand response."), httpRequest));
                }
            } else {
                if (httpRequest.status === 0) {
                    console.log("Abort successful");
                } else {
                    console.error("Request status " + httpRequest.status);
                    dispatch(requestError(new Error("Could not make search request"), httpRequest));
                }
            }
        }
    };
    httpRequest.open("GET", url);
    try {
        httpRequest.send();
    } catch (e) {
        console.error(e);
        dispatch(requestError(e, httpRequest));
    }
    return httpRequest;
};
function startFetchQuery(searchParams, request) {
    return {
        type: "REQUEST_STARTED",
        request: request,
        searchParams: searchParams
    };
}
function resetSearch(searchParams) {
    return { type: "RESET_SEARCH", searchParams: searchParams };
}
function fetchResults(searchParams) {
    return function (dispatch) {
        dispatch(resetSearch(searchParams));
        var url = fetch_search_results_1.makeUrl(searchParams, 50, 0);
        return fetchQuery(dispatch, searchParams, url);
    };
}
exports.fetchResults = fetchResults;
function queryChanged(params) {
    return fetchResults(params);
}
exports.queryChanged = queryChanged;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(6);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(128);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(133);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(132)();
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(12);

var invariant = __webpack_require__(0);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(14);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstrumentation = __webpack_require__(7);

var quoteAttributeValueForBrowser = __webpack_require__(195);
var warning = __webpack_require__(1);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(40);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);

var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(155);

var containsNode = __webpack_require__(110);
var focusNode = __webpack_require__(54);
var getActiveElement = __webpack_require__(55);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(13);
var DOMProperty = __webpack_require__(14);
var React = __webpack_require__(16);
var ReactBrowserEventEmitter = __webpack_require__(25);
var ReactCurrentOwner = __webpack_require__(11);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMContainerInfo = __webpack_require__(149);
var ReactDOMFeatureFlags = __webpack_require__(151);
var ReactFeatureFlags = __webpack_require__(67);
var ReactInstanceMap = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(7);
var ReactMarkupChecksum = __webpack_require__(165);
var ReactReconciler = __webpack_require__(15);
var ReactUpdateQueue = __webpack_require__(43);
var ReactUpdates = __webpack_require__(9);

var emptyObject = __webpack_require__(24);
var instantiateReactComponent = __webpack_require__(78);
var invariant = __webpack_require__(0);
var setInnerHTML = __webpack_require__(29);
var shouldUpdateReactComponent = __webpack_require__(49);
var warning = __webpack_require__(1);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var React = __webpack_require__(16);

var invariant = __webpack_require__(0);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(71);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(4);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var ReactCompositeComponent = __webpack_require__(146);
var ReactEmptyComponent = __webpack_require__(66);
var ReactHostComponent = __webpack_require__(68);

var getNextDebugID = __webpack_require__(214);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);
var escapeTextContentForBrowser = __webpack_require__(28);
var setInnerHTML = __webpack_require__(29);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(11);
var REACT_ELEMENT_TYPE = __webpack_require__(161);

var getIteratorFn = __webpack_require__(192);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(39);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(84);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(85);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(51);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(23),
    _assign = __webpack_require__(3);

var ReactNoopUpdateQueue = __webpack_require__(89);

var canDefineProperty = __webpack_require__(90);
var emptyObject = __webpack_require__(24);
var invariant = __webpack_require__(0);
var lowPriorityWarning = __webpack_require__(215);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(23);

var ReactCurrentOwner = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(8);
var Search_1 = __webpack_require__(101);
var SearchResults_1 = __webpack_require__(103);
exports.App = function () {
    return React.createElement("div", { id: "app-root" }, React.createElement(Search_1.SearchContainer, null), React.createElement(SearchResults_1.SearchResults, null));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFwcC50c3giXSwibmFtZXMiOlsiT2JqZWN0IiwiZGVmaW5lUHJvcGVydHkiLCJleHBvcnRzIiwidmFsdWUiLCJSZWFjdCIsInJlcXVpcmUiLCJTZWFyY2hfMSIsIlNlYXJjaFJlc3VsdHNfMSIsIkFwcCIsImNyZWF0ZUVsZW1lbnQiLCJpZCIsIlNlYXJjaENvbnRhaW5lciIsIlNlYXJjaFJlc3VsdHMiXSwibWFwcGluZ3MiOiJBQUFBOztBQUNBQSxPQUFPQyxjQUFQLENBQXNCQyxPQUF0QixFQUErQixZQUEvQixFQUE2QyxFQUFFQyxPQUFPLElBQVQsRUFBN0M7QUFDQSxJQUFNQyxRQUFRQyxRQUFRLE9BQVIsQ0FBZDtBQUNBLElBQU1DLFdBQVdELFFBQVEsVUFBUixDQUFqQjtBQUNBLElBQU1FLGtCQUFrQkYsUUFBUSxpQkFBUixDQUF4QjtBQUNBSCxRQUFRTSxHQUFSLEdBQWM7QUFBQSxXQUFPSixNQUFNSyxhQUFOLENBQW9CLEtBQXBCLEVBQTJCLEVBQUVDLElBQUksVUFBTixFQUEzQixFQUNqQk4sTUFBTUssYUFBTixDQUFvQkgsU0FBU0ssZUFBN0IsRUFBOEMsSUFBOUMsQ0FEaUIsRUFFakJQLE1BQU1LLGFBQU4sQ0FBb0JGLGdCQUFnQkssYUFBcEMsRUFBbUQsSUFBbkQsQ0FGaUIsQ0FBUDtBQUFBLENBQWQiLCJmaWxlIjoiQXBwLnRzeCIsInNvdXJjZVJvb3QiOiIvaG9tZS9tYWFydGVuL1dlYnN0b3JtUHJvamVjdHMvY2VidWFuby1hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJcInVzZSBzdHJpY3RcIjtcclxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsIFwiX19lc01vZHVsZVwiLCB7IHZhbHVlOiB0cnVlIH0pO1xyXG5jb25zdCBSZWFjdCA9IHJlcXVpcmUoXCJyZWFjdFwiKTtcclxuY29uc3QgU2VhcmNoXzEgPSByZXF1aXJlKFwiLi9TZWFyY2hcIik7XHJcbmNvbnN0IFNlYXJjaFJlc3VsdHNfMSA9IHJlcXVpcmUoXCIuL1NlYXJjaFJlc3VsdHNcIik7XHJcbmV4cG9ydHMuQXBwID0gKCkgPT4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoXCJkaXZcIiwgeyBpZDogXCJhcHAtcm9vdFwiIH0sXHJcbiAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFNlYXJjaF8xLlNlYXJjaENvbnRhaW5lciwgbnVsbCksXHJcbiAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFNlYXJjaFJlc3VsdHNfMS5TZWFyY2hSZXN1bHRzLCBudWxsKSkpO1xyXG4iXX0=

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var search_1 = __webpack_require__(105);
var redux_1 = __webpack_require__(32);
exports.rootReducer = redux_1.combineReducers({
    search: search_1.searchReducer
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzIl0sIm5hbWVzIjpbIk9iamVjdCIsImRlZmluZVByb3BlcnR5IiwiZXhwb3J0cyIsInZhbHVlIiwic2VhcmNoXzEiLCJyZXF1aXJlIiwicmVkdXhfMSIsInJvb3RSZWR1Y2VyIiwiY29tYmluZVJlZHVjZXJzIiwic2VhcmNoIiwic2VhcmNoUmVkdWNlciJdLCJtYXBwaW5ncyI6IkFBQUE7O0FBQ0FBLE9BQU9DLGNBQVAsQ0FBc0JDLE9BQXRCLEVBQStCLFlBQS9CLEVBQTZDLEVBQUVDLE9BQU8sSUFBVCxFQUE3QztBQUNBLElBQU1DLFdBQVdDLFFBQVEsVUFBUixDQUFqQjtBQUNBLElBQU1DLFVBQVVELFFBQVEsT0FBUixDQUFoQjtBQUNBSCxRQUFRSyxXQUFSLEdBQXNCRCxRQUFRRSxlQUFSLENBQXdCO0FBQzFDQyxZQUFRTCxTQUFTTTtBQUR5QixDQUF4QixDQUF0QiIsImZpbGUiOiJpbmRleC50cyIsInNvdXJjZVJvb3QiOiIvaG9tZS9tYWFydGVuL1dlYnN0b3JtUHJvamVjdHMvY2VidWFuby1hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJcInVzZSBzdHJpY3RcIjtcclxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsIFwiX19lc01vZHVsZVwiLCB7IHZhbHVlOiB0cnVlIH0pO1xyXG5jb25zdCBzZWFyY2hfMSA9IHJlcXVpcmUoXCIuL3NlYXJjaFwiKTtcclxuY29uc3QgcmVkdXhfMSA9IHJlcXVpcmUoXCJyZWR1eFwiKTtcclxuZXhwb3J0cy5yb290UmVkdWNlciA9IHJlZHV4XzEuY29tYmluZVJlZHVjZXJzKHtcclxuICAgIHNlYXJjaDogc2VhcmNoXzEuc2VhcmNoUmVkdWNlclxyXG59KTtcclxuIl19

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(147);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(8);
var react_dom_1 = __webpack_require__(97);
var react_redux_1 = __webpack_require__(31);
var redux_1 = __webpack_require__(32);
var reducers_1 = __webpack_require__(96);
var App_1 = __webpack_require__(95);
var redux_thunk_1 = __webpack_require__(99);
var redux_logger_1 = __webpack_require__(98);
var loggerMiddleware = redux_logger_1.createLogger();
var store = redux_1.createStore(reducers_1.rootReducer, redux_1.applyMiddleware(redux_thunk_1.default, loggerMiddleware));
var mountPoint = document.getElementById("mount-point");
if (mountPoint) react_dom_1.render(React.createElement(react_redux_1.Provider, { store: store }, React.createElement(App_1.App, null)), mountPoint);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(8);
var react_redux_1 = __webpack_require__(31);
var fetch_search_results_1 = __webpack_require__(18);
var search_1 = __webpack_require__(52);
var react_1 = __webpack_require__(8);
var lodash_1 = __webpack_require__(130);
var SearchMode_1 = __webpack_require__(102);
var StemmingDerivations_1 = __webpack_require__(104);
var cebuano_stemmer_1 = __webpack_require__(106);
var mapDispatchToProps = function mapDispatchToProps(dispatch, ignored) {
    return {
        onChange: function onChange(params) {
            dispatch(search_1.queryChanged(params));
        }
    };
};
var mapStateToProps = function mapStateToProps(state, ignored) {
    return Object.assign({}, state.search, {
        results: state.search.searchResults
    });
};
function abortActiveRequest(activeRequest) {
    if (activeRequest) {
        console.log("ABORTING " + activeRequest.responseURL);
        activeRequest.abort();
    }
}
exports.abortActiveRequest = abortActiveRequest;

var SearchPresenter = function (_react_1$PureComponen) {
    _inherits(SearchPresenter, _react_1$PureComponen);

    function SearchPresenter() {
        _classCallCheck(this, SearchPresenter);

        var _this = _possibleConstructorReturn(this, (SearchPresenter.__proto__ || Object.getPrototypeOf(SearchPresenter)).apply(this, arguments));

        _this.propagateInputChange = lodash_1.debounce(function (value) {
            var derivations = _this.props.searchMode === fetch_search_results_1.SearchMode.CEBUANO_TO_ENGLISH ? cebuano_stemmer_1.normalizeAndStem(value.trim()) : [];
            _this.onQueryChange(value, _this.props.searchMode, derivations);
        }, 500, { leading: true, trailing: true });
        return _this;
    }

    _createClass(SearchPresenter, [{
        key: "onQueryChange",
        value: function onQueryChange(query, searchMode, roots) {
            abortActiveRequest(this.props.activeRequest);
            this.props.onChange({
                query: query,
                searchMode: searchMode,
                roots: roots
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return React.createElement("div", { className: "search-panel" }, React.createElement("div", { className: "search-input-wrapper mdc-form-field mdc-form-field--align-end" }, React.createElement("div", { className: "mdc-textfield" }, React.createElement("input", { type: "text", placeholder: this.props.searchMode === fetch_search_results_1.SearchMode.CEBUANO_TO_ENGLISH ? "Type Cebuano" : "Type English", className: "mdc-textfield__input search-input", onChange: function onChange(t) {
                    return _this2.propagateInputChange(t.target.value);
                } }))), React.createElement(StemmingDerivations_1.StemmingDerivationsPresenter, { searchMode: this.props.searchMode, query: this.props.searchQuery, roots: this.props.searchRoots }), React.createElement(SearchMode_1.SearchModePresenter, { searchMode: this.props.searchMode, onQueryChange: function onQueryChange(b) {
                    return _this2.onQueryChange(_this2.props.searchQuery, b, _this2.props.searchRoots);
                } }));
        }
    }]);

    return SearchPresenter;
}(react_1.PureComponent);

exports.SearchPresenter = SearchPresenter;
exports.SearchContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SearchPresenter);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(8);
var fetch_search_results_1 = __webpack_require__(18);
var cebuanoToEnglish = "Cebuano to English";
var englishToCebuano = "English to Cebuano";
exports.SearchModePresenter = function (_ref) {
    var searchMode = _ref.searchMode,
        onQueryChange = _ref.onQueryChange;

    return React.createElement("div", { className: "search-mode" }, React.createElement("div", { className: "mdc-form-field" }, React.createElement("div", { className: "mdc-radio", "data-demo-no-js": "" }, React.createElement("input", { className: "mdc-radio__native-control", type: "radio", id: "cebuanoToEnglish", checked: searchMode === fetch_search_results_1.SearchMode.CEBUANO_TO_ENGLISH, onChange: function onChange(t) {
            return onQueryChange(fetch_search_results_1.SearchMode.CEBUANO_TO_ENGLISH);
        }, name: "cebuanoToEnglish" }), React.createElement("div", { className: "mdc-radio__background" }, React.createElement("div", { className: "mdc-radio__outer-circle" }), React.createElement("div", { className: "mdc-radio__inner-circle" }))), React.createElement("label", { id: "ex1-radio1-label", htmlFor: "cebuanoToEnglish" }, cebuanoToEnglish)), React.createElement("div", { className: "mdc-form-field" }, React.createElement("div", { className: "mdc-radio", "data-demo-no-js": "" }, React.createElement("input", { className: "mdc-radio__native-control", type: "radio", checked: searchMode === fetch_search_results_1.SearchMode.ENGLISH_TO_CEBUANO, onChange: function onChange(t) {
            return onQueryChange(fetch_search_results_1.SearchMode.ENGLISH_TO_CEBUANO);
        }, id: "englishToCebuano", name: "englishToCebuano" }), React.createElement("div", { className: "mdc-radio__background" }, React.createElement("div", { className: "mdc-radio__outer-circle" }), React.createElement("div", { className: "mdc-radio__inner-circle" }))), React.createElement("label", { id: "ex1-radio2-label", htmlFor: "englishToCebuano" }, englishToCebuano)));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(8);
var react_redux_1 = __webpack_require__(31);
function determineTagName(tagName) {
    switch (tagName) {
        case "sup":
        case "super":
            return "sup";
        case "sub":
            return "sub";
        case "sense":
            return "span";
        default:
            return "span";
    }
}
function convertToHtml(xml, i) {
    if (typeof xml === "string") {
        return xml;
    }
    if (xml[0] === 1) {
        var tagName = xml[1];
        var classes = [tagName];
        if (xml[3]) {
            for (var a = 0; a < xml[3].length; a++) {
                var attr = xml[3][a];
                classes.push(attr[0].toString() + "-" + attr[1].toString());
            }
        }
        var children = xml[2] && xml[2].length > 0 ? xml[2].map(function (a, i) {
            return convertToHtml(a, i);
        }) : [];
        return React.createElement.apply(React, [determineTagName(tagName), {
            key: i.toString(),
            className: classes.join("")
        }].concat(_toConsumableArray(children)));
    } else {
        console.error("COULD NOT HANDLE " + JSON.stringify(xml));
        return "COULD NOT HANDLE " + JSON.stringify(xml);
    }
}
function toHtmlEntry(doc) {
    var xml = doc.entry;
    if (xml) {
        return xml.map(function (xml, i) {
            return convertToHtml(xml, i);
        });
    } else {
        console.error("COULD NOT HANDLE " + JSON.stringify(xml));
        return doc._id;
    }
}
exports.SearchResult = function (_ref) {
    var row = _ref.row;

    return React.createElement("li", { key: row.id + Math.random() }, row.doc ? toHtmlEntry(row.doc) : row.id);
};
var mapDispatchToProps = function mapDispatchToProps(ignored1, ignored2) {
    return {};
};
var mapStateToProps = function mapStateToProps(state, ignored) {
    return {
        searchResults: state.search.searchResults,
        error: state.search.error,
        activeRequest: state.search.activeRequest
    };
};
exports.SearchResultsPresenter = function (_ref2) {
    var searchResults = _ref2.searchResults,
        error = _ref2.error,
        activeRequest = _ref2.activeRequest;

    return error ? React.createElement("div", { className: "error" }, "ERROR: ", error.message) : searchResults ? React.createElement("div", { className: "search-results" }, React.createElement("div", { className: "search-results-count" }, searchResults.total_rows, " results"), React.createElement("ul", null, searchResults.rows.map(function (result) {
        return React.createElement(exports.SearchResult, { key: result.id, row: result });
    }))) : activeRequest ? React.createElement("div", { className: "no-query" }, "Loading\u2026") : React.createElement("div", { className: "no-query" });
};
exports.SearchResults = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.SearchResultsPresenter);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(8);
var react_1 = __webpack_require__(8);
var fetch_search_results_1 = __webpack_require__(18);
exports.AffixPresenter = function (_ref) {
    var affix = _ref.affix;

    var children = [];
    children.push(React.createElement("span", { key: "form", className: "affix-form" }, affix.form));
    if (affix.rootType) {
        children.push(" ");
        children.push(React.createElement("span", { key: "roottype", className: "affix-roottype" }, affix.rootType));
    }
    if (affix.label) {
        var label = affix.label.trim();
        if (label !== "" && label !== "TODO") {
            children.push(" ");
            children.push(React.createElement("span", { key: "label", className: "affix-label" }, label));
        }
    }
    return React.createElement("dd", { className: "stem-affix" }, React.createElement("span", null, children));
};
exports.Stem = function (_ref2) {
    var derivation = _ref2.derivation;

    var affixes = derivation.affixes ? derivation.affixes.map(function (a, i) {
        return React.createElement(exports.AffixPresenter, { key: a.label + i, affix: a });
    }).reverse() : [];
    return React.createElement("li", { key: derivation.root, className: "stem" }, React.createElement("dl", { className: "stem-dl" }, React.createElement("dt", { className: "stem-root" }, React.createElement("div", { className: "mdc-form-field" }, React.createElement("div", { className: "mdc-checkbox" }, React.createElement("input", { onChange: function onChange(t) {
            console.log(derivation.root, t.target.checked);
        }, disabled: true, checked: true, type: "checkbox", id: derivation.root, className: "mdc-checkbox__native-control" }), React.createElement("div", { className: "mdc-checkbox__background" }, React.createElement("svg", { className: "mdc-checkbox__checkmark", viewBox: "0 0 24 24" }, React.createElement("path", { className: "mdc-checkbox__checkmark__path", fill: "none", stroke: "white", d: "M1.73,12.91 8.1,19.28 22.79,4.59" })), React.createElement("div", { className: "mdc-checkbox__mixedmark" }))), React.createElement("label", { htmlFor: derivation.root, id: derivation.root + "-label" }, derivation.root))), affixes));
};
exports.CebuanoStemmingDerivations = function (_ref3) {
    var derivations = _ref3.derivations;

    return React.createElement("ul", { className: "cebuano-stems" }, derivations.map(function (d, i) {
        return React.createElement(exports.Stem, { key: i, derivation: d });
    }));
};

var StemmingDerivationsPresenter = function (_react_1$PureComponen) {
    _inherits(StemmingDerivationsPresenter, _react_1$PureComponen);

    function StemmingDerivationsPresenter() {
        _classCallCheck(this, StemmingDerivationsPresenter);

        return _possibleConstructorReturn(this, (StemmingDerivationsPresenter.__proto__ || Object.getPrototypeOf(StemmingDerivationsPresenter)).apply(this, arguments));
    }

    _createClass(StemmingDerivationsPresenter, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                searchMode = _props.searchMode,
                roots = _props.roots;

            return searchMode === fetch_search_results_1.SearchMode.CEBUANO_TO_ENGLISH ? React.createElement(exports.CebuanoStemmingDerivations, { derivations: roots }) : React.createElement("div", { className: "english-query" });
        }
    }]);

    return StemmingDerivationsPresenter;
}(react_1.PureComponent);

exports.StemmingDerivationsPresenter = StemmingDerivationsPresenter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var search_1 = __webpack_require__(52);
var fetch_search_results_1 = __webpack_require__(18);
var defaultState = {
    activeRequest: undefined,
    error: undefined,
    searchMode: fetch_search_results_1.SearchMode.CEBUANO_TO_ENGLISH,
    searchQuery: "",
    searchResults: undefined,
    searchRoots: []
};
function isForDifferentRequest(request, activeRequest) {
    return !activeRequest || request.responseURL !== activeRequest.responseURL;
}
exports.searchReducer = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    if (search_1.isRequestStarted(action)) {
        return {
            searchRoots: action.searchParams.roots,
            searchMode: action.searchParams.searchMode,
            searchQuery: action.searchParams.query,
            activeRequest: action.request,
            error: undefined
        };
    } else if (search_1.isRequestSuccess(action)) {
        if (isForDifferentRequest(action.request, state.activeRequest)) {
            console.error("Expected a response for " + (state.activeRequest ? state.activeRequest.responseURL : "|nil|") + ", not " + action.request.responseURL);
            console.error(action.request);
            return state;
        } else return {
            searchQuery: state.searchQuery,
            searchRoots: state.searchRoots,
            searchMode: state.searchMode,
            activeRequest: undefined,
            searchResults: action.result,
            error: undefined
        };
    } else if (search_1.isResetSearch(action)) {
        return {
            searchMode: action.searchParams.searchMode,
            searchQuery: action.searchParams.query,
            roots: action.searchParams.roots,
            searchRoots: state.searchRoots,
            activeRequest: undefined,
            error: undefined,
            searchResults: undefined
        };
    } else if (search_1.isRequestError(action)) {
        if (isForDifferentRequest(action.request, state.activeRequest)) {
            console.error("Expected a response for " + (state.activeRequest ? state.activeRequest.responseURL : "|nil|") + ", not " + action.request.responseURL);
            return state;
        }
        return Object.assign({}, state, {
            activeRequest: undefined,
            results: [],
            error: action.error
        });
    } else return state;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

!function(a,u){ true?module.exports=u():"function"==typeof define&&define.amd?define("cebuano-stemmer",[],u):"object"==typeof exports?exports["cebuano-stemmer"]=u():a["cebuano-stemmer"]=u()}(this,function(){return function(a){function u(n){if(i[n])return i[n].exports;var t=i[n]={i:n,l:!1,exports:{}};return a[n].call(t.exports,t,t.exports,u),t.l=!0,t.exports}var i={};return u.m=a,u.c=i,u.d=function(a,i,n){u.o(a,i)||Object.defineProperty(a,i,{configurable:!1,enumerable:!0,get:n})},u.n=function(a){var i=a&&a.__esModule?function(){return a.default}:function(){return a};return u.d(i,"a",i),i},u.o=function(a,u){return Object.prototype.hasOwnProperty.call(a,u)},u.p="",u(u.s=9)}([function(a,u,i){"use strict";function n(a,u){(0,p.compilePatterns)(a.patterns,u)}function t(a,u){return g(a,u.patterns)}function g(a,u){var i=!0,n=!1,t=void 0;try{for(var g,s=u[Symbol.iterator]();!(i=(g=s.next()).done);i=!0){var l=g.value;if((0,p.patternApplies)(l,a))return!0}}catch(a){n=!0,t=a}finally{try{!i&&s.return&&s.return()}finally{if(n)throw t}}return!1}function s(a,u){var i=!0,n=!1,t=void 0;try{for(var g,s=u[Symbol.iterator]();!(i=(g=s.next()).done);i=!0){var l=g.value;if((0,p.patternApplies)(l,a))return(0,p.stripPattern)(l,a)}}catch(a){n=!0,t=a}finally{try{!i&&s.return&&s.return()}finally{if(n)throw t}}}function l(a,u){var i=[],n=!0,t=!1,g=void 0;try{for(var s,l=u[Symbol.iterator]();!(n=(s=l.next()).done);n=!0){var k=s.value;if((0,p.patternApplies)(k,a)){var r=(0,p.stripPattern)(k,a);r&&i.push(r)}}}catch(a){t=!0,g=a}finally{try{!n&&l.return&&l.return()}finally{if(t)throw g}}return i}function k(a){var u=["<affix form='"+a.form+"' label='"+a.label+"'"];a.rootType&&""!==a.rootType&&u.push(" rootType='"+a.rootType+"'"),u.push(">\n");var i=!0,n=!1,t=void 0;try{for(var g,s=a.patterns[Symbol.iterator]();!(i=(g=s.next()).done);i=!0){var l=g.value;u.push((0,p.toXmlAffixPattern)(l))}}catch(a){n=!0,t=a}finally{try{!i&&s.return&&s.return()}finally{if(n)throw t}}return u.push("</affix>\n"),u.join("")}Object.defineProperty(u,"__esModule",{value:!0}),u.compileAffix=n,u.appliesToAffix=t,u.appliesToAny=g,u.stripPatterns=s,u.rootCandidates=l,u.toXmlAffix=k;var p=i(5)},function(a,u,i){"use strict";Object.defineProperty(u,"__esModule",{value:!0}),u.DictionaryDatabase=void 0;var n=i(2),t={};u.DictionaryDatabase={isRootWord:function(a){return!(a.length<3)&&n.roots.has(a)},isRootWordWithType:function(a,u){if(a.length<3)return!1;var i=t[a+"."+u];if(void 0!==i)return i;var g=!0,s=!1,l=void 0;try{for(var k,p=n.roots[Symbol.iterator]();!(g=(k=p.next()).done);g=!0){var r=k.value;if(0===r.indexOf(a)&&r.indexOf(u)>a.length-1)return!0}}catch(a){s=!0,l=a}finally{try{!g&&p.return&&p.return()}finally{if(s)throw l}}return!1}}},function(a,u,i){"use strict";Object.defineProperty(u,"__esModule",{value:!0});u.roots=new Set(["-a","-a(←)","-an","-an-","-an(→)","-anan","-anan(→)","-anay","-anun","-ay","-g-","-i","-i(→)","-in-","-in-an","-in-an(→)","-in-anan","-in-ay","-ira","-iru","-l-an","-l-un","-nun","-um-r-","-un","-un(→)","-unun","-y or nga","— ang baraha","— nga bata","— pawdir","— sa balutbut","(sa) imung kigul","(walay) hitsura","[adj.] —","[adj.] pay [subject]","[adj.] ra","[adj.] uyamut","[dat.]","[exclamation] usab","[expression of time] lamang","[future verb abstract form] pa","[gen.] sir","[maingun","[measurement] kwadrada","[name] nga sanglay","[nom.]","[noun] nga [noun]","[noun] pay","[noun] pay aku","[noun] pay imu","[noun] sintral","[noun]-a ba uruy","[numeral] ka tudlu","[plant name] nga tuud","[predicate] pay imu","[preposed gen. pronoun] ra","[pronoun","[pronoun]","[proper name] irmanus","[so-and-so] sa imung (iyang) tunga","[verb base","[verb]","[verb] ki [verb]","[verb] lang ug putung","[verb] ug amu","a","a.d.","ab-ab","aba","aba tuy","abaa","abab","abab disaya","abad","abag","abaga","abagahun","abahu","abahu dispusisiyun","abahu kunsidirar","abahu kunsidirasiyun","abaka","abakada","abakahan","abakal","abakanhan","abal","abalu","abalwasiyun","abandunadu","abandunar","abandunu","abang","abangan","abanid","abaniku","abansada","abansadu","abansadu sa buling","abansawu","abansi","abansin","abanti","abanu","abat","abat-abat","abatan","abay","abay ug sawa","abayan","abgaw","abgawun","abhak","abhul","abhung","abhungun","abi","abi [gen.]","abi kay","abi na lang","abi nimu","abi nimu ug","abiabi","abiba","abibar","abihid","abilay","abilidad","abilidaran","abilyana","abin","abintura","abinturar","abinturira","abinturiru","abinturista","abir","abirids","abiriya","abirtu","abis","abisu","abitsuylas","abitu","abiyu","abiyun","abkay","abla","abladu","ablasa","abli","abr.","abrap","abrasa","abrasadur","abrasiti","abrasyiti","abri","abri birat","abri tilun","abridur","abrigana","abrigawu","abrigu","abril","abrilata","abrisiti","abrisyiti","absin","absin mayindid","absiniru","absinus","absulusiyun","absuwiltu","abtanan","abtik","abtung","abu","abuabu","abubhu","abubhuan","abud","abug","abugada","abugadu","abugadu dikampana","abugadu dikampanilya","abugadu dikumbinyu","abugaduhun","abugagu","abugan","abugar","abugasiya","abughu","abugun","abuhun","abukadu","abukay","abunansiya","abunda","abundansiya","abung","abungaw","abunu","aburidu","aburidu ang ulu","abusada","abusadu","abusar","abusu","abusu dikumpiyansa","abut","abut ang ginhawa","abut sa hunahuna","abut-abut","abwag","abyadur","abyadur sa lubi","abyan","abyanan","abyasiyun","abyasyun","abyirtu","abyug","ad","ad-ad","ad-aran","ad-un","ada","ada uruy","ada uy","adan","adbans","adbans gard","adbaysir","adbintista","adbinturar","adbirbiyu","adbiyintu","adgaw","adia","adik","adilantadu","adilantar","adilantu","adilpa","adimas","adingmasin","adinuwid","adisir","adiyus","adiyus na lamang","adj.]","adj.] ... mau pay [verb","adj.] unya","adjective]","adlaw","adlaw gabii","adlaw nga daku","adlaw sa minatay","adlaw sa panudiya","adlaw-adlaw","adlawan","adlib","adlip","adlu","administradur","administrasiyun","administratibu","admiradur","admirar","admisiyun","admitar","admitidu","admitir","adngan","adpan","adpanan","adris","adtu","adtuan","adtut","adtuunun","adubadu","adubawu","adubi","adubu","adul","adult","adult idyukisyun","adultiryu","aduna","adunahan","adunay [subject]","aduptar","adurnu","adwana","adya","adyaan","adyaks","adyas","adyinda","adyinumutu","ag","ag lang","ag sa","ag-ag","agaab","agaak","agad","agad nga","agad ug","agad-ad","agad-agad","agagang","agahad","agak","agak-ak","agakay","agalun","agan-an","agan-anun","agang","agang-agang","agang-agangun","agap","agapang","agara","agaray","agas","agas ug palad","agaw","agawan","agawun","agay","agay-ay","agbat","agbati","agbaw","agbay","agbun","agda","agdahunun","agdul","agh","aghad","aghat","aghud","aghup","aghuy","aghuyan","agi","agi sa","agi ug","agianan","agid","agigising","agiik","agik-ik","agil","agila","agimud","aginaldu","agingay","aginsud","aginud","agipu","agiri","agis-is","agit-it","agit-itun","agitung","agiw","agiwanan","agkut","aglidulsi","aglipay","aglipayanu","agmang","agmud","agngan","agni","agnus","agpan","agpang","agpas","agrabiyar","agrabyadu","agrabyu","agri","agribyadu","agridulsi","agrigawu","agrikultura","agrikulturista","agriminsur","agrisib","agrisiba","agrisibu","agsa","agsing","agta","agtang","agtangun","agti","agu","agu.","agub-ub","agubhub","agud","aguha","aguhilya","aguhu","aguk-uk","agukuy","agul","agulang","agulu","agum","agum-um","agumaa","agumud","agung","agung-ung","agungal","agunguy","aguniyas","aguntu","agup-up","agup-upun","aguruy","agus","agus-us","agusahis","agustu","agut","agut-ut","agutay","aguting","agutiut","agutnga","agutun","aguut","aguy","aguyangyang","agwa","agwa bindita","agwa diawukulur","agwa pinikada","agwa uksinada","agwada","agwadahan","agwadu","agwadur","agwahan","agwanta","agwanta muy","agwanta nga","agwantadu","agwantadur","agwardiyinti","agwas","agwas putablis","agwasil","agwasun","ah","aha","ahaan","ahag","ahagan","ahak","ahan","ahas","ahat","ahaw","ahay","ahidris","ahidrisan","ahinghu","ahinsiya","ahinti","ahinti sa babuy","ahitu","ahu","ahug","ahus","ahus nga puti","ahus-ahus","ahusan","ak","ak-ak","akaak","akab","akadimik","akadimiya","akal","akasya","akasyahan","akata","akatar","akawntant","akawunting","akba","akbay","akbu","akbuanan","akhab","akin","akip","akip-akipun","aklas","akmu","akni","aknit","aksi","aksidinti","aksidu","aksintu","aksiyun","aksiyunista","aksul","akta","aktibidadis","aktibista","aktibu","akting","aktitud","aktris","aktu","aktu sa kuntrisiyun","aktur","aktur kantur","aktuwal","aku","aku (iya","aku na","akua","akuakuhan","akub","akud","akudi","akulitu","akumpaniing","akumpaniyamintu","akumpaniyar","akumplisi","akung","akup-akup","akurdiyun","akusadu","akusar","akusasiyun","akwaryum","akwintans","akwintans parti","akyut","al-al","ala","ala una","alabadu","alabanit","alabdan","alabihid","alabtan","alabtun","alabugan","alabuhan","alabutan","alabutun","alad","aladtuun","alag-ag","alag-agan","alagad","alagad sa balaud","alagakun","alagasi","alagaw","alagay","alagbati","alagbay","alagdahun","alagdun","alagian","alagiwan","alagubay","alagukuy","alahas","alahibi","alahiru","alak","alakaak","alakri","alaksiw","alaktrisun","alakturun","alalag-agun","alalay","alam","alam-alam","alamag","alambihid","alambihud","alambri","alambri nga tunukun","alambri sa suga","alambrilyu","alambring pinutus","alambring tunukun","alambriru","alampad","alampat","alampuanan","alamuan","alamutan","alan","alanayun","alang","alang-alang","alangaang","alangiing","alangilan","alangisig","alangitngit","alangkan","alangsuhan","alantusun","alap-alap","alap-ap","alap-apun","alapahap","alapsunun","alapugan","alariun","alarma","alaru","alas","alas [number]","alas [number] impuntu","alas dus","alas dusi","alas kwatru","alas tris","alas utsu","alasan","alasiman","alasinan","alasiwsiw","alaslun","alastar","alasuhan","alasuus","alasuyun","alat","alatan","alatay","alaut","alaw","alaw-alaw","alawans","alawihaw","alawiswis","alayuhan","alayuhun","alayun","alayunan","alayupiyup","alba","albahaka","albangku","albati","albinu","albularyu","album","albumina","albuminahun","algudun","alguwasil","alhibi","alhu","ali","alibagbag","alibangbang","alibangbangun","alibangu","alibanta","alibay","alibhat","alibi","alibusbus","alibwag","alibyu","alid-an","alid-i","alig-alig","alig-ig","alig-igun","alig-igunun","aligasiyun","aligatu","aligaya","aligi","aligri","aligrihun","aliguriya","aligutgut","alihid","aliid","alikabu","alikasi","alikati","alikati sa murus","alikumu","alikun","alikway","alili","aliling","alilis","aliluya","aliluyuk","alim","alima","alimadmad","aliman","alimangu","alimanguhun","alimanya","alimasa","alimasag","alimatmat","alimatuk","alimatukan","alimbrilyu","alimbukad","alimgas","alimgasan","alimgat","alimpatakan","alimpulu","alimpuluhan","alimpulus","alimpuyang","alimpuyas","alimpuying","alimugmug","alimukaw","alimukun","alimungaw","alimungawung","alimusan","alimuut","alimuut ug nawung","alimyun","alindahaw","alindanaw","alindanga","alindangay","alindasay","alinga","alingabngab","alingagngag","alingagngagan","alingasa","alingasu","alingasuhun","alingawngaw","alingganay","alinggat","alingiing","alingisi","alingisig","alingisngis","alingit","alingiting","alingkawas","alingugngug","alinsuub","alintabu","alinupung","alip-ip","alipadnu","alipadsay","alipanti","alipasa","alipata","alipatpat","alipulu","alipulung","alipunga","aliputu","aliraw","alirdyik","alirung","alis","alisbu","alisbung","alisdan","alisdi","alisiwsiw","alisngaw","alistu","alisuksuk","alitundan","aliwalang","aliwarus","aliwas","aliwasa","aliwasun","aliyunyun","aliyupyup","alkabala","alkaldi","alkampur","alkampuradu","alkansi","alkansi sa lutaw","alkansiya","alkaydi","alkila","alkitran","alkuba","alkuhiris","alkuhul","alkuhulira","alkumbra","alkuntra","almagri","almahadun","almamatir","almanaki","almasiga","almasin","almindras","almiranti","almiris","almirul","almismutyimpu","almuhada","almuhadun","almundigas","almunida","almuranas","alpa","alpabit","alpabitayis","alpaka","alpalpa","alpalpahan","alpilir","alpilir dinagum","alpiril","alpirin","alpirisiya","alpumbra","alpunsinu","alput","alsa","alsa ang kabuhi","alsa butang","alsa ug kamut","alsadu — ug kabuhi","alsamyintu","alta","alta prisiyun","alta prisyun","alta susyidad","altar","altu","alu","alualu","alualuhan","alubihid","alud-ud","alud-udun","alug","alug-ug","alugbati","aluhanay","aluhipan","alukaba","alukabhang","alula","alulung palu","alum","alum-um","aluman","aluminum","aluminum rapir","aluminus","alumnus","alumun","alun","alundris","alung","alung-alung","alungaing","alungaingun","alungaug","alungnan","alup","alup-up","alupaup","alupi","alupuup","alus","alusiman","alut","aluwihaw","aluy","aluy subjunctive passive verb","aluyan","aluyuk","aluyukan","alyadu","alyadus","alyansa","alyas","alyin","am-am","ama","ama namu","amaama","amaama sa buti","amag","amag-amag","amaga","amagan","amagus","amahan","amahan namu","amahung","amakan","amamahung","amamakul","amamaliw","amamangkas","amamangluy","amamangpang","amamaylan","amamaylu","amang","amang-amang","amangtan","amanti","amanus","amapulun","amapung","amara","amargusu","amarilyu","amaspas","amasuna","amat","amatung","amatyur","amaun","amaw","amawun","amay","amayung","amba","ambahan","ambak","ambak-ambak","ambakan","ambalang","ambang","ambangul","ambas","ambaw","ambi","ambid","ambig","ambihas","ambilay","ambir","ambisiyun","ambisiyunadu","ambisiyunar","ambisyusa","ambisyusu","ambit","ambit sa kalipay","ambit sa kasubu","ambrila kat","ambu","ambug","ambuhut","ambuhutan","ambulansiya","ambung","ambungan","ambus","ambut","ambut [gen.]","ambut lamang","ambut sa kagang","ambut sa lagung","ambut sa langaw","ambuy","amgid","amgu","amiga","amigas","amigu","amigu sa ubu","amihan","amihanan","amimihid","amimihig","amimislun","amimispis","amimitas","amin","amin-amin","amindar","amirika","amirikan brid","amirikana","amirikanayis","amirikanu","amirkana","amirkana nga walay kindi","amirkanu","amirkanu nga walay kindi","amirul","amistad","amitu","ampa","ampaampa","ampad","ampahan","ampalaya","ampapangig","ampara","ampaw","ampay","ampayir","amping","ampityatru","ampiyun","ampiyuniru","ampli","amplipayir","amplipayiran","ampu","ampungul","amu","amua","amuay","amul","amulan","amulun","amuma","amumun","amumun lumban sa dagat","amumung","amumunggut","amumungpung","amumuntag","amung","amung-amung","amung-amungan","amunistal","amur","amur prupiyu","amur sikritu","amuradu","amural","amuritis","amuritisun","amursiku","amurtisasiyun","amurusu","amut","amuti","amuy","amuy-amuy","amyat","amyun","an","an-an","an-un","ana","anaa","anaa dat.","anaa ra [dat.]","anaahun","anab","anabu","anabyung","anad","anag","anagasi","anagu","anagun","anagunan","anaha","anahaw","anahaw lagwis","anahaw mubu","anak","anak ni iba","anak sa anuus","anak sa buhat","anak sa bunyag","anak sa diyus","anak sa gawas","anak sa hulaw","anak sa ingkantu","anak sa kagang","anak sa pagkadalaga","anak sa pagkaulitawu","anak sa sakramintu","anak sa sala","anak sa sapi","anak sa tawu","anak-anak","anakun","anam","ananaklaw","ananakyud","ananamsi","anananggal","ananangkil","anapug","anapugan","anapugun","anaran","anas","anaw","anawnsir","anay","anay-anay","anayun","anayunun","anda","andadur","andak","andakan","andam","andamyu","andana","andar","andarul","andas","andaw","andayag","andayun","anding","andir","andir dibunal","andir ditibul","andir grawun","andir gul","andir ids","andir kubir","andir pas","andir tayim","andir wit","andu","anduhaw","anduhay","anduhunun","ang","ang aku gud","ang amu gud","ang daut","ang intunsis","ang itlug","ang kabuhi","ang kristung diyus","ang kristung hari","ang luyu","ang parat","ang purki","ang singgit sa balintawak","ang sulti","ang tuhud","ang-ang","ang-angan","anga","angaang","angal","angalan","angalaskalas","angan-angan","angat","angat sa","angatun","angay","angdu","angga","anggal","anggid","angguy","anghal","anghaw","anghil","anghil magbalantay","anghilika","anghinghu","anghit","anghuy","angiing","angilan","angin","angitngit","angka","angkab","angkan","angkanun","angkas","angkasanan","angkat","angkla","angkub","angkun","angkuniru","anglit","angsu","angsud","angsuhan","angtad","angtud","angturun","anguangu","anguanguhun","angul","angul-angul","angulunkulun","angus","angut","anha","anha ku","anha mag-agi","anha pa","anhaan","anhi","anhi lamang","anhian","anhin","anhing","anhuy","ani","ania","ania kanaku","aniag","anib","anibal","anibirsaryu","anibung","anig-ig","anihag","anii","anikad","anilaw","anilyu","animal","animar","animas","animasiyun","animik","animiku","animu","animya","aninag","aninaw","anindut","anindut nimu a","aninikad","aniningsing","aniniput","aninu","anipay","anis","anis-is","anisadu","anisay","anislag","anislagun","anist","anistisya","anit","anitu","aniyu","anlit","ansir","ansiyanu","ansiyanu sa simbahan","ansu","ansuy","antad","antagunismu","antahay","antak","antaw","anti","anti rayut iskwad","anti-","antibayutiku","antidit","antigu","antihay","antikristu","antimanu","antina","anting-anting","antipara","antipas","antipatiku","antipulu","antipun","antipuna","antirabis","antis","antisiptiku","antisipu","antitirhi","antititanus","antiuhus","antiyuhus","antiyuhus ug bika","antrak","antraks","antu","antuan","antubung","antud","antug","antugan","antugun","antuhuy","antulang","antulanga","antulanga nga asul","antulanga nga lut-ud","antulihaw","antulihawun","antulu","antus","antutu","antuwanga","anu","anud","anug","anugas","anugun","anugut","anuhus","anuk","anular","anumaliya","anunang","anunas","anunimus","anunsiyu","anunugba","anunugbu","anup-up","anupug","anur","anur rul","anus-a","anut","anutasiyun","anuus","anuwal","anyag","anyil","anyil sa lubut","anyu","anyu nuybu","anyus","ap lay","ap-andawun","ap-ap","apa","apahap","apali","apan","apan lagi","apan-apan","apapangig","apapangigun","aparadur","aparatu","aparisyun","apartar","apartardu","apartmin","apartmint","apas","apas sumpay","apas-apas","apat","apat kay","apaw","apay","apayud","apdu","apid","apid-apid","apidabit","apiki","apikta","apiktadu","apiktar","apil","apil-apil","apilar","apilasiyun","apilu","apilyidu","apindiks","apindisaytis","aping","apinig","apir","apir baks","apir kat","apirmatibu","apisiyun","apisiyunada","apisiyunadu","apitung","apla","aplay","aplikasiyun","aplikisyun","aplud","aprika","aprikana","aprikanu","aprindis","aprintis","aprisir","aprita","apritada","apritadu","aprubadu","aprubar","apsaydawun kik","apsunun","aptan","aptudit","apu","apu sa matag bagul","apu sa sungay","apu sa sungkud","apu sa tuhud","apud","apud-apud","apug","apuhan","apuhan sa sungay","apuhan sa sungkud","apul","apung","apuntadur","apuntar","apuntasiyun","apunti","apuntin","apupa","apura","apuradu","apuru","apus","apustrupi","apustul","apustulis","apuwintmint","apuy","apuya","apuyus","apyu","apyug","apyugun","ar-ip si","ar-utisi","ara","arab","arabi","arabun","arabya","aradur","arag","arang","arang-arang","arangan","arangka","arangkar","aransil","aranya","aranyas","arapal","araru","aras","arastar","arasti","arastri","arasun","arat","araw-araw","arawkarya","aray","arayis","arbul","arbul di","arbularyu","arbur di","argabyadu","argabyu","argardulsi","argh","argulya","argumintu","ari","ari na ku","arian","ariba","aribada","aribadur","ariglada","arigladu","ariglar","ariglu","arikmitik","arimadur","arimar","arina","arindu","aringkil","arinula","arisgadu","arisgar","aristadu","aristar","aristu","aristukrata","arit","aritis","aritmitik","aritmitika","aritmitiku","aritus","ariunun","ariya","ariyadu","ariyus","ark","arka","arkabala","arkanghil","arkaydi","arkila","arkitiktu","arkitiktura","arku","arkuhul","arkus","armada","armadu","armamintu","armar","armas","armas dimanu","armas dipuygu","armatyur","armi","armikat","armirul","armistisyu","armunida","armunyum","armunyun","arnibal","arnika","arnis","arpa","arpiis","arpilir","arpiril","arsa","arsii","arsinik","arsubispadu","arsubispu","arsupu","art.","artal","arti","artiarti","artikulu","artiliyiriya","artipisyal","artista","artisyanu","aru","aruk","arukan","arul","aruma","arun","arun ingnun","arunsa","arus","arus ala balinsiyana","arus kaldu","arus kun kamarun","aruwaka","aruy","arya","aryat","aryindu","as-as","as-ip","asa","asa [verb]","asa ug","asadu","asal","asam-asam","asambliya","asawa","asawa sa banig","asawaasawa","asayin","asayinmin","asayti","asayti alkampuradu","asayti dibakalaw","asayti dikastur","asayti diuliba","asayti diulibu","asbistus","asdang","asgad","asi","asiasi","asiasihun","asidu","asikasu","asilada","asilu","asiman","asimbul","asin","asin-asin","asinda","asindira","asindiru","asinsiyun","asinsu","asir","asiras","asirawu","asirawu ug buhuk","asirkasu","asiru","asistinsiya","asistir","asiti","asitira","asitun","aslay","aslum","aslunun","asnat","asnu","aspaltadu","aspaltu","asparagus","asparagus irmusu","aspira ultima","aspiranti","aspirasiyun","aspirin","aspirina","asta","astri","astrunawta","astrunumiya","astrunumu","astrunut","asu","asuasu","asud","asud-asud","asugi","asukal","asukar","asukarira","asul","asul marina","asul marinu","asunting","asuntu","asupli","asupri","asus","asusasiyun","asusiluy","asusina","asusinas","asusisyun","asusyit","asusyit iditur","asutiya","asuus","asuy","aswang","aswas","aswat","asya","asyinda","asyiti","asyus","asyusa","asyusu","asyutis","at","at-at","ata","atab","atabay","atad","atadu","atahu","atak","atakar","ataki","ataki silibrar","ataman","atang","ataru","atas","atatalu","atay","atay sa abu","atay sa suka","atay-atay","atayunun","atbang","atbang sa hangin","atbu","atbug","athag","athanay","atibas","atik","atik-atik","atiman","atimuya","atin","atindan","atindant","atindida","atindidu","atindir","atinsiyun","atip","atipu","atipulu","atis","atitaw","atlita","atmuspira","atnga","atngal","atngaw","atraka","atraksiyun","atraktibu","atras","atras {—","atras abanti","atrasadu","atrasar","atrasawu","atrasu","atribidu","atribir","atril","atripisyu","atripisyun","atsa","atsaatsa","atsak","atsal","atsar","atsara","atsay","atsi","atsuytis","atu","atua","atuanun","atub","atubang","atubangan","atubangay","atud","atug","atug-atug","atul","atuli","atum","atum-atum","atum-atumun","atumatik","atumay","atumik","atumik bam","atumik ids","atumika","atung","atup","atup nga kinamalig","atup-atup","aturga","aturgar","aturni","atut","atutung","aw","aw uu","aw-aw","awa","awaaw","awagan","awahi","awak","awang","awas","awas sa kalindaryu","awas ug palad","awasan sa apdu","awasan ug palad","awasanan","awat","away","awayan","awdisyun","awditibu","awditur","awdituryum","awgid","awhag","awhu","awihaw","awil","awit","awla","awra","awra mismu","awrura","awstriyanhun","awsud","awtburd","awting","awtlit","awtu","awtugrap","awtuhan","awtumatik","awtumatiku","awtumubil","awtunumiya","awtupsi","awtupsiya","awtur","awturidad","awturisar","awturisasyun","awu-","awug","awuk","awuk-uk","awul","awumbak","awut","awut ab bawuns","awut ab istak","awut ab lak","awut-ub tapik","awutsayid","awuy","awuy agkut","awyan","ay","ay ku nimu","ay-ar it","ay-ar payib","aya","ayaan","ayaay","ayad","ayag","ayagak","ayagan","ayam","ayaman","ayang-ang","ayang-angan","ayang-angun","ayaw","ayaw bali","ayaw lang","ayaw na","ayaw na ku","ayaw na lang","ayaw na lang ku ana","ayaw na ta (nimu)","ayaw tihiktihik","ayawan","ayawat","ayay","ayayan","aybru","ayda","aydi","ayha","ayha na","ayha pa","ayhab","ayil nibir giyud","ayis","ayis bag","ayis baks","ayis drap","ayis kap","ayis kindi","ayis kiyub","ayis krim","ayis pik","ayis-ayis","ayri","ayruplanu","ayruplanu nga bayut","aysyid","ayta","ayu","ayu ang buut","ayuayu","ayuda","ayuda dikampu","ayudanti","ayudi","ayum","ayum-ayum","ayun","ayup","ayup-up","ayus","b1","ba","ba diha","ba gud","ba karun","ba pasiyu","ba ugud","baag","baagbaag","baagbaagun","baang","baat","bab","baba","baba sa atay","babaan","babad","babag","babalunan","babaun","babaw","babaw pa niana","babay","babayhana","babayi","babayi nga buak","babayi sa iskina","babayi sa rilis","babayin-an","babayin-un","babaying buhat","babaying bunhukun","babaying muhir","babayiru","babaylan","babha","babhir","babil","babit","babul gam","babung","babuy","babuy ihalas","babuy ug balatian","babuyan","babuybabuy","babuyng sulup","babuyun","bad-ay","bad-un","badaybaday","badbad","badbaran","badiday","badigard","badingding","badlipanis","badlis","badlis myirkulis","badlis sa palad","badlisan","badlit","badlun","badlung","badlungun","badmintun","baduduy","badung","badut","badutu","badyang","badyangun","badyi","badyibadyi","badyikdyik","badyikdyikan","badyit","badyu","badyung","badyuun","bag","bag-ang","bag-angan","bag-as","bag-aw","bag-id","bag-u","bag-u sa kalayu","bag-u sa kinabuhi","bag-u sa utang","bag-uhay","bag-ung","bag-ung daan","bag-ung haun","bag-ung kalayu","bag-ung kinabuhi","bag-ung saad","bag-ung tistamintu","bag-ung tubu","bag-ung tugun","bag-ung tuig","baga","baga ang buang","baga ang nawung","baga ug buang","baga ug gwatsi","baga ug nawung","bagaang","bagaba","bagabaga","bagahan","bagakay","bagakayun","bagal","bagalan","bagalbagal","bagalnga","bagamundu","bagan","baganaw","bagang","bagansiya","bagasi","bagasiru","bagasu","bagat","bagatungul","bagaw","bagay","bagaybay","bagaybayun","bagbag","bagdal","bagduk","bagduy","bagduyan","bagduybagduy","baghak","baghanan","baghas","baghud","baghut","bagibi","bagibian","baging","bagis","bagit","bagitbagit","bagiyus","baglis","bagnas","bagnid","bagnud","bagnul","bagnulun","bagnus","bagnut","bagnutun","bagransiya","bagrung","bagsak","bagsang","bagtak","bagtakun","bagtas","bagtasun","bagti","bagtian","bagtik","bagtikan","bagting","bagting sa kampana","bagtuk","bagtukun","bagtus","bagu","bagubhu","bagubu","bagudlus","bagukbuk","bagul","bagulbagul","bagulbul","bagulbulan","bagumbayan","bagun","bagunbun","bagunbunun","bagung","bagungun","bagunul","bagurung","bagurus","bagus","bagutbut","bagutbutan","baguud","baguung","bagwisan","bagyang","bagyu","bagyu bins","bagyu sa kinabuhi","baha","bahaanan","bahabaha","bahad","bahada","bahadu","bahag","bahag ang ikug","bahagbahag","bahaha","bahak","bahakhak","bahal","bahal nga syiti birnis","bahala","bahala na","bahalina","bahan","bahanbahan","bahandi","bahandianun","bahar","bahas","bahasbahas","bahaulu","bahaw","bahawan","bahawbahaw","bahay","bahayan","bahi","bahig","bahignit","bahihi","bahikhik","bahilya","bahin","bahinay","bahirig","bahis","bahista","bahiya","bahu","bahu nga","bahu nga paryinti","bahud","bahug","bahugbahug","bahulu","bahun","bahung ingun-ingun","bahut","bahuulu","baid","baidbaid","baiid","bail","bail ug nawung","bairan","bais","bait","baiwas","bak-ap","baka","baka (ng) litsira","bakaang","bakabaka","bakag","bakagan","bakahan","bakak","bakakun","bakalaw","bakaling","bakan","bakanan","bakanbakan","bakang","bakang turu","bakanti","bakas","bakasi","bakasiyun","bakasiyunista","bakat","bakatin","bakatya","bakawan","bakay","bakaybakay","bakbak","bakgrawun","bakgrawunir","bakgut","bakhad","bakhan","bakhaw","bakhu","bakhuy","baki","bakid","bakig","bakik","bakikaw","bakiki","bakilid","baking","bakintul","bakir","bakiru","bakita","bakiya","bakla","baklag","baklarit","baklaw","baklay","bakliad","baklid","baknal","baknalan","baknit","bakpi","bakrayid","baksan","baksidur","baksing","baksingan","baksir","baksit","baksiwa","baktas","baktasay","baktin","baktinay","baktinbaktin","baktirya","baku","bakud","bakud ug nigusyu","bakudbakud","bakukang","bakukang sa ulu","bakuku","bakukun","bakul","bakulan","bakulaw","bakulkul","bakulud","bakulung","bakun","bakuna","bakunadur","bakunawa","bakung","bakungan","bakungun","bakus","bakus sa amu","bakut","bakutut","bakwi","bakwit","bakya","bakya krawud","bakyanu","bakyaw","bal-ang","bal-is","bala","balaan","balaang kasulatan","balaanun","balaat","balabag","balabagan","balabala","balad-un","baladaw","baladbad","baladin","balag","balag-ung","balagbalag","balaghuy","balagsang","balagsangun","balagtasan","balagtuk","balagula","balagulan","balagun","balagyuhun","balahaan","balahak","balahala","balahan","balahibu","balak","balak-ang","balaka","balaka ku","balakanan","balakasi","balakbak","balakiki","balakikihun","balaknun","balala","balalanti","balalatuk","balalaw","balana","balanak","balanakun","balanaun","balanban","balandra","balangas","balangasun","balangaw","balangawan","balangay","balangaynun","balangbalang","balanghitaw","balanghutan","balanghuy","balangubang","balangus","balani","balansi","balansikul","balantak","balantayan","balanti","balantigun","balantiyung","balanus","balaraw","balas","balasahun","balasbas","balaslan","balaslukun","balasubas","balat","balat balat hanginan","balat hanginan","balat uwak","balat-ang","balat-angun","balatakan","balatian","balatik","balatung","balatwanun","balaud","balaudnun","balaudun","balaungun","balauranan","balaurun","balaw","balawbaw","balay","balay alampuanan","balay lungsud","balay patigayun","balay sa kahilayan","balay sa lamigas","balay sa lawalawa","balay sa ligwan","balay sa utut","balayan","balayanan","balaybay","balaydan","balaydanan","balayi","balayran","balayranan","balayrunun (balaydunun","balayung","balbag","balbakuwa","balbal","balbangaan","balbangahan","balbas","balbiru","balbula","balda","baldadu","baldi","baldiyu","baldusa","balhas","balhibu","balhibuun","balhibuun ug dila","balhibuun ug kamut","balhin","balhinbalhin","balhinun","balhug","balhun","bali","bali ang sungay","bali nga","bali ug","bali ug igu","bali ug pangutana","bali wala","baliad","baliala","balialaun","balibad","balibag","balibali","balibalihun ug kasaba","balibaran","balibay","balibud","balibul","balibul kurt","balibulan","balibung","balibungan","balidbid","balidikturyan","balighu","balighut","baligkawang","baligkus","baligsala","baligtad","baligtus","baligwat","baligya","baligya sa unud","balik","balikas","balikasan","balikawang","balikbalik","balikhaw","balikid","balikig","balikis","baliktad","balikturyan","baliktus","baliku","baliku nga lyabi","balikud","balikug","balikugkug","balikus","balikutkut","balikutsa","balikwaut","balikwit","balila","balili","balili tsina","balilikid","balimbing","balimbugay","baling","balingag","balingay","balingbing","balingit","balingkagas","balingkawang","balingkut","balingug","balinsala","balinsay","balinsayaw","balinsiyana","balinsuguan","balinsungag","balintang","balintawak","balintayins","balintayins di","balintayins kard","balintayins parti","balintung","balintuwad","balirung","balirusu","balisa","balisada","balisala","balisbis","balisbisan","balising","baliskad","baliskug","balista","balistada","balisung","balit prup","balit-ad","balita","balitang","balitaw","baliti","balituk","balitutu","baliug","balius","baliw","baliwag","baliwas","baliwliw","baliyug","balkun","balkunahi","balkuni","balsa","balsamu","balsi","balu","baluarti","balubalu","balud","balug","balugbug","baluk","balukag","balukanad","balukat","balukbaluk","balukbuk","balukbukun","baluktut","balukun","balukut","balulang","balun","balun tayir","balunabid","balunanan","balunas","balunbalun","balunbalunan","balungag","balungan","balungbalung","balungus","balungusun","balunus","balur","balus","balusbus","baluskad","baluskag","balut","baluta","balutu","baluybuy","baluyut","balwarti","balyakag","balyina","balyu","bam","bam-i","bamba","bamban","bambu","baming","bamir","bampir","bampira","bamus","ban-id","ban-ug","ban-uk","bana","banaag","banaba","banabana","banag","banagan","banagbanag","banahaw","banahian","banak","banal","banana turun","banasay","banata","banaw","banawan","banawgan","banawug","banay","banban","banbanun","banda","bandabanda","bandala","bandana","banday","bandi","bandi klak","bandida","bandidu","bandiha","bandihadu","bandihawu","bandila","bandilyu","bandira","bandira ispanyula","bandiyu","bandmidyurit","bandu","bandul","bandung","bandurin","banduriya","bandurya","banduryahun","banduy","bandyu","bandyubandyu","bang","bang-ug","banga","bangaag","bangag","bangag sa imung ina","bangagun","bangal","bangalga","bangan","banganga","bangas","bangasun","bangati","bangaw","bangawan","bangawug","bangaybangay","bangaybangayan","bangaybangayun","bangbang","bangday","bangdaybangday","bangga","banggi","banggiitan","banggira","banggirahan","banggis","banggud","banggun","banggunun","bangguran","banggus","banghag","banghat","banghaw","banghilig","banghitaw","banghutin","banghuting","bangi","bangig","bangil","bangil sa tinggutum","bangilbangil","bangilid","bangin","bangingi","bangis","bangisun","bangitaw","bangka","bangkaag","bangkadur","bangkal","bangkaruta","bangkaruti","bangkat","bangkaw","bangkawbangkaw","bangkay","bangkbuk","bangkil","bangkilan","bangkiling","bangkilya","bangkiru","bangkiti","bangkitu","bangkiwa","bangkiwag","bangkiyu","bangkiyud","bangkrap","bangku","bangku rural","bangkulisan","bangkuliya","bangkung","bangkuru","bangnanan","bangrus","bangs","bangsi","bangtugan","bangu","bangubang","bangug","bangun","bangungut","bangus","bangut","bangutan","bangyaw","banha","banhal","banhaw","banhig","banhud","banhutin","banhuting","bani","banidad","banig","banika","banikanhun","baniku","banilad","banilya","banitlung","baniug","bankil","bankiyu","banlag","banlas","banlaw","banlawan","banlawanan","banlawunun","banlud","banlun","banlus","banlut","bansa","bansag","bansagun","bansalan","bansay","bansaybansay","bansikul","bansil","bansili","bansiwag","banta","bantaaw","bantabanta","bantak","bantal","bantam","bantam wit","bantang","bantawan","bantay","bantayan","bantayanan","bantaybantay","bantayug","banti","bantigi","bantilis","banting","bantingbanting","bantiyung","bantiyungun","bantug","bantug na man","bantug ra","bantuk","bantuk sa dughan","bantuk ug nawung","bantuk ug ulu","bantul","bantulay","bantulayan","bantulinaw","bantut","bantutun","banu","banug","banugbanug","banugun","banus","banusbanus","banuut","banwa","banwaanun","banwag","banwagi","banwas","banyaga","banyak","banyira","banyu","banyu publiku","banyumariya","banyus","bapul","bapuls","bapur","bapur digira","bapur mirkantil","bapurbapur","bar","bar klam","bara","bara dikabra","bara i bara","bara sa ispiritu santu","barabara","baradiru","baradiruhan","barag","baragbarag","baraha","baraha nga dunut","barahadur","barahan","barak","baraka","barandilya","barandilyas","barang","barangan","baranggay","barasbaras","barasu","barat","baratiha","baratilyu","baratira","baratiru","baratu","baratuhun","baraw","barawan","baraybaray","barbahan","barbas","barbikiyu","barbil","barbiladu","barbilawu","barbir","barbir siyap","barbiriya","barbiru","barbiruhan","barbityurits","barbula","barbun","barbuniru","barda","bardadu","bards","bardut","bargas","bari","barikus","baril","barilis","barina","barina dimanu","barinis","barinugan","barinuhan","barit","barita","baritun","baritunu","barkada","barkadur","barkilyus","barku","barku digira","barnati","barnis","barpin","bartiha","bartindir","bartulina","bartuniku","baru","barug","barugan","baruganan","barumbada","barumbadu","barumitir","barumitru","barung","barung pulu","barung tagalug","barungbarung","barunguy","barut","barutu","baryabli","baryu","baryu kapitan","baryu kawunsil","baryu nga way kaldiru","baryu nga way kulun","baryubaryu","baryuhanun","bas","bas-ug","bas-uy","basa","basa ang papil","basa ang tingug","basa ug kumiks","basag","basagbasag","basak","basakan","basal","basalyu","basalyus","basangag","basar","basas","basaun","basbas","basdak","bashuy","basi","basi nabal","basibas","basilika","basilin","basin","basiyar","basiyu","baska","baskad","baskag","baskit","baskit balan","baskit bul","baskitbul kurt","baskug","baskug ang kabuhi","baskula","baslan","baslanan","basngag","basnig","basta","basta kay","basta lamang","basta nga","bastabasta","bastanti","bastar","bastarda","bastardu","bastid","bastidur","bastika","bastipul","bastiyan","bastruk","bastun","bastun di san husi","bastuniru","bastus","basu","basuka","basul","basun","basun pa","basuni","basura","basurahan","basuriru","baswat","basyaw","bat","bat-ang","bat-ug","bat-ul","bat-us","bata","bata dibanyu","bata nga lingkit","bata nga linti","bata pa ang pandayan","bataan","bataan di","batabata","batabataun","batad","batadbatad","batak","batakan","batakan nga balaud","batakang balaud","batakbatak","batal","batal ang nawung","batalan","bataliyun","batalya","batalyadur","batalyun","batan-un","batan-un nga dugu","batanas","batang","batangbatang","batanggas","batangginya","batangginyu","batas","batasan","bataut","bataw","batayan","batbat","bathala","bathay","bati","batibati","batid","batiis","batiisun","batikan","batikanu","batikubra","batikula","batikulun","batil","batimbatim","batin","batinan","batinbatin","bating","bating sut","batingaw","batinggilan","batinggul","batinggulan","batingting","batir","batiri","batiriya","batirplay urkids","batirul","batis","batiwtiw","batiya","batsi","batsihi","batsihun","batsilyir","batu","batu balani","batu nga unay","batu sa kidni","batuan","batubalanihun","batubara","batubatu","batud","batug","batuk","batul","batulang","batulata","batun","batung","batung buhi","batungbatung","batunis","batus","batuta","batuun","batuwang","batuytuy","batwan","batwanun","batya","batyag","bau","bauay","baubau","baud","baug","bauhay","baul","baul mundu","baulu","baung","baungun","baus","baut","bauu","baw-u","bawang","bawas","bawbaw","bawbaw sa tuu","bawbu","bawhag","bawhinya","bawi","bawis","bawkag","bawnsir","bawnus","bawtismu","bawu","bawud","bawug","bawugbawug","bawugbug","bawuk","bawukbawuk","bawun","bawunas","bawund","bawungbawung","bawungkut","bawunu","bawunus","bawut","bay","bay-ad","bay-ang","bay-ansil","bay-ug","baya","bayaay","bayabas","bayabasan","bayad","bayad nga sininghir","bayamban","bayanan","bayang","bayang-ang","bayangbayang","bayani","bayanihun","bayas","bayas tip","bayat","bayaw","bayayat","baybay","baybayun","baydi nambir","bayhana","bayhun","bayi","bayibayi","bayin","bayin-an","bayingbaying","bayinti","bayinti dus","bayinti unu","bayinti utsu","bayintihun","baykarb","baykawun","baykawunt","baylakag","baylan","baylarina","bayli","baylihan","baylihanan","baylirina","baylu","bayluay","bayna","bayntisingkuhun","bayrunun)","baytamins","bayu","bayubayu","bayud","bayudang","bayugbayug","bayugbug","bayukawi","bayukbayuk","bayukbuk","bayukut","bayulin","bayulinista","bayulit","bayumbu","bayung","bayungad","bayungbayung","bayunita","bayupsi","bayurang","bayut","bayuti","bayutun","bayuuk","bayuus","baywantikwan","bi","bias","biaw","biawan","biaybiay","biaypi","biba","bibahut","bibi","bibihan","bibingka","bibingka nga hilaw","bibingka nga usa ray liki","bibingka nga usay liki","bibirun","bibisitir","bibliya","bibliyutika","bibu","bibut","bida","bidbid","bidhan","biding","biding nga makina","bidings","bidiyu","bidlak","bidli","bidlisiw","bidsit","bidsiyit","biduk","bidyu","biga","bigal","bigamya","bigatla","bigatlun","bigaun","bigay","bigiw","bigiwbigiw","bigkas","bigking","bigni","bigsa","bigsyat","bigtas","bigting","bigu tilyu","biguk","bigunya","bigunya dibumbilya","bigunya dikalbasa","bigunya dikurasun","bigut","biguti","bigutihun","bigutilyu","bigwis","bihag","bihagay","bihi","bihibihi","bihihi","bihikulu","bihilya","bihis","bihu","bihud","bihuku","bihun","bii","bika","bikabika","bikag","bikaka","bikang","bikangkang","bikarbunatu","bikarbunatu disusa","bikaryu","bikil","bikilunun","biking","bikini","bikiri","biklunun","biks","biks inhilir","biktima","bikturi","bikturya","bikturyusu","biku","bikubiku","bikug","bikul","bikusbikus","bikwad","bikwang","bikwing","bil-is","bila","bilaan","bilabila","bilad","bilada","biladbilad","bilag-ung","bilahan","bilaka","bilang","bilangbilang","bilangga","bilanggu","bilangguan","bilanggutanan","bilangkad","bilangkadra","bilangkat","bilangkatra","bilar","bilas","bilasun","bilat","bilat sa imung (iyang) ina","bilat sa ina","bilat sa iyang ubu","bilatbilat","bilatra","bilaug","bilay","bilaybilay","bilbatum","bilbaw","bilbig","bilbiki","bilbil","bilbilun","bilding","bildu","bildura","bildyun","bilgas","bilhad","bili","bilib","bilibid","bilibud","bilibul","biligalun","biligya","bilik","bilikan","bilikis","bililhun","bilin","bilin ug pulung","biliyun","bilt-in","biltubil","bilu","bilug","bilungbilung","bilus","bilwa","bilya","bilyaka","bilyaku","bilyanu","bilyar","bilyiti","bilyu","bilyuhan","bilyuhanan","bilyun","bilyunaryu","bimul","binaba","binabayi","binabayi nga ulan","binabuy","binag","binag-u","binagis","binagri","binagsa","binagsaan","binagus","binagusan","binahug","binahugan","binakat","binakhaw","binakhawan","binaki","binaklid","binal-an","binalatung","binalayi","binali","binalitutu","binalusan","binandahan","binandul","binangkal","binangkung","binanwagan","binara","binaraka","binasbas","binasbasan","binasuan","binat-an","binata","binati","binatirul","binatnan","binatu","binatunan","binaulan","binaw","binayabas","binayu","binayunita","bindahi","binday","binday nga kalibkibun","bindisiyun","bindita","bindita sa lukay","binditadu","binditahanan","binditu","binga","bingag","bingal","bingat","bingaw","bingbing","bingga","binggadura","binggala","binggansa","binggar","binggu","bingit","bingka","bingkas","bingkil","bingkung","bingwit","binhamin","binhi","binhud","binhurun","binibuy","binignit","binikang","binilanggu","biniliyun","binilyaka","binilyun","binipisya","binipisyu","binisaya","binit","binlad","binlangan","binlud","binlunun","binrubyum","binsul","binta","bintaha","bintahadur","bintahusu","bintana","bintang","bintanilya","bintarug","binti","bintiladur","bintilasyun","bintul","bintulawu","bintus","bintusa","binu","binu tintu","binu tuniku istumakal","binu uy masuy","binuang","binudlayan","binug","binugang","binugkus","binugtung","binuguk","binugun","binuguy","binuhan","binuhat","binuhatan","binuhi","binuhian","binuhuan","binukal","binuktunan","binulabid","binulad","binulan","binulanan","binulaus","binultu","binumbay","binunga","binungsuran","binunyagan","binurda","binurdahan","binuru","binuta","binutakal","binutilya","binutuk","binuungan","binuut","binuutan","binuy-an","binuyuk","binyal","binyal pa","bip-istik","bipiay","bir","bira","bira ang kawit","bira sa kunut","birabira","birada","biradur","biranda","biranu","birbal","birbiki","birbina","birbu","bird ub paradayis","birdadiru","birdi","birdi butilya","birdi mansanas","birdi nga hangin","birds-ay","birdugu","birgansusa","birgat","birgatinya","birgum karum","birha","birhin","birhin sa rigla","birianadir","biribiki","biribiri","birig","birigay","birigbirig","biriking","biring","birisbiris","birlina","birmuda","birnakular","birnakyular","birnis","birnis santu","birnisbirnis","birsikulu","birsiyun","birsu","birsus","birta","birtdi","birtdi kik","birtdi parti","birtibra","birtikal","birtkuntrul","birtud","birtusu","biru","biruk","birukun","bis","bisa","bisag maulahi basta prunsit","bisag unsaun","bisagak","bisagra","bisan","bisan (bisag) unsa","bisan kalamayan pa","bisan kinsa","bisan na lang","bisan pa","bisan pag mangaupaw","bisan sa","bisan ug","bisan unsa","bisap","bisaya","bisayista","bisbis","bisbul","bisbulista","bisgu","bisi","bisibis","bisiklita","bisiklita nga binabayi","bisiklita nga tuluy ligid","bisis","bisita","bisita iglisya","bisku","biskundi","biskutsu","biskwit","bisnis","bisnis manidyir","bisnis wuman","bispiras","bispiras sa himatayun","bista","bisti","bistida","bistidahun","bistidu","bistig","bistipul","bistu","bistu ang baraha","bistu ang bulitin","bisug","bisukut","bisul","bisung","bisyu","bisyusa","bisyusu","bitad","bitad ug habul","bitaki","bitamin","bitamina","bitan-ag","bitang","bitas","bitaug","bitaw","bitay","bitayan","bitaybitay","bitayun","bitayunun","bitbit","biti","bitiis","bitik","bitik sa hunsuy","bitik sa utut","bitikbitik","bitin","bitinan","bitirana","bitiranu","bitirinaryu","bitli","bitlig","bits","bitsikurnu","bitsin","bitsubitsu","bitsukuy","bitsuylas","bitu","bitudbitud","bitugul","bituk","bitukbituk","bitukun","bitulbitul","bituls","bitun","bitut","bituun","bituun sa dagat","biu","biuhun","biuung","biya","biyaw","biyin","biyin tirada","biyu","blag","blak plin","blak-anwayit","blak-awut","blak-ay","blakbins","blakbur","blakburd","blakbuting","blakdyak","blakhart","blaking","blakmarkit","blakmil","blakmiling","blakrami","blaktin","blangku","blap","blatir","blawus","blid","bliding","blits","blu","bluawut","blubuk","bluki","blumir","bluprint","blusa","blusil","bluwir","bra","brad","bradi","bradir","brandi","brandilya","brandilyas","bras","brasa","brasas","brasu","brasuhun","brasus","brasus dimirsidis","brawun","brayids mid","brayit","brid","brids","brik","brikdawun","brilyanti","brilyantin","brilyu","brinda","bringhawus","brip","bris","briskas","brislit","britsis","brudkas","brudklut","brunda","brungkitis","brungkurab","bruns","brunsi","brunsi dulsi","brunsi pina","brutsa","brutu","bruwa","bruwas","bu","buad","buagas","buagsa","buagya","buak","buang","buangbuang","buangun","buaw","buaya","buayahun","buba","bubhu","bubhuan","bubu","bubuanan","bubuanay","bubuay","bubud","bubun","bubung","bubungan","bud","buda","buda diplata","buda diuru","budabil","budabilay","budas diuru","budbud","budbud linamburan","budbud nga hilaw","budburan","budburun","budhi","budiding","budiga","budigiru","budigus","budlat","budlatan","budlatun","budlay","budlis","budlisan","budlisiw","budlung","budlut","budluy","budu","budyas","budyung","budyung kamwa","budyung lungga","budyung sa lubut sa anay","budyung tambuli","budyung tangali","bug","bug-at","bug-at ang balatian","bug-at ang buut","bug-at ang dughan","bug-at ang dugu","bug-at ang kumu","bug-at ang nawung","bug-at ang tumuy","bug-at nga masugu","bug-atan","bug-us","buga","bugaguy","bugais","bugal","bugalbugal","bugalu","bugalun","bugan","bugang","bugarak","bugarut","bugas","bugas bugtung","bugas humay","bugas mais","bugasan","bugasanan","bugasiru","bugasun","bugaud","bugaung","bugaungun","bugaw","bugawisan","bugay","bugbug","bugdu","bugha","bughat","bughat tingag","bughaw","bughuan","bugi","bugimbilya","buginbilya","buging","bugirit","bugkas","bugkus","bugkut","bugna","bugnaw","bugnaw ug mantika","bugnaw ug simud","bugnay","bugnu","bugnusun","bugnut","bugsay","bugsayan","bugsu","bugsuk","bugtai","bugtak","bugtakun","bugtas","bugtaw","bugti","bugtik","bugtu","bugtu ang ginhawa","bugtuk","bugtung","bugtung lubi","bugtungan","bugtus","bugu","buguk","bugul","bugun","bugunan","bugung","buguy","bugwad","bugwak","bugwal","bugway","bugyas","bugyung","buha","buhagay","buhaha","buhakhak","buhalhal","buhang","buhanghang","buhat","buhatan","buhatang","buhatbuhat","buhawi","buhay","buhi","buhi ang bulan","buhi nga bakak","buhi nga dugu","buhi ug bakak","buhi ug dugu","buhibuhi","buhilaman","buhimyu","buhis","buhiyas","buhu","buhuk","buhuk ni mariya","buhukan","buhukbuhuk","buhul","buhunbuhun","buhung","buhus","buhut","buing","buka","buka abyirta","buka insindiyu","buka sa balay","buka tilun","bukabularyu","bukabyirta","bukabyirtu","bukad","bukad ang atay","bukad ug ngabil","bukadu","bukag","bukagay","bukagayun","bukaghay","bukaghayun","bukagkag","bukaka","bukal","bukal ang dugu","bukal sa dugu sa kasingkasing","bukana","bukarilyu","bukas","bukas ang pultahan","bukasyun","bukasyunal","bukatut","bukaw","bukawbukaw","bukawi","bukay","bukayu","bukbuk","bukdu","bukgay","bukhad","bukhad ug palad","bukhayu","buki","buki digira","bukid","bukid sa buut","bukidnun","bukiki","bukilya","buking","buking upis","bukinggan","bukiran","bukirun","bukiskis","bukiskisun","bukisyunal","bukitkit","bukitla","buklad","buklas","buklat","bukni","buknul","buksidur","buksing","buksiyadur","buktu","buktun","buktut","buku","bukubar","bukubuku","bukud","bukug","bukug sa buut","bukug ug panit","bukul","bukulbukul","bukung","bukut","bukwas","bukway","bukya","bukyabukya","bul","bul-a","bul-an","bul-anun","bul-anung tagubtub","bul-ug","bula","bula ang baba pagkaun","bula dimanu","bulabid","bulabula","bulabung","bulad","bulada","buladur","bulag","bulagaw","bulagsak","bulahan","bulahug","bulak","bulakan","bulakaw","bulakbul","bulakbulak","bulaktay","bulalakaw","bulalhug","bulalu","bulalung","bulan","bulanbulan","bulandur","bulandus","bulang","bulangan","bulanghug","bulanghuy","bulanglang","bulangsud","bulanit","bulansud","bulanti","bulanting","bulantis","bulanun","bularat","bulas","bulasa","bulasut","bulatik","bulatsira","bulatsiru","bulaus","bulaw","bulawan","bulawanun","bulawis","bulay","bulay-ug","bulbug","bulbul","buldu","buldug","buldusir","buldyak","bulgan","bulgar","bulhang","bulhay","bulhug","bulhun","bulhut","bulhut!","bulhutay","buli","buli mu","bulibard","bulibud","bulibul","bulibuli","bulibuy","bulibuyan","bulig","bulikat","bulilis","bulilit","bulilyus","bulimanu","bulinaw","buling","bulinga","bulingan","bulinggit","bulingit","bulingun","bulingut","buliniyu","bulintang","buliraw","buliring","buliru","bulis","buliskad","bulit","bulitas","bulitik","bulitin","bulitin upisyal","bulitlit","bulitsi","buliyus","bulkan","bulkas","bulpin","buls-ay","bulsa","bulsahan","bulsita","bult","bult tridir","bultahi","bultimitru","bultu","bulu","bulu bataliyun","bulubakintul","bulubalintung","bulubathala","bulubilyun","bulubud","bulubulu","bulubuntag","buluburdahi","bulubutunis","bulud","bulug","bulugan","buluhatun","buluhi","buluhisan","buluk","bulukbuluk","bulukut","bulung","bulungan","buluniyu","buluntad","buluntar","buluntaryu","buluntir","bulus","bulut","buluungun","buluy","buluyagun","bulwang","bulyum","bum","bumabagyu","bumba","bumbardiyu","bumbay","bumbil","bumbilya","bumbira","bumbiru","bumbiruhan","bumbu","bumibiya","bumubuhat","bun buyids","bun-ag","bun-i","bun-u","bun-ug","bun-ug ang hilanat","bun-ug ang tulug","buna","bunabuna","bunak","bunakan","bunakun","bunal","bunaw","bunayus","bunbun","bundak","bundak sa sala","bundu","bundul","bung","bung-aw","bunga","bunga di tsina","bunga sa katulug","bunga ug singut","bungabung","bungabunga","bungad","bungag","bungag singut","bungahuy","bungalun","bungan","bungang kahuy","bunganga","bungarul","bungat","bungatngat","bungatud","bungaw","bungawu","bungawuy","bungay","bungbung","bungbung kawayan","bungdu","bungdul","bungduun","bunggalu","bunggu","bunghan","bunghayag","bunghug","bungi","bungingi","bungisngis","bungiut","bungkag","bungkagay","bungkal","bungkaliw","bungkas","bungkawil","bungkig","bungkug","bungkul","bungkut","bunglay","bunglayun","bungsi","bungsud","bungsuran","bungsuranan","bungtan","bungtud","bungug","bungugun","bungul","bungul nga lubi","bungulan","bungun","bungut","bungutan","bungutbungut","bungutbungutun","bungutun","bunguy","bunhayag","bunhuk","bunhukun","buni","bunita","bunitu","bunkawil","bunkul","bunlaw","bunlay","bunlud","bunlut","bunlutay sa tukug","bunsaka","bunsalu","bunsika","bunsu","bunsud","bunsudbunsud","buntag","buntagbuntag","buntagun","buntal","buntas","buntaug","buntaw","buntay","buntis","buntud","buntug","buntugun","buntul","buntung","bunu","bunuan","bunug","bunugbunug","bunuk","bunul","bunulun","bunus","bunusan","bunut","bunut labay","bunut madyung","bunut paningit","bunut pyanghaw","bunut supu","bunyag","bunyagan","bunyun","bupalu","bupanda","bupiti","burabug","buradur","burak","burakburak","burara","buraska","buraw","burayburay","burd","burd pit","burda","burdadira","burdadu","burdadur","burdag","burdahi","burding hawus","burdir","burdu","burdug","burdun","burgahuy","burgis","buridu","burilyus","buringug","buringut","buriring","buriskas","burit","burlas","burlis","burnay","burnir","burniyu","bursa","bursigi","buru","burud","buruka","burukburuk","burukinta","burukintu","burul","burumbut","burunda","burung","buruniyu","burus","burus sa pasalig","burut","burutburut","buruwas","buruy","bus","bus-aw","bus-uk","busa","busa nuba","busagak","busak","busal","busaug","busaw","busawus","busay","busbus","busdak","busdik","busdu","busi","busiad","busikad","busilak","busina","busing","busing-ut","busiru","busisi","busisiru","buskad","buskad ug ngabil","buskadira","buskag","busla","buslahay","buslung","buslut","buslut sa bulsa","buslut sa iyang ina","buslut ug bulsa","busngal","busngi","busting","bustipul","bustu","busu","busug","busugan","busun","busung","busung grandi","buswak","buswang","buswat","busyad","busyu","but","but-an","but-anay","but-uk","buta","buta bungul","butabuta","butad","butaka","butakal","butakal sa gubirnu","butalhag","butalid","butaltal","butalu","butang","butang sa siguru","butangbutang","butangi","butangiru","butanika","butaniku","butanti","butar","butas","butasiyun","butay","butay-ad","butbut","butbut pula","butbutun","butdanun","buthanan","buthu","buti","butibut","butig","butigis","butihun","butika","butikaryu","butikin","butikug","butikul","butikulun","butil","butilus","butilya","buting","butingting","butirik","butirus","butiti","butku","butkun","butlig","butlug","butsaka","butsi","butsing","butsir","butsu","butsukuy","butu","butubutu","butud","butuk","butukbutuk","butul","butun","butung","butunis","butuy","butyag","buud","buug","buugan","buuk","buukan","buulbuul","buun","buung","buungun","buuran","buus","buut","buutan","buutbuut","buuti","buwa","buwa-","buwabuwa","buwal","buwan","buwang","buwaun","buway","buy","buy-ud","buy-uk","buy-un","buya","buyag","buyag sa tubig","buyagan","buyang","buyang-ang","buyangyang","buyasyas","buybuy","buybuyan","buyinggit","buykutiyu","buylas","buylu","buylug","buyna","buyna manu","buynas","buynas diyas","buynu","buyprind","buysit","buyu","buyud","buyug","buyugun","buyuk","buyukan","buyun","buyung","buyut","bwabuwa","bwagas","bwahan","bwahat","bwanbuwan","bwaus","bwaybuway","bwi-","bwilta","bwiltabwilta","bwinggit","bwisit","byabas","byahi","byahian","byahidur","byakrusis","byamban","byanggas","byanggasun","byanti","byasung","byata","byatiku","byatilis","byatu","byinbinida","byinbinida parti","byinis","byintus","byirnis","byitnam rus","byu","byuda","byuda aligri","byuda nga buhi","byudu","byudung buhi","byugul","byulin","byulita","byumbu","byuti parlur","byuuk","byuus","da","da man","daabdaab","daan","daan nga tugun","daan pa [subject]","daan pa lagi [gen.]","daana","daang saad","daang tistamintu","daang tugun","daani","daat","daay","daba","dabahan","dabdab","dabdabun","dabudabu","dabuk","dabukan","dabul bid","dabung","dad-unun","dadangatan","dadi","dag-an","dag-anan","dag-um","dag-um ang langit","dag-un pa","dag-unun ug lamas","daga","dagaang","dagabdab","dagabdabun","dagahay","dagami","dagan","daganas","dagandagan","dagandang","dagang","dagangan","dagangdang","dagasdas","dagat","dagatnun","dagatun","dagaw","dagaya","dagayday","dagdag","daghan","daghan nga","daghanan","daghang salamat","daghung","dagil","daging","daginut","daginutan","daginutan ug sulti","daginutun","daginutun ang bulsa","dagir","dagit","dagitab","dagitabnun","dagku","dagkut","dagkutay","dagma","dagmal","dagmalan","dagmuk","dagnay","dagpak","dagpak sa pamilya","dagpal","dagpas","dagpas sa abug","dagpi","dagpi timu","dagsa","dagsang","dagsay","dagtum","dagubdub","daguhub","daguhung","daguhuy","dagukduk","dagukdukan","dagul","dagum","dagun","dagundagun","dagundun","dagundung","dagungdung","dagut","daguuk","dagway","dagway tawu","dagway ug","dagwayan","dagyaw","dahan","dahay","dahig","dahik","dahil","dahili","dahili humay","dahilug","dahilus","dahinggay","dahiraw","dahis","dahug","dahugan","dahugun","dahul","dahuldahul","dahulug","dahuluy","dahum","dahun","dahun sa","dahun tubu","dahun ug lagpad","dahundahun","dahung laya","dahunug","dahup","dahut","dahuyag","daig","daik","dail","dailun","dailus","dait","daitul","daiya","dak","dakaldakal","dakaldakalun","dakan","dakang","dakbalay","dakbayan","dakbayanun","dakbut","dakdak","dakdak ulan","dakdakan","dakdakan ug sabadu","dakin-as","dakinas","dakit","daklap","daklit","dakpanay","dakrun","daktil","daktul","daktul ug nawung","daku","daku ang atay","daku ang dagat","daku ang hunahuna","daku ang tinguha","daku nga","daku nga balita","daku nga kabaw","daku nga mamsa","daku nga tai","daku nga tawu","daku ug aninu","daku ug baba","daku ug sala","dakuan","dakuay","dakudaku","dakug","dakul","dakuldakul","dakun","dakung","dakung kalabaw","dakung mamsa","dakung manbad","dakung tai","dakung tawu","dakup","dakupdakup","dakuyung","dakyup","dal","dal-us","dal-usan","dal-usanan","dala","dala sa kahig","dala sa pagkatawu","dala sa tigaw","dala ug hilas","dalad-unun","daladala","dalag","dalaga","dalagan","dalagan sa hitabu","dalaganan","dalagangdang","dalaginding","dalagita","dalahig","dalahik","dalakit","dalam","dalamba","dalan","dalangin","dalap","dalapugan","dalaput","dalar","dalaura","dalayig","daldag","daldal","daldalira","daldaliru","dalhap","dalhig","dalhug","dalhunun","dali","dalid","dalidali","daligdig","dalikdik","dalikyat","dalilang","dalimasu","dalin-as","dalinuan","dalinug","dalipanus","dalipasu","dalipsang","dalipsu","dalipsut","dalipsut sihi","dalipunga","dalisay","dalispang","dalispu","dalit","dalitik","dalius-us","dalu","daludalu","dalugdug","daluk-an","dalum","dalundalun","dalundun","dalungdung","dalunggan","dalunggan sa amu","dalunggan sa ungguy","dalunggandalunggan","dalupang","dalupang ginting","dalupang kukhan","dalupapa","dalupugan","dalus-us","dalus-usan","daluyduy","dalwak","dalyang","dam","dam-ag","dam-ug","dam-uk","dam-ut","dama","dama dinutsi","dama hwana","damag","damagan","damahan","damahwana","damak","daman","damandaman","damas","damba","dambil","damgu","damhuy","damids","damig","damika","damili","damlag","dampilas","dampiyas","dampug","damput","dampuug","damu","damulmug","damulug","damun","damung","damurhaw","damusing","damyang","damyu","dan","dan-ag","dan-uk","danag","danakit","danas","danasdanas","danaw","danay","danga","dangadanga","dangag","dangan","dangarag","dangarang","dangas","dangat","dangaw","dangawdangaw","dangay","dangdang","dangga","danggas","danggit","danghag","danghal","danghalan","danghili","dangilag","dangili","dangka","dangkalan","dangkit","dangkulus","danglas","danglay","danglug","dangput","dangs","dangug","dangulngul","dangup","danguynguy","dani","danlak","danlug","dansbul","dansir","dansuy","danug","danyus","danyus piruhisyus","dap","dap-ag","dap-as","dap-as sa kapayas","dap-ig","dap-us sa kapayas","dapa","dapak","dapal","dapaldapal","dapat","dapaw","dapawdapaw","dapawun","dapay","dapdap","dapi","dapidapi","dapig","dapigas","dapilus","dapit","dapiyas","dapiyu","dapla","daplak","daplas","daplay","dapli","daplin","daplus","dapsut","dapu","dapug","dapugan","dapul","dapul bag","dapulas","dapuliru","dapya","dapyas","darami","dariyu","dariyut","dariyut [subjunctive verb]","darling","daru","darudaru","daruhan","das","das-ag","das-ug","dasa","dasag","dasdas","dasig","dasigdasig","dasmag","dasmag sulung","dasngag","daspan","dastir","dasuk","dasun","dasundasun","dat-ug","dat-ul","dat-ulan","data","datadata","datag","dati","dating","datslan","datsun","datu","datum","datung","datus","dau","daub","daubanan","daug","daug pa","daugan","daugdaug","daul","daup","daura","daurus","daus-us","daut","daut ang buut","dautan","dautan nga hangin","dautdaut","daw","daw [adjective","daw may mutyang gisapnay","dawa","dawadawa","dawal","dawat","dawatdawat","dawdaw","dawhug","dawi","dawin","dawiraw","dawpang","dawu-","dawun","dawungdung","dawuntawun","dawuntawun ikspris","day","day-a","day-as","day-u","dayabitis","dayag","dayag na lang","dayagnus","dayagram","dayak","dayal","dayal tun","dayalug","dayalugu","dayamanti","dayamitru","dayamun","dayan","dayana","dayandayan","dayang","dayap","dayapir","dayari","dayariya","dayaw","dayban","dayday","daydayan","daygun","dayhag","dayhagan","dayhagun","dayhard","dayib","dayig","dayik","dayis","dayis-ul","dayisir","dayit","daylang","daynamu","daysik","dayugdug","dayuk","dayun","dayung","dayung ug tuig","dayungan","dayungyung","dga.","di","di hislung","di kadungug","di na mudungug ug tawgun","di sapinu","di uras","di-","dia","diadtu","diagwa","dialkampur","dialta","dialta mar","dialtamar","diana","diani","diarti","diay","diay ba","dibal","dibaldi","dibalur","diban","dibati","dibatista","dibaydibay","dibaydir","dibayid","dibidind","dibidindu","dibilap","dibilapir","dibilup","dibirsiyun","dibisiyun","dibisiyun syupirintindint","dibisyun","dibitir","dibu","dibuhista","dibuhu","dibultu","dibumba","dibunyas","dibursiyada","dibursiyadu","dibursiyu","dibusiyun","dibutanti","dibutu","dibutus","dibuynas","did-an [subject]","didak","didaksiyun","didal","didbul","didi","didikisyun","didikit","diditi","didiyut","didlayin","didtu","didtu nga [noun]-a","didtut","didtuy","diduksiyun","didusu","dig-ab","diga","digamu","digasa","digastu","digira","digkit","digmi","dignidad","digu","digum","diguma","diguun","digwa","digwat","digyas","digyu","digyut","diha","diha ka lang","diha nga [noun]-a","diha nga plus [clause]","diha pa","dihadiha","dihadu","dihapun","dihay","dihin guli","dihug","diin","diin nga [noun]-a","diin nga impirnuha","diindiin","diini","dik","dikabra","dikakaw","dikampana","dikampanilya","dikanu","dikapling","diki","dikidiki","dikit","dikitan","diklamar","diklamasiyun","diklarar","diklarasiyun","diklim","diklimir","diklimisyun","diksiyunaryu","dikstrus","dikta","diktadur","diktadura","diktaduriya","diktar","dikulur","dikuluris","dikumbati nga parul","dikun","dikurar","dikurasiyun","dikurisyun","dikuryinti","dikutsun","dikyam","dila","dila nga kalayu","dila ni lapulapu","dila sa iru","dilaab","dilabari","diladila","diladila sa iru","diladila sa sapatus","dilamita","dilana","dilantadu","dilantar","dilantawu","dilantira","dilantu","dilap","dilargu","dilastiku","dilata","dilatar","dili","dili (wala) lang ... kun di","dili ba","dili basta","dili gayud","dili hapit","dili hingan","dili hungut ang kalibutan","dili iglabut","dili iglain","dili iglayu","dili ila","dili ingun natu","dili ingun sa pag-unsa","dili kay","dili kay ... kun dili","dili ku bi","dili ku uy","dili kubir","dili lang usab kay ...","dili madruwing","dili magkadimau","dili magsumala","dili makaun ug iru","dili marituki","dili palandung","dili palibak","dili pisik","dili tantu","dili tiaw","dilibir","dilibiri buy","diligadu","diligar","diligasiyun","diligisyun","dilihinsiya","dilikada","dilikadisa","dilikadu","dilikinti","dilinyadur","dilinyanti","dilir","diliryu","dilitayim","dilitayim rikurd","dilitsi","dilitu","dilmundu","dilutu","dilyabi","dim","dimalas","dimalas lang","dimalasun","dimanda","dimangga","dimanu","dimas","dimasyadu","dimasyawu","dimau","dimdim","dimirit","dimisiyun","dimitir","dimitudu","dimudu","dimukrasya","dimukrata","dimukratika","dimukratiku","dimul","dimungkug","dimunstradur","dimunstrasiyun","dimunstrit","dimuntris","dimunyu","dimusdimus","dimutur","dinad-an","dinagaang","dinagat","dinagaw","dinaginut","dinagku","dinagpi","dinagum","dinaguuk","dinahun","dinakpan","dinakup","dinala","dinalaganay","dinalhan","dinalian","dinalidali","dinalunggan","dinamita","dinamitahan","dinamitiru","dinanggit","dinapit","dinatu","dinautan","dinawin","dinayganay","dinaygunan","dinayun","dingag","dingagun","dingas","dingat","dingaw","dingding","dinghal","dingili","dinguldingul","dinha","dinhi","dinhi nga [noun]","dinhiy","dinigamu","dinihug","diniru","diniyus","dintist","dintista","dintistri","dintru","dinugmakan","dinugtungan","dinugu","dinuguan","dinuldug","dinuminasiyun","dinumiru","dinumug","dinunggaban","dinungganay","dinurug","dinuta","dinuwin mani","dip","dip-ig","dip-it","dipalita","dipamilya","dipapil","dipara","diparal","diparar","dipartamintu","dipartamintu sa agrikultura ug rikursus naturalis","dipasahiru","dipasit","dipdip","dipi","dipiktadu","dipiktu","dipiktusu","dipindi","dipindir","dipinsa","dipirinsiya","dipirinsiyadu","dipisit","dipiyi","dipluma","diplumasiya","diplumasya","diplumatiku","dipluy","diprimira","diprimira klasi","diprimira marka","diprinsiya","diprisisiyun","diprisyun","dipudata","dipudipu","dipung","dipuntu","dipurt","dipurtasiyun","dipurtasyun","dipusil","dipusit","dipusitu","dipusituhanan","diputadu","dipwat","dipyi","dir-is","dira","dirami","dirapidu","dirasa","diri","diri nga [noun]-a","dirihir","diriksiyun","dirikta","diriktaminti","diriktiba","diriktu","diriktur","dirikturi","dirikturyu","diris","diritsu","diriy","diriyu","diriyut","dirusas","diruska","dis","dis-a","dis-arma","dis-impikta","dis-inpikta","dis-inpiktanti","dis-iridar","dis-ug","dis-unurabul distsards","dis-uras","dis.","disapiyu","disaya","disbar","disdi","disdis","disgayis","disgrasya","disgrasya nga malingin","disgrasyada","disgrasyadu","disgrasyang malingin","disgustadu","disgustawu","disgustu","disgwapa","disgwapu","disi","disibi","disididu","disidir","disil","disilya","disimal","disimbri","disimitru","disimitrus","disimpiktar","disimri","disimuladu","disinti","disintiriya","disintralisasiyun","disintralisisyun","disinuybi","disinyu","disiplina","disiplinada","disiplinadu","disiplinaryan","disipulu","disirt","disisayis","disisayis kartas","disispiradu","disisyiti","disisyun","disiutsu","disiyu","disk","diskansadu","diskansar","diskansawu","diskansu","diskansu sa dayun","diskansuhan","diskansuhanan","diskansuhanan sa dayun","diskarga","diskarids","diskaril","diskarni","diskas","diskasi","diskasyun","diskitar","diskrayib","diskribir","diskubri","diskumpiyada","diskumpiyadu","diskumpiyar","diskuntintu","diskursu","diskusyun","diskutik","diskutir","diskutsu","diskuwalipayid","diskuwintu","dismayar","dismayu","dismis","dismisal","dismuladu","dismular","dispalkadur","dispalkadura","dispalku","dispanta","dispasir","dispatsadur","dispatsadura","dispatsar","dispatsir","dispatsu","dispidida","dispidir","dispinsa","dispinsaryu","dispinsasiyun","dispinsisyun","dispirada","dispiradu","dispiras","dispirinsiya","dispisiyar","dispras","disprinsiya","dispuga","dispugadira","dispunir","dispusisiyun","dispuwis","distansiya","distiliriya","distinadu","distinar","distinasiyun","distinu","distiyiru","distribuwir","distribyutur","distritu","distrungkar","distrusar","distrusu","distsards","disturbar","disturbu","disturnilyadur","distursiyun","diswildu","disyimbri","disyirtu","dit","dit.","dita","ditalyi","ditiktib","ditiktib aksiyun","ditirminasiyun","ditsu","diwa","diwal","diwalwal","diwanag","diwanhun","diwata","diwatahan","diwatiru","diwindi","diwit","diwitdiwit","diya","diyabitis","diyablu","diyakunu","diyamanti","diyamitru","diyana","diyaryu","diyas","diyatilis","diyita","diyu","diyudiyu","diyung","diyus","diyusa","diyusdiyus","diyusisis","diyusnun","diyut","diyutay","diyutdiyut","diyuy","dr.","dra.","dragun","dragunis","dram","drama","dramatik","dramatik intrans","dramaturga","dramaturgu","dramir","drams","dramstik","drap","drap-awut","drapir","draybir","drayib","drayir","dri","dribul","dridyir","dril","dripwud","dris","drising","drising rum","drisir","drismiking","drisrihirsal","dristukil","dru","druwing","druwinganan","druwir","du","duak","duas","duaw","duaw ang katulugun","duay","duay-ay","dubdub","dubla","dubli","dubli antsu","dubli bista","dubli dus","dubli kara","dubli u","dubudubu","dubuk","dubul","dubul badi","dubul bid","dubul dayis","dubul dik","dubul krus","dubul krusir","dubul parking","dubul pawul","dubun","duda","dudhu","dudu","dudung","dudusu","dug","dug payit","dug-ab","dug-ul","duga","dugamis","dugang","dugang sa","dugap","dugaun","dugay","dugay na","dugayan","dugaydugay","dugaydugay na","dugbak","dugdug","dughan","dughang","dughang samaran","dughanun","dughanun ug tiyan","dughit","dughu","dughuun","dugkal","dugmak","dugmil","dugmu","dugmuk","dugmun","dugnas","dugsak","dugsang","dugsaw","dugsib","dugsu","dugta","dugtung","dugtung ang dalan","dugtung ang hunahuna","dugtung ug pusud","dugtung ug tinai","dugu","dugu ang balatian","dugu sa dugu","dugu sa laki","dugudugu","duguk","dugukan","dugung","dugung puti","dugus","dugusdugus","dugusnun","duguun","dugwa","dugwat","duha","duhaduha","duhal","duhalduhal","duhawit","duhay nawung","duhig","duhiras","duhiraw","duhul","duk","duka","dukandukan","dukduk","duki","dukiduki","dukiruk","dukisa","dukla","duklap","duktanan ug buling","duktrina","duktrina kristiyana","duktur","duktur laway","duktur rural","duktura","duku","duku ug paalut","dukul","dukumintadu","dukumintu","dukumintu sa palit","dukung","dukut","dul-ay","dul-ayun","dul-it","dul-u","dul-ug","dul-ung","dula","dulaan","dulaanan","dulamug","dulang","dular","dulaw","duldug","duldul","dulhug","duling","dulipanus","duliyar","dulsi","dulsira","dulug","dulugukun","duluk","dulum","dulum ang pangisip","dulumdumun","dulun","duluna","dulung","dulurusa","dulurusa ug nawung","dulurusu","dulut","dulut sa bukug","dulut sa kasingkasing","dulyan","dulyum","dum","dum-ug","duma","dumadaghan","dumadagkut","dumadaktul","dumadapig","dumadaug","dumagat","dumagsa","dumala","dumalaga","dumalagku","dumalagkut","dumalagkuun","dumalagsa","dumalahan","dumalapig","dumalayun","dumalig","dumaligyut","dumanu","dumar","dumay","dumbay","dumbul","dumdum","dumigyu","dumigyut","dumika","dumili","duminar","duminggu","duminggu diglurya","duminggu diramus","duminu","dumising","dumistik sayans","dumpaug","dumpil","dumpu","dumpul","dumuduaw","dumuduung","dumug","dumul","dumuluaw","dumut","dumyang","dun","dun-ag","duna","dunar","dunasiyun","dunat","dunat intir","dunay nigusyu","dundi","dundun","dundunay","dung","dung-ag","dung-aw","dungag","dungalig","dungan","dungan sa","dungandungan","dungas","dungaw","dungawug","dungdung","dungga","dunggab","dunggan","dungganan","dungganay gabii","dungganun","dunggu","dunggu ang bisita","dungguan","dungguanan","dunggudunggu","dunggut","dunghay","dungilu","dungka","dungkul","dungluy","dungpul","dungsul","dungu","dungug","dunguk","dunguy","dunluk","dunsal","dunsilya","dunsul","dunul","dunut","dunut nga baraha","dunya","dunya awrura","dunya imilda","dunya lilang","dunya lus","dunya trining","dunyang","dup-adik","dupa","dupang","duplikadu","duplikit","dupung","duput","durabli","duradu","duranti","duranti sa","durar","duraw","durbil","durmiluna","durmituryana","durmituryu","duru","duru nga","durug","duruha","duruk","durul","duryan","dus","dus bilus","dus pur dus","dus puyra","dus-ug","dusahus","dusaus","dusawus","dusdus","dusi","dusi paris","dusib","dusil","dusina","dusingut","dusipil","duslak","duslib","duslit","duslug","dusmu","dusmug","dusu","dusud","dusul","dusyintus","dut","dut-uy","duta","dutdut","dutdutan","dutu","duug","duugduug","duuk","duul","duul nga silangan","duul sa kusina","duul sa luwag","duum","duun","duung","duungduung","duut","duwa-","duwahug","duwahut","duwal","duwilu","duwit","duy","duya","duyan","duyan sa dughan bra","duyas","duyduy","duyug","duyum","duyung","dwindi","dwitu","dy-","dya","dya-","dyab","dyaba","dyabayinti","dyablis","dyads","dyadyis","dyag","dyag-aw","dyag-awan","dyaging","dyak","dyaki","dyakimpuy","dyakinpuy","dyakit","dyakpat","dyakstun","dyalusi","dyam","dyambul","dyamburi","dyaming","dyamp daspayin","dyamp dispayin","dyampingkuy","dyampir","dyamsisyun","dyamu","dyamuntris","dyana","dyandi","dyangk","dyangkimpuy","dyanitur","dyapan","dyapandyapan","dyapanis","dyapinis","dyar","dyas","dyasingku","dyaski","dyatilis","dyiay","dyid","dyikni","dyiktin","dyili","dyilirul","dyilusi","dyim","dyimnastiks","dyimnasyum","dyiniral","dyiniral admisyun","dyiniral makartur","dyiniral manidyir","dyins","dyintul man","dyinuwin","dyip","dyip-ut","dyipni","dyirk","dyirman kat","dyirsi","dyiru","dyis","dyisinuybi","dyismus","dyit","dyitplin","dyiwil","dyu","dyubus","dyudista","dyuditsu","dyudu","dyuk","dyukbaks","dyukir","dyulin","dyun","dyunbrayid","dyunsun","dyunyur","dyus","dyuti","dyuwil","dyuwit","dyuy rayding","et al.","etc","etc.","etc. dyunyur","etc.) lugar","g","g.","ga","ga-","gaab","gaak","gaan","gaan ang buut","gaan ang dugu","gaan ang lawas","gaan ang ulu","gaan ug buut","gaan ug kamut","gaan ug sulti","gaan ug ulu","gaang","gaay","gab","gab-ul","gaba","gabaan","gabagaba","gaban","gabang","gabardin","gabas","gabasgabas","gabasiru","gabat","gabay","gabayan","gabhang","gabhianun","gabhiun","gabhiuna","gabhut","gabi","gabi sa amirikanu","gabi sa haway","gabigabi","gabii","gabiigabii","gabiing","gabing","gabiniti","gabling","gabnut","gabsanan","gabsunun","gabu","gabuk","gabuk ug balatian","gabuk ug lawas","gabuk ug tinai","gabun","gabunun","gabut","gabutun","gadim","gadimit","gadlas","gaga","gagmating","gagmatuy","gagmay","gagming","gagmituy","gagu","gaguy","gahab","gahad","gahapun","gahapun lamang","gahas","gahi","gahi nga tingug","gahi ug ilung","gahian","gahid","gahig ulu","gahin","gahit","gahu","gahub","gahubun","gahuk","gahum","gahung","gahut","gahutay","gai","gaid","gak-ang","gaka","gakagaka","gakahun","gakit","gaksanay","gakud","gakus","gakusgakus","gakut","gala","gala nga unipurmi","gala primyir","galab","galagala","galahan","galalmun","galam","galam-an","galam-un","galamhan","galamitun","galangan","galansiyang","galanti","galanutun","galas","galastuhan","galaw","galawgaw","galay","galbanisadu","galgal","galgalan","galgalun","galha","galhab","gali","galihira","galing","galing lamang","galing nang galing","galingan","galinggaling","galiriya","galmu","galu","galugalu","galun","galunan","galung","galusgalus","galut","galyira","galyirahan","galyita","galyitas","galyu","gam","gam-anan","gam-ul","gam-unun","gama","gamat","gamating","gamatuy","gamaw","gamay","gamaygamay","gamayun","gamayut","gamayutun","gambalay","gambat","gamhanan","gamhanun","gaming","gaminggaming","gamit","gamit sa balay","gamitanan","gamiting","gamituy","gamlu","gamsanan","gamu","gamus","gamusa","gamut","gamut daku","gan salut","gana","ganadu","ganansiya","ganas","ganay","ganayan","ganda","gang","gangad","gangan","gangay","ganggang","ganggangan","ganggrina","gangha","ganghaan","gangi","gangis","gangkap","gangkay","gangking","gangrina","gangsa","gangstir","gangu","gangugangu","gangut","gani","ganid","ganiha","ganiha ra","ganina","ganir","gansa","gansal","gansalgansalun","gansang","gansanggansang","gansangun","gansilyu","gansiyang","gansu","gansung","ganta","gantaaw","gantang","gantangan","ganti","ganting","gantsilyu","gantun","gantuung","ganus-a","ganut","ganuy","ganuyan","gap-ak","gapang","gapas","gapasan","gapasgapas","gapasun","gapi","gapin","gapinay","gapnud","gapu","gapud","gapugapu","gapung","gapus","gapus ang kwarta","gara","garab","garaba","garabi","garabu","garabun","garagara","garagaraun","garahi","garahian","garahianan","garakgarak","garakgarakun","garal","garamal","garan","garang","garanggarang","garanil","garantisadu","garantisar","garantiya","garapa","garapinyira","garapun","garas","garay","garbansus","garbantus","garbu","garbu sa iru","garbusa","garbusu","gardaba","gardim","gardimit","gardin","gardining","gardiniru","gardiyan","garing","garipu","garis","garisun","garmint bag","garnalda","garnati","gartir","garu","garud","garus","garuti","gas","gas istub","gas mask","gasa","gasang","gasangun","gasap","gasbut","gasgas","gaskit","gasli","gasling","gaspang","gaspin","gastadu","gastadur","gastadura","gasti","gastruintiraytis","gastu","gastu ang","gastu ang kasingkasing","gastub","gastus","gastusa","gasulina","gasulinadur","gasulinahan","gata","gatal","gatang","gatas","gatasan","gatasgatasan","gatasgatasun","gatasun","gataw","gatawun","gathanay","gatilyu","gats","gatu","gatud","gatudgatud","gatudgaturun","gatung","gatus","gatusan","gaud","gaudgaud","gaugau","gaung","gauran","gauy","gaw","gawad","gawal","gawang","gawas","gawasanan","gawasnun","gaway","gawaygaway","gawgaw","gawi","gawsanan","gawu","gay","gay-ut","gayang","gayhab","gayi","gayid","gayud","gayud hinuun","gayud lang","gayuma","gayun","gayung","gayung nang —","gayunggayung","gi","gi-","gi-an","giak","giatay","giatsay","giatud","gib-an tik","gibag-un","gibala gilukdu","gibali wala","gibang","gibantul","gibhang","giblang","gibug-atun","gibusing","gidaghanun","gidak-un","gidalayig","gidamag","gidlak","gidlakgidlak","gidlaw","gidlay","gidugayun","gidulaw","gigkanun","gigming","gigukud sa gunting","gigulu","gihabugun","gihang","gihangup","gihapun","gihay","gihi","gihu","gihukad","gika-","gikan","gikan karun","gikan sa mandaluyung","gikan sa ubra padulung sa trabahu","giktanun","gikusugun","gil","gil iskawut","gil-as","gil-it","gil-ud","giladmun","gilak","gilakgilak","gilalumun","gilang","gilapdun","gilaw","gilawgilaw","gilay","gilay-un","gilayun","gilhang","gilis","gilit","giluk","giluk ang kamut","gim","gim-aw","gim-ut","gimat","gimaw","gimbuhatun","giming","gimuk","gin-u","gin-ut","gina-","gina-an","ginabas","ginabii","ginabingan","ginabsan","ginabut","ginagmay","ginahapun","ginahub","ginakit","ginamay","ginamit","ginamitun","ginamus","ginamusginamus","ginang","ginansilyu","ginansiya","ginapinay","ginarapun","ginarbu","ginat-an","ginatang","ginatus","ginga","gingging","ginggun","gingharian","gingi","gingigingi","ginhapun","ginharian","ginhawa","ginhawa ug luag","ginhawaan","ginikanan","ginilayun","gining","gininhawa","ginit","ginitgit","giniya","ginlaw","ginsud","ginta","gintang","ginting","gintingginting","ginuba","ginugma","ginuk","ginukdanay","ginunting","ginusang","ginuu","gip","gip-ut","gipak","gipakaingun naku","gipakaingun ug [gen.] ug","gipakig-an","gipang","gipangunun","giping","giplud","giprap","gipud","gipung","gira","gira patani","gira sibil","girawut","girdul","girilya","girilya mani","girilyiru","girilyista","giring","giringgiring","giripu","girira","girnalda","gisa","gisadu","gisal","gisaldu","gisangkarun","gisantis","gisaw","gisi","gisigisi","gising","gisiun","gislang","gisnga","gist","gist ispikir","gisu","gisuk","gisumban","gisung","giswid","git","git kras","git krasir","gitara","gitarista","gitas-un","gitgit","giti","giti sa imung (iyang) ina","gitib","gitik","gitinggiting","gitkanun","gitli","gitlib","gitpas","gitugitu","gitung","giuk","giut","giwang","giwanun","giwatay","giwaw","giwit","giwitgiwit","giya","giyan","giyaw","glab","gladiyula","glu","glurya","gluryusu","gluryusu nga mistiryu","gn.","gng.","graba","grabadu","grabadur","grabansus","grabi","grabihan","grabihun","gradu","graduwada","graduwadu","graduwar","graduwasyun","graduwisyun","graduwit","grahi","gramatika","gramu","gramus","grana","granada","granati","grandi","granil","graniti","granstan","granu","granu malditu","grap","grap ug (an) kurapsiyun","grapa","grapinyira","grapupunu","grasa","grasahun","grasya","grasyada","grasyas","grasyusa","grasyusu","gratis","gratis it amuri","grawun","grawundid","grayin","grid","gridir","grin","grin dragun","grips","gripu","gris","grispul","grumiti","grupu","grupugrupu","grusiri","grusiriya","grutu","gu","gu signal","guang","gub","gub.","guba","guba ang nawung","gubaguba","gubana","gubat","gubat patani","gubaun","gubhay","gubin","gubirnadur","gubirnaduriya","gubirnu","gubirnu militar","gubirnur","gubuk","gubul","gubut","gubut ang hunahuna","gubut ug palad","gubutgubut","gubyirnu","gubyirnu insular","gubyirnu ribulusiyunaryu","gud","gud mani","gud nayit","gud syat","gugma","gugmagugma","gugmahanun","gugu","gugul","guguls","guha","guhab","guhang","guhay","guhit","guhitguhit","guhu","guitguit","guk-ung","gukam","gukan","gukang","gukdanay","gukdunun","guknat","guku","gukud","gul","gul-anan","gula","gulaanan","gulam","gulaman","gulamgulam","gulang","gulang sa hiktanan","gulangun","gulasiman","gulat","guld","guldigir","guldin syawir","gulgul","gulgulanan","gulhab","gulhu","guli","gulimuk","gulis","guliyang","gulpi","gulpi digulat","gulub","gulubgulub","gulugabii","gulunggulung","gulut","gulutman","gulwa","gum-us","gum-ut","guma","guma nga iskripir","gumaguma","gumahan","gumahun","gumbul","gumbulan","gumikan","gumu","gumudgumud","gumuk","gumun","gumunhap","gun-ub","guna","gunahun","gunas","gunat","gunaw","gundya","gunga","gungahun","gunggung","gungi","gungis","gungut","gunhub","gunit","guns","gunstabulari","gunsung","gunsunggunsung","guntang","gunting","gunting nga ginting","guntudguntud","guntudguntudun","gunu","gunuk","gunung","gunurya","gupak","gupang","gupuk","gupun","guput","gura","gurami","guratsa","guray-ut","guray-utun","gurayan","gurdu","guruguru","gurumiti","gurung","gurunggurung","gurut","gurutgurut","gurutgurutun","guruy","guryun","gus","gus-ab","gus-ap","gusa","gusab","gusang","gusanu","gusar","gusaw","gusbat","gusbatun","gusi","gusla","guslab","gusnik","gustu","gustuay","gustuhay","gusu","gusud","gusugusu","gusuk","gusukan","gusus","gususu","gut","gut-ub","gutab","gutad","gutadgutad","gutang","gutas","gutas amargas","gutay","gutgut","guti","gutiba","gutlab","gutli","gutling","gutlu","gutlu nga luha","gutlub","gutlubgutlub","gutmanun","gutu","gutub","gutubgutub","gutuk","gutukgutuk","gutum","gutus","gutut","guud","guuk","guul","guum","guun","guurun","guut","guwa","guwing","guwing istrit","guy-ang","guyabana","guyabanu","guyam-ut","guyku","guyud","guyuguyu","guyungguyung","guyuran","gwabana","gwantis","gwanu","gwapa","gwapita","gwapitu","gwapu","gwarda","gwarda kusta","gwarda munti","gwardiya","gwardiya kusta","gwardiya sibil","gwardiyadu","gwarnasiyun","gwarni","gwatsi","gwatsinangga","gwatsinanggu","gwatsira","gwatsiru","gwayabanu","gyira","ha","ha ba","ha ha","ha-","haa","haadtu","haagang","haagum","haam-am","haanha","haanhi","haari","haasa","hab","haba","habag","habagat","habagatan","habahab","habak","habal","habalu","habas","habasan","habaw","habay","habhab","habi","habig","habilhabil","habilin","habir sak","habitsuylas","hablanan","habluk","hablun","hablunan","hablus","habu","habubuyna","habug","habug manulti","habug ug pamarug","habuhabu","habuk","habul","habulan","habulhabul","habun","habunira","habuylug","habwa","habwa ang kinaun","habwas","habyug","had","hadag","hadaw","hadigi","hadiyung","hadla","hadluk","hadlukan","hadul-ung","hadung","hadus","haduul","hag","hag-as","hag-ut","hag-utan","haga","hagabhab","hagad","hagakhak","hagal","hagalam","hagalhal","haganas","haganhagan","hagard","hagas","hagashas","hagawad","hagawhaw","hagba","hagbanan","hagbas","hagbay","hagbaya","hagbunan","hagbung","hagdan","hagdan maya","hagdan ug uwak","hagdanan","hagdanhagdan","hagdaw","haghag","hagid","hagikhik","hagilis","hagimit","hagip-ut","hagis","hagit","hagiyung","hagiyus","hagkanan","hagkik","hagkut","hagkut ug kamut","haglihuk","hagmang","hagmangun","hagmata","hagmun","hagmuyu","hagnaw","hagnaya","hagpa","hagpak","hagpat","hagpatiru","hagpik","hagpu","hagsa","hagsak","hagtak","hagtik","hagtub","hagtuk","hagtus","hagu","hagubhub","hagud","hagudila","hagugma","haguk","haguka","hagulhul","hagumaa","hagung","hagunub","hagunus","hagunuy","hagupaas","hagupit","hagurila","hagurub","hagurus","hagus","hagusahis","haguyag","hagwa","hagwasun","hagyung","haha","hahay","hai","hail","hailalum","hain","hain bay","hain bay napula","hain na","hain pay [noun]-un","hait","haiy","hak-ab","hak-abhak-ab","hak-ang","haka","hakab","hakabhakab","hakad","hakalimut","hakap","hakaslabu","hakatawa","hakatulug","hakayhakay","hakbang","hakgum","hakhak","hakimbid","haklap","haklup","hakmal","haknut","hakug","hakugan","hakughakug","hakugun","hakuhak","hakuhaku","hakuka","hakup","hakurat","hakut","hakutanan","hakutun","hakutunun","hakwat","hal-u","hal-up","hal.","hala","halab","halabas","halablan","halabulan","halad","halag","halaghag","halahala","halalum","halambigit","halandumun","halang","halangdun","halanggup","halanghag","halanguhag","halap","halapad","halaphalap","halas","halatagan","halatagun","halawig","halay","halayan","halayhalay","halayhay","halayu","halbu","halhag","halhal","hali","haligi","halihali","halili","halilib-un","halimbawa","halin","halin pa ba","halindanaw","haling","halinub-un","haliphip","halithalit","haliya","halla","halsi","haltir","halu","halu blak","haluag","haluan","haluan tasik","halub","halug","halughug","haluhalu","haluk","halukhaluk","halukhuk","haluksu","halum","halumhum","haluna","halung","halup","halupuwint","halurat","halus","halus dili","halus tanan","halushus","halut","haluthut","halwa","halwan","halwut","ham-ak","ham-ug","hamabaw","hamag","hamangpang","hamayhamay","hambabalud","hambabayaw","hambag","hambat","hambaw","hambil","hambilhambil","hambilika","hambin","hambu","hambubukag","hambubuyna","hambug","hambugira","hambugirit","hambugiru","hambugiruhun","hambugiruun","hambuk","hambun","hamburdyir","hambuy","hami","hamil","hamilhamil","hamili","hamilsing","hamir","hamis","hamisik","hamiun","hamlag","hamlig","hamlug","hamluy","hampak","hampak ang (sa) hangin nga itum","hampang","hampid","hampil","hampilhampil","hampilu","hampul","hampuug","hamtang","hamtung","hamu","hamubu","hamudlay","hamug","hamugaway","hamuk","hamukan","hamukun","hamulag","hamun","hamunada","hamung","hamungalung","hamus","hamutan","hamutang","hamuut","hamuy","hamuy sa tudlu","hamuyhamuy","hamuyu","hamyang","han salut","han-","han-ay","han-grinid","han-uk","han-ukanan","hana","hanab","hanabu","hanagdung","hanap","hanas","hanashanas","hanaw","hanaw sa mapa","hanay","hanayak","hanayhay","hanayun","hanbag","handa","handag","handahanda","handalamay","handalanaw","handalas","handalitik","handamay","handanaw","handay","handbag","handig","handilib-un","handilika","handilitik","handul","handum","handumanan","handumi","handunguy","handuraw","handurawan","handus","hang","hangad","hangag","hangahang","hangak","hangal","hangangha","hangas","hangawa","hangay","hangbat","hangdanan","hangga","hanggab","hanggap","hanggat","hanggaun","hanggaw","hanggrinid","hanggup","hanggus","hanghang","hangin","hanginan","hanginun","hanginun ug utuk","hangir","hangit","hangita","hangitan","hangkab","hangkub","hanglas","hangtud","hangtud [noun]","hangtud sa hangtud","hanguhag","hangul","hangup","hangus","hangut","hangwat","hangyu","hangyu lubu","hangyuanan","hangyuunun","hani","hanib","hanig","hanig sa impiyirnu","hanimun","hanip","haniti","hanlag","hanlas","hanlilibun","hanlilika","hanlilitik","hanlulukay","hansak","hantak","hantakan","hantakanan","hantakiru","hantana","hantatalu","hantatamsi","hantatansi","hantik","hanting","hanting nayip","hantir","hantuk","hantung","hanu","hanubuy","hanugun","hanum-u","hanumdum","hanunum-u","hanut","hanuy","hanyag","hanyu","hap","hapa","hapaag","hapag","hapahayang","hapak","hapas","hapathapat","hapatindug","hapatung","hapaumud","hapaw","hapay","hapdus","hapi","hapihapi","hapihip","hapin","hapit","hapit madugay","hapitanan","hapithapit","hapla","haplak","haplas","haplu","haplus","haplut","hapluy","hapnig","hapnut","hapsa","hapsak","hapsay","hapslip","hapu","hapuhap","hapulas","hapun","hapun na","hapunanun","hapunhapun","hapunis","hapunta","hapunun","hapus","hapuy","hapuyhapuy","hapyud","hara","hara sa panimalay","harab","harabharab","harabi","harabi ditulu","harag","harana","harang","haras","harasharas","harat","haraw","haraw ka-[root]","harayharay","harbas","harbur paylut","hard libur","hardin","hardiniru","hardul","hardwir","hari","hari nga gangis","hari nga lungsud","harianun","harihari","harihariun","harim","harina","harina sa mais","haring gangis","haring lungsud","harining","harsi","harsiya","harug","haruhas","haruhay","harun","harung","harus","haruyharuy","has","hasag","hasagmukuy","hasagmuyu","hasahasa","hasan","hasang","hasang-at","hasangan","hasanghasang","hashas","hasi","hasindiru","hasinta","hasirilsiril","haskan","haskan nga [adjective]-a","haslag","haslir","haslu","hasluhaslu","hasmag","haspi","hasta","hasta labista","hastilan","hasu","hasug","hasugamak","hasuk","hasul","hasul sa katursi","haswa","hasyinda","hat","hat kik","hata","hataas","hatabu","hatag","hatag ug bili","hatag ug dalan","hatag ug katahuran","hataganan","hatagpilaw","hatagunun","hatak","hatan-aw","hatangka","hatankugu","hatapu","hataw","hatawhataw","hatawu","hatay","hatay sa banig","hatdug","hati","hatidlum","hatindug","hatingsi","hatipas","hatiuruk","hatsa","hatsit","hatsuy","hatub","hatud","hatud balay","hatud kawat","hatud sa","hatud sa panan-aw","hatuhatu","hatukma","hatul","hatum","haud","haum","haun","haw-ang","haw-as","hawa","hawa sa","hawak","hawakan","hawakun","hawan","hawanan","hawas","haway","hawaya","hawayan","hawhaw","hawid","hawid sa dunggan","hawid sa pulsu","hawin","hawiranan","hawla","hawlut","hawsir","hawu-","hawud","hawudhawud","hawughug","hawulhawul","hawung","hawus","hawut","hawuy","hay","hay-ad","hay-alay","haya","haya ang bulan","hayabhayab","hayag","hayaghag","hayahay","hayan","hayang","hayang ang kulun","hayang ang paya","hayang ang platu","hayaw","hayblad","hayblarun","haybul","haybulhaybul","haybuy","haydrudyin","haydyam","haydyamp","hayhat","hayhay","hayhil","hayis","hayiskul","hayit","haylu","haypay","hayun","hayung","hayup","hayupan","haywi","haywis","hi","hi hi","hi-","hi-(→)","hi-an(→)","hiadtu","hiagang","hiagum","hiam-am","hianha","hianhi","hiari","hiasa","hiay","hibabuyna","hibag","hibal","hibal-anay","hibalag","hibalay","hibalu","hibangkaagan","hibat","hibaw-anay","hibawu","hibi","hibi dyuti","hibihibi","hibilin","hibilin sa daplin","hibilya","hibiwit","hibubuyna","hibuk","hibul","hibulhibul","hibulung","hibulus","hibun","hibung","hibunghibung","hibus","hibutu","hibuylas","hibuylug","hibyaan sa barku","hid","hid titsir","hidban","hidhid","hidkwartir","hidlaw","hidlayin","hidlayit","hidul-ung","higa","higad","higal","higala","higalam","higam","higanti","higantihiganti","higantihun","higasbut","higaw","higawad","higayun","higda","higda lang ug magdaut","higda nga magkaun (nagkaun)","higda sa bahandi","higda sa banig","higdaanan","higku","higmata","higmuyu","higpit","higtanan","higugma","higugmaay","higup","higupan","higupanan","higus","higut","higut sa pilitina","higut sa trabahu","higwaus","hihin","hihuba","hik","hikabhikab","hikad","hikadhikad","hikalimut","hikap","hikap sa dili hilikapun","hikap sa lubut","hikap ug tubig","hikaphikap","hikat","hikatawa","hikatulgan","hikatulug","hikaw","hikawan","hikay","hikdat","hikihiki","hikimbid","hikislabu","hiklad","hiklin","hikling","hikluhiklu","hiknat","hiknit","hiktarya","hiktin","hikug","hikuhiku","hikuka","hikum","hikurat","hikut","hikutadu","hikutar","hikuy","hikyad","hila","hilab","hilabian","hilabihan","hilabihanay","hilabtanun","hilabut","hilada","hiladur","hilahila","hilak","hilakhilak","hilam","hilam-us","hilam-usanan","hilambigit","hilamun","hilan","hilanat","hilanatun","hilang","hilangyud","hilantan","hilap","hilas","hilas nang nawung nimu","hilaw","hilaw nga ayis","hilawas","hilay","hilayu","hilbas","hilhig","hilhil","hilibis","hilig","hilihud","hilikayun","hilikuptir","hilimasaw","hilinawan","hiling","hilipusun","hilira","hilirgan","hilis","hilisgutan","hilit","hilmit","hilmithilmit","hilt sintir","hilu","hilu dikarita","hilu nga pinalus","hiluan","hilug","hilug sa himalatyun","hiluksu","hilum","hilumun","hiluna","hilurat","hilus","hilut","hiluwas","hiluy","hilwas","him-an(→)","himabaw","himabay","himabayi","himag","himagsak","himakang","himalad","himalang","himalatyun","himaling","himalingka","himalising","himalit","himalitan","himalta","himalu","himamat","himan","himangnu","himangpangun","himangud","himanhiman","himantayun","himarat","himaraut","himasa","himasaw","himasmu","himat-an","himatayun nga bulan","himatiis","himaya","himayi","himba","himbangkaagan","himbay","himbayhimbay","himbis","himi","himian","himidya","himidyaan","himihimi","himil","himilhimil","himili","himilian","himilu","himisik","himisung","himnu","himpit","himpus","himsug","himu","himu nga","himudlay","himughat","himugna","himugsu","himukas","himukug","himul","himulag","himulak","himulalung","himulas","himulaut","himulbul","himulbul ang swildu","himulig","himulsu","himulus","himulylas","himunga","himungaal","himungahun","himungalung","himungaun","himungawung","himungaya","himungsiyu","himungtud","himungut","himuntug","himurids","himus","himusak","himusud","himut-uk","himuta","himutaan","himutakal","himutang","himutu","himuut","himuylas","himuyu","hin-","hin-an(→)","hin.","hinabang","hinabang nga sibika","hinabdus","hinabhab","hinabi","hinabluk","hinablus","hinabu","hinag","hinag-an","hinaganas","hinagawhaw","hinagbu","hinagbung","hinagdawan","hinagdung","hinagiban","hinagsa","hinagtik","hinaguran","hinagurus","hinahin","hinai","hinaklid","hinalaga","hinalam","hinalanggup","hinalangpun","hinalaran","hinalu","hinam","hinambid","hinambug","hinambuy","hinamhinam","hinampak","hinampak sa hangin","hinan-aw","hinan-ay","hinana","hinanali","hinandum","hinangal","hinangiban","hinangkan","hinangup","hinangyuan","hinanib","hinanuk","hinapaw","hinapay","hinapi","hinapit","hinapuhap","hinapun","hinapus","hinas","hinasa","hinashasan","hinasuy","hinatag","hinatagan","hinaut","hinaut nga","hinaut unta","hinaw","hinawan","hinawat","hinaway","hinawayun","hinawnaw","hinay","hinay ug lihuk","hinayak","hinayan","hinayawan","hinayhay","hinayhinay","hinayun","hinda","hindaanan","hindang","hindian","hindik","hindikan","hing-an(→)","hingabsin","hingadlawan","hingag","hingahinga","hingak","hingalan","hingalhingal","hingan","hingandar","hingangha","hingangkan","hingangkun","hingaphingap","hingapin","hingari","hingasaba","hingatag","hingatawa","hingatulgun","hingatuli","hingatulugun","hingaun","hingawa","hingayat","hingbangkaagan","hingbis","hingbisun","hinggan","hinghapun","hingi","hingigu","hingihingi","hingiki","hingilay","hingilid","hingilin","hinginum","hingita","hingiting","hingkud","hingkud ang salabutan","hinglabihan","hinglakat","hinglit","hinglu","hingmama","hingpit","hingpit nga babayi","hingu","hingudtu","hingugmu","hinguha","hinguhaw","hinguk","hinguku","hingulalag","hinguli","hingulud","hingunas","hingus","hingushingus","hingusi","hingusig","hingusug","hingut-anay","hingutang","hingutas","hingutu","hinguy","hingwinta","hinhin","hinibra","hinigtag lanut","hinigtan","hinigugmaay","hinigulang","hinigut","hinikawan","hinikay","hiniksik","hinilak","hinilakay","hinilibis","hinilisan","hinilus","hinimbang","hinimbu","hinimu","hinin","hininawan","hiningulian","hininugun","hiniral","hiniru","hinis","hinis sa tubu","hiniti","hiniwa","hinlas","hinlawan","hinlit","hinlu","hintil","hintulhintul","hinu","hinuba","hinubay","hinubig","hinubigan","hinubra","hinubuan","hinubug","hinug","hinug ang ulu","hinug-u","hinugalbung","hinugan","hinugas","hinugay","hinugid","hinugilun","hinugmad","hinugun","hinuk","hinukad sa ginhawaan","hinukit","hinuklug","hinuktuk","hinukud","hinul","hinulaman","hinulhan","hinulipas","hinulsul","hinultihun","hinultul","hinulung","hinuma","hinumdum","hinumud","hinumulan","hinunat","hinunga","hinungatunga","hinungaw","hinungdan","hinungdanun","hinunua","hinunuk","hinurut","hinusayan","hinutdanay","hinuun","hinyu","hip","hip-ut","hipahayang","hipalag","hipanhipan","hipatindug","hipatung","hipaumud","hiphip","hiphipan","hipi","hipi dibyahi","hipihip","hipli","hiplig","hiplus","hiplut","hipnu","hipsut","hipun","hipunta","hipus","hipus ug nawung","hipusanan","hipushipus","hipusun","hipusunun","hir pulir","hirada","hirag","hiral","hiram","hiraminta","hiramintas","hiramyinta","hiramyintas","hirbabuyna","hirbubuyna","hirbularyu","hirdu","hirig","hiringga","hiringgilya","hiringgiru","hiringhiring","hirit","hirniya","hiro tiligrapiku","hirpin","hirsayans","hiru","hiru pustal","hiru tiligrapiku","hirushirus","hisa","hisagmukuy","hisagmuyu","hisang","hisang-at","hisgut","hisgutanan","hisi","hisinta","hislung","hislut","hisu","hisugamak","hisukristu","hisupu","hisus","hisusmaryusip","hiswita","hiswitas","hit","hit-anmis","hit-anran","hitabu","hitad","hitagpilaw","hitak","hitakhitak","hital","hitalay","hitalunung","hitan-aw","hitangka","hitankugu","hitapu","hitawu","hitidlum","hitindug","hiting","hitinghiting","hitingsi","hitipas","hitiuruk","hitsas","hitsu","hitsu diritsu","hitsura","hitsuraan","hitsurahan","hitudhitud","hitukma","hiubus","hiusa","hiwa","hiwaanan","hiwal","hiwalhiwal","hiwasa","hiwatid","hiwaus","hiwi","hiwid","hiya","hiyak","hiyas","hiyawasa","hiyuba","hiyud","hiyudhiyud","hiyum","hiyumhiyum","hiyung","hiyunghiyung","hiyungun","hiyus","hiyut","hmm","hmp","hu","hubad","hubad ug damgu","hubadhubad","hubag","hubag ang pusud","hubag sa babuy","hubak","hubakun","hubas","hubashubas","hubaw","hubawhubaw","hubganun","hubhub","hubit","hubkas","hublag","hublut","hubu","hubu sa katungdanan","hubu sa santu ninyu","hubug","hubughubug","hubuhubu","hubun","hubung","hubunhubun","hubut","hubuy","hubuyhubuy","hubya","hubyas","hud","hudas","hudhud","hudir","hudiya","hudiyaka","hudiyu","hudlat","hudnu","hudnuhan","hug","huga","hugadu","hugadur","hugalbu","hugalbung","hugalbut","hugan-ub","hugangkul","hugar","hugas","hugasan","hugasun","hugaw","hugaw sa lalaki","hugaw ug batasan","hugawan","hugawhugaw","hugay","hugayaw","hughug","hugita","hugkal","hugkas","hugkat","hugmad","hugna","hugnahugna","hugnu","hugpa","hugpit","hugpung","hugpuy","hugsaw","hugu","hugung","hugunghugung","hugunhugun","hugup","hugus","hugushugus","hugut","hugut ang","hugut ang batingting","hugut ang puasa","hugut sa bakus","huguy","huguyhuguy","hugyaw","hugyun","huhu","huhungihung","huk","huk an ay","huka","hukab","hukabhukab","hukad","hukad sa ginhawaan","hukahuk","hukal","hukas","hukashukas","hukaw","hukbalahap","hukdung","hukhuk","hukhukira","hukhukiru","hukihuk","hukip","huklub","hukmanan","hukmanan sa unang lakbang","hukmuy","huks","hukuhuku","hukum","hukut","hukyaw","hukyaw ang dughan","hul-ap","hul.","hulab","hulabun","hulad","hulagway","hulahula","hulahup","hulak","hulam","hulamanan","hulangyud","hular","hulas","hulat","hulatanan","hulaw","hulay","hulaya","hulaya laki","hulba","hulbad","hulbaw","hulbu","hulbut","hulbut sinaw","hulbuthulbut","huld-ap","huld-apir","huldam","hulding","huldir","hulga","hulhug","hulhul","huli","hulibis","hulihud","hulikab","hulin","huling","hulip","hulipanan","hulma","hulmahan","hulmahanan","hulmigas","hulmigasan","hulpa","hulsil","hulstir","hult","hulu","hulud","hulug","hulug sa kamut","hulughulug","hulum","hulungawan","hulunghulung","hulungihung","hulup","hulus","hulut","huluy","hulyu","hulyut","hum","humabdus","humablus","humabus","humad","humagbus","humahabhab","humahangbat","humalatag","human","humanan","humanhuman","humay","humay sa bantuk","humayan","humayanun","humayhumay","humayunun","humba","humbingay","humbingil","humbis","humdunun","humhum","humigas","humil","humisayid","humisayid pulis","humpal","humpay","humpid","humpil","humran","humrum","humrum pitii","humstid titulu","humtawun disisyun","humud","humud ug papil","humuk","humuk ug ilung","humukun","humul","humulhumul","humut","humutan","humutun","hun","hun-ag","hun.","hunad","hunahuna","hunas","hunasan","hunasun","hunat","hunaw","hunda","hundunghundung","hungakhungak","hungaw","hungawanan","hungay","hunggal","hunggaw","hunghung","hungihung","hungit","hungkad","hungkag","hungkagul","hungkarul","hungkiyang","hungkung","hunglus","hungu","hungug","hungus","hungut","hunguy","hunhun","huni","hunit","hunitun","hunlak","hunlus","hunsuy","hunsuy nga muiti ug mani","hunsuyhunsuy","hunta","hunta diriktiba n","hunta munisipal","huntahunta","hunub","hunulhunul","hunung","hununganan","hunus","hunushunus","hunyu","hup","hup-ak","hupa","hupak","hupas","hupaw","hupay","huphup","huping","hupit","hupu","hupukhupuk","hupung","huput","hupuy","hupya","hupyak","hurabhurab","huradu","hurahura","hural","huraminta","huramintadu","huramintu","hurar","hurat","huraw","hurawhuraw","hurawhurawan","huriki","hurimhurim","hurisdiksiyun","hurnada","hurnal","hurnu","hurs","hurspawir","huruhuru","hurung","hurus","hurut","hus","husa","husay","husayunun","husgadu","husgar","hushus","husi","husla","huslir","huslu","huslut","huspital","hustis","hustisya","hustiyas","hustu","hustu sa karga","hustu sa kulu","husu","husud","huswa","huswa ang katahum","hut","hut-ung","huta","hutak","hutay","hutba","hutbaw","hutdanay","huthut","hutik","hutikay","hutil","hutinani","hutluk","huts","hutuhut","hutukhutuk","hututay","hutuy","hutwang","huum","huung","huut","huwa","huwa-","huwad","huwag","huwaghuwag","huwan","huwan dila krus","huwan pusung","huwap","huwaranan","huwas","huwasay","huwasu","huwat","huwatid","huwi-","huwis","huwis dikutsilyu","huwis dipas","huwis diprimir istansiya","huy","huy-ab","huyad","huyami","huyang","huyatid","huybis","huybis santu","huygu","huygu tudu","huyhuy","huypanay","huyu","huyuhuy","huyung","huyunghuyung","huyup","huyut","hwasa","hwisyu","i","i i","i midiya","i nga gahi","i nga humuk","i-","i-(←)","i-[verb]","iasa","iba","iba sa insik","ibabaw","ibabaw sa kamay","ibakwisyun","ibakwit","iban","ibanan","ibang","ibanghilista","ibanghilyu","ibapurada","ibat","ibay","ibi","ibid","ibid-ibid","ibidinsiya","ibingan","ibinrud","ibis","ibit","ibud","ibug","ibug-ibug","ibul","ibus","ibut","ibutang sa lugar","ibutang ta","ibyuk","ibyus","id-id","ida","idabwilta","idad","idad nga makalilinga","idad-idaran","idag","idang","idar-idar","idaran","idibul","idibul uwil","idintipikasiyun","idipisyu","idisyun","iditing","iditur","idituryal","idituryal adbaysir","idiya","idiyuluhiya","idlas","idlut","idru","idru nga bayut","idruhina","idruidru","idruplanu","ids","idukada","idukadu","idukadur","idukar","idukasya","idukasyun","idulu","idung","idyaidya","idyaidya ahuahu","idyap","idyaw","idyuk","idyukisyun","idyus","ig-","ig-agaw","ig-agaw igtagsa","ig-agaw igtagurha","ig-agaw igtagutlu","ig-agaw sa kasingkasing","ig-alanak","ig-amgid","ig-anak","ig-ig","ig-l-","ig-r-","ig-unsa","iga iga","igad","igagaw ug ikatrayinta idus ug tunga","igaiga","igalagil","igalayam","igang","igapugas","igat","igatun","igbabayad","igbahu","igbahu nga paryinti","igbalayad","igbaw","igbitir","igbubulang","igbubumba","igbululang","igdadapat","igdadaru","igdadaut","igdal","igdalaru","igdalaut","igdalun","igdudugang","igdulugang","igdulungug","igdungug","ighahatag","ighahatud","ighahatud sa mintiryu","ighalatag","igham","ighihingulud","ighiligut","ighilingulud","ighuhungit","ighulungit","igi","igihan","igiik","igik","igip","igit","igit ra","igka-","igkam","igking","iglabut","iglalangkit","iglilimpiyu","iglisya","iglisya ni kristu","iglisya pilipina","igmanghud","igmat","ignu","ignudul","ignuramus","ignuranti","ignuy","igpalahulay","igpangaasawa","igpapahulay","igpulugas","igpulusta","igpupugas","igpupusta","igput","igput-igput","igputul","igputul ug tinai","igsaktu","igsalanduk","igsilikdu","igsilimba","igsirsayis","igsu","igsulula","igsulumpa","igsumpay","igsusugid","igsuun","igsuun sa inahan","igsuun sa ngalang igsuun","igtagsa","igtagurha","igtalan-aw","igtalari","igtam","igtatan-aw","igtatari","igu","igu [dat.]","igu na man","igu nga","igu ra","igu rang gunit sa dalunggan","igu rang ipanghingiki","igu rang nakagunit sa dunggan","igu sa pana","igu sa pana ni kupidu","igulukay","iguluran","igurut","igut","igut-igut","igutul","iguuliay","iguuran","igwad","igwad-igwad","igwalis","igwit","igwitira","iha","iha dibastarda","iha miya","ihada","ihadu","ihalas","ihalasun","ihap","ihap sa lakang","ihap sa tudlu","ihari","ihas","ihas di karidad","ihaw","ihawanan","ihayup","ihi","ihi ug iru","ihid","ihiihi","ihikutibu","ihim","ihimplu","ihiptu","ihirsisyu","ihirsitu","ihirsitus","ihu","ihu dibastardu","ihu diputa","ihud-ihud","ihung iringun","ihuy","ii","iitu","ik","ik-ik","ika-","ikaalas","ikaduha","ikag","ikapamista","ikapila","ikapitu","ikapitung langit","ikapulu","ikasuga ang ihi","ikasuruy","ikat","ikatulu","ikaupat","ikaw","ikaw karun","ikaw lang","ikaw ra","ikawalu","ikgam","ikganun","ikging","ikibali","ikid","ikid-ikid","ikipahi","ikipu","ikis","ikit","ikit-ikit","iklas","iklipsi","iklisyastiku","ikman","ikmat","iknat","iks","iksahirada","iksahiradu","iksaktu","iksam","iksamin","iksaminadu","iksaminadur","iksaminisyun","iksampul","iksibisiyun","iksibit","iksihidu","iksihir","iksilinti","iksilsiyur","iksima","iksimtid","iksirsayis","iksit","iksitan","ikskambik","ikskiyus","ikskursiyun","ikskursiyunista","ikspan","ikspandir","ikspidisyun","ikspild","ikspirimin","ikspirimintu","ikspirinsiya","ikspirinsiyadu","ikspirmin","ikspirmintu","ikspirtu","ikspiryinsadu","ikspiryinsyadu","iksplikar","iksplurasiyun","iksplusibu","ikspris","ikspurtadur","ikspus","ikspusisiyun","iksri","ikstin","ikstinsiyun","ikstiriyur","ikstra","ikstra bagids","ikstralards","ikstriyul","ikstriyur","iktarya","iktin","iku","ikud","ikud-ikud","ikug","ikug-ikug sa iring","ikugan","ikunumika","ikunumiya","ikus","ikut","ikut-ikut","ikwadur","ikyas","ikyut","ila","ila ka [name]","ila ug ginuu","ilab","ilabi na","ilabihan","ilad","ilada","iladu","iladur","ilag","ilaga","ilaga sa urupa","ilagailaga","ilaha","ilahan","ilahanun","ilaid","ilaid sa kawad-un","ilaila","ilak","ilalum","ilang-ilang","ilap","ilas","ilawud","ilaya","ilayanhun","ilbu","ilhanan","ili","ilibitur","ilibitur buy","ilidyibul","ilidyitimit","ilig","iligal","iligal pusisiyun","iligan","iliganti","ilihan","ilik","ilikgan","iliksiyun","iliktrik","iliktrik ayurn","iliktrik istub","iliktrik tsir","iliktrisidad","iliktrisyan","iliktruniku","iliktur","ilikturada","iliktural","ilimintari","ilimintarya","ilimintu","ilimnan","ilimnanan","ilimnun","ilin-ilin","iling","ilipant wuk","ilipanti","ilipanti nga laki","ilis","ilisan","ilisdan","ilisdi","ilisi","ilisipan","ilitirit","ilitsu dibilin","iliw","ilmundu","ilpuwiblu","iltur","ilu","ilu nga tulapus","ilub","ilug","ilug sa bandira","ilug sa yawa","ilug ug lugar","ilugan","ilugun","iluhan","iluk","ilukanu","iluku","ilukus","ilun-ilun","ilung","ilungan","ilungga","ilunggu","ilustrada","ilustradu","ilut","ima","imabaw","imahin","imakulada kunsipsiyun","imas","imat","imbahada","imbahadur","imbalidu","imbalsamadu","imbalsamadur","imbalsamar","imbargu","imbasyun","imbaw","imbaw sa bunbun","imbay","imbintu","imbis","imbistigadur","imbistigar","imbistigasyun","imbitadu","imbitar","imbitasiyun","imbraimatsu","imbudu","imbukar","imburnal","imburu","imbus","imbuyis","imbyirnu","imi","imigrant","imirdyinsi","imirdyinsi mani","imirhinsiya","imiri","imiri bag","imit","imitasiyun","imitisyun","imnanan","imnu","imnunun","impaki","impaktu","impanada","impantil","impantil biribiri","impantiriya","impas","impas tibawas","impas tudas","impati","impatsu","impatsu sa sabun","impi","impiksiyun","impiktu","impilya","impilyahun","impiradur","impiratris","impirdibli","impirmariya","impirmarya","impirmu","impirnu","impiryu","impisar","impisi","impitu","impiyirmu","impiyirnu","implimintar","impliyada","impliyadu","impliyar","impliyu","impluwinsa","impluwinsiya","imprinta","imprintahan","imprisaryu","imprumtu","impuntu","impurmal","impurmasiyun","impurtansiya","impurtanti","impurtasiyun","impurti","impurtid","impusibli","impuy","impyirnu","imraimatsu","imsi","imu","imu na","imu) lamang","imuha","imuimu","imuimu lang","imulsiyun","imung","imurahiya","imuralidad","imut-imut","imyus","in","in-anay","in-grandi","in-gratu","in-gridiyinti","in-grisu","ina","ina nga [vegetable]","inaan","inabaniku","inadlaw","inadlawan","inagay-ay","inagrisibu","inagurar","inagurasiyun","inahan","inahan nga buhatan","inaina","inalba","inalig-igay","inalisngaw","inalsa","inamakan","inamang","inamil","inamirikanu","inampingan","inampityatru","inamyat","inanag","inanak","inanay","inani","inantigu","inanu","inartista","inaryat","inasal","inasgad","inasin","inat","inatu","inaun","inaw","inawgura","inawugan","inay","inayan","inayran","inbiay","inbitisyun kard","inburd","inbuyis","indak","indaksiyun","indaksiyun bul","indakting upisir","indangan","inday","inday-inday","indibag","indibi","indig","indigay","indihistiyun","indikasiyun","indilibli","indimunyadu","inding","indipindinsiya","indipindinti","indipindiyinti","indipirinti","indiriktaminti","indispir","indiya","indiya ingk","indiyan","indiyan hid","indiyan pana","indiyu","indulhinsiya","indung","indunu","indur","industriya","industriyal","indyiksiyun","indyuy","ing","ing-iing","ing-ing-ing","inga","ingahay","ingat","inggansa","inggarasya","inggasti","inggit","ingglis","inggrandi","inggrasadur","inggrasya","inggrata","inggratu","inggrisu","inggwintu","ingit","ingk","ingkahi","ingkantada","ingkantadu","ingkantu","ingkantuhanun","ingkarga","ingkargada","ingkargadu","ingkargu","ingkarids","ingkasu","ingkasu ug","ingkib","ingkit","ingkitadur","ingkitadura","ingkitar","ingku","ingkud","ingkug","ingkurdun","ingkuwintru","ingkuy","inglatira","ingli","inglis","inglis ispiking","ingug","ingun","ingun ka-[adjective] sa","ingun man","ingun ngari","ingun sa [sentence]","ingun sa pag-unsa","ingun-ingun","ingung ku","ingus","ingus-ingus","inhilir","inhiniriya","inhinyiriya","inhinyiru","inhinyiru miniru","inhinyiru sibil","ini","inibut","iniduru","inig-","inigat","inigka-","inigkaingun] — ugma","inigsuun","inigwad","inihaw","iniksiyun","iniktan","iniktin","inila","inilug","inilugan","inilukanu","inilus","inima","ining","ininglis","iningun","ininsik","iniras","inirisan","iniru","inislagan","inispada","init","init ang kwarta","init ang kwarta sa kamut","init ug dugu","initay","initlug","initun","iniwagan","inkahi","inkargadu","inkargu","inklinar","inklusu","inkuwintru","inkyubitur","inlards","inlardsir","inpisi","inpuntu","inpurmir","inri","inruk","inruki","inrul","inrulmin","inrulmint","insalada","insayid","insayid dyab","insayklupidya","insaymada","insayu","insayuhan","insayuhanan","insi","insigniya","insik","insik tsibay","insik wakang","insika","insiktu","insikun","insima","insimada","insinsaryu","insinsu","insisaryu","insistir","insiyur","insiyurd","inspiksiyun","inspiktur","inspiktur sa sanidad","inspiradu","inspirar","inspirasiyun","instalar","instalasiyun","institiyut","institusyun","instraktur","instruksiyun","instrumintal","instrumintu","instul","instulmin","instulmint","insular","insultadur","insultu","insumada","insumniya","insuriktu","insuriktus","insuy","intabladu","intap","intawun","intil","intilhinti","intilihinti","intimanu","intinsiyun","intir kurs","intirbinir","intirbintur","intirbiyu","intiris","intirisadu","intirisis","intiriyur","intirmidiya","intirmidiyu","intirmisyun","intirn","intirna","intirnal","intirnal himurids","intirnasyunal","intirnu","intirpriti","intirpritir","intiru","intiru adlaw","intiru bulan","intiru gabii","intiru kwirpu","intiw","intiyiru","intra","intrabinus","intrabudyus","intrada","intrada hiniral","intrans","intrans iksaminisyun","intranti","intri","intribinir","intribista","intribudyus","intriga","intrigadu","intrigar","intrigu","intrimitida","intrimitidu","intrimitir","intripiti","intrisadu","intrisali","intriyul","intriyur","intru","intrubudyus","intrudyus","intrunisar","intrunisasiyun","intsards","intunsis","intus","intusan","intuy","inubanan","inubrahan","inuduru","inugsad","inugurasiyun","inuinu","inulian","inulu","inulug amu","inuluhan","inulung","inum","inuman","inumul","inun-an","inun-un","inun-unan","inunay","inundangan","inundangan nga swildu","inungaban","inungaran","inunlan","inupa","inupahan","inupung","inuras","inusara","inusaranhun","inusdak","inusinti","inusintis","inuslan","inuslan nga batasan","inusngaran","inut","inut-inut","inutan","inutaw","inutil","inutluban","inutuk","inyam","inyiksiyun","inyu","inyuinyu","ip buy","ip lay","ip-is","ipainit","ipak","ipi","ipidimya","ipik","ipikasint","ipikasint uwil","ipiktadu","ipiktar","ipiktibu","ipiktu","ipiktus","ipil","ipil-ipil","ipiliptiku","ipis","ipisanan","ipistula","ipit","ipli","iprun","ipsut","ipu","ipukrita","ipukritu","ipun","ipus","ipus-ipus","iputika","ir5","irad","irag","iraid","iras","irasan","iray","irbabuyna","irbras","irbubuyna","irbularyu","irgat","irgu","irgu trit","irgutina","iri","irid","irid syiltir","iridar","iridira","iridiru","irigar","irigasiyun","irigular","irihinsiya","irihis","iring","iring-iring","iringun","irinsiya","iris","iriser","irisipilas","irispunsabli","iritar","iritasiyun","irkun","irkundisyun","irkundisyunir","irmad","irmana","irmana mayur","irmanu","irmanu mayur","irmanus","irmat","irmil","irmitanyu","irniya","irpad","irpakit","irpap","irpat","irpun","irpurt","irsisyu","iru","iru nga daug","irug","iruiru","iruiruay","iruk","is-is","isa","isa ka run","isab","isang dakut na bigas","isda","isda sa batu","isda sa hapun","isda sa insik","isda sa mintiryu","isdaan","isdaanun","isdug","isdyi","isi","isi riturn","isig","isig (isig) usa","isig [verb base]","isig ka [noun]","isig-isig","isig-isigun","isiisi","isina","ising-ising","isip","isip [number]","isipan","iskabitsi","iskala","iskalanti","iskalar","iskalarsyip","iskalipsi","iskalira","iskalira plasis","iskalira ruyal","iskalitur","iskandalu","iskandalusa","iskandalusu","iskapadur","iskapal","iskapar","iskaparati","iskapaturya","iskapu","iskapularyu","iskarp","iskats","iskats tip","iskawut","iskawut lidir","iskay is da (di) limit","iskidyul","iskilibinti","iskilipsi","iskilitun","iskina","iskinadu","iskinita","iskiping rup","iskir","iskirima","iskirul","iskiyus","isklibinti","isklimintar","isklipsi","iskrab","iskrabul","iskram","iskrats","iskrats pipar","iskriba","iskribanu","iskribinti","iskribyinti","iskrima","iskrimadur","iskrimintar","iskrin","iskrip","iskripir","iskrituryu","iskru","iskru draybir","iskuba","iskuba nga kilayan","iskuhidu","iskuhir","iskular","iskulbus","iskulsuplayis","iskultur","iskupidur","iskupita","iskur","iskur burd","iskurir","iskuriya","iskursiyun","iskurt","iskusya","iskutinyu","iskutir","iskuwadrun","iskuwala","iskuwala nga balay","iskuwat","iskuwat dyamp","iskuwatir","iskuwir","iskuwir bab","iskuyla","iskuylahan","isla","islag","islagan","islaks","islang","islaw","islawan","islayding","islayid","islayid rul","islayis","isliblis","islindir","islu drag","isluput","ismagling","ismaglir","ismagul","ismart","ismarti","ismayling","ismayling burnay","ismilir","ismiril","ismiringhuy","ismugul","ismul batiri bul","isnatsir","isnikir","isnu","ispada","ispada disambuwangga","ispada diuru","ispada nga isda","ispadil","ispaghiti","ispaltu","ispanis","ispanis lis","ispaniyul","ispansbat","ispanta","ispanya","ispanyula","ispanyulis","isparing","isparing partnir","ispark plag","ispasyu","ispat","ispatir","ispatlayit","ispayik","ispayral","ispid","ispidbut","ispidnu","ispihu","ispiking","ispikir","ispiksiyun","ispiktur","ispiling","ispir","ispira ultima","ispira unmumintu","ispiragus","ispiraltima","ispiransa","ispirit","ispirit ab amunya","ispirit ub di glas","ispiritista","ispiritu","ispiritu dilimun","ispiritu malignu","ispiritu santu","ispirituhanun","ispirma","ispisiyal","ispisiyal dilibiri","ispisu","ispisu nga [noun]","ispisu ug apdu","ispisu ug dugu","ispisu ug hambug","ispisyal","ispisyal minsiyun","ispisyalista","ispiya","isplikar","isplikasiyun","isplikatut","isplit","ispri","ispri nit","ispringpild","ispuksib","ispuku","ispuku ug","ispukuy","ispungha","ispunghadu","ispunghar","ispunghawu","ispunsur","ispur is","ispurt","ispurts kar","ispusa","ispusu","isputing","ispuwil","ispuwild","israylitas","ist","istabiyin","istablisar","istablisimintu","istadista","istadiyum","istadu","istadus unidus","istak","istak huldir","istak-ap","istaka","istaking","istakings","istakul","istalar","istalasiyun","istambay","istambayan","istampa","istampar","istampita","istan","istanbay","istandar","istandard","istandarti","istanding","istansa","istanti","istanyu","istap","istapa","istapadur","istapbul","istar","istar dansir","istarim","istaring","istartir","istasiyun","istasiyunan","istatik","istatistika","istatuwa","istayil","istaylis","isti","istibidur","istidi","istigi","istigi santu","istikin ap","istikinap","istikir","istilitu","istilmating","istilmit","istilu","istilwul","istima","istimar","istimasiyun","istimit","istinsil","istinu","istinugrapir","istip","istip-in","istipburd","istiping","istiplir","istipul","istiril","istirilayis","istiryu","istiryu punu","istisyun wigun","istits","istitsayid","istituskup","istityu","istityu dans","istiyudint","istraglir","istranghiru","istranyu","istrap","istrayik","istri","istribilyu","istribu","istribur","istrikta","istriktu","istrilya","istrilyadu","istrilyawu","istrilyita","istrimlayin","istrit","istritbul","istritkat","istritsabul","istritsibul","istritsir","istru","istru bag","istrubiri","istruk","istruki","istruking","istruksiyun","istrungkadur","istrungkar","istrupa","istu is","istub","istudiyanti","istudiyu","istukada","istuki","istula","istumagu","istupa","istupadu","istupadu nga lansang","istupida","istupidu","isturbu","isturya","isturyadur","isturyahanay","isturyahay","isud","isug","isug ug dugu","isul","isulud sa bulsa","iswag","iswid","iswim","iswis","isyu","it-un","ita","itaas","itad-itad","itay","itbi","itgam","iti","iti ug langgam","itiiti","itik","itik-itik","itikan","itikita","itip","itir","itirinaryu","itlib","itlib ug asin","itlug","itluganan","itman","itnib","itsa","itsa puyra","itsa sa kalu","itsa sa tualya","itsa ug tualya","itsaitsa","itsar","itsas","itsay","itsiban","itsu diritsu","itsus","itsuy","itu","ituhun","ituk","itum","itum nga hangin","itum ug dila","itum ug kasingkasing","itum ug tanlag","itumun","itumun ug dila","itung","itus","itus-itus","itusan","itut","ituy","ituy-ituy","iwa","iwad","iwag","iwang-iwang","iwas","iway","iway sa kadaut","iwigik","iwik","iwit","iya","iya na lamang","iya ra","iya ra di manakud","iyaan","iyaan sa pag-agawan","iyagak","iyahay","iyaiya","iyak","iyak-iyak","iyang","iyang lagus","iyang unud","iyasa","iyat","iyawan","iyawat","iyay","iyu","iyu hantuy","iyukaristiku","iyurupa","iyut","iyut ta","ka","ka naku","ka ug","ka-","ka-[adjective]","ka-an","ka-an (←)","ka-un","ka-un(→)","ka-unun(→)","kaabag","kaabin","kaabiyunan","kaabu","kaabug","kaadilantuhan","kaadlawan","kaadlawun","kaadtuun","kaag","kaagi","kaaginhun","kaaguman","kaaksidu","kaakuhan","kaalagaran","kaalam","kaalampad","kaalayun","kaaligutgut","kaalimatuk","kaalingasa","kaambung","kaamgid","kaamursiku","kaamyun","kaang","kaangayan","kaanghit","kaangkaang","kaangsu","kaanhaun","kaanhiun","kaanib","kaanyag","kaapingan","kaaru","kaat","kaata","kaatbang","kaaway","kaayu","kaayuhan","kab iskawut","kab-anan","kab-ang","kab-ay","kab-ing","kab-it","kab-ut","kaba","kababayin-an","kababil","kabad","kabag","kabag-uhan","kabaghak","kabagulan","kabahan","kabahin","kabahinanan","kabahiru","kabahu","kabahung","kabahungun","kabakaba","kabakas","kabakildan","kabaknitan","kabal","kabal-anan","kabalag-un","kabalas","kabalawan","kabalayan","kabalhinan","kabalilinhan","kabalinsungag","kabaliti","kabalu","kabalungga","kabalyiriya","kabalyiru","kabalyiti","kabalyu","kabalyus","kaban","kaban mundu","kabana","kabanay","kabanayan","kabang","kabanga","kabangahan","kabangian","kabangkaagan","kabanha","kabanikahan","kabanis","kabankaban","kabansag","kabantung","kabarit","kabaritira","kabarkada","kabaryu","kabasahun","kabasi","kabat","kabat-ul","kabata","kabataan","kabataang makabayan","kabatan-un","kabati ug bagting","kabatinggulan","kabatkabat","kabaw","kabawkabaw","kabayaran","kabayatbayat","kabaybayunan","kabayru","kabayu","kabayu sa dagat","kabayu sa daru","kabayukabayu","kabayuun","kabdus","kabgan","kabhang","kabi","kabiba","kabibat","kabibit","kabig","kabikab","kabikag","kabikusbikus","kabil","kabila","kabilaan","kabilaw","kabildu","kabilduhay","kabilin","kabilinggan","kabilingganun","kabiliti","kabilkabil","kabilunun","kabilusu","kabilya","kabin","kabingkilan","kabinit","kabir","kabirkabir","kabisa","kabisa dibaranggay","kabisa sa baryu","kabisada","kabisadu","kabisay-an","kabisdak","kabisilya","kabisira","kabit","kabkab","kabkab sa","kabkabay","kabli","kabligrama","kabling","kablit","kabra","kabtang","kabtangan","kabting","kabu","kabu nigru","kabuang","kabubut-un","kabud","kabudlay","kabuduk","kabug","kabug-atun","kabug-us","kabug-usan","kabugasun","kabugaw","kabugul","kabugwasun","kabuhi","kabuhiun","kabuhunbuhun","kabuhung","kabukabu","kabukabuhun","kabukaw","kabukidan","kabukilan","kabukiran","kabukugan","kabulahanan","kabulak","kabulakan","kabulakay","kabulay","kabulig","kabulung","kabulusgun","kabulwang","kabunghan","kabungturan","kabuntagun","kaburata","kabus","kabus-uk","kabut","kabutan","kabutang","kabutilun","kabuut","kabuway","kabya","kabyara","kabyaw","kabyun","kad-ang","kada","kada ratu","kada usa [dat.]","kadaan","kadading","kadagaya","kadaghan","kadaghanan","kadagkuan","kadagway","kadahunan","kadaiya","kadak-an","kadakbayanan","kadal-ug","kadalagahan","kadali","kadaludalu","kadangkadang","kadapig","kadasig","kadastral","kadatagan","kadaugan","kadaut","kadautan","kadaw-ug","kadayunan","kadayung","kadina","kadina diamur","kadina pirpituwa","kadina wib","kading","kadinita","kadisnun","kaditi","kadiyu","kadiyut","kadkad","kadlas","kadlasan","kadlasanay","kadlasun","kadlit","kadlitan","kadlitanan","kadlum","kadlum ihalas","kadlumkadlum","kadtu","kadtu siya","kadtut","kadubudubu","kadugayan","kadugayun","kadugtung","kadugu","kadugus","kadula","kadulug","kadumalahan","kadumising","kadungan","kadungawug","kadungganan","kadusingut","kadyapa","kadyi","kadyung","kadyungan","kadyus","kag","kag-ang","kag-usa","kaga","kagaangan","kagabhiun","kagabii","kagabkab","kagaguhan","kagahapun","kagahub","kagaka","kagala","kagalkal","kagamhanan","kagamhanan insular","kagamitan","kagamu","kagana","kaganay","kagang","kagangkagang","kaganiha","kaganina","kagar","kagaral","kagards","kagas","kagasangun","kagaskas","kagastuhan","kagat","kagaun","kagaw","kagaw sa lalaki","kagawad","kagawasan","kagawian","kagawkaw","kagawun","kagay","kagaykay","kagibuhi","kagid","kagidlay","kagihay","kagiit","kagikan","kagiki","kagil-as","kagilkil","kagimat","kaging","kagingking","kagirun","kagis","kagiskis","kagit","kagitkit","kagiw","kagkag","kagmu","kagmud","kagrupu","kagtan","kagu","kagubkub","kagubut","kagud","kaguhang","kagukam","kaguku","kagul-anan","kagul-unun","kagula","kagulangan","kagulangun","kaguliyang","kagulkul","kagumkum","kagung","kagungkung","kagungkungun","kagunkagun","kagupa","kaguran","kagus","kaguskus","kagustuhan","kagut","kagutkut","kagutmanan","kagutum","kaguul","kaguyud","kagwang","kagyu","kaha","kaha diyiru","kaha sa trak","kahabugun","kahagu","kahalang","kaham","kahamili","kahamkaham","kahanas","kahandig","kahangal","kahangay","kahangbatun","kahanginan","kahangturan","kahangul","kahangulhangul","kahaniti","kahapdus","kahapu","kahapun","kahapunanun","kahapunun","kahas","kahaslu","kahasul","kahatas-un","kahati","kahaw-ang","kahayag","kahayahay","kahibalu","kahibudngan","kahibudnganun","kahibulungan","kahibunghibungan","kahid-un","kahidlaw","kahig","kahigal","kahigalaan","kahigayunan","kahigwaus","kahikawan","kahikurat","kahil","kahilada","kahiladman","kahilakun","kahilaluman","kahilayan","kahilipsan","kahilitan","kahilithilitan","kahilum","kahimanan","kahimangud","kahimatngun","kahimayaan","kahimsug","kahimtang","kahimuan","kahimut-anan","kahimuut","kahinam","kahinangup","kahinay","kahingawa","kahingpitan","kahingpitun","kahinugun","kahinuklug","kahinukud","kahinwian","kahipsan","kahir","kahira","kahiral","kahiru","kahis","kahisagmuyu","kahista","kahita","kahitas-an","kahitsuan","kahitsuhan","kahiubus","kahiusahan","kahubu","kahug","kahugaw","kahugpungan","kahugu","kahukbalahapan","kahulbawun","kahulmigasan","kahulugan","kahuluganun","kahumanan","kahumanun","kahumayan","kahumil","kahumpay","kahumpayan","kahumpayun","kahumut","kahun","kahungug","kahunis","kahunit","kahurutun","kahusay","kahustuan","kahutdanun","kahuy","kahuyang","kahuykahuy","kahuyun","kahuyung","kaibug","kaigang","kaigit-igit","kaiguan","kaihiun","kaikug","kaila","kailibgan","kailibgun","kailikgan","kailu","kaimitu","kain","kaina","kaindig","kaing","kainggit","kaingin","kainginiru","kaingun","kaingun [gen.] ug si kinsa","kainit","kainitun","kainsikan","kainti","kairil","kais-is","kaisipan","kaisparing","kaisug","kaituk","kak","kaka","kakab-utan","kakahuyan","kakak","kakalayuhan","kakan-unun","kakapuy","kakas","kakatay","kakaunun","kakaw","kakawati","kakha","kakha tuhak","kakha tuka","kaki","kakibul","kakin","kakinis","kakisaw","kakislabu","kaklasi","kaktil","kaktus","kakudak","kakugi","kakugnan","kakulangan","kakulba","kakulhanun","kakulian","kakunsabu","kakuntintuhun","kakupungkupungan","kakurat","kakusgun","kakustablihan","kakutas","kakuyaw","kakyup","kal","kal-ang","kal-angan","kalaay","kalab-anan","kalaba","kalabanan","kalabanghan","kalabantus","kalabasa","kalabasa nga pula","kalabasa nga puti","kalabat","kalabatan","kalabaw","kalabawun","kalabi","kalabilun","kalabira","kalabkab","kalablitun","kalabu","kalabus","kalabusu","kalabutan","kaladangan","kaladkad","kaladu","kalag","kalag sa animas","kalagilagi","kalagiw","kalagkag","kalagkalag","kalagmitan","kalagnun","kalagsik","kalagu","kalaguran","kalagut","kalaha","kalahati","kalahi","kalahid","kalahung","kalainan","kalainlain","kalakala","kalaki","kalakihan","kalakkalak","kalaktaw","kalalakin-an","kalalauhan","kalalis","kalalum","kalam","kalamalunggay","kalamansi","kalamantigi","kalamatyan","kalamay","kalamayu","kalambibat","kalambigitan","kalambitay","kalambri","kalambuan","kalambura","kalamdagun","kalamidad","kalampusan","kalamri","kalamuhuy","kalamukat","kalamukay","kalamundi","kalamundin","kalamunding","kalamunggay","kalamutsing","kalan","kalan-an","kalan-un","kalanaugun","kalandatay","kalandrakas","kalang","kalang-u","kalangan","kalanggis","kalangitan","kalangkalang","kalantip","kalantugi","kalap","kalapad","kalapasan","kalapati","kalapi","kalapiti","kalapitsi","kalapkalap","kalapkap","kalapuk","kalapukan","kalaputi","kalapuy","kalaru","kalas","kalasab-an","kalasag","kalasan","kalasangan","kalasikas","kalasikas sa panahun","kalaskalas","kalaskas","kalaslun","kalat","kalata","kalataw-an","kalatkat","kalatkat sa kapayas","kalatsutsi","kalatung","kalauman","kalaw","kalaw-it","kalaw-itan","kalaw-itanan","kalawan","kalawasan","kalawat","kalawatan","kalawatanan","kalawran","kalay","kalay-un","kalaykay","kalaylay","kalayu","kalbaryu","kalbasa","kalbu","kalburu","kaldira","kaldirin","kaldirita","kaldiritas","kaldiru","kaldiyu","kaldu","kalduhan","kalgas","kalgasun","kalhang","kalhay","kali","kalibang","kalibang ang baba","kalibangan","kalibangun","kalibaung","kalibhay","kalibkib","kalibri","kalibuan","kalibug","kalibugan","kalibunan","kalibutan","kalibutanun","kalidad","kalidadis","kalidadis ang tingug","kalids","kalids swing","kalig-un","kalig-unan","kaligdung","kaligiran","kaligiray","kaligkig","kaligu","kaliguan","kaliguanan","kaligutgut","kaliguy","kalihay","kalihim","kalihim sa salapi","kalihukan","kalihukang langyaw","kalihun","kalimbagas","kalimpus","kalimuhagan","kalimut","kalimutaw","kalinaw","kalindaryu","kalinding","kaling","kalingag","kalingaw","kalingawan","kalinghud","kalingkaling","kalingkit","kalintuwad","kalinyas","kalinyasan","kalipay","kalipay sa unud","kalipayan","kalipikar","kalipikasiyun","kalipir","kaliplawir","kalipsu","kalipuhan","kalipulipu","kalipung","kaliputan","kaliring","kaliru","kalis","kalisa","kalisang","kalisdanan","kaliskis","kalisud","kalisudlisud","kalisun","kalit","kalitang","kalitkalit","kaliupan","kaliwat","kaliwat ni adan","kaliwat ni daguhuy","kaliwat ni iba","kaliwat ni lapulapu","kaliwatan","kalkag","kalkal","kalkulu","kalma","kalmadu","kalmanti","kalsada","kalsadur","kalsitin","kalsu","kalsunis","kalsunsilyu","kaltik","kaltiks","kalu","kalu sa pitrumaks","kalub","kalubay","kalubian","kalubid","kalubihan","kalubinhan","kalubkub","kalubngan","kalubus","kalug","kalugkalug","kalugpus","kalugpuy","kalugti","kalugungkugung","kalugungkugung sa kabayu","kalugutan","kaluha","kaluha nga lingkit","kaluha ug sawa","kaluhaan","kalukalu","kalukhu","kalukhuun","kalukud","kalukuhan","kalukus","kalumba","kalumingking","kalumitsing","kalumpang","kalumpit","kalung","kalunggu","kalungkung","kalungsuran","kalunsing","kalupu","kalus","kalusayan","kaluskus","kalut","kalut ug dili katul","kalutkut","kaluun","kaluuy","kaluwaan","kaluwasan","kaluykuy","kalyi","kalyu","kalyuhun","kalyus","kam","kam-aw","kama","kamaayu","kamabaw","kamad-an","kamada","kamadmalaan","kamadutsay","kamadyung","kamagku","kamagulangan","kamagung","kamahalan","kamaisan","kamalig","kamalu","kamalunggay","kaman","kamanbad","kamandag","kamandir","kamandirun","kamanduan","kamang","kamang daw umang","kamang sa kalisud","kamanghuran","kamangyan","kamanir","kamaniru","kamansi","kamansili","kamansilis","kamantigi","kamanyan","kamapahitas-un","kamara baha","kamarin","kamarun","kamarun ribusadu","kamaruti","kamas","kamasimasi","kamaskamas","kamatang","kamatay","kamatayun","kamatis","kamatuuran","kamau","kamaug","kamaut","kamay","kamay mu","kamay ug","kamay-ung","kamaya","kamayingking","kamayu","kamayukmuk","kamba","kambang","kambantuli","kambas","kambat","kambaya","kambirs","kambiyada","kambiyada sa hangin","kambiyu","kambiyulu","kambuha","kamhir","kami","kamig","kamikami","kamikami ra","kamil","kamilyu","kamingaw","kamingawan","kamingking","kaminiru","kamintang","kaminyuun","kamira","kamisa","kamisa dintru","kamisa tsinu","kamisin","kamisin dibrasu","kamisin disaliku","kamisita","kamisula","kamisulin","kamisun","kamkam","kamla","kamlas","kamlut","kampamintu","kampana","kampanakampana","kampanaryu","kampanilya","kampaniru","kampanti","kampanya","kampat","kampi","kampihi","kampilan","kamping","kampisaw","kampiyun","kampiyunatu","kampu","kampu santu","kampur","kampus","kamras","kamray","kamrut","kamu","kamug","kamugaw","kamuhanun","kamuhuy","kamukamu","kamul","kamulitsing","kamulu","kamumhu","kamunggay","kamuning","kamuritsing","kamurusan","kamusta","kamut","kamuti","kamuti nga kahuy","kamutihan","kamutinhan","kamuy","kamwa","kamya","kamyas","kan","kan-anan","kan-uman","kan-un","kana","kana nga","kana nga ...","kana siya","kanaas","kanahan","kanahu","kanait","kanaka","kanaku","kanal","kanalkanal","kanamu","kanap","kanapkanap","kanastru","kanasuran","kanat","kanatu","kanaug","kanaway","kanawayan","kanawkanaw","kanawungnawung","kanay","kanay bata","kanay laki","kanaykanay","kanayun","kanbas","kandadu","kandaktur","kandi","kandidata","kandidatu","kandidatu upisiyal","kandidatura","kandidit","kandiis","kandiisun","kandil","kandila","kandila sa pirdun","kandilabra","kandilarya","kandilaun","kandilaw","kandiliru","kanding","kanding nga way sungay","kandingan","kandingkanding","kandingun","kandul","kandungga","kandus","kanduwali","kang","kang buki","kang kinsa","kang sa bulak","kang-a","kang-al","kanga","kangakanga","kangasngas","kangga","kanggahan","kanggaru","kanggrina","kanghu","kangitgnitan","kangkang","kangkarut","kangrina","kangu","kanguhu","kangukangu","kanguwakan","kanhi","kanhianun","kanhiay","kani","kaniadtu","kaniadtu pa","kaniha","kanila","kanilun","kanimu","kanimu matinahurun","kanina","kaningag","kaninyu","kanit","kaniya","kaniyun","kaniyunasu","kankan","kanlat","kanplay","kansa","kansang","kansil","kansilar","kansild","kansiling","kansilkansil","kansir","kansirun","kansirus","kansiyun","kansiyung","kansiyuniru","kansursilyu","kanta","kanta misa","kantadu","kantakanta","kantalita","kantar","kantidad","kantil","kantiladu","kantin","kantina","kantiru","kantu","kantu barina","kantu buy","kantur","kantura","kanu","kanugkug","kanukay","kanunay","kanunayan","kanunisar","kanus-a","kanus-a lang","kanuus","kanyahay","kanyahay ra","kanyamasu","kanyamu","kanyunasu","kanyutu","kap","kap-al","kap-atan","kap-us","kapa","kapaaw","kapagaw","kapagkapag","kapakapa","kapakut","kapakyasan","kapal","kapalaran","kapalaw","kapan","kapan-usan","kapangakuhan","kapanganuran","kapangdulan","kapangpangan","kapanguluhan","kapankapan","kapansilun","kapar","kaparang","kaparas","kapariha","kaparis","kapartidu","kaparut","kaparutan","kaparyintihan","kapasidad","kapatagan","kapatas","kapaw","kapay","kapayas","kapayas sa amirikanu","kapayasun","kapaykapay","kapayuk","kapdrap","kapi","kapi aspirina","kapi kapi","kapid-an","kapihun","kapikal","kapikapi","kapikas","kapila","kapilahay","kapildihan","kapiliwan","kapilya","kapin","kapin kun kulang","kapin nga buut","kapin pa","kapinan","kaping","kaping buut","kaping su","kapingut","kapinhun","kapintas","kapintura","kapir","kapisnun","kapistuwa","kapit","kapit-us","kapital","kapitalista","kapitan","kapitan birinu","kapitan sa baryu","kapitira","kapitiriya","kapitirya","kapitu","kapituan","kapitul","kapitulu","kapitulyu","kapkap","kaplag","kapling","kapri","kapritsu","kapritsusa","kapritsusu","kapug-an ug singut","kapukanan","kapul","kapula","kapulawan","kapuli","kapulihay","kapulisan","kapulu","kapuluan","kapulut","kapun","kapunawpunawan","kapung","kapungan","kapungapunga","kapungturan","kapungut","kapunsa","kapunungan","kapunungang sibika","kapupud-an","kapupungtan","kapupusan","kapus","kapuslanan","kaput","kaputi","kaputli","kaputul","kaputul ug tinai","kaputut","kapuy","kapuy na","kapyaspirina","kapyut","kara","kara krus","karaan","karaan nga gantang","karaan nga kansiyun","karaan pa ni mampur","karaang awit","karaang kansiyun","karab","karabalyas","karabanit","karabansus","karabaw","karabu","karadutsi","karadyaw","karag","karag sa mga babayi","karagan","karaghanan","karagid","karahay","karahu","karakara","karakarahun","karaktir","karakul","karal","karamba","karambula","karamilu","karampag","karamusing","karamutsing","karang","karangan","karansa","karansay","karansu","karapata","karapatdapat","karapitsi","karapitsihun ug baba","karapkarap","karas","karaskaras","karat","karati","karatihay","karatil","karatista","karatisyan","karatsutsi","karatsutsu","karatula","karatung","karaw","karawan","karawi","karawkaraw","karaygan","karbalyas","karbansus","karbayin","karbin","karbun","karbun kalids","karbun kapi","karbunatu","karburadur","karburu","kard","kardaba","kardinal","kardiru","karga","karga buru","karga burut","karga sirada","kargada","kargadu","kargadur","kargamintu","karganti","kargu","kari","kari dipata","karibal","karidad","karidyuyridyuy","karihan","karikari","karikatura","karikit","karina","karindiriya","karingking","karinyu","karinyusa","karinyusu","karir","karira","karirahan","karista","karita","kariti","karitihan","karitil","karitila","karitilya","karitira","karitira prubinsiyal","karitiras","karitis","karitun","kariyut","karkulu","karlang","karmas","karmilitus","karmilu","karmin","karminatibu","karnaba","karnabal","karnabalan","karni","karni asadu","karni nurti","karni pura","karnihan","karniru","karnisira","karnisiru","karpintiru","karpit","karsada","karsil","karsitin","karsu","karsunis","karsunisun","karsunsilya","karsunsilyu","karta","kartabun","kartas","kartil","kartilya","kartira","kartiru","kartiyu","kartiyuhan","kartulina","kartun","kartun kartuning","kartutsu","karu","karul","karumata","karumatilya","karun","karun dayun","karun ka giyud","karun mismu","karun na","karun nga [time]","karun pa","karunay","karung","karung bag-u","karung ulahi","karunkarun","karunkarun dayun","karunsing","karusa","karut","karwahi","karwas","karyada","karyadahan","karyir","kas","kas adbans","kas-a","kasa","kasa digubyirnu","kasa riyal","kasaad","kasab-itag kawit ang simud","kasaba","kasabut","kasabutan","kasadiya","kasadu","kasag","kasagaran","kasagbutan","kasagum-ut","kasagutsutan","kasahus","kasal","kasal-anan","kasaladpan","kasalanggiun","kasalbahisanan","kasaliping","kasama","kasamahan","kasamintu","kasamtangan","kasamuk","kasamyintu","kasandurut","kasangga","kasangkad","kasangkapan","kasangkarun","kasangkayan","kasangyawan","kasanihan","kasap","kasapuygu","kasar","kasarangang","kasaring","kasasgul","kasaw","kasaya","kasayaan","kasayahan","kasaypanan","kasaysayan","kasayun","kasayupan","kasayuran","kasba","kasbu","kasi","kasibaw","kasibaya","kasibut","kasigaw","kasiguruan","kasiguruhan","kasikas","kasikasi","kasikbit","kasilag","kasilaw","kasili","kasilik","kasilik-an","kasilinganan","kasilyas","kasilyiru","kasina","kasinatian","kasing","kasing nga inulukan","kasinggitun","kasingkasing","kasingkasingan","kasingut","kasinihan","kasipa","kasir","kasira","kasirahan","kasirula","kasiyaman","kasiyu","kaskadu","kaskaru","kaskas","kasku","kaskug","kasla","kaslinganan","kaslunun","kaspa","kaspag","kaspahun","kaspat","kasta","kastanits","kastanyas","kastanyita","kastanyitas","kastar","kastigu","kastigu hiniral","kastila","kastilya","kastilyanhun","kastilyu","kastur uwil","kastus","kasu","kasu [dat.]","kasub-anan","kasublian","kasubu","kasugiran","kasugpung ug kasingkasing","kasugpung ug tinai","kasuguan","kasuka","kasukaun","kasuku","kasulatan","kasulaw","kasulbaran","kasulbarun","kasulti","kasulya","kasum-ul","kasumaran","kasumpay sa kasingkasing","kasumpay ug tinai","kasundaluhan","kasungian","kasungkaan","kasupang","kasusyu","kasuud banay","kasuukan","kasuy","kaswal","kasway","kasya","kasyahan","kasyahun","kasyir","kasyuti","kasyutis","kat","kat-in","kat-un","kata","katab","katabang","katabuk","katabun","katadkatad","katag","katagaun","katagbaw","katagbawan","katagbawun","katagibalangay","katagibaryu","katagilungsud","kataguk","katagun","kataguun","kataha","katahaan","katahapan","katahum","katahuman","katahuran","katai","kataka","katakata","katakus","katala","katalagman","katalirungan","katalug","katalugu","katambak","katambayayung","katang","katap","katapad","katapusan","katapusang byahi","katarak","katarata","kataru","katarung","katarungan","katas-an","kataslak","kataspuk","kataw","kataw-anan","kataw-anay","kataw-unun","katawa","katawhan","katay","katayan","katayanan","kati","katibu","katidral","katids","katids indastri","katig","katigayunan","katigbi","katigulangan","katigulangun","katiguman","katiguriya","katihan","katihanan","katikat","katikati","katikatihun","katikatiun","katikismu","katikista","katilingban","katilingbanun","katimbang","katimpa","katin","katin ang bulan","katin-awan","kating","kating klasis","katingala","katingalahan","katinuan","katipa","katipan","katipik","katipun","katipunan","katipuniru","katir","katirir","katisismu","katitikan","katitir","katitiun","katkat","katkat sa kapayas","katla","katluan","katmun","katri","katsa","katsap","katsaw","katsila","katsilaun","katsir","katsuk","katsukulati","katsuri","katsuy","katu","katu ang ulu","katuba","katubhan","katubsanan","katud","katudluan","katugbang","katugnaw","katuigan","katuk","katuka","katukatu","katukuran","katul","katul ug kamut","katul-iran","katulganan","katulgun","katulik dipindir","katulika","katuliku","katuliku rumanu","katulisismu","katulkatul","katulu","katulug","katulugun","katumanan","katumbas","katumsan","katunga","katungdanan","katunggan","katungud","katunhayan","katursa","katursi","katutung","katuwad tuali","katuwang","katuyuan","katyalis","katyubung","kaub","kauban","kauban nga","kauban sa kinabuhi","kaubanan","kaubay","kaubus","kaudtuhun","kaug","kaug-ug","kaugalingnan","kaugalingun","kaugatan","kaugdang","kaugmaran","kaugmaun","kauhaw","kaul-ul","kaulag","kaulahi","kaulahian","kaulahiay","kaulangan","kaulaw","kaulawan","kaulawun","kaulay","kaulipnan","kaulit","kaulitawhan","kauliun","kauluhan","kaulut","kaumahan","kaumhan","kaun","kaun ug tagam","kaung","kaungkaung","kaungkuy","kaunkaun","kaunsa","kaunuran","kaupat","kaupayan","kaupayun","kaupud","kausa","kausaban","kausbawan","kauswagan","kauswagun","kautud","kautul","kautungun","kauyamut","kauyunan","kaw","kaw-ing","kaw-it","kaw-uy","kawa","kawakawa","kawalaan","kawalad-un","kawali","kawalu","kawan","kawanangan","kawang","kawani","kawanihan","kawankawan","kawarung","kawas","kawas na sa kalindaryu","kawas sa kalindaryu","kawasdak","kawat","kawatan","kawatkawat","kawatun","kawatunun","kaway","kawayan","kawayanun","kawbuy","kawhaan","kawhat","kawhit","kawil","kawili","kawilkawil","kawinkawin","kawit","kawkaw","kawkawan","kawkus","kawpi","kawras","kawrut","kawsa","kawu","kawu-","kawunsil","kawuntid","kawuntir","kay","kay [dative]","kay [interrogative]","kay arun","kay basta","kay hanu","kay kinta","kay-a","kay-ag","kay-ag ang lawas","kay-ag ang tinai","kaya","kayaan","kayab","kayabag","kayag-ang","kayagaw","kayagkag","kayali","kayamat","kayamatyamat","kayamukat","kayang","kayangkayang","kayankayan","kayapa","kayapak","kayas","kayat","kayaw","kayawayawa","kaybuy","kayda","kayha","kayha ... kayha","kayhaan","kayhun","kayi","kaykay","kaylab","kaylap","kaymitu","kayril","kayu","kayuan","kayuang","kayud","kayug","kayugpus","kayugut","kayukayu","kayunda","kayung","kayuring","kayut","kayutaan","kayutik","kayutis","ki","ki [verb] ki dili","kiamkiam","kiang","kiangun","kiat","kiaykiay","kiba","kibad","kibag","kibhang","kibidu","kibkib","kibra","kibrada","kibu","kibul","kibut","kibut nimu","kibut niya","kid","kida","kida bwilta","kidangkidang","kidhat","kidlap","kidnap","kidni","kig-(←)","kighud","kigi","kigkig","kigkigun","kignat","kigul","kigwa","kigwahun","kiha","kiha ug atras","kihaguan","kihanti","kihar","kihat","kihud","kihul","kiim","kik","kikbak","kikhi","kiki","kikik","kikilu","kikim","kiking","kila","kilab","kilaba","kilabkilab","kilala","kilas","kilat","kilatan","kilati","kilatnun","kilaw","kilawan","kilawkilaw","kilawnun","kilawun","kilawun ug way sukasuka","kilay","kilayun","kilditayim","kilid","kilighan","kiligkilig","kiligu","kilikisi","kilikiti","kilikug","kilikut","kilim","kiling","kiling ditayim","kilipay","kiliran","kilis","kilisiw","kilislan","kilislun","kilkig","kilkigan","kilkil","kilu","kilug","kiluhan","kilumitrahi","kilumitru","kilumitrus","kilumkilum","kilya","kilyakilya","kim-ut","kimakima","kimaw","kimay","kimba","kimbid","kimbig","kimi","kimika","kimikal","kimikal indyinir","kimikimi","kimikna","kimiku","kimin","kimist","kimpang","kimpi","kimpit","kimpitay","kimu","kimud","kimug","kimugkimug","kimukimu","kimun","kimuna","kimunu","kimut","kina-an(→)","kinaadman","kinaalimpuluhan","kinaaluyukan","kinabag-an","kinaban","kinabay-an","kinabay-anay","kinabayu","kinablit","kinabuang","kinabudlayan","kinabug","kinabuhi","kinadak-an","kinadul-an","kinagis","kinagud","kinagutkut","kinaham","kinahangan","kinahanglan","kinahanglanun","kinahilitan","kinahun","kinahunsan","kinahuy","kinaiya","kinaiyahan","kinaiyanhun","kinakas","kinakin","kinakurusan","kinal-angan","kinalabaw","kinalap","kinalawran","kinalay-an","kinalayu","kinalibang","kinaling","kinalutan","kinaluukan","kinama","kinamada","kinamagulangan","kinamagulangan nga buling","kinamalig","kinamangay","kinamanghuran","kinamarin","kinamatayun","kinamatyan","kinambaya","kinambiyu","kinamisun","kinampay","kinamrasan","kinamut","kinan-an","kinanat","kinankan","kinapatagan","kinapiliwan","kinapnan","kinapungkayan","kinapungtan","kinapungturan","kinapuntahan","kinapusuran","kinaraan","kinarburuhan","kinarniru","kinarsunis","kinarsunisan","kinartun","kinaryadahan","kinasal","kinasampungan","kinasang-an","kinasing","kinasingkasing","kinaskas","kinastiguhan","kinataliwad-an","kinataw-an","kinataw-anay","kinatawu","kinatibuk-an","kinatsila","kinatulgan","kinatulug","kinatung-an","kinatung-an nga silangan","kinatung-an silangan","kinaugalingun","kinaulahian","kinaun","kinaunahan","kinaunsa","kinaunsaay","kinauyukan","kinawalugan","kinawat","kinawatay","kinawatkawat","kinawbuy","kindakinda","kindang","kindangkindang","kindaykinday","kindi","kindir","kindirgartin","kindwit","king","king sayis","kingas","kingat","kingki","kingkilya","kingking","kingkiri","kingpin","kingpus","kingsan","kinhas","kinhasun","kinhud","kini","kini nga","kinihun","kinilab","kinilaw","kinilis","kinilisan","kinilkig","kinilkil","kinilkilan","kinilu","kinina","kininhasan","kininsina","kinintu","kinis","kiniskis","kiniskisan","kinitaan","kiniyas","kiniyuran","kinkin","kinlaw","kinsa","kinsa [noun]-a","kinsa kadtung","kinsa pa","kinsakinsa","kinsan","kinsaun","kinsay","kinsay arang","kinsay ngalan [gen.]","kinsi","kinsina","kinsinal","kinsinas","kinta","kinta kinta kinta","kinta martsa","kinta siniyal","kintab","kintahay","kintal","kintid","kintsay","kintu","kintu distritu","kintu gradu","kintu limbu","kintuplits","kinu","kinu ang utuk","kinu ug utuk","kinubtanan","kinudlit","kinugay","kinughad","kinugihan","kinugus","kinul","kinulihad","kinulit","kinulitan","kinumu","kinumuay","kinunsihal","kinuntra","kinupsan","kinupusan","kinural","kinuraw","kinusian","kinusiay","kinusnitan","kinut","kinutbanan","kinutil","kinutkut","kinutkutan","kinutlu","kinutuban","kinyintus","kipat","kipditsins","kipi","kipikipi","kipit","kiput","kiputkiput","kira","kirakira","kirang","kirat","kiraw","kirawan","kirawkiraw","kiri","kirida","kirig","kirigkirig","kirilya","kiring","kirir","kiriring","kiritkirit","kiriw","kiriwan","kirkir","kirkirun","kirubinis","kirug","kirus","kirut","kiryi","kiryulina","kis","kisa","kisakit","kisami","kisamkisam","kisap","kisapkisap","kisas","kisaw","kisaykisay","kisdum","kisdung","kisi","kisibaya","kisikisi","kisira","kisira ug","kisiyu","kiskis","kiskisan","kislabu","kislanan","kislap","kislunun","kisma","kismi","kisu","kisu dibula","kisul","kisum","kita","kita mu","kita ug aniniput","kita ug langit","kitahanun","kitaipuni","kitakita","kitang","kitara","kitarahun","kitbi","kitbi ang","kitib","kitiban","kitid","kitidkitid","kitikut","kitin","kiting","kitiw","kitiwkitiw","kitkit","kitsap","kitu","kitung","kituy","kiug","kium","kiung","kiwa","kiwag","kiwakiw","kiwat","kiwatkiwat","kiwaw","kiwi","kiwiskiwis","kiwkiw","kiwut","kiya","kiyag-ang","kiyas","kiyaw","kiyud","kiyudkiyud","kiyus","kiyut","kkk","klab","klabu","klag-ap","klam","klap","klara","klarinit","klariniti","klaru","klaru na lamang","klaru na lang","klaruhay","klas","klas adbaysir","klas rikurd","klas ring","klasi","klasika","klasiklasi","klasipikar","klasmit","klats","klik","klim","klima","kling","klinik","klinika","klinsing krim","klip","kliping","klir","klirans","klirikal","klirk","klitsi","kliyinti","kliyintila","klum","kluruks","klus","klus-upin","klusnik","krak","krakir","krakirs","krang","kras","kratsis","kraysis","krayula","kridinsiyal","kriditu","kridu","krim","krima","krimahun","krimin","kriminal","kriminalidad","krin","kring","krip","krip pipar","kris","krisis","krismas","krismas kard","krismas tri","kristal","kristal bul","kristal silk","kristiya","kristiyanismu","kristiyanu","kristiyanus","kristu","kristu ri","kristuhanun","kristung hisus","kristung manunubus","kristung tinagu","krit","kritikal","kritiku","kriyada","kriyadu","kriyulina","krudu","krukidnul","krukignul","krumyu","krunir","krus","krus raypul","krus ruha","krusada","krusan","krusing","krusipihu","krusipiksiyun","kruslayin","krutsay","krutsitis","kruwis","ku","ku ikaw","kuadhutur","kuadutur","kuan","kuaw","kuaw ug utuk","kub","kuba","kubad","kubakuba","kubal","kubalkubal","kubalt bam","kubalun","kubana","kubanug","kubasa","kubaw","kubay","kubiku","kubikubi","kubikubian","kubikubiun","kubil","kubing","kubir","kubirkubir","kubirta","kubirtus","kubit","kubit ug way paun","kubkub","kubkubay","kubkubun","kubla","kublan","kubli","kubra","kubrada","kubradur","kubransa","kubri","kubrikama","kubtanan","kubu","kubul","kubung","kubus","kubut","kubutan","kubyirta","kubyirtus","kud","kudak","kudakir","kudakiris","kudambus","kudigu","kudigu iliktural","kudigu iliktural ribisadu","kudigu penal","kudigu pinal","kudigu pinal ribisadu","kudigu sibil","kuding","kudkud","kudkuran","kudlis","kudlit","kudlit sa palad","kudlitanan","kudlungun","kudrisu","kudsan","kudyapa","kudyapi","kugal","kugan","kugang","kugangkugang","kugaw","kugay","kughad","kughal","kughay","kughun","kugi","kugihan","kuging","kugita","kugitahun","kugiut","kugkug","kugmat","kugmu","kugmuhun","kugpus","kugpuy","kugtung","kugum","kugun","kugungkugung","kugus","kugwa","kuha","kuha ug palta","kuhil","kuhin","kuhir","kuhit","kuhu","kukakula","kukakula badi","kukhan","kukhu","kukib","kukiri","kuku","kuku krudu","kukud","kukug","kukug banug","kukuk","kukuks","kukunat paylut","kukus","kukwa","kul","kul-ap","kula","kulabting","kulaburitur","kulabutan","kulabyaw","kulabyun","kulag","kulagting","kulagu","kulakdup","kulaknit","kulambus","kulambut","kulambutan","kulampisaw","kulampit","kulamug","kulamus","kulamuy","kulamuy sa balaud","kulan","kulanap","kulandir","kulang","kulang ug dugu","kulangan","kulangkulang","kulangu","kulangun","kulangut","kulangutun","kulanguun","kulansi","kulap","kulapiti","kulapkulap","kulapu","kulaput","kulapyut","kulapyut sa sagbayan","kulapyutanan","kulasisi","kulasiyun","kulat","kulat-ug","kulat-ugun","kulata","kulatadu","kulating","kulatiral","kulaw-it","kulay","kulayapan","kulaykulay","kulba","kulba hinam","kulbaanun","kulbasa","kuldas","kuldun","kulgirl","kulgit","kulhanun","kulhiad","kuli","kulianun","kulibugan","kuligi","kulihad","kulihiyala","kulihiyu","kulihiyu iliktural","kuliik","kuliksiyun","kulikta","kuliktar","kuliktur","kulikug","kulikut","kulikutkut","kuliling","kulilisi","kulilising hari","kulima","kuling","kulintas","kulipa","kulipad","kulipas","kulipat","kulipi","kulipian","kulipiti","kuliplawir","kulir","kulira","kulirit","kuliru","kulis","kulisaw","kulisdum","kulisdung","kulisiw","kulisiyum","kulismaut","kulismautun","kulismut","kulistirul","kulisuk","kulisyun","kulit","kulitis","kulitu","kulitug","kulitus","kuliun","kuliut","kuliyun","kulkug","kulkul","kulkulanay","kultibadu","kultibar","kultsun","kultu","kultura","kulu","kulub","kulub hayang","kulub hubag","kulub sa platu","kulubutan","kulud","kuludkulud","kulugkug","kulugpus","kulugpuy","kulukabayu","kulukabildu","kulukadu","kulukar","kulukasiyun","kulukinsina","kuluks","kulukud","kulukulu","kulukuratan","kulukurawan","kulukurawun","kulukus","kulukusu","kulukuy","kulukuydawu","kululbaan","kulumbabit","kulumbitay","kulumingking","kulumna","kulumnista","kulumpiyu","kulumrinu","kulun","kulung","kulungan","kulungu","kulungun","kulunkulun","kulunun","kulunya","kulupug","kulur","kulur dikarni","kulur dilitsi","kulur diubi","kulurawu","kuluriti","kuluritis","kulurkulur","kulurum","kulus","kuluskulus","kuluskus","kulut","kulutasan","kuluutun","kuluyawan","kulyada","kulyar","kum-us","kum-ut","kuma","kumadri","kumads","kumagat","kumagku","kumakaun","kumakaun ug tawu","kumakuma","kumalagku","kuman","kumandansiya","kumandanti","kumandir","kumari","kumari kumablit","kumaw","kumayingking","kumbabit","kumbal","kumbansiru","kumbat","kumbati","kumbi","kumbiksiyun","kumbinar","kumbinasiyun","kumbinasyun","kumbinasyun nga pinasugu","kumbini","kumbininsiya","kumbinsi","kumbinsidu","kumbinsir","kumbinsiyun","kumbinsiyun kunstituyinti","kumbintu","kumbinyinti","kumbinyu","kumbira","kumbirs","kumbirsiyun","kumbirtibli","kumbirtibul","kumbirtir","kumbis","kumbitatay","kumbitay","kumbiti","kumbu","kumbukasiyun","kumbukisyun","kumbulsiyun","kumbutan","kumbuy","kumbuya","kumi","kumida","kumidi","kumidiya","kumidiyanti","kumidur","kumiks","kumilik","kumingking","kumintang","kumintarista","kumintaryu","kumintitur","kumirsiyal","kumirsiyu","kumirsyanti","kumisiyun","kumisiyunadu","kumisiyunir","kumisyun","kumita","kumiti","kumitiba","kumitir","kumkum","kumkum ug kamut","kumnay","kumpabli","kumpad","kumpadri","kumpang","kumpangun","kumpaniya","kumpanya","kumpanyira","kumpanyiru","kumpara","kumparar","kumparasiyun","kumpari","kumparsa","kumpas","kumpay","kumpayan","kumpayut","kumpi","kumpidinsiyal","kumpirinsiya","kumpirma","kumpirmadu","kumpirmasiyun","kumpisal","kumpisalan","kumpisinaryu","kumpisinaryuhan","kumpiskadu","kumpiskadur","kumpiskar","kumpisur","kumpisyun","kumpisyunaryu","kumpit","kumpitinsiya","kumpitis","kumpiyansa","kumpli","kumplianyu","kumplikadu","kumplikar","kumplikasiyun","kumplimintu","kumplin","kumplitu","kumplut","kumpra","kumpradur","kumpradur di-","kumprumisu","kumprumitibu","kumprumitidu","kumprumitir","kumprunta","kumpruntar","kumpuni","kumpunir","kumpurmi","kumpurtabli","kumpus pit","kumpusir","kumpusisyun","kumpusitur disapatus","kumpusu","kumu","kumu [noun","kumu kay","kumuda","kumudkumud","kumudkumuran","kumuhuy","kumulga","kumulganti","kumulgar","kumulgasiyun","kumun","kumunal","kumungkumung","kumunikasiyun","kumunismu","kumunista","kumunwilt","kumunyun","kumunyunan","kumurga","kumurganti","kumus","kumusta","kumusta ka diha","kumustamus","kumut","kun","kun dili","kun maarang","kuna","kunan","kunat","kunay","kunaykunay","kunbinsyun","kundadu","kundas","kundat","kundatan","kundi","kundim","kundiman","kundina","kundinadu","kundinar","kundinsada","kundisa","kundisiyun","kundisiyunal","kundukta","kunduktur","kundul","kundun","kung","kungas","kunggrisu","kunggrisu iyukaristiku","kunggrisu yukaristiku","kunggu","kungking","kungkista","kungkistadu","kungkistadur","kungkiyang","kungkritu","kungkung","kungrigasiyun","kungrisista","kungrisu","kunhud","kunhun","kunihu","kunik","kuniksyun","kuniktadu","kuniktar","kuniktid","kuninit","kunis","kuniskunis","kunklusyun","kunkritu","kunkun","kunpirma","kunpirmasyun","kunpisinaryu","kunpisur","kunsabu","kunsad","kunsagrar","kunsagrasiyun","kunsidirar","kunsidirasiyun","kunsigrar","kunsigrasiyun","kunsihal","kunsihala","kunsihu","kunsihu munisipal","kunsilba","kunsilyu","kunsimisiyun","kunsinsiya","kunsintadur","kunsintidur","kunsintidura","kunsintir","kunsirba","kunsirbar","kunsirbatib","kunsirbaturyu","kunsirtu","kunsisiyun","kunsisiyunaryu","kunsisyun","kunsiyirtu","kunstabularya","kunstabularyu","kunstitusyun","kunstitusyunal","kunstitusyunal kumbinsiyun","kunstituyinti","kunstruksiyun","kunsul","kunsuladu","kunsulasiyun","kunsulasiyun guwa","kunsulasiyun sud","kunsulisyun prayis","kunsulta","kunsultasiyun","kunsumisiyun","kunsumpsiyun","kunsumu","kunsurti","kunsuylu","kuntadur","kuntadur sa tubig","kuntak","kuntar","kuntidyus","kuntimpuraryu","kuntindir","kuntininti","kuntintu","kuntis","kuntra","kuntra gustu","kuntra hitsu","kuntra kumpas","kuntra partidu","kuntra risibu","kuntra sa","kuntra sa ampay","kuntra sa dugu","kuntra tyimpu","kuntra ug","kuntrabandista","kuntrabandu","kuntrabida","kuntraktur","kuntraryu","kuntrasinyas","kuntrata","kuntratadu","kuntratista","kuntratu","kuntribusiyun","kuntringkanti","kuntrisiyun","kuntrul","kuntruladu","kuntrular","kuntrulawu","kuntud","kuntudu","kuntudu ubligasiyun","kunu","kunuhay","kunukunu","kunul","kunul ug ulu","kunulun","kunun","kunup","kunuskunus","kunut","kunutun","kunya","kupa","kupad","kupal","kupas","kupat","kupay","kupidu","kupil","kupirar","kupit","kupita","kupitinsiya","kupkup","kupras","kupu","kupug","kupukupu","kupun","kupun ban","kupungkupung","kupus","kuput","kupuy","kupya","kupyadur","kupyamus","kupyur","kur kamandir","kur kumandir","kur-ispunsur","kura","kura paruku","kuradang","kuradang kun danggit","kurag","kuragan","kurakul","kurakura","kural","kuralun","kurambus","kurambusa","kurang","kurangut","kurapkurap","kurapsiyun","kurasiyun","kurasunada","kurat","kuratsa","kuraw","kuraw ug kinhasun","kuray","kurayag","kurayus","kurayut","kurba","kurbada","kurbadu","kurbahun","kurbata","kurbata ang tuba","kurbawu","kurbu","kurd","kurdaping","kurdiru","kurdiru sa diyus","kurdis","kurdisu","kurdun","kurduruy","kuri","kuribut","kuridas","kuridu","kuridur","kuridura","kurihidur","kurihir","kurik","kurikit","kuriksiyun","kurikuri","kurindu","kurinti","kuriput","kuriring","kuriskuris","kurispundinsiya","kurispunsal","kurista","kurit","kuriya","kuriya rihistradu","kuriyu","kurkubadu","kurkubawu","kurlir","kurmata","kurna","kurnada","kurnawu","kurnil","kurnir","kurnit","kurnita","kurnitin","kurnitun","kurpinyu","kurpiyu","kurpural","kurpurasiyun","kurpus kristi","kursan","kursi","kursikan","kursilyista","kursilyu","kursit","kursu","kursunada","kurt","kurta","kurta {di-","kurta diabaniku","kurta pluma","kurtadu","kurtadur","kurtal","kurtang awtumatik","kurti","kurti diapilasyunis","kurti suprima","kurtin risir","kurtina","kurtinahun","kurtisiya","kurtsitis","kurtsu","kurtu","kurtu sa buut","kurtu ug buut","kuru","kurug","kuruhay","kuruk","kurukignul","kurukunghu","kurukuntung","kurukuru","kurukutuk","kurum","kuruna","kurunasiyun","kurung","kurungkuntung","kurunil","kurunit","kuruntu","kurupsiyun","kurus","kurus pa","kurusan","kuruskurus","kurut","kurutsay","kuruy","kuryinti","kuryintisyan","kuryusu","kus","kusahus","kusaw","kusay","kusbat","kusi","kusikusi","kusina","kusing","kusinilya","kusinira","kusiniru","kusisang","kusitsa","kuskus","kuskus balungus","kuslad","kusmaut","kusmitik","kusmu","kusmud","kusmus","kusnit","kusnitkusnit","kusnut","kuspag","kuspidur","kustabli","kustablis","kustabularya","kustanyira","kustar","kustiyada","kustiyadur","kustiyar","kustiyun","kustum","kustumbri","kustumir","kustumri","kusturira","kusug","kusug pa sa kilat","kusukusu","kusung","kut","kut an tay","kuta","kutab","kutana","kutang","kutas","kutat","kutaw","kutaw ang libug","kutay","kuthan","kuti","kuti baru","kutib","kutihawu","kutihu","kutiks","kutikuti","kutikutihan","kutil","kutilkutil","kutim","kuting","kutingkuting","kutingun","kutir","kutis","kutitub","kutkut","kutli","kutlig","kutlu","kuts","kutsara","kutsarita","kutsarun","kutsi","kutsilyu","kutsina","kutsinta","kutsinu","kutsiru","kutsitis","kutsitsa","kutsu","kutsukutsu","kutsun","kutu","kutub","kutub karun","kutub sa [word referring to action]","kutubkutub","kutud","kutuhun","kutukkutuk","kutukutu","kutul","kutuun","kutuy","kuub","kuug","kuugkuug","kuul","kuum","kuup","kuupirar","kuupirasiyun","kuurdinadur","kuurdinasiyun","kuut","kuut sa kuluutun","kuutkuut","kuuykuuy","kuwa-","kuwak","kuwan","kuwing","kuyabug","kuyaig","kuyakin","kuyakiw","kuyaknit","kuyamad","kuyamang","kuyamas","kuyamis","kuyamud","kuyamug","kuyamuy","kuyanap","kuyap","kuyapi","kuyaput","kuyarut","kuyaw","kuyawanun","kuyawkuyaw","kuyayi","kuyba","kuydawu","kuydawukuydawu","kuykuy","kuylada","kuylaw","kuymi","kuyug","kuyug babuy","kuyug sa lupad","kuyugkuyug","kuyugpus","kuyukus","kuyus","kuyuskus","kuyut","kwa-","kwabutan","kwadhutur","kwadirnu","kwadra","kwadrada","kwadradu","kwadrisu","kwadru","kwadruplikit","kwahab","kwahaw","kwahu","kwakig","kwakir uts","kwaku","kwalipikar","kwalipikasiyun","kwalisiyun","kwalta","kwamug","kwandig","kwanggul","kwanggulu","kwanggulun","kwari","kwarinta","kwarinta diyas","kwarinta isingku","kwarintina","kwarintinas","kwarisma","kwarta","kwarta klasi","kwartahan","kwartang malabu","kwartil","kwartisar","kwartu","kwatru","kwatru kantus","kwatru puyra","kwayir","kwilyu","kwilyu sa matris","kwin","kwin ani","kwinpus","kwinta","kwintada","kwintakwinta","kwintas","kwintas klaras","kwintas ug bukug","kwirdas","kwirpu","kwistiyun","kwistiyunabli","kwitis","kwuta","kyag-ang","kyaknit","kyampaw","kyampi","kyamud","kyamuy","kyapu","kyawkaw","kyawkyaw","kyugpus","kyukus","kyungkung","kyusku","kyuskus","kyuum","la","laag","laagan","laang","laas","laaw","laay","laaylaay","lab","lab-ak","lab-an","lab-ang","lab-as","lab-asira","lab-asiru","lab-u","lab-uk","laba","lababu","labad","labada","labadlabad","labadur","labadura","labag","labaha","labak","labakara","labalaba","laban","laban sa nigusyu","labana","labanan","labandira","labandiru","labang","labang pa","labang sa","labanganan","labangun ug pitu ka lawud","labangunun","labanu","labanus","labas","labasira","labasiru","labat","labatiba","labatlabat","labaw","labaw nga sasirduti","labaw pa","labay","labay pa","labayan","labayanan","labdanan","labdunun","labha","labhag","labhak","labhan a — nga","labhanan","labhu","labhunun","labi","labi na","labi nang [verb]","labi nga","labi pang [adj.]","labian","labid","labigan","labiha","labiha nga [maka-","labihan","labihanay","labihanay pud (sad)","labihay","labil","labilabi","labing","labit","labitira","labitiru","labitlabit","labitlabitun","labka","labkahan","lablab","lablab ang baba","labnaw","labnganan","labni","labnit","labnub","labnug","labnut","labsik","labsit","labtik","labting","labtingaw","labu","labu kasuy","labu liba","labud","labug","labuk","labuk sa hilum","labuklabuk","labulabu","labun","labun kay","labunay","labung","labur","laburaturyu","labut","labut pa","labutlabut","labuy","labuyu","labuyuun","labyug","lad-an","lad-ang","lad-anun","lad-uk","ladila","ladlad","lads","ladyir","lag-ab","lag-i","lag-id","lag-it","lag-uk=","laga","lagaak","lagaanan","lagablab","lagak","lagala","lagalaga","lagalaun","lagalaw","lagamak","lagang","lagapak","lagaplap","lagarat","lagaraw","lagari","lagas","lagasak","lagat","lagatak","lagatlat","lagatukan","lagaw","lagay","lagba","lagbas","lagbas sa","lagbasanan","lagda","lagdas","lagdu","lagduk","lagduk ang aninu","lagdukan","lagdung","laghang","laghaw","laghay","laghay nga ubu","laghus","lagi","lagi kay","lagilagi","lagilhi","laging","lagingling","laginit","lagiti","lagiting","lagiw","lagiwliw","lagkaw","laglag","laglum","lagmaw","lagmit","lagmun","lagnak","lagnas","lagnaw","lagnay","lagnub","lagnut","lagpad","lagpak","lagpang","lagpat","lagpi","lagpiunun","lagput","lagsaw","lagsik","lagsut","lagtang","lagtiw","lagtub","lagu","lagub","lagubu","lagudlagud","laguk","lagukluk","lagulu","lagum","lagumlum","lagumu","lagumuk","laguna","lagunda","lagundi","lagung","lagunit","lagunut","lagupu","lagurul","lagurut","lagus","lagusa","lagusu","lagut","lagutan","lagutmun","lagutu","lagutub","lagutuk","lagutum","lagutunun","lagutuy","laguun","laguy","laguylaguy","laguyluy","lagwirta","lagwis","lagwum","lagyu","lagyum","laha","lahang","lahap","lahawlahaw","lahay","lahaylahay","lahi","lahi ra","lahib","lahid","lahilahi","lahing","lahit","lahu","lahug","lahugay","lahuglahug","lahundung","lahung","lahus","lahus sa","lahuslahus","lahutay","lahuy","lahuylahuy","lain","lain nga kalibutan","lain nga tawu","lain pay aku","lain pay atu","lain ra","lain ug buut","lain ug kamut","lain ug sabaw","laing kalibutan","lainlain","lainun","lainun ug buut","lais","laiti","lak","lak-ab","lak-ang","lakad","lakad ang bulan","lakad sa","lakad sa adlaw","lakad ug bulan","lakag","lakagay","lakang","lakat","lakatan","lakaw","lakayan","lakbang","lakbay","lakbit","lakbit saysay","lakdap","lakdup","lakgak","lakgakan","lakgut","laki","lakilaki","lakin-un","lakinayin","lakip","lakir","lakit","laklak","laknit","lakpawlakpaw","lakra","laksa","laksanti","laksi","laksit","laksut","laktaw","laktawlaktaw","laktud","laktudanan","laktunun","lakturanan","lakun","lakung","lakuy","lakuy-ung","lakwatsa","lakwatsira","lakwatsiru","lakwig","lala","lala ug baba","lalag","lalagan","lalaki","lalaking buhat","lalan","lalang","lalau","lalawigan","lalha","lali","lalik","lalim","lalim mu","laliman ka ba","lalin","lalis","lalisan","lalisun","lalug","lalum","lalum ang bughat","lalum ug bughat","lalum ug dulut","lalum ug tingkuy","lalung","lalungun","lam-ang","lama","lamak","lamakan","lamalama","laman","lamang","lamanu","lamas","lamat","lamaw","lamawan","lamay","lamba","lambalamba","lambang","lambanug","lambaruk","lambay","lambayaw","lambayung","lambi","lambid","lambigit","lambing","lambiyaw","lambiyug","lambiyung","lambu","lambuanan","lambud","lambun","lambunaw","lambung","lambungay","lambungayun","lambunit","lamburan","lamburanan","lambus","lambut","lambuyud","lambuyug","lamdag","lamdaman","lamhun","lamhung","lamhuy","lami","lami nga dili ikapanangpit","lami nga i-[verb]","lami ug kalit","lamian","lamigas","lamigmig","lamili","lamina","laminasiyun","laming","lamingan","laminisyun","laminit","lamisa","lamisita","lamiti","lamlam","lampaag","lampaga","lampak","lampakanay nga kugun","lampanug","lampara","lamparahan","lamparahanan","lamparilya","lamparista","lamparu","lamparunis","lampas","lampas tanum","lampasu","lampay","lampin","lampingas","lampingasan","lampinig","lampirung","lampis","lampuay","lampurnas","lampus","lampuug","lampuyang","lampuyut","lamu","lamudlaw","lamugay","lamugdung","lamuglamug","lamuglamug sa tuba","lamugmugan","lamuk","lamukat","lamukay","lamuklamuk","lamulamu","lamun","lamuruk","lamurukun","lamuy","lamuy sa bakunawa ang buwan","lamuya","lamwas","lamyat","lan-grabir","lan-u","lan-ug","lan-us","lana","lana nga pangulang","lana sa hilug","lana ug putut","lanag","lanahan","lanahun","lanang","lanangan","lananglanang","lanap","lanat","lanatad","lanaw","lanay","lanay ang atay","lanay ug sinultihan","lanay ug tingug","landa","landag","landahan","landang","landasan","landay","landig","landig sa pantalan sa himaya","landing","landing bards","landing pild","landrakas","landung","landuylanduy","lang","lang-u","lang-ug","langab","langan","langanan","langas","langasan","langatad","langaw","langawlangaw","langay","langaya","langayan","langbay","langbayan","langbi","langbu","langbud","langday","langga","langgam","langgamun","langgaw","langgi","langgikit","langgilanggi","langgis","langgisaw","langgita","langgiti","langgung","langgus","langgut","langgutira","langgutiru","langgwita","langi","langigngig","langis","langisiru","langit","langitlangit","langitlangit sa muskitiru","langitngit","langitnun","langkap","langkat","langkaw","langkawan","langkay","langki","langking","langkit","langkiya","langkub","langkuy","langkuylangkuy","langpus","langsa","langsad","langsi","langsub","langtaw","langtawan","langtawanan","langtu","langtung","langtung sa hunas","langu","langub","langut","languy","langyaw","langyaw nga kalabutan","lanhan","lanipga","lanit","laniw","lankay","lanlan","lanlidi","lansa","lansad","lansadira","lansalira","lansang","lansar","lansaranan","lansarira","lansaru","lansaruhun","lansaruun","lansilira","lansis","lansita","lansiyang","lanslayid","lansu","lansun","lansunis","lanta","lantaka","lantap","lantaw","lantaw ug layag","lantay","lantayug","lanti","lanting","lantip","lantsa","lantugay","lantugi","lantugiun","lantung","lanubu","lanug","lanulin","lanut","lanutlanut","lanutun","lap-ak","lap-aklap-ak","lap-ut","lap-utay","lapa","lapad","lapad ang atay","lapad ug sala","lapak","lapalapa","lapanag","laparu","laparun","lapas","lapas na sa kalindaryu","lapasi","lapat","lapaw","lapaw sa","lapay","lapdus","lapgus","lapi","lapian","lapida","lapiki","lapilapi","laping","lapinig","lapis","lapis linungbuy","lapiti","laplap","lapnis","lapnut","lapnuy","lapnuylapnuy","lapris","lapsanan","lapsaw","lapsaw ug dugu","lapsaw ug utuk","lapta","laptalapta","lapu","lapug","lapuk","lapuk sa agtang","lapuklapuk","lapukun","lapulapu","lapung","lapus","laput","lapuy","lapwa","lapya","lapyahan","lapyahanan","lapyat","lapyu","larag","larag ang bulak","laran","larang","laras","larasan","laraw","larawan","laray","larga","larga manuk","largabista","largada","largadur","largit","largu","larguhanan","laring","larinu","laruk","larut","laruylaruy","laryang","las","las trip","las-ag","las-ay","las-u","las-ung","las-ut","lasa","lasak","lasang","lasangnun","lasaw","lasaw ug dugu","lasbi","lasbi ug","lasgas","lasib","lasid","lasik","lasing","laski","laskuta","laslas","lasmu","lasnit","laspa","last","last dil","last trip","lastats","lasti","lastiku","lastrip","lasu","lasugas","laswa","lasyadur","lasyu","lat","lat-ang","lat-anglat-ang","lat-as","lat-asanan","lata","latab","latad","latag","latagaw","latak","latang","lataran","latas","latas sa","latasunun","latay","latay sa kangga","latay sa usa ka lugas lanut","latayan","latayanan","latbu","latbug","lathang","lati","latiba","latid","latigu","latik","latin","lating","latu","latuk","latun","latundan","latung","latungdan","latus","latuy","lau","laublaub","laud","laug","laugan","laugdu","laum","laumlaum","laun","launduk","laung","laus","lausag","lauy","law-ay","law-it","law-uy","lawa","lawaan","lawaan nga puti","lawaan pula","lawag","lawak","lawak pahulayan","lawalawa","lawang","lawanglawang","lawanlawan","lawas","lawas ug katarungan","lawasan","lawasnun","laway","laway ray puhunan","lawayan","lawaylaway","lawgaw","lawi","lawian","lawig","lawigan","lawihan","lawilawi","lawis","lawiswis","lawit","lawitan","lawitlawit","lawlaw","lawngun","lawril","lawriyat","lawsi","lawting","lawud","lawudlawud","lawudnun","lawug","lawung","lawus","lawut","lay","lay-u","lay-ug","laya","laya ang baga","laya ug baga","laya ug lagudlagud","layag","layagan","layagun","layagun ug datu","layalaya","layanglayang","layas","layat","layaw","layaw ug dugu","layaw ug hunahuna","layaw ug utuk","layawan","laybrari","laybrariyan","laygay","layhan","layi","layi diantigwa","layik","layiku","layip","layit wit","laylay","laylu","layning","laysul","layti","laytir","layu","layu nga silangan","layu ra","layu ra sa tinai","layu ra sa tinai sa manuk","layu sa tinai","layug","layuglayug","layun","layus","li","liab","liad","liadliad","liap","liat","liawt","lib","lib-ug","liba","libad pa","libadura","libagbag","libagha","libak","libakag","libakira","libakiru","liban","libang","libang ang baba","libanta","libas","libat","libaung","libaungun","libayan","libganun","libgaw","libgus","libilawu","libilu","libinta","libintadur","libiral","libirasiyun","libirisyun","libirtad","libitus","libkas","libra","libras","libri","libri kumida","libri pasahi","librihanay","librihay","librilibri","libririya","librita","libritu","libritu sa bangku","libritu sa tikit","libru","librulibru","libu","libud","libud suruy","libudlibud","libug","libugan","libugay","libuhay","libulibu","libun","libur","libur di","libur yunyun","liburus","libut","libut sa","libutug","libuu","libuy","libwas","libwaslibwas","libwasunun","lid","lid gitar","lidgid","lidgiran","lidgiranan","lidibag","lidir","lidiratu","lidis","lidis diyis","lidis dringk","lidis tsuys","lidlid","lig-un","lig-un ug kasingkasing","liga","liga puul","ligad","ligad sa kasarangan","ligadira","ligal","ligal nga asawa","ligal nga siparasiyun","ligalidad","ligas","ligasan","ligasun","ligaw","ligay","ligdas","ligdung","lighut","ligid","ligid sa banig","ligingliging","ligings","ligis","ligitligit","ligngin","ligpit","ligsanan","ligsi","ligsik","ligtak","ligti","ligtik","ligtiw","ligu","ligung","ligutgut","liguy","liguyliguy","ligwa","ligwan","ligwat","liha","lihang","lihat","lihay","lihi","lihiri ug kamut","lihiru","lihisladur","lihislatibu","lihislatura","lihiya","lihu","lihud","lihug","lihuk","lihukan","lihukun","lihut","lik-up","likag","likat","likay","likbung","likhad","liki","liki sa kawayan","likid","likida","likidar","likids","likidu","likin","likinan","likis","likisan","likit","liklik","likmu","liksi","liksiliksi","liksiyun","liktanay","liktyur","liku","likuan","likuanan","likub","likud","likudlikud","likug","likuliku","likulikuan","likulikuhan","likung","likup","likuplikup","likuran","likus","likuslikus","likut","likuy","likwa","likwad","likwadlikwad","likwala","likwalikwa","likwang","likyad","lila","lilang","lilas","lilasan","lili","liligan","lilingbasan","lilingliling","lilit","lilitik","liliun","lilu","liluan","liluk","lilung","lim-aw","lima","limangka","limas","limasun","limatuk","limba","limbag","limbahun","limbakug","limbalimba","limbaruk","limbarut","limbas","limbasug","limbatianun","limbaun","limbawut","limbu","limbu rak","limbukad","limbung","limbungan","limbuwad","limbuyuk","limin","liminlimin","limis","limitadu","limitar","limiti","limpangug","limpisa","limpiya","limpiya butas","limpiyada","limpiyu","limtanun","limu","limud","limugmug","limugmugan","limuhag","limuk","limukun","limulimu","limun","limunada","limunada ruhi","limunglimung","limunsitu","limunsitus","limuruk","limus","limut","limuta","limutlimut","limuut","lina","linaang","linab","linabag","linabhuan","linabug","linabuhan","linadlad","linagbasan","linaginit","linagiti","linagkaw","linagpak","linagpang","linagsik","linagtang","linagtangan","linagubu","linahap","linahapan","linakadan","linakaran","linaki","linaktan","linaktud","linalang","linalik","linama","linamaw","linambay","linambid","linambiran","linambunan","linamu","linamuyan","linan-us","linandag","linangkub","linangyan","linanta","linantip","linapak","linapya","linaras","linat-an","linata","linatik","linaw","linawas","linay-anay","linayagan","lindag","lindug","ling-un","linga","lingab","lingabngab","lingag","lingagngag","lingas","lingat","lingatung","lingaw","lingawlingaw","lingay","lingbahun","lingbas","lingbas nga lingin","lingbas nga midiya lingin","lingbas nga tris kantus","lingga","linggalingga","lingganay","lingganayan","linggawas","linggiru","linggukud","lingguwahi","lingguwista","lingguwita","linghud","lingi","lingig","lingin","lingin ang bula","linginun","lingiw","lingka","lingkaang","lingkag","lingkalang","lingkang","lingkas","lingkawas","lingkit","lingkubaw","lingkud","lingkung","lingkuranan","lingkurun","lingkus","lingla","lingling","lingu","linguglingug","lingugngug","linibu","linidgid","linihukan","linikin","linikit","linimintu","linimsan","linin","liningbas","lininuan","linis","linitsun","linlang","linsa","linsuwak","linta","lintadu","lintar","linti","lintihuylas","lintubaw","lintuhilas","lintunganay","lintuwad","lintuwang","linu","linubag","linubid","linubung","linudhan","linug","linug-ag","linugabu","linugamak","linugan-ub","linugapak","linugatub","linugaw","linugdang","linugdangan","linugsanay","linulyum","linunaw","linungbuy","linungkab","linunhan","linunud","linupak","linusak","linusbak","linusuk","linuti","linutu","linutuan","linuug","linuwang","linuwas","linuyang","linya","lip-an rayit","lip-istik","lip-it","lip-ut","lipad","lipagha","lipaghung","lipak","lipaka","lipang","liparak","lipas","lipas ang gutum","lipasan","lipat","lipata","lipatlipat","lipatpat","lipay","liphuk","liplip","lipstik","lipsut","lipti","lipting","liptung","lipu","lipudlipud","lipulipu","lipun-ug","lipung","liput","lipuwa","lipya","lira","liraw","lirawliraw","liri","liru","liruliru","lirung","liryu","lis","lisa","lisang","lisay","lisik","lisinsiya","lisinsiyadu","lisis","liskad","liskag","liskug","liskuhag","lisngag","lisngig","lispu","lista","listahan","listu","listun","lisu","lisu sa buut","lisu sa turnilyu","lisu sa twirka","lisu sa utuk","lisuanan","lisuay","lisud","lisudlisud","lisuglisug","lisuhan","lisulisu","lisun","lisun plan","liswi","lisyinsiya","lit","lit-ad","lit-adlit-ad","lit-ag","lit-ag nga mubutu","litaniya","liti","liti sa udtung tutuk","litik","litikanay","litikay","litiklitik","litiliti","litira","litiral","litiratura","litis","litkanay","litra","litratista","litratu","litru","litruhan","litsi","litsi kun yilu","litsi kundinsada","litsi plan","litsi priska","litsihan","litsilitsi","litsing yawa","litsugas","litsun","litsun dilitsi","litsunun","litu","lituanan","litub","litub sa amu","lituglitug","lituk","litundan","liu","liug","liug sa bitik ni san markus","liugat","liunduk","liup","lius","liuslius","liut","liwa","liwag","liwas","liwat","liwat sa giliwatan","liwayway","liwit","liyaliya","liyinda","liyu","liyug","liyugliyug","liyuk","liyun","lu","luad","luag","luagluag","luaryang","luaryung","luas","luatan","luay","lub-ang","lub-angun","luba","lubad","lubag","lubag ang pangarmin","lubaglubag","lubak","lubakan","lubang","lubarun","lubas","lubasan","lubat","lubaung","lubay","lubaylubay","lubganan","lubi","lubi nga lupisan","lubi nga ugis","lubid","lubidlubid","lubilubi","lubing","lubintadur","lubiran","lubitus","lubkanan","lublub","lublubanan","lubnganan","lubngananun","lubu","lubug","lubug sa banig","lubugun","lubuk","lubulubu","lubun","lubung","lubung sa kalimut","lubus","lubus kaliwat","lubut","lubut mu","lubut sa basu","lubut sa kulun","lubut ug anay","lubutlubut","lubyuk","lud","lud-an","lud-anan","lud-anun","lud-unun","luda","ludabi","ludhan","ludhanan","lug-as","lug-is","luga","lugabu","lugabung","lugak","lugaluga","lugamak","lugan-ub","lugapak","lugar","lugaraha","lugas","lugas lanut","lugatub","lugaw","lugay","lugaynan","lugaynun","lugbak","lugbati","lugda","lugdang","lugdat","lugdum","lugdung","lugi","luging","lugit","lugituk","lugitum","lugkab","lugkat","luglug","lugmak","lugmaw","lugmay","lugmuk","lugmuy","lugnas","lugnut","lugpad","lugpit","lugput","lugraha","lugru","lugsad","lugsanay","lugsung","lugsung sa","lugsungun","lugsut","lugtab","lugtas","lugti","lugu","lugud","luguk","lugum","lugus","lugut","lugwa","lugway","luha","luha sa bau","luha sa dalaga","luhaan","luhag","luhaluha","luhangan","luhaun","luhit","luhu","luhud","luhud (pangluhud)","luhudluhud","luhuranan","luib","luing","luka","lukab","lukad","lukahay","lukal","lukal mid","lukaluka","lukap","lukapa","lukas","lukat","lukat sa signus","lukat ug away","lukat ug lalis","lukatan","lukay","lukaylukay","lukba","lukbun","lukdu","lukdu ug kalbasa","lukdulukdu","lukgaw","lukguk","lukim","lukimya","luking","lukip","lukluk","lukmay","lukmuy","luksu","luktun","luku","luku diamur","lukub","lukublukub","lukud","lukuluku","lukun","lukun sa bulak","lukunan","lukung","lukung sa bulak","lukunglukung","lukunlukun","lukup","lukuplukup","lukut","lukut sa banig","lukutlukut","lula","lulan","lulaw","lulhu","lulid","lulinghayaw","lulipap","lulu","lulu mu","lululagunda","lulut","luluy","lum-it","luma","lumad","lumadnun","lumag","lumalabay","lumalabu","lumalakat","lumaluma","lumat","lumawig","lumay","lumayagun","lumayan","lumba","lumbaanan","lumbaanay","lumbaglumbag","lumbagu","lumban","lumbang","lumbay","lumbayan","lumbiya","lumbuy","lumi","lumid","luminarya","luming","lumiru","lumiun","lumlum","lumpag","lumpanug","lumpat","lumpatlumpat","lumpayat","lumpi","lumping","lumpiya","lumpiya nga prisku","lumpiya nga pritu","lumpu","lumpung","lumput","lumu","lumud","lumuk","lumulupyu","lumun","lumung","lumus","lumus sa sabaw","lumut","lumutlumut","lumutun","lumuy","lumyan","lun","lun-as","lun-ub","lun-us","lun-ut","luna","luna dimiyil","lunag","lunang","lunas","lunaw","lunay","lundag","lundris","lunduk","lung tibul","lung-ag","lunga","lungaan","lungab","lungag","lungas","lungay","lungbuy","lungbuyun","lungdistans","lunggu","lunggub","lunggung","lunggungan","lunghan","lungi","lungib","lungis","lungkab","lungkaub","lungki","lunglayin","lungnik","lungnus","lungpli","lungslib","lungsud","lungsudnun","lungsuranun","lungtad","lungulungu","lungun","lungutlungut","lunhat","lunhaw","lunis","lunit","lunlun","lunmawir","lunsay","lunsing","lunsud","luntad","luntalunta","luntud","luntudluntud","lunu","lunud","lunud ang buwan","lunud ang puhunan","lunud palit","lunud patay","lunuglunug","lunuk","lunup","lunus","lunuy","lup-ad","lup-aranan","lup-it","lup-ug","lup-ut","lupa","lupa ang atay","lupad","lupad ang","lupak","lupasi","lupi","lupig","lupig pay mantika kun matulug","lupig sa balhibuay","lupir","lupis","lupnis","lupu","lupug","lupuk","lupus","luput","lupuy","lupyak","lupyu","lurang","lurat","luray","lurir","luru","lurung","lus","lusa","lusad","lusak","lusaranan","lusaun","lusay","lusaylusay","lusba","lusbak","lusbakunun","lusbu","lusbug","lusgus","lusi","luslus","luslus mu","lusnu","luspad","lusparun","luspi","lusu","lusu nimu","lusu niya","lusub","lusug","lusuk","lusun","lusung","lusut","lusyun","lut-ud","luta","lutab","lutaban","lutabun","lutahan","lutak","lutaluta","lutang","lutanglutang","lutariya","lutas","lutaw","lutaw ang ganansiya","lutaw sa hangin","lutaw ug dugu","lutay","luthang","luthangluthang","luti","lutiriya","lutlut","lutsanan","lutu","lutu daan","lutu nga makaw","lutub","lutuk","lutung","lutung makaw","lutup","lutus","lutuy","lutya","luub","luud","luug","luuging","luuk","luukluuk","luum","luun","luup","luuran","luuray","luus","luuy","luwa","luwa-","luwaanan","luwag","luwak","luwaluwa","luwang","luwas","luwat","luwis","luwist","luy","luy-a","luy-a nga tapul","luy-aluy-a","luya","luyahun","luyang","luyat","luyhanun","luyluy","luyu","luyu ug luyu","luyuluyu","luyung","luyut","lyabi","lyabira","lyabiru","lyagay","lyamada","lyamadur","lyamar","lyamar ang tiyan","lyawi","lyukimya","lyupis","ma","ma-","ma-anun","ma-in-anun","ma-in-un(←)","ma-un","ma-un(←)","maabiabihun","maabibahun","maabut sa luwa","maaghatun","maaghup","maaginhun","maagmaag","maakuakuhan","maakuakuun","maalagarun","maalam","maalam-alamun","maalampuun","maalamun","maalualuhun","maampingun","maampuun","maamung-amungun","maangayun","maangduun","maanindut","maantusun","maanyag","maarang-arang","maas","maasa","maasiasihun","maawhagun","maayu","maayu ang pining","maayu gani","maayu kay","maayu lang tayada way tadtad","maayu pa","maayu pay amu naa pay duha ka daku sa lubut","maayu ra","maayu ug pulsu","maayu unta","maayung buntag","maayung laki","maayung pasku","maba","maba ug lanat","mabadlungun","mabagitbagitun","mabaharun","mabakhuun","mabalak-un","mabalakhun","mabalhinun","mabangis","mabantayun","mabaw","mabaw ug lubut","mabaw ug salabutan","mabdus","mabdus sa pasalig","mabgas","mabiaybiayun","mabihagun","mabinag-uhun","mabinansayun","mabinantayun","mabinatiun","mabinatukun","mabudhiun","mabugalun","mabugnawun","mabuhatbuhatun","mabuhi pay ginamus","mabul-ugan","mabulakun","mabulu","mabungahun","mabuut","mabuutbuutun","mad-as","madaginutun","madagmalun","madahan nga","madahan ug","madaitun","madalag","madalidaliun","madamguhun","madanihun","madasigun","madaugdaugun","madaugun","madil","madilun","madinayganun","madinumtanun","madirn","madrasta","madri","madri dipamilya","madri kakaw","madri miya","madri supiryura","madrihun","madrina","madugu","maduhaduhaun","madukidukiun","madulumtun","madumduman","madungganun","madyik","madyikiru","madyung","madyung tibul","madyungan","madyungira","madyungiru","madyurit","mag-","mag-aampu","mag-agaw","mag-alampu","mag-alanak","mag-l-","mag-r-","mag-unsa","maga-","magaagak","magahat","magahi","magalyanis","magang","magarayun","magarbuhun","magasin","magay","magay magay","magaya","magbababuy","magbabalak","magbabalaud","magbabantay","magbabasa","magbabaul","magbalantay","magbalantay sa kalinaw","magbalasa","magbarkada","magbaw","magbubahat","magbubuhat","magbubuhis","magbubukag","magbubulung","magbubuut","magdadagan","magdadalayig","magdadapit","magdadaru","magdadasig","magdadaut","magdala sa iray","magdalaut","magdayig ug pul-an ug guna","maghahalad","maghahatag","maghalatag","maghihilut","maghihimu","maghilak ang panahun ug dili","maghilimu","maghitsura","maghuhubad","maghuhuni","magil-asun","magilakun","magilukun","magindanaw","magitikun","magka-","magka-(←)","magkakandila","magkukudlit","magkukulit","magkunu","magkurbata","magkut","maglalantugi","maglalatik","maglilimpiya","maglilimpiyu","maglilindug","maglilipay","magmalatay","magmamandu","magmamantala","magmilinyu","magmumugna","magnisya","magnisya simpli","magnit","magpalas-an","magpalatik","magpapas-an","magpapatigayun","magpapatik","magpatugatuga","magpipirlas","magpipisi","magpupuhunan","magsasagib","magsasangyaw","magsilirbi","magsisibya","magsusugilanun","magsusukud","magsusulat","magsusumbung","magsuun","magsuun sa lamisa apan dili sa bulsa","magtagsa","magtagurha","magtalisay","magtatagik","magtatambag","magtatanum","magtiayun","magtutudlu","magtutukud","magtutunhay sa kalinaw","magu","magubaun","magubtanun","magugulun","magukdanun","magul-anun","magulang","magulang sa hatag","magus","maguugmad","maguuma","magwawali","magyuyuhut","magyuyuta","maha","maha blangka","maha diubi","maha riyal","mahadlaun","mahadlukun","mahagithagitun","mahagitun","mahakinsa","mahakinsakinsa","mahal","mahal nga adlaw","mahal ug pahiyum","mahal ug tingug","mahalun","maham-utun","mahan","maharihariun","maharlika","mahasulun","mahatas-un","mahatungud","mahay","mahayag","mahayluhun","mahayluun","mahibudnganun","mahigalaun","mahigugmaun","mahika","mahiku","mahilak","mahilapun","mahilig","mahiligun","mahilumun","mahimayaun","mahimu","mahimuslanun","mahimut-anun","mahimut-un","mahinalangpun","mahinalun","mahinamun","mahinangpanun","mahingawaun","mahinugnanun","mahinuklugun","mahinungdanun","mahistradu","mahitas-un","mahitungud","mahudiyakaun","mahugani","mahugaw","mahulgaun","mahumpayun","mahumut","mahunahunaun","mahunatun","mahuniun","mahunpawun","mahuyang","maibganun","maibid-ibirun","maibugun","maidaran","maigang","maikagun","mailibgun","mailuku","main-ampuun","mainampingun","mainantusun","mainitun","mainum","mais","maisal","maisan","maisig-isigun","maisip","maismais","maistra","maistru","maistru amu","maistru kusina","maistru kusiniru","maisug","maisugun","maisun","maitukun","maka-","maka-r-","makaagpas sa lisu","makabibihag","makadaghan","makadili ug bahu","makadiyu","makadiyut","makag-usa","makagagahum","makaguguul","makahahadluk","makahiya","makahubas ug danaw","makahuhumpay","makahulganun","makahuluganun","makaiibug","makailikganun","makalalagut","makalibri","makalilibug","makalilimus","makalilinga","makalilingaw","makalilisang","makalit","makalitun","makaluluuy","makan","makantalitahun","makanunayan","makapadaku sa atay","makapakitbi sa atay","makapakulu sa atay","makapiang","makapila","makapitu","makapulu","makapunu","makariyut","makaruni","makasasala","makasaysayanun","makasusubu","makatarunganun","makatulu","makaun","makaupat","makausa","makauulaw","makaw","makawalu","makawiwili","maki","makiangayun","makibabayi","makidiyus","makig-(←)","makigdaitun","makighi-un","makililimus","makilungsud","makilungsudnun","makina","makina dimutur","makina sa bugas","makinaadmanun","makinarya","makinasudun","makinilya","makinilyadu","makinista","makinita","makisandurutun","makisapi","makisini","makitawhanun","makiyutawhanun","makmak","makmak ug kasaba","makmak ug sulti","makra","maksut","maku","maku dyamu","makuli","makuliun","makulub mahayang","makupa","makurugun","makutihun","mal","mal numiru","mal tirada","mal-am","mal-idukada","mal-idukadu","mala","mala sa dugu","malabagakay","malabanu","malabutang","malagaya","malaglagun","malagmit","malagsikun","malagutun","malahalun","malakanyan","malakanyang","malam-an","malam-un","malamatun","malambuun","malamdagun","malampusan","malanganun","malangsi","malantugiun","malapasun","malapati","malapi","malapunti","malarya","malaryahun","malas","malasadu","malasawu","malasugi","malatalu","malatinduk","malaumun","malay","malayang","malaypalay","malayu","malbas","maldisiyun","maldita","malditu","malditu sa babayi","malibakun","maligas","malignu","malihuk","malimbungun","malimdanun","malimnu","malimtanun","malimutun","malinawun","malingin","malingka","malinglahun","malinis","malipayun","malipayun nga pasku","maliputun","malisu pay buku sa kawayan","malisya","malisyusa","malisyusu","malit","malita","malitin","malmal","malpagadur","malpagadura","maltabana","maltratar","malu","malu [dat.]","malu pa na","malu pa ug","malubgas","maluibun","malukmayun","maluluy-un","malumay","malumu","malung","malunggay","malungtarun","malupigun","malus","malutu","maluyahun","malyiti","malyurka","mam","mam-anan","mama","mama ug dugu","mamadur","mamahandi","mamakyawan","mamala","mamaligyaay","mamam","mamamagus","mamamahandi","mamamakyaw","mamamaligya","mamamaling","mamamamuu","mamamangga","mamamitayan","mamanduun","mamangaay","mamaw","mamay","mambad","mambu","mami","mamilikpik","mamiluku","mamimihag","mamimikpik","mamimintal","mamimisan","mamimisi","mamimista","maming","mamingaw","mamingawun","mamistahay","mamisu","mamisuun","mampud","mampur","mamsa","mamulugsay","mamuluyu","mamumugnu","mamumugsay","mamumuhat","mamumuhi","mamumulung","mamumulung maglalantugi","mamumumba","mamumun-ug","mamumunu","mamumunyag","mamumuyu","mamun","mamuray","mamurd","mamurds","mamuti (muputi) ang uwak","man","man diay","man gani","man kaha","man kayha","man lagi","man ugud","man usab","man-","man-ay","man-l-","man-r-","man-r-ay","mana","manag-agaw","managhigala","managing","managsuun","managtratu","manaku","manalabtan","manalagna","manalanggi","manalapi","manaluthu","manamu","manamu.","manan-aw","mananabang","mananabang ug sanggi","mananabtan","mananabung","mananag-an","mananag-ub","mananaga","mananagat","mananagit","mananagna","mananagpi","mananahi","mananakud","mananakup","mananalsal","mananalum","mananambal","manananda","manananggal","manananggi","manananggut","mananangku","mananangkuy","mananangway","mananantu","mananap","mananapas","mananapaw","mananapit","mananari","mananaug","mananayaw","mananaygun","manandis","manang","mananggiti","mananggiti nga nagkurbata","mananghid","mananiid","mananikit","mananiyu","mananuy","manatad","manau","manaul","manay","manbad","mandalusa","mandaluyung","mandamyintu diaristu","mandar","mandarin","mandasiyun","manday","manday unta","mandi","manding","mandu","mandunggada","mandunggu","manga","mangaabay","mangaagaw","mangaalahas","mangaangkat","mangaangkun","mangaapil","mangaayam","mangagat","mangagaw","mangalabay","mangalahuy","mangalangkat","mangalasawa","mangamut","mangandakun","mangangahuy","mangangalas","mangangalut","mangangandila","mangangati","mangangawkaw","mangapud","mangga","mangga buru","mangga wani","manggad","manggagahas","manggahan","manggahun","manggahungay","manggaranun","manggas","manggatus","manggi-","manggi-un(←)","manggiabiabihun","manggiakuakuhan","manggialamun","manggiapil-apilun","manggiasiasihun","manggibaluhan","manggibuhatun","manggibuhian","manggibuhiun","manggihatagun","manggihibaluun","manggihipusun","manggihunahunaun","manggilimtanun","manggilis","manggimbuhatun","manggisahaun","manggisanayun","manggisinahun","manggitahapun","manggiulawun","manggu","manggugubat","manggugubut","manggulimbaw","manggustan","manghahag-ut","manghahatag","manghalatag","manghihilut","manghihimalad","manghud","mangiihaw","mangiilad","mangiinsiyur","mangiisda","mangingidnap","mangingilin","mangkay","mangkimangki","mangku","mangkumu","manglalaban","manglalawgaw","manglilibak","manglilimpiya","mangliw","manglulugus","mangluluku","mangluluuk","mangluluwas","mangluy","mangnu","mangsi","mangtas","mangu","mangungudak","mangungulat","mangungulit","mangungulung","mangunguut","manguuway","mangyan","manhak","mani","mani sa kasuy","mani urdir","manibila","manids","manidsir","manidsir hiniral","manihu","maniit","manikin","manikiyur","manikiyurista","manila","manila buy","manila pipar","manilan-un","manilinya","manilinyu","manimani","manin-","maninay","maningamut","maninikas","maniniksik","maniniku","maninilhig","maninimba","maniningil","maninintal","maninista","maniniyat","maniniyun","maniniyut","manintabus","manintimus","maninuy","manipistu","manistil","maniubra","maniyut","maniyuy","mankumunidad","manla","manlawud","manlulunda","manlut","mansa","mansadu","mansahun","mansanas","mansanilya","mansanitas","mansibadu","mansinitas","mansiyun","mansu","mansuhan","mansuhanan","mantaga","mantala","mantalaan","mantalaga","mantas","mantianak","mantiaw","mantika","mantika dikakaw","mantikaun","mantikilya","mantil","mantilya","mantilyina","mantinil","mantinir","mantiw","mantiyanak","mantsa","mantsinitas","mantsusu","manu","manubig","manubila","manubu","manugimpu","manugimpul","manuhan","manuhik","manuk","manukan","manukmanuk","manukulu","manukun","manul","manulti","manulunda","manumanu","manumbaga","manung","manungbalay","manunggal","manunggul","manunubad","manunubus","manunugtug","manunugway","manunukub","manunukud sa yuta","manunukut","manunulay","manunulda","manunuli","manunulung","manununud","manunurusu","manunuruy","manus","manutu","manuy","manwal","manya","manyak","manyampuk","manyana","manyana ka lang","manyana ka purin","manyang","mapa","mapagarbuhun","mapagawalun","mapahimuslanun","mapahitas-un","mapahiubsanun","mapahiyumun","mapailubun","mapainubsanun","mapalabilabihun","mapalumalumahun","mapanagan-un","mapanamastamasun","mapangabubhuun","mapangahasun","mapangandakun","mapangandamun","mapangilyupuun","mapanglimbasugun","mapangutan-un","mapaniirun","mapanindahayun","mapaningkamutun","mapasalamatun","mapasayluun","mapasigarbuhun","mapasipad-anun","mapasipalahun","mapasulabihun","mapatuyangun","mapaubsanun","mapikalun","mapilitun","mapinalanggaun","mapinasagarun","mapinasagdanun","mapinaubsanun","maping","maping upirisyun","mapinigun","mapinugsanun","mapuangurun","mapudsanun","mapugnganun","mapugsanun","mapugtasun","mapungtanun","mapunti","mapuslanun","mar.","marabal","marabilyas","marabya","maragabit","maragati","marakas","maral","maram","marama","maranaw","marang","marapita","maratun","marbas","margarin","margarina","margati","mari","maribagu","maribuhuk","mariguld","marihwana","marik","marika","marina","marinira","mariniru","marinu","maripusa","maripusa urkid","marisi","mariya","mariya agwanta","mariya buhuk","mariya klara","mariya santisima","mariyal","marka","marka bulkan","marka dimunyu","marka kalabira","marka rihistrada","markir","markis","markisa","markit","marku","markut","marmul","marpil","marsanti","marsiku","marsiyal","marsu","marsutu","martabana","marti","martilyu","martilyu dibula","martilyu dikabra","martiniku","martinis","martir","martir sa gulguta","martis","martis santu","marts","martsa","martsanti","martuniku","marubya","marunung","maruy","maruya","maryanas","maryusip","mas","mas [adj.]","mas bali","mas bali nga","mas-uk","masa","masa kumun","masaarun","masabug","masadiyaun","masahan","masahi","masahista","masalad-un","masalaypun","masaligun","masamung","masanagun","masanayun","masandurutun","masang","masariyal","masayaun","masaypanun","masi","masiawun","masibutun","masig","masig ka [noun]","masilagun","masimasi","masin-gan","masinabtanun","masinabutun","masinahun","masinandurutun","masinayurun","masinggan","masinugtanun","masinundanun","masinupakun","masip-ut","masipaun","masitas","masitas sa ingkantu","masitasan","masitira","masiyar","maskada","maskara","maski","maskin","maskipap","maskipaps","maskirid bul","maskulada","maskuladu","masputitu","masputitus","mastir","mastir katir","mastir ki","mastir mayind","masturbisyun","masu","masudiyaun","masuk-anun","masukihun","masuktanun","masulingahun","masulub-un","masun","masundanun","masungtanun","masunurun","masupilun","masurahun","masustansiya","masustansiyahun","masusu","masusuylu","masusuyluhun","masuy","masyada","masyadu","masyadur","masyaw","mat","mat-an","mat-an pa sa pinya","mat-ay balili","mata","mata pubri","mata sa","mata sa baling","mata sa baskit","mata sa gabi","mata sa lubi","mata sa pinya","mata sa ulitawu (dalaga)","mata ug buntag","mata ug lumban","mata ug sikup","matada","matadira","matadiru","matadur","matag","matag [verb base]","matag [word referring to time or day]","matag karun ug unya","matag tiki","matag usa [dat.]","matahaan","matahapun","matahum","matak-anun","mataka","matakdanun","matalak-un","matam-isun","matamata","matamayun","matambaka","matambalun","matamihirun","matampuhun","matang","matanglas","matansa","matansira","matansiru","matarung","mataw-anun","matawa","matay","mati","matiawun","matig-a","matikmatik","matikud","matimati","matimatiks","matinabangun","matinagaun","matinagdanun","matinaguun","matinahurun","matinamdanun","matinamihirun","mating","matintalun","matinud-anun","matinumanun","matinumanun sa gustu","matir dulurusa","matiriyal","matirniti","matirniti lib","matiryalis","matiryalis pwirtis","matistisun","matmat","matnga","matngun","matngun ug buut","matraka","matrakahun ug baba","matridu","matrikula","matrimunyal","matrira","matriru","matris","matruna","mats","matsa","matsing","matsuy","matubagtubagun","matubayun","matubitubiun","matud [gen.]","matud pa [gen.]","matugbawun","matuhupun","matuhutuhuun","matukiun","matuli","matulisukun","matulug","matulugun","matulun-anun","matumat","matun","matungluhun","matunhayun","matutu","matutulun","matuud","matuuhun","matuutuuhun","matyag","matyanak","mau","mau bitaw","mau diay tsu","mau gayud","mau gihapun","mau kaayu","mau kana ug kana","mau kini ug kini","mau kinig kini","mau lamang","mau lang","mau man gani","mau na sa ginhawa","mau na sa ginhawang [verb]","mau nang","mau nay lalaki","mau nga [noun]","mau nga [sentence]","mau pa","mau pa diay atu","mau pay ... mau pay","mau pay [abstract form] or [instrumental passive]","mau pay [verb","mau pay [verb]","mau ra","mau ra gihapun nga bisyu","mau ra nga","mau ra pud hinuun","mau ra pud nuun","mau ra ug","mau ra usab hinuun","mau rag (si) kurik","mau rang ubana","maukubun","maukutun","maukyabun","maulagun","maulawun","maumau","maumau na sa ginhawa","maunaunahun","maundanun","maung","maunsa ba","maunuk-unukun","maunungun","mauraura","mausbawun","mausikun","mausisahun","mauswagun","mauswahun","maut","mauy (ang) pag-[verb]","maw-uy","mawilihun","mawmaw","mawu-","mawungmawung","mawutpis","may","may (walay) alam","may (walay) markit","may (way) kapin nga kabubut-un","may adlaw rang magabii","may arti","may distansiya","may gahapun","may gats","may hangin","may hayit","may idad","may lain pa","may lain pi","may mga","may nigusyu","may pagka-","may panuigun","may tawu na ang payag","may tipu","may ubligasiyun","may-ung","maya","maya nga bungul","mayam-irun","mayaman","mayamaya","mayana","mayaus","maybay","mayhu","mayhum","mayik","maylab","maymay","maynur","maynur patrun","maypay","mayrun","maytir","maytir baks","mayu","mayubitun","mayugtanun","mayuhumun","mayukmuk","mayung","mayunis","mayunisa","mayur","mayur diidad","mayur duma","mayur dumu","mayuriya","mayuru","mayuskula","mga","mga partikular","mga unang tawu","mi","mi mayur","mi minur","mi-","mid","mid tu urdir","mid-in dyapan","mid-ub-anur","midal","midalist","midalya","midalyun","midi","midida","midikal","midikilyu","midiku","midiku ligal","midisin","midisin bag","midisin kabinit","midisina","midiya","midiya agwa","midiya bangku","midiya diya","midiya lutu","midiya nutsi","midiya paga","midiya tawu","midiyahan","midiyamidiya","midiyas","midiyasan","midiyu","midiyu [adj.]","midiyus","midtik","midtirm","midul kard","midwayip","midwayipiri","midyur","miga","migkap","migkat","migrupunu","migu","miguwa ang pari","mihihi","mihimihi","mihit","mihuras","mik","mik-ap","mika","mikanikal","mikanikal indyinir","mikanikal indyiniring","mikaniku","mikanismu","miki","mikru krum","mikrubyu","mikrupunu","mikruskupyu","mikskla","mil","mil unu","milagru","milagru ug","milagrusa","milagrusu","milamila","milangkuliya","milaru","milbaks","milibiki","miligramu","miliguy","milimitru","milindris","milisya","milisyaun","militar","milk","milma","milmil","milu","milun","milung","milya","milyahi","milyun","milyun dalar ismayil","milyun dalar ligs","milyun plawir","milyunarya","milyunaryu","mimbru","mimi","miming","mimis","mimu","mimurandum","mimurayis","mimurya","mimyu","mimyugrap","min-ibin","min-ibint","min-ibintir","min-upis","mina","minaayu","minabaw","minagbaw","minahal","minahan","minahun","minakinilya","minalditu","minananap","minandis","minantikaan","minantinil","minanuk","minarunung","minasinggan","minatada","minatarung","minatay","minaut","mindanaw","ming","ming-","mingaw","mingaw pay (pa sa) tirana","mingaw sa gunting","minghuy","mingkay","mingming","mini","minimu","minimum","minindyaytis","miniral","miniralis","minirba","miniru","miniskirt","ministil","ministiryu","ministisu","ministru","mins","minsahi","minsahiru","mintal","mintalidad","mintira","mintiryu","mintras","mintras tantu","mintul","minu","minubu","minudu","minuldi","minunga","minur","minur diidad","minuriya","minurminur","minurus","minus","minuskula","minutiru","minutu","minutus","minyak","minyat","minyu","mira","mirakul","mirakul rayis","miramira","mirasul","mirida","mirigurawun","miriku","mirinda","miringgi","mirisi","miritu","mirkadu","mirkana","mirkanu","mirku krum","mirkulis","mirkulis santu","mirkyur krum","mirkyuru krum","mirma","mirtiyulit","mirun","miruy","miryinda","miryinda sina","mis","mis palad","misa","misa diaginaldu","misa digalyu","misa digrasya","misa ditris","misa griguryana","misa ispisiyal","misa kantada","misa kumun","misa kunsilibrada","misa mayur","misa puntipikal","misa rikim","misa risada","misa sulimni","misada","misal","misay","misbuy","misik","misimis","misimus","misirabli","misirinubis","misis","misita","misitas","misitasan","misitira","misiyas","misiyun","misiyunary","misiyuniru","miskinu","miskla","mismis","mismu","mistik","mistil","mistir","mistiri tyun","mistiryu","mistiryu dulurusu","mistiryu gususu","mistiryu sa himaya","mistiryusa","mistiryusu","mistisa","mistisa dris","mistisahun","mistisilya","mistisu","mistisu balulang","mistisu sanglay","mistisuhun","mistra","mistru","miswa","misyunibirs","mitad","mital","mitalika","mitaliku","mitamita","mitamitaun","mithi","miti","mitilmitil","mitimiti","miting","miting di abansi","miting diabansi","mitinganan","mitirmitir","mitkan","mitmit","mitna","mitru","mitruhan","mitrus","mitrusan","mitsa","mitsadu","mitsahan","mitsilin","mituaku","mitudu","mituluhiya","mituu aku","miuk-uk ang butbut","miunmiun","miya","miyaw","miyur","mlbn.","mm","month","mr.","mu","mu rag gisagpa ug wala","mu rag naghatud ug dili","mu rag nakadili","mu rag si kinsa","mu-","mub","mubgas","mubil","mubil patrul","mubu","mubu ug buut","mubu ug ginhawa","mubu ug idukasiyun","mubu ug lanat","mubu ug lupad","mubu ug paminsar","mubu ug panlantaw","mubu ug pasinsiya","mubu ug tinan-awan","mubu ug tubul","mubu ug tul-an","mud-uk","mud-ukun","muda","mudilu","mudipikar","mudiradur","mudirn","mudirnu","mudista","mudmud","mudmuluanun","mudtu","mudu","mudugu pay uhung","mudus","mudus upirandi","mug-aw","mug-ut","mugbu","mugbu pa ang lubi","mugmug","mugna","mugtuk","muguwa ang pari","muhir","muhun","muilis nga simana","mukasin","mukaug baga","mukda","muku","mukuy","mul","mula","mulasis","muldi","muldihan","mulignu","mulinu","mulistiya","mulitsing","mulmul","multa","multibaytamins","multiplay","multiplikar","multiplikasiyun","multiplikisyun tibul","multu","mulu","mulupyu","mulyi","mulyihan","mulyinu","mumhu","mumhuun","mumintu","mumu","mumug","mumuy","munamuna","munarkiya","munastiryu","munay","mundu","munduy","munga","mungaan","mungalung","mungawmungaw","mungawung","munggus","mungha","munghi","mungit","mungkadista","mungkadu kuluni","munha","munhi","munisipal","munisipyu","munitur","muntada","muntar","munti","muntinglupa","muntura","munumintu","munyika","munyika nga nuug","munyumintu","muplay","mur","mur pa","mura","murabya","muradu","mural","muralidad","muralista","murdir","murgi","murina","murinu","muritsing","murkun","murpina","mursiku","mursikus","murtal","murtal sin","murtar sin","muru","murumuru","murun","murus","murusu","muryumuryu","mus","mus na","musa","musgut","musgutan","musi","musika","musikal","musikira","musikiru","musiku","musimus","muskatil","muskit","muskitiru","muskitiru ug tabla","muskubadu","muskuladu","muskulawu","musmus","mustasa","mustra","mustradur","musu","musuliyu","musyun","mut-uk","muta","mutaun","mutibu","mutil","mutimuti","mutsatsa","mutsatsu","mutsu","mutsu diniru","mutu","mutumutu","mutun","mutung","mutur","muturbayik","muturista","mutursaykul","mutursiklu","mutya","mutya sa mga mata","mutya sa saging tinduk","muu","muuk","muukan","muukmuuk ug katawa","muung","muut","muwaybuway","muy","muyu","mwiblis","mwilyi","mwistra","mwistradur","myapi","myaus","myimbru","myintras","myintras tantu","myirkulis","myusik","na","na gayud","na hinuun","na lamang","na lang","na man","na na","na pud","na usab","na-","na-an","naa","naa na pud lagi","naadtu","naaka","naana","naba","nabal","naban","nabdus","nabigar","nabu","nabusing","nada","nadaug sa halung","nadtu","nag-","naga","naga-","nagdala","nagdala ug kamhir","nagdayig ug pul-an ug guna","nagiknik","nagkarsunis","nagmu","nagnag","nagngisi mu rag buhi","nagsapnay ug mutya","nagtuyuk pa ang bula","nagumnum","nagutnut","nagutnutan","nagwas","nahinunghud","nahu","nahulugan ug nangka","nahut","nait","nak-awut","naka-verb]","nakadiyut","nakahikap sa lubut","nakariyut","nakdawun","nakig-","nakinnakin","naknak","naku","naku ug","nalam","nalisuan sa kwirdas","namarku","namat-an ug kahayag","nambir","nambir wan","namu","namuk","namun","nan","nana","nanak","nanam","nanang","nanaw","nanay","nang","nangka","nangnang","nanhi","nanimahung kumpurmi","naniw","nanu","nanuy","napkin","napta","naptalina","napu","napulu","nara","naranghita","narik","narkutiku","nars","narsing","narsis","nasiyunalismu","nasiyunalista","nasnas","naspu","nasud","nasudnun","nasyunalisar","nat kawuntid","natad","nataran","nati","natibidad","natu","natuk","natun","natural","naturalisa","naturalya","naug","naugnaug","nawasa","nawasa dyus","nawi","nawihan","nawnaw","nawug","nawung","nawung [gen.]","nawung sa dagat","nawung ug birnis","nawung ug dungsul","nawung ug hungut","nawung ug kwarta","nawung ug tikus","nawungan","nawunganay","nawungnawung","nay","nayanaya","nayintinayin","nayit klab","nayitgawun","nayitklab","nayitklabing","nayitlitir","nayits ab kulumbus","nayitskul","naylun","nayun","nbi","ndb","ng","nga","nga; — mu (ba)y","ngaab","ngaan","ngab","ngaba","ngabil","ngabngab","ngadtu","ngadtu nganhi","ngadtungadtu","ngalab","ngalan","ngalan nga","ngalngal","ngamig","ngan","nganga","ngangha","nganha","nganhi","nganhi lamang","ngani","nganu","nganu ba uruy","nganu gayud","nganu ug","ngari","ngasngas","ngatanan","ngatngat","ngawngaw","ngaya","ngi","ngiaw","ngibingibi","ngidlis","ngidngid","ngigngig","ngihit","ngil-ad","ngilbit","ngili","ngilit","ngilngig","ngilu","ngipnan","ngipun","ngisi","ngisingisi","ngislit","ngislu","ngisngis","ngitngit","ngitungitu","ngiub","ngiwngiw","ngiyan","ngiyaw","ngual","ngugngug","nguhal","nguhu","ngulngul","ngulub","ngulut","ngulutan","ngumiks","ngungu","ngurk","ngusngus","ngutngut","nguwal","nguynguy","nguyunguyu","ngyawa","ngyilu","ni","ni kinsa","ni-","nia","niadtu","niadtung tungura","niana","niani","niarun","nibi","nibi blu","nibil","nibiladu","nibilawu","nibir","nibir gayud","nibir mayin","nibira","nidnid","nidniran","nidnirun","nigar","nigatib","nigra","nigru","nigrus","nigu","nigusiyar","nigusyabul","nigusyanta","nigusyanti","nigusyu","nihit","nihitnihit","niini","niiri","niitu","nikiladu","nikilawu","nikinikinu","nikruluhiya","niktay","nikutin","nikutina","nila","nilab-as","nilabhan (linabhan)","nilaktan","nilanta","nilat-an","nilibu","nilidgid","nilkatir","nilugaw","nilugdang","nilupak","nilusak","nilusbak","nilutu","nilutuan","niluyang","nimpa","nimu","nindut","ning-","ninu","ninya bunita","ninyu","ninyu bunitu","ninyu inusintis","nipa","nipay","nipis","nipul","nirayahan","nirbiyus","nirbiyusa","nirbiyusu","nirbus brikdawun","nislagan","nisnis","nit","nitbul","nitruhinu","nitsu","nitu","nitung puti","niwang","niwniw","niya","niyan","niyun","noun","noun] lamang","npc","nu","nu parking","nu puydi","nub.","nubali","nubali [number of spanish origin]","nubali nada","nubatu","nubatus","nubi","nubila","nubilista","nubimbri","nubina","nubina nga bug-us","nubina sa kumun","nubina ug sugung","nubinahan","nubinaryu","nubinta","nubu","nubya","nubyimbri","nubyu","nudnud","nudul sup","nugbu","nuisu","nuisu karambula","nuka","nukanuk","nukaun","nukliyar","nukus","nukus sa ipil","nukus tarurut","nukusnukus","nuli","nulu","numbramyintu","numbrar","numbri","numinar","numinasyun","numirawu","numiru","numiru kwatru","numiru unu","numramyintu","numrar","numri","nung","nungka","nunut","nupuydi","nuranti","nurmal","nurt","nurti","nurul","nurwigu","nusnus","nusul","nuta","nutadu","nutaryu","nutaryu publiku","nutbuk","nutikal","nutisya","nutrisyunista","nuts","nutsi","nutsi buyna","nutsis","nuud","nuug","nuugnuug","nuun","nuy","nuybi","nuybinta","nwistra","nwistra sinyura","nwistra sinyura sa lurdis","nwistra sinyura sa patima","nya","nyibi","nyur","nyura","nyuralhiya","nyurita","nyuritu","nyus","nyus pipar","nyusbuy","nyutral","or [verb]","p.s.","p.s.k.","pa","pa gani","pa lamang","pa mayur","pa minur","pa sustinidu","pa-","paa","paabung","paabut","paagi","paagiw","paagpaag","paagpas","paagum","paahan","paak","paalibagbag","paalim","paalingawngaw","paalus","paalut","paambug","paambuhut","paamin","paanak","paanam","paangay","paangayan","paanghal","paangka","paangkan","paangtag","paantaw","paanud","paanuk","paapas","paapupa","paarat","paarbularyu","paarmikat","paarti","paaru","paarun ingnun","paarun-arun","paas","paas-ip","paasawa","paasir","paasu","paatab","paatbang","paatik","paatub","paatubang","paaw","paawas","paayang-ang","paayuayu","paayudi","paayun","paayup","pababayi","pabadlung","pabaga","pabaga sa nawung","pabagung","pabahar","pabail","pabakrawun","pabalun","pabalunan","pabalur","pabatal","pabatang","pabatibati","pabaya","pabhas","pabiga","pabilib","pabilibid","pabilin","pabilu","pabituls","pabiya","pablik","pablik biding","pablik disturbans","pablik iskul","pablik markit","pablik sirbis","pablikar","pabliku","pablisir","pablisiti","pablum","pabrika","pabu","pabu riyal","pabuadbuad","pabuak","pabuangbuang","pabug-at","pabugnaw","pabugnawan","pabugnawanan","pabugsuk","pabuhi","pabuhi sa dugu","pabukid","pabulan","pabulhut","pabungut","pabuntag","pabuntul","pabur","pabur sa hangin","paburabli","paburita","paburitismu","paburitu","paburut","pabuti","pabutu","pabuut","pabuy","pabuyag","pabyu","pad","pad-anan","padagaya","padagsang","padahan","padakbayan","padaku","padala","padalagan","padalagan sa dagang","padalayig","padamandaman","padamyang","padangat","padanglug","padapit","padaplin","padayag","padayday","padayugdug","padayun","padilantira","padilidili","pading","padir","padisgayis","padiyusdiyusnun","padlak","padlas","padpad","padri","padri dipamilya","padri nwistru","padrinu","padrun","paduguk","paduktur","padukuduku","padulung","padumug","padungugdungug","padupa","paduul","padyama","pag","pag-","pag-[verb] ug imu","pag-agawan","pag-andu (inig-andu) pa","pag-antus","pag-ayu","pag-ud","pag-uk","pag-ulingun","pag-umangkun","pag-umangkun sa pag-agawan (panag-agawan)","paga","paga distinu","paga-a","paga-an","paga-i","paga-un","pagabii","pagadiru distinu","pagadu","pagadu distinu","pagadur","pagahigahi","pagakpak","pagal","pagaligu sa bulawan","pagamut","pagan","pagana","paganansiya","pagang","pagangun","paganti","paganu","paganut","pagapak","pagarab","pagarbu","pagari","pagas","pagatpat","pagaw","pagawal","pagawas","pagawpaw","pagawpawun","pagawun","pagayun","pagba","pagbasul","pagbati","pagbuut","paghatag ug rinda","paghiamgu","paghid","paghinilak","paghinulsul","paghut","pagi","pagikan","pagiluk","pagiyun","pagka-","pagka-a(←)","pagkaamgu","pagkaanaa","pagkabulak","pagkabutang","pagkabutil","pagkaingun","pagkang","pagkatapus","pagkatawu","pagkatinuud","pagkaun","pagkut","paglaum","pagpag","pagpakasala","pagpakig-ingun-ingun","pagpuyu","pagranstan","pagrasya","pagsalig","pagsulay","pagsuma (inigsuma) pa","pagtagad","pagtan-aw","pagtandug","pagtulun-an","pagtung","pagtuu","pagtuun","pagu","pagud","pagudpud","paguha","pagula","pagulub","pagunting","pagupak","pagurut","pagustu","pagut","pagutput","pagya","paha","pahaba","pahabal","pahabalan","pahaigu","pahak","pahalipay","pahaluna","pahamtang","pahamutang","pahang","pahangin","pahanumdum","pahapun","pahat","pahatanan","pahatay","pahauliay","pahaw","pahawa","pahawin","pahayag","pahayagan","pahayahay","pahayahay sa baga","pahayahayan","pahayang","pahaylu","pahi","pahiangay","pahiayu","pahiayun","pahibalu","pahid","pahid ug sala","pahigayun","pahigut","pahigut sa asawa","pahigut sa pilitina","pahiigu","pahikut sa pilitina","pahilayu","pahilihili bagu kiri","pahilit","pahiluna","pahimangnu","pahimatngun","pahimaya","pahimug-at","pahimulus","pahimunalung","pahimungut","pahimus","pahimutang","pahina","pahinabangun","pahinadur","pahinadura","pahinahin","pahinanti","pahinar","pahinayak","pahindik","pahingawala","pahinhin","pahinug-u","pahinumdum","pahinungud","pahinunut","pahiran","pahiranan","pahit","pahitukma","pahiuli","pahiuyun","pahiyas","pahiyum","pahu","pahubas","pahubu","pahubung","pahugpahug","pahulam","pahulay","pahuli","pahumukhumuk","pahumut","pahunas","pahunat","pahung","pahungaw","pahungaw sa angsu","pahunpahun","pahuping","pahurnal","pahut","pahutpahut","pahuut","pahuwas","pahuy","paibabaw","paibug","paig","paigu","paigun","paigut","paiksri","paiku","paila","pailaila","pailalum","pailaya","pailin-ilin","pailu","pailub","paimpurtansiya","paingun","painit","painitan","painrul","pairid","pais","paisanu","paiskuyla","paislindir","paistiisti","paistits","pait","pait pa sa pangyawan","paitan","paitik","paitung","paiwit","pak","pak-an","pak-ap","pak-il","paka","paka ang inamang","paka-","pakaaduna","pakaadunahan","pakaanaa","pakaarun ingnun","pakaayu","pakababuy","pakabalaan","pakabana","pakabansay","pakabastus","pakabata","pakabathala","pakabatid","pakabuang","pakabuhi","pakabuntag","pakabuta","pakabuut","pakadiyu","pakadiyutay","pakaduktur","pakadungug","pakagabii","pakahapun","pakahilum","pakahimu","pakahinungdan","pakaignuranti","pakainahan","pakaingun","pakakita","pakal","pakalaki","pakalalaki","pakalit","pakamaalamun","pakamadri","pakamakinaadmanun","pakamanggiun","pakamatay","pakamatuud","pakamau","pakamithi","pakamutsatsu","pakamutya","pakanahut","pakang","pakaninyu","pakapin","pakarahay","pakas","pakasal","pakasala","pakasama","pakat","pakatagaabad","pakatakus","pakatam-is","pakatawu","pakatigas","pakatigulang","pakatulug","pakaugma","pakaulaw","pakaun","pakaw","pakawala","pakbit","pakdul","pakgang","pakgut","pakha","paki","paki-","pakibu","pakibut","pakids","pakidugang","pakig-(←)","pakig-an(←)","pakig-i","pakigbisug","pakigpulung","pakigsaad","pakilaba","pakililimus","pakilimus","pakiluuy","pakimaluuy","paking","pakingan","pakiput","pakira","pakiring","pakisayud","pakisi","pakisusi","pakit","pakit buk","pakit mani","pakit sayis","pakita","pakitabang","pakitambag","pakiti","paklang","paklay","pakli","paklid","pakling","pakluy","paknit","pakpak","pakpakan","pakpakun","pakshul","paksi","paksit","paksiw","paksiyun","paksul","paksut","paktaw","paktu","paktu diritru","paktul","paktura","paku","pakuankuan","pakudlit","pakug","pakugpakug","pakul","pakulukatulug","pakulungan","pakuma","pakumkum","pakumpisal","pakumpisyun","pakung","pakunsuylu","pakupak","pakupaku","pakupil","pakupya","pakurat","pakusug","pakut","pakutas","pakuyaw","pakwan","pakyas","pakyaw","pal","pal-ak","pala","pala man run","palaabsin","palaan","palaanak","palaangkanan","palaarit","palaaway","palaba","palabad","palabangahan","palabanghan","palabas","palabaw","palabay","palabi","palabilabi","palabilabihun","palabra","palabra diunur","palabras","palabtik","palabu","palabun","palabuy","palabuylabuy","palabwanay","palad","paladpalad","paladyaw","palag","palagdas","palagpag","palagpat","palagput","palagupak","palagut","palahi","palahilak","palahubug","palahus","palahuta","palaihi","palain","palainum","palaiyut","palaka","palakat","palakaya","palakayat","palakbit","palakiru","palakita","palakpak","palakpalak","palakul","palakulun","palakulun ug tiil","palakupak","palamban","palamdag","palami","palamilami","palamingku","palamunu","palamuuk","palanas","palandung","palangaw","palangga","palanggana","palangging","palanggingging","palangka","palangki","palangri","palanhay","palansa","palantig","palantigun","palantugay","palanug","palapa","palapad","palapad sa papil","palapag","palapala","palaran","palariti","palarun","palas","palas-an","palasan","palasibu","palastar","palasu","palasyu","palata","palatawag","palatiaw","palatik","palatiru","palatsu","palatu","palatulun","palatun","palatyanan","palautang","palautug","palautut","palaw","palaw-a","palawan","palaway","palawir","palawlaw","palawran","palaypay","palaypayan","palayu","palbangaan","palbangahan","palda","palda iblusa","paldiyas","paldu","palhi","palhug","pali","palias","paliasun","palibak","palibkas","palibut","palid","palid sa luwag","palid ug hanginun","palidpalid","palidpid","paligas","paligid","paligwat ug sulti","palihan","paliharu","palihug","palihuk","paliki","palikiru","palikiru ug mata","palikup","palimut","palina","paling","palingawlingaw","palingkud","palingpaling","palinpinun","palipariha","palipat","palipi","paliput ug pusta","palis","palispis","palista","palit","palit baligya","palit ug away","palit ug kasu","palita","palitadu","palitaw","palitu","palitu sa puspuru","paliwat","paliya","paliyar","paliyu","palku","palkupalku","palma","palma uliba","palmira","palmita","palmu","palmug","palpag","palpagu","palpal","palpalun","palpara","palsi walsi","palsipikadu","palsipikar","palsipikasiyun","palsu","palta","paltik","paltus","palu","palu mariya","palu sibu","paluap","palubad","palubag","palubat","palubilubi","palubun","palud","palug","palugar","palugit","palugmuk","palugpit","paluhud","paluma","palumaluma","palumalumahun","palumar","palung","palung ang kasuku","palungpung","palungtad","palunis","palup-it","palupalu","paluphu","palurus","palus","palusut","palut","palut saging","palutaw","palutput","palutup","paluwa","paluy","paluyu","palwa","palwa sa kadaugan","palwahun","palya","palyadu","palyawu","palyu","pam-","pamaa","pamaag","pamaak","pamaba","pamabayi","pamabdus","pamad-ay","pamada","pamag-u nga tuig","pamagaba","pamagatan","pamagay","pamagungun","pamagus","pamahala","pamahaw","pamahawbahaw","pamahawin","pamahid","pamahit","pamahunpahun","pamakla","pamaktul","pamaku","pamakulkul","pamalagdas","pamalak","pamalantak","pamalatul","pamalauranan","pamalawir","pamalay","pamalaybay","pamalayi","pamalbal","pamalbas","pamalhibu","pamali","pamalibad","pamaling","pamalirung","pamalisbis","pamalisbisan","pamalitu","pamaltik","pamalung","pamalungag","pamalus","pamalusbalus","pamalwa","pamalyakag","pamama","pamamatul","pamampam","pamana","pamanagan","pamanay","pamanday","pamangal","pamanggal","pamangil","pamangkaw","pamangkiti","pamangku","pamangsi","pamanhunun","pamanit","pamansat","pamanti","pamanyus","pamapha","pamarada","pamaratilyu","pamarayig","pamardut","pamarian","pamartidu","pamarug","pamarutu","pamasahira","pamasahiru","pamasayan","pamasgung","pamasin","pamasinbasin","pamasku","pamaslan","pamaslanan","pamasnig","pamasul","pamasung","pamatas","pamatasan","pamatay","pamatayan","pamati","pamatid","pamatu","pamau","pamaul","pamayabas","pamayaw","pamaybay","pamayhun","pamaymay","pamaymayun","pamaypay","pamayupas","pamayut","pambrutsa","pambul","pambut","pamid","pamidbid","pamidyu","pamiga","pamigwis","pamihis","pamihud","pamili","pamili sayis","pamiligru","pamilikula","pamilinbilin","pamilinu","pamiluk","pamilya","pamilyar","pamimbru","pamimislun","paminaw","pamingkungan","pamingwit","paminsar","paminta","pamintaha","pamintal","pamintana","paminti","pamintun","paminudu","pamipsi","pamiriku","pamirlas","pamirtdi","pamisa","pamisibis","pamisliun","pamista","pamitad","pamitay","pamitli","pamitut","pamituun","pamituun ang panan-aw","pamlasibu","pamlug","pampam","pampaman","pampangginya","pampangginyu","pampbut","pamplit","pamrimisyas","pamuaya","pamubhu","pamubu","pamug","pamug-at","pamugas","pamughat","pamugkat","pamugnaw","pamugung","pamuhat","pamuhatbuhat","pamuhawpuhaw","pamuhi","pamuhis","pamuhunan","pamuklat","pamukul","pamukung","pamukut","pamulak","pamulang","pamulawan","pamulbus","pamuligi","pamulis","pamulitika","pamulug","pamulung","pamuluris","pamulut","pamumada","pamun-u","pamunas","pamunawpunaw","pamunbun","pamungawmungaw","pamungbung","pamungul","pamungut","pamuntaw","pamuntu","pamuntug","pamuntura","pamunu","pamunu lalawigan","pamunu nasud","pamunuan","pamunuan nga kumpaniya","pamursiyintu","pamusbus","pamusdak","pamusil","pamuslut","pamusnga","pamustura","pamusu","pamuta","pamutakal","pamutang","pamutbut","pamutingting","pamutiti","pamutsatsu","pamutu","pamutung","pamutus","pamuu","pamuuk","pamuybuy","pamuyu","pamwinti","pamwirsa","pamyinta","pan","pan amirikanu","pan byina","pan dipasas","pan disal","pan pransis","pan-","pan-us","pana","panaad","panabaku","panabang","panabi","panabla","panablig","panabtan","panabu","panabugan","panabut","panadiriya","panadiru","panag-agawan","panag-ing","panaga","panagana","panagang","panagat","panagaytay","panagdait","panagdaitay","panaghap","panaghigala","panaghigalaay","panaghuyhuy","panagingting","panagingun","panagkaun","panagku","panaglain","panagna","panagpa","panagpu","panagtiayun","panagtigi","panagtipun","panagtratu","panagukduk","panagutu","panagway","panaha","panahap","panahataha","panahum","panahun","panahun di atu","panahun pa ni mampur","panahun pa sa tangantangan","panakla","panakmul","panaksan","panaksay","panakut","panakyuran","panalabay","panalaga","panalagna","panalagsa","panalahid","panalamban","panalamin","panalang","panalangin","panalapi","panalaw","panalayig","panalganan","panaligsik","panalindrun","panalipud","panaliwtiw","panalum","panam-ut","panama","panamala","panamastamas","panambagun","panambal","panamban","panambunan","panamilit","panamkun","panampiling","panampinit","panampung","panampungan","panamtam","panan huwan","panan-aw","panan-awun","pananda","panangil","panangitan","panangka","pananglit","pananglitan","panangpit","panangputan","panantik","pananum","panap-ung","panapaw","panapi","panapsay","panaptun","panapu","panapul","panapus","panaput","panarap","panari","panas","panastri","panatiku","panatismu","panaug","panaup","panaw","panaw sa laing kalibutan","panawag","panawag ug nanay","panawagan","panawagtawag","panawan","panay","panayday","panayming","panaytay","pandak","pandan","pandanggu","panday","panday (sa) pandaut","panday daut","panday pangdaut","pandayan","pandita","pandul","pandung","pandungan","pang-","pang-adlaw","pang-an","pang-apud","pang-araw-araw","pang-asinan","pang-it","pang-us","panga","pangabaga","pangabang","pangabaniku","pangabanu","pangabis","pangabla","pangabtik","pangabu","pangabubhu","pangabug","pangabuhi","pangabung","pangadurnu","pangadyi","pangadyiun","pangag","pangagad","pangagalun","pangaghu","pangagi","pangagis","pangagmu","pangagpas","pangagud","pangagun","pangagwa","pangagwada","pangahas","pangahuy","pangahuykahuy","pangaku","pangala","pangalab","pangalabkab","pangalag","pangalagkalag","pangalamag","pangalang-alang","pangalap","pangalasaw-un","pangaligkig","pangalilung","pangalimasa","pangalimyun","pangalisngaw","pangaliya","pangaliya panalangin","pangalpa","pangalpilir","pangalukut","pangalus","pangalut","pangalwan","pangalyupu","pangama","pangamahan","pangamat","pangamatay","pangambut","pangamigu","pangamihan","pangampis","pangampiyun","pangamu","pangamung","pangamut","pangamuti","pangamuyu","pangan","panganak","panganay","pangandak","pangandam","pangandila","pangandilarya","panganduy","pangangat","panganimas","panganiniput","panganinu","panganti","pangantihan","pangantina","panganud","panganugun","panganurun","pangapang","pangapayud","pangapi","pangaping","pangapitiriya","pangapkap","pangapu","pangapung","pangapuy","pangaraan","pangarasti","pangarbun","pangarga","pangariglar","pangarindiriya","pangarisgar","pangaritira","pangariyus","pangarmin","pangarnabal","pangarsada","pangarsunis","pangarti","pangarumata","pangaryada","pangasag","pangasaw-unun","pangasawa","pangasilyas","pangasu","pangasyus","pangatahuran","pangatarungan","pangati","pangatribir","pangatuli","pangatungdanan","pangaugalingun","pangawan","pangawhat","pangawili","pangayagkag","pangayam","pangayaw","pangaybru","pangayhun","pangaysyid","pangayu","pangayu ug katahuran","pangdan","pangdan nga humut","pangdaut","pangdul","pangdulpangdul","pangdungan","pangga","panggahi","panggahit","panggal","panggala","panggalatuk","panggalay","panggamut","panggantaaw","panggapu","panggas","panggasininsi","panggatung","panggaung","panggaw","panggi-","panggilabut","panggim","panggranstan","panggrasyas","panggubatan","panggunis","panggunis sa hiktanan","panggunit","panggunit sa dalunggan","panggus","pangguud","pangguun","panghabyug","panghadluk","panghak","panghaluhalu","panghalwan","panghanaw","panghangad","panghaplas","pangharana","panghaw","panghawid","panghay-alay","panghayhay","panghigabii","panghigut","panghihapun","panghilabut","panghilam","panghilam-us","panghilam-usan","panghilawas","panghilimasaw","panghiliug","panghilus","panghimabayi","panghimakak","panghimaklid","panghimalad","panghimalbas","panghimanlaw","panghimaraut","panghimasa","panghimasin","panghimatiis","panghimug-at","panghimul","panghimulas","panghimulig","panghimungut","panghimuntu","panghimuray","panghimuta","panghinana","panghinaut","panghinaw","panghinaw sa matag bagul","panghinawnaw","panghindik","panghingatuli","panghingawat","panghingiki","panghingu","panghingudtu","panghingugmu","panghinguku","panghinlas","panghinulsul","panghipus","panghirpin","panghisu","panghisus","panghit","panghiugma","panghiwi","panghudhud","panghudnu","panghugas","panghugasan","panghulu","panghumpay","panghumuk","panghunahuna","panghunas","panghungkung","panghuni","panghupaw","panghupung","panghuy-ab","panghuygu","pangibug","pangidad","pangidarun","pangidlap","pangidnap","pangigi","pangigkig","pangigmat","pangigsuun","pangihas","pangihaw","pangihi","pangihirsisyu","pangikik","pangiktik sa baki","pangikug","pangilab","pangilaba","pangilabut","pangilad","pangilat","pangilin","pangilit","pangilkil","pangilu","pangilug","pangilugkilug","pangilukan","pangilung","pangilyupu","pangimbaw","pangimbid","pangimbig","pangimbisug","pangimpliyu","pangimug","pangina","panginabuhi","panginahan","panginahanglan","panginanu","panginbisug","pangindahay","pangingkasu","pangingkitar","pangingkitar ug tabi","panginit","panginlabut","panginsiyur","pangintawun","pangirus","pangisda","pangisip","pangiskina","pangiskirul","pangiskuba","pangisug","pangit","pangita","pangitaun","pangitik","pangitlug","pangitngit","pangiwag","pangiya","pangka","pangkaay","pangkapangka","pangkay","pangki","pangku","pangkug","pangkul","panglab","panglabaha","panglaban","panglabyug","panglaguk","panglagum","panglagut","panglambu","panglambungay","panglampara","panglangbay","panglangbayan","panglanggam","panglangtaw","panglastiku","panglawas","pangli","panglihuk","pangliluk","panglilung","panglimbasug","panglimbawut","panglimbung","panglimpiya","panglimut","panglin","panglingi","panglingu","panglipstik","panglipung","pangliput","panglipuwa","panglisinsiya","panglisis","panglista","panglistun","pangliug","pangliugat","pangliwat","panglugnut","panglugud","panglugus","panglukut","panglumayagan","panglup-ad","panglupad","panglupig","pangluru","panglusa","panglusyun","pangluud","pangmantalaan","pangmata","pangmutung","pangnipas","pangnukus","pangnutsi","pangpang","pangpanganun","pangpangun","pangpatahum","pangrilis","pangristawran","pangriyunyun","pangsud","pangsut","pangtamban","pangtunaw","pangu","pangubkub","pangubyirtus","pangug","pangugat","pangugi","pangugita","pangugmad","panguhu","pangukasiyun","pangukuk","pangulabyaw","pangulag","pangulahi","pangulahian","pangulaknit","pangulang","pangulapyut","pangulba","panguldun","pangulihad","pangulilang","pangulipas","pangulipi","pangulitawu","pangulu","pangulukasiyun","pangulumpiyu","pangulung","pangulurum","panguma","pangumbira","pangumpisal","pangumplianyu","pangumusta","pangumustahay","pangunahan","pangunggu","pangunglu","pangunsa","panguntra","pangunu","pangupiraryu","pangurakul","pangurasanta","panguridur","pangurimus","pangurinaw","pangurtina","pangurug","panguruna","pangurus","pangus","pangusi","pangusina","pangusmu","pangustiyada","pangustiyar","pangusug","pangut","pangutan","pangutana","pangutas","pangutiks","pangutlu","pangutlub sa dila","pangutsara","pangutsilyu","pangutsiru","pangutsitis","pangutuk","panguun","panguut","panguwaping","panguway","panguyabug","panguyamad","panguyap","panguyaw","panguyuan","pangwaku","pangwakwak","pangwangis","pangwarisma","pangwarta","pangwili","pangwinta","pangwintirgrin","pangyam-id","pangyangud","pangyas","pangyawan","panibin","panibsib","panid","panig","paniga","panigarily","panighawak","panigingun","paniglain","panigu","panihag","panihagsihag ang tutunlan","panihapun","paniid","paniil","panikad","panikas","panikbut","paniksik","paniktik","panil","panilap","panilung","panimahu","panimahu kandila","panimahung bakalaw","panimahung piutpiut","panimahung tagum","panimahung yuta","panimaklid","panimalay","panimalus","panimati","panimaul","panimayad","panimayad sa utang","panimbaku","panimbang","panimhut","paniming","panimpalad","panimpla","panimpu","panimuhi","panimun","panimusimu","panimuut","panimuyu","panin-","paninda","paningala","paningali","paningalit","paningamut","paningaun","paningit","paningkamut","paninglunun","paningsingan","paningud","paningudsingud","paningug","paninguha","paningut","panini","panipay","panipilyu","panipir","panipis","panipuy","panira","paniradu","panirbis","paniriguylas","paniru","paniruk","paniruk buy","panis","panista","panistis","panit","panit mu rag irug panit","panitik","panitsit","paniudtu","pankik","panlalaki","panlumayaganan","panrapu","panratu","pans","pansak","pansat","pansayan","pansi","pansil","pansilun","pansing","pansing bag","pansir","pansis","pansit","pansit kantun","pansit luglug","pansitan","pansitiriya","pansitirya","pansiyadur","pansu","pansud","pansung","pansut","pantalan","pantalun","pantalun dilargu","pantalun dipuntu","pantalya","pantasma","pantat","pantaw","pantawan","pantaypantay","panti","pantihan","pantilit","panting","pantiyun","pants","pantsak","pantsing bag","pantug","pantuk","pantun","pantuplas","panuba","panubad","panubag","panubid","panubig","panubli","panubu","panud-an","panudas","panudiya","panudlay","panudsud","panuga","panugid","panugilun","panugnaw","panugun","panuhut","panuig","panuigun","panukad","panukadur","panukaranan","panukhi","panukiduki","panukiruk","panuklang","panuklus","panuku","panukud","panukul","panukus","panulat","panulay","panulda","panulindaw","panulis","panulti","panultihun","panulu","panulud","panulundun","panulung","panumbalay","panumbaling","panumduman","panumpa","panumus","panun","panun-ug","panungatunga","panungbalay","panunggan","panunglu","panuni","panunik","panuntun","panunu","panupak","panurambaw","panuramik","panuramik bilt","panurbiti","panuru","panurusu","panusu","panut","panutbras","panutpik","panutsa","panutsut","panuud","panuuk","panuway","panuylu","panuytuy","panuyu","panyanggi","panyas","panyawan","panyu","panyulitu","panyulun","pap-ay","papa","papaak","papabur","papait","papal nunsiyu","papan","papang","papangasawa","papangisug","papap","papas","papating","papay","papha","papha sa mapa","papil","papil dibangku","papil dihapun","papil diliha","papil intirmidiya","papil nga","papili","papilis","papilit","papilita","papilitus","papiliw","papiri","papisi","papiug","papkurn","paplin","paprika","paprisyu","papsikul","papula","papulaspulas","papulis","papupa","papusungpusung","par","para","para [noun referring to action]","para [noun]","para [verb]","para alas","para rubu","para rumans","para sa","para sa ginhawa","parabir","parabir [verb]","parabula","parada","paradahan","paradista","paradur","paragatus","paragayu","paragparag","paragu","paragwa","paraisu","parak","parakayda","parakul","parakyut","parakyutir","paralayis","paralisadu","paralisar","paralisis","paralitiku","paramuut","parang","parapara","parapin","parapirnalya","parapu","paras","parasan","parasparas","parat","paraw","parawu","paray","parayganay","paraygun","parayig","parayuiks","pardnir","pardu","pardun","pari","parian","parid","paridyus","parigla","pariha","parihas","parihu","parihug balhibu","parikunusir","paril","parilya","parimidiyu","parinhayit","parinti","paripa","paripari","paripir","paris","parisan","parisiyu","parisparis","parisun","pariti","paritira","paritratar","paritratu","pariun","parka","parki","parking","parkingan","parliyamint","parliyamintu","parlur","parmasya","parmasyutika","parmasyutiku","parnasu","parpar","parsila","parsir","parsiyadu","parsiyar","part","partayim","partayimir","parti","parti layin","partida","partida dibawtismu","partidista","partidu","partidu libiral","partidu nasyunalista","partidus","partikular","partiparti","partira","partisipasiyun","partisiyun","parts","paru","paruk","paruku","parukya","parukyanu","parul","parul dikumbati","parula","paruli","paruliru","parulus","paruni","paruparu","parus","parusas","parut","parutput","paruy","paruyparuy","paryinti","pas","pas-an","pas-anunun","pas-ung","pasa","pasa banda","pasabunga","pasabut","pasad","pasadu","pasadur","pasagad","pasagidsid","pasagnunut","pasahan","pasahanan","pasahi","pasahira","pasahiru","pasahiruan","pasakalyi","pasakayli","pasakpasak","pasalig","pasalipud","pasamanu","pasamanus","pasamuhan","pasan","pasan-antun","pasandig","pasangil","pasanib","pasantusantu","pasapasa","pasapul","pasapurti","pasar","pasar [noun","pasar ang gana","pasar ang gutum","pasar ang kaun","pasar sa kamut","pasas","pasatyimpu","pasaw","pasawan","pasaya","pasayan","pasayanpasayan","pasaylu","pasburd","pasgaw","pasgung","pasi","pasiatab","pasiaw","pasibana","pasibantug","pasidaan","pasidungug","pasig","pasigarbu","pasignunut","pasigpat","pasigustu","pasigwar","pasikad","pasikat","pasiklap","pasil","pasilang","pasilib","pasilip","pasilung","pasilyu","pasimik","pasinaw sa lingkuranan","pasingadtu","pasinganha","pasinganhi","pasingari","pasingit","pasingulan","pasingut","pasinsilyu","pasinsiya","pasinsiyusa","pasinsiyusu","pasinti","pasipala","pasipala ug sulti","pasipiku","pasis","pasistur","pasitib","pasiugda","pasiun","pasiuna","pasiuyun","pasiyal","pasiyu","pasiyun","paskan","paskan nu","paskanan","paskin","pasku","pasku sa kalipay","pasku sa kasakit","pasku sa labadura","pasku sa pagkabanhaw","pasku sa pagkatawu","paskuwas","paslag","paslak","paslang","paslayit","pasluk","paslut","pasmu","pasmu ang","pasmu sa gutum","pasmu sa kusug","pasmu sa pasalig","paspas","paspasanan","paspayit","paspurt","paspuru","pasta","pastang","pastidiyar","pastidiyu","pastikum","pastilan","pastiliriya","pastilyas","pastilyas dilitsi","pastilyas dimani","pastilyas diubi","pastiyurisadu","pastu","pastuhan","pastur","pastura","pasturis","pasu","pasuan","pasubra","pasud-ung","pasugbu","pasugu","pasuhul","pasuk","pasul","pasulabi","pasulat","pasulit","pasulud","pasuluguun","pasulung","pasumangil","pasumanu","pasumban","pasumbingay","pasundayag","pasundayagan","pasunding","pasung","pasungan","pasunud","pasupasu","pasusi","pasusu","paswurd","pasyandu","pasyandu dulur pakita sa balur","pasyinsiya","pasyinti","pasyuhan","pasyun syu","pasyunarya","pat huldir","pat-ak","pat-akpat-ak","pat-ud","pat-ul","pat-ulanan","pat.","pata","pataantaan","pataas","pataban","patad","patadyung","patag","patahud","patahum","patahur","patak","pataka","patakal","patakpatak","pataktak sa bukbuk","patakud","patal","patala","patalas","patalinghug","pataliwala","patamak","patangka","patani","patantu","pataput","patara","patardang","patari","patas","patatas","pataw","patawan","patawu","patay","patay gutum","patay nga iru","patay sa bahu","patay sa kabugnaw","patay sa utug","patay ug dugu","patay ug halas","patay ug lami","patay ug limud","patay-ug","patayan","patayg dugu","pataypatay","pathaw","pati","pati ang [noun]","patianud","patibagbag","patibi","patid","patidpatid","patidpatid sa lata","patig","patig-atig-a","patigastigas","patigayun","patigbabaw","patik","patikan","patikanan","patikig","patikit","patilik","patilubtilub","patilya","patin","patindug","pating","pating nga bungul","patinga","patingpating","patingug","patinti","patintiru","patipati","patiplas","patir nustir","patirn","patis","patiwas","patriyuta","patrul","patrulman","patrulya","patrun","patruna","patsada","patsang","patsarming","patsi","patsing","patu","patubig","patubu","patubud","patubud sa uhung","patuda","patuga","patugbabaw","patuk","patuka","patukar","patuktuk","patukuranan","patul","patula","patulin","patulu","patulu sa singut","patulugtulug","patulus","patulut","patumsan","patun-ug","patuna","patung","patungha","patungpatung","patungud","patunhay","patupatu","patupi","paturagas","paturu","paturuturu","patuskig","patusutusu","patuu","patuud","patuutuu","patuyang","patuyuk","patyanay","patyu","pauban","paubayun","paubir hul","paubu sa baga","paubus","paubus kay laylay pa","paud","paugma","paugmad","paugnat","pauk","paukub","paukyab","paulahi","paulan","paulan-ulan","pauli","paulian","paulianan","paulipin","pauliping","pauliunun","paulus","paumud","paumuk","paumuy-umuy","paun","pauna","paundayun","paungad","paunlud","paunud","paunuk-unuk","paupuy-upuy","pauraray","paurdir","paursa","paurung","paurus","pauruy","paus","pausu","pautang","pautug","pautukay","pauyug","pauyun","paw","paw-ak","paw-ang","pawa","pawala","pawdir milk","pawikan","pawikanun","pawir","pawir ab aturni","pawis","pawla","pawpaw","pawu-","pawud","pawug","pawul","pawul layin","pawul syat","pawundirs di","pawuntin","pawuntin pin","pay","pay-uk","pay-ut","paya","payadpayad","payag","payaka","payakpak","payanpayan","payas","payasu","payat","payaw","paybut","payhag","payhaw","payi","payib","payib kulum","payib pinggir","payil","payil nga ininsik","payil sa bulak","payin tri","payir","payir damids","payir tri","payit","payitunun","payla","paylas","payling","payling kabinit","payling klirk","paylut","paylut hawus","paylut sa kukunat","paylut sa lubi","payn-apul","payn-apul dyus","paynadura","paynar","paypay","payr-awut","payramid","payriks","payring","payring iskwad","payring layin","payring pin","payta","payting ispirit","payting pis","paytir","payud","payudpayud","payuk","payung","payung sa bulan","payung sa libgus","payung sa uhung","payungpayung","payungpayung sa santus","payupas","payuphu","payuriya","payus","payut","perdida","pi","pi dibawtismu","pi trap","piang","piangan","piangun","piar","piay","pib.","pibak","pibriru","pibur","pid","pid-uk","pidal","pidal pusir","pidasu","pidbak","pidi","pididu","pididus","pidikab","pidikiyur","pidikiyurista","pidir rud","pidir wit","pidirasiyun","pidistal","pidiyus","pidla","pidlasut","pidlut","pidpid","pidru","pidsbuy","pig pay","pig-it","pig-ut","piga","pigadu","pigal","pigal pang dahun","pigat","pigawu","piging","pigiri","pigis","pigit","pignit","pigsa","pigsanan","pigsang","pigsat","pigsik","pigsikan","pigsit","pigsut","pigting","pigtul","pigung","pigura","pigurin","pigus","pihadu","pihak","pihakpihak","pihar","pihaw","pihig","pihing","pihu","pihu na lang","pihuk","pii","piis","piit","piitan","pik","pik-ap","pika","pikak","pikal","pikas","pikas dughan","pikas sa kinabuhi","pikaspikas","pikat","pikaturum","pikbung","pikdul","pikdung","pikdut","piki","piking","pikit","pikit layin","pikitir","piknat","piknik","piknit","pikpik","piktiyur tiking","piktus","piku","piku nga payung","piku nga siya","pikuls","pikun","pikunan","pikupiku","pikut","pikuy","pil","pil indi pamili wi","pil-ap","pila","pila ka adlaw","pila may sugilun","pila ra gud","pila ray pungut","pilahay","pilahun","pilak","pilaknun","pilantrupu","pilapil","pilapilan","pilas","pilata","pilatu","pilaun","pilaw","pilay","pilay palad","pilaypilay","pilbaks","pildi","pildir","pildira","pildiru","pildura","pilduras","pilhuk","pilhung","pili","pilian","piliay","piligis","piligru","piligrusu","piligu","piliik","pilik","pilikpilik","pilikula","pilinu","pilipig","pilipina","pilipinas","pilipinhun","pilipinismu","pilipinista","pilipinu","pilipit","pilipit ang dila","pilipiti","pilipug","pilipugun","pilipul","pilir","pilir gids","pilis","pilit","pilit ang dila","pilit mais","pilit ug dila","pilit ug kamut","piliti","pilitina","pilitpilit","piliunun","piliw","pilkag","pilm","pilpil","pils","pilt","piltir","pilu","pilu sa","pilu sa —","piluk","piluk mariya","piluk sa nipa","piluka","pilung","pilupilu","pilus","pilusupiya","pilusupu","pilut","pilutari","pilutu","pilya","pilyu","pilyu sa babayi","pima","pimbrira","piminta","pimrira","pimyinta","pin","pin puyint","pin-ut","pina","pina-","pinaagi","pinaak","pinaakan","pinaakay","pinaangkan","pinabuhat","pinabukal","pinad-an","pinadagit","pinadalagan","pinadayag","pinadingan","pinagud","pinahitan","pinahubung","pinaidlut","pinaig","pinaisan","pinakaligu sa bulawan","pinakanat","pinakas","pinakatay","pinakaun","pinakbit","pinakupsan","pinakurba","pinal","pinalaan","pinalabi","pinalabyug","pinalagtub","pinalangga","pinalansa","pinalasan","pinalayaw","pinaldu","pinali","pinalihug","pinalinkud","pinalinkud sa urinula","pinalispis","pinaluray","pinalutaw","pinamalung","pinamanaan","pinamuhuan","pinana","pinanagatan","pinandanggu","pinang-an","pinang-usan","pinanganak","pinangayaman","pinangayu","pinangisdaan","pinangita","pinangitaan","pinangku","pinanglabuhan","pinapasan","pinapul","pinarak","pinaras","pinaru","pinasagdan","pinasgungan","pinasidunggan","pinasikad","pinaskuhan","pinaslan","pinasngan","pinaspasan","pinasubay","pinatbatir","pinatikan","pinatubu","pinatumanan","pinatumsan","pinatuptup","pinaturagas","pinatuyangan","pinatuyu","pinatyanay","pinaubra","pinaugdu","pinaulbu","pinaundak ang tingug","pinaungut","pinaurus","pinauslan","pinausu","pinawikan","pinay","pinayasu","pinayusan","pinbuy","pindaypinday","pindi","pindian","pinding","pindir","pindisitis","pindulu","pindulum","pindulun","ping","ping-it","ping-ut","pingag","pingak","pingakpingak","pingay","pingga","pinggahan","pinggan","pingganpinggan","pinggir prin","pinggir print","pinggir wib","pinggiring","pinghuy","pingis","pingk","pingkaw","pingki","pingkit","pingpung","pingpung tibul","pingpungan","pinguspingus","pingut","pinguypinguy","pingwit","pingwitan","pinhuldir","pinid","pinig","pinig-itan","pinigal","pinigsan","pinihig","pinikada","pinikas","pinikitu","pinil-an","pinilay","pinili","pinilian","pinilukan","pinilyu","pining","piningki","piningkit","pininsa","pinintal","pinintalan","pinipig","pinipig krans","pinipita","pinirasu","pinirinda","pinisi","pinisilin","pinising","pinista","pinitik","pinitinsiya","piniyalan","pinkaw","pinkusyun","pinpal","pinpin","pinsa","pinsada","pinsamintu","pinsamyintu","pinsar","pinsil","pinsil kat","pinsing","pinsit","pinsiyun","pinsiyunada","pinsiyunadu","pinta","pintada","pintakasi","pintal","pintas","pintik","pintikustis","pintil pin","pintuk","pintukpintuk","pintul","pintur","pintura","pintus","pinu","pinudpud","pinuga","pinugian","pinugngan","pinuhalay","pinuhan","pinukpuk","pinul","pinul-ungan","pinulhuan","pinuluhu","pinulungan","pinunit","pinunitan","pinuntikan","pinupinu","pinupu","pinusil","pinusu","pinuti","pinutung","pinuun","pinuy","pinuy-anan","pinya","pinyahan","pinyatu","pipa","pipar bag","pipi","pipila","pipinu","pipir","pipir bag","pipis","piplum","pipsi","pipti","piptipipti","pir","pir bay pir","pir dayim","pira","piras","pirasu","pirat","pirata","piratpirat","piraypiray","pirdi","pirdigana","pirdigun","pirdigunis","pirdisiyun","pirdun","pirgula","pirhisyu","pirhwisyu","piri","piri but","pirigpirig","pirigrinasiyun","pirigrinu","pirigula","pirihisyu","piriku","piriku pikuy","piriku tawu","pirikuhun","pirimyu","pirinda","piris wil","piritu","pirkal","pirlas","pirma","pirmaninti","pirmi","pirmi ang taku","pirmiru","pirmisu","pirmisyas","pirmit","pirnu","pirpiktu","pirpitwa","pirpumi","pirs","pirs klas","pirsigir","pirsing kap","pirst","pirst bis","pirst hap","pirst klas","pirst lidi","pirst plur","pirst prayis","pirst ran","pirst trip","pirsuna","pirsunahi","pirsunal","pirsunal apirans","pirsunalidad","pirsunalminti","pirtilaysir","piru","piruhwisyu","piruk","pirukpiruk","pirul","pirut","piruypiruy","pirwil parti","pirwisyu","pirya","piryud","piryudikal","piryudikal tist","piryudiku","piryudista","pis","pis-ak","pis-an","pisa","pisada","pisadur","pisak","pisakpisak","pisami","pisan","pisar","pisara","pisat","pisaw","pisi","pisi kuntrul","pisian","pisik","pisikal","pisiks","pisil","pisiun","piskadur","piskal","piskal sa simbahan","piskaliya","piskanti","piskat","piskay","piskayun","piskul","piskur","piskut","piskuy","pisla","pislangu","pislat","pislayit","pislit","pislit layit","pisluk","pislun","pislung","pislut","pismil","pisnga","pisngag","pisngi","pisngig","pisngu","pispan","pispis","pista","pista sa inyu","pista sa simbahan","pista sa siniyur","pista upisiyal","pistang iglilihi","pistayim","pisti","pisting yawa","pistud","pistul","pistul (nga) yawaa","pistula","pistula nga ditambur","pistula nga sinyurita","pistun","pistun rad","pistun ring","pisu","pisu kuntra usa ka daku","pisuk","pisukut","pisul","pisun","pisus","pisut","pisyat","pisyu","pisyutis","pit sinyur","pit-us","pita","pitada","pitak","pitaka","pitati","pitay","piti","pitibut","pitii","pitik","pitikut","pitimini","piting","piting rum","pitisyun","pitiw","pitiwpitiw","pitla","pitlag","pitlagung","pitlud","pitluk","pitnit","pitpit","pitpita","pitpitahun","pitpitun","pitrulyu","pitrulyum","pitrumaks","pitrun","pitrun tikit","pits","pitsa","pitsas","pitsasan","pitsay","pitsay bisaya","pitsbuy","pitsi","pitsikurnu","pitsil","pitsipitsi","pitsir","pitsu","pitsukurnu","pitu","pitu ka lawud","pitugu","pituk","pitukpituk","pitul","pitupitu","pituru","pitut","pitwurk","piud","piug","piut","piutpiut","piward","piyad","piyadpiyad","piyak","piyal","piyangpiyang","piyas","piyatpiyat","piyu","piyuk","piyun","piyung","plag","plag-in","plagpul","plagrising","plagritrit","plagsirimuni","plagsut","plahuta","plaka","plakul","plamingku","plamir","plan","planggana","plangganita","plangka","plangkiru","planhay","planila","planita","plansa","planta","plantada","plantasiyun","plantilya","planting rayis","plantsa","plantsadu","plantsaduhun","plantsadur","plantsahan","plantsahun","plantsahunun","plantsawu","planu","plariti","plas","plas [number of english origin]","plas balb","plasa","plasibu","plasing","plasis","plaskiya","plaslayit","plasta","plastar","plastik","plastik surdyiri","plastir","plastir ab paris","plastir kast","plasu","plat","plat syus","plat tap","plat tayir","plata","platap","platapurma","platik","platinu","platinum","platiriya","platiru","platitu","platnus","platu","platun","platun lidir","plawir","plawir bis","plawir gil","plawir pat","plawta","play","play-awi","playing susir","playir","playis","playit","playit atindant","playwit","playwud","pli","plibisitu","plibul","plibuy","pligis","pligrawun","pligrawun dimunstrisyun","pligu","plima","plimiru","plin","plinantsa","plirayid","plirt","plising","plismat","plit","pliti","plitina","plitnambir","plits","plitsa","plu","pluhu","pluma","plumahi","plumiru","plumu","plur","plural upiring","plurdilis","plurira","pluris","pluris di mayu","plurisin","plurlidir","plurwaks","plut","pluting","pluting rit","pluwid","pra","prabir","pragata","pragatus","pragmin","prak","prakasu","prakayda","praktikal","praktis","praktis titsing","praktisadu","prakul","prangha","prangka","prangkisa","prangkisiya","prangkiyu","prangku","pranila","pransis","pransiya","prantada","prantsit","prasis","prasising","prasku","prawud","praybasi","praybit","praybit iskul","praybit nars","praybit rud","praybit rum","prayid rayis","prayid tsikin","prayli","praymari","pri","pri mid","pribada","pribadu","pribilids","pribilids ispits","pribilihiyu","pribinidu","pribinir","pribyu","pridi","pridikar","pridiktar","pridyidir","prigunta","prihu","prilansir","prilim","priliminari","priliminaris","prima","primarya","primatiyur","primir","primir gradu","primir kumuniyun","primir ministru","primira","primira dama","primira klasi","primira kumuniyun","primira kumunyun","primiru","primiru (ikaduha","primiru anyu","primiru gradu","primiru makinista","primiru nga [verb]","primiru upisiyal","primirung buling","primisyas","primu","primyu","prinatal","prinda","prinda indunu","prinda palit","prindadu","prindahanan","prininda","prinitu","prinsa","prinsipal","prinsipi","prinsipi amanti","prinsipi digalis","prinsipyu","prinsis kat","prinsisa","prinsisita","prinspus","printing pris","prinu","pripab","priparadu","priparar","priparasiyun","priparaturi","pripatin titulu","pris","pris rilis","pris.","prisidinsiya","prisidinsiyal","prisidinsiyal tibul","prisidint","prisidinta","prisidinti","prisidiyu","prisidiyum","prisintabli","prisintada","prisintadu","prisintar","prisintu","prisir","prisirb","prisirbing dyar","prisiyun","priska","priskrayib","priskripsiyun","prisku","pristid","pristihiyu","prisu","prisu kabalyiru","prisuhan","prisupwistu","prisyat","prisyu","prisyu pihu","pritindir","pritru","pritu","priwar","priward","priwur","pronoun]","prubar","prubidinsiya","prubinsiya","prubinsiyal","prubinsiyana","prubinsiyanhun","prubinsiyanu","prubinsyal","prubinsyal burd","prubinsyal dyil","prubisung","prubisyun","prubisyunal","prubitsar","prubitsawu","prubitsu","prublima","pruduksiyun","pruduktu","prudyusir","prugram","prugrama","prugrisista","prugrisu","pruhibir","pruklamar","pruklamasiyun","prumininti","prumisa","prumusiyun","prumusyun","prumusyun sil","prumusyunal sil","prumut","prumutid","prumutir","prunawuns","prunsit","pruntsit","pruntu","pruntun","prunumbri","prup","prupaganda","prupagandista","prupagar","prupidad","prupisiyun","prupisiyunal","prupisur","prupisura","prupita","prupitaryu","prupursiyun","prupusisiyun","prupyidad","prusa","prusikusiyun","prusisiyun","prusisyun","pruspik","pruspiktus","pruspirar","prususu","prut kik","prutagunista","prutas","prutihidu","prutihir","prutiksiyun","prutina","prutira","prutista","prutistanti","pruwa","pruyba","pruyiktu","pu","puan","puangud","puas","puasa","puay","puaypuay","publasiyun","publikadur","publikar","publikasiyun","publiku","publisidad","pubri","pubri nga utin","pubrihun","pubring kahuy","pubring subirbiyu","pubrisita","pubrisitu","pud","pud kulur","pud kuluring","puday","puding","pudir","pudirusu","pudlung","pudlus","pudngan","pudpud","pudul","pudyut","pug","pug-aw","pug-is","pug-uk","puga","puga sa utuk","pugad","pugahan","pugapu","pugapuga","pugaran","pugas","pugaspugas","pugawu","pugdaw","pugdul","pughad","pughak","pughaw","pugi","pugis","pugispugis","pugnit","pugpug","pugsak","pugsanan","pugsit","pugsun ug pugus","pugsunun","pugsunun ug utuk","pugtas","pugtasan","pugtud","pugu","pugud","pugudpugud","pugul","pugun","pugung","pugung sa pulsu","puguniru","pugurun","pugus","pugusu","pugut","pugutun ug baba","pugwat","puhag","puhal","puhaw","puhun","puhunan","puhunpuhun","puhuun","puk","puk-ung","puka","pukak","pukakha","pukan","pukang","pukas","pukat","pukaw","pukay","pukdaw","pukgaw","pukgu","puki","pukir","puklat","puklatpuklat","puklid","pukling","puklu","puknit","pukpuk","puksi","puku","puku mas u minus","pukupuku","pukut","pukuy","pukwang","pukwat","pukway","pul","pul-an","pul-anun","pul-ung","pula","pula ang tapay","pula ug saya","pulahan","pulahay","pulahun","pulak","pulaki","pulakut","pulalak","pulalay","pulan","pulana","pulang","pulangan","pulangi","pulangki","pulanu","pulapula","pulas","pulasik","pulaspulas","pulaw","pulaw-as","pulawan","pulay","pulaynas","pulbira","pulbu","pulbura","pulburun","pulbus","puldir","pulgada","pulgadahan","pulgadas","pulgadira","pulgadirista","pulgas","pulgasun","pulhawus","pulhu","puli","puli [noun]","pulida","pulidu","puliki","puling","puling sa mata","pulipug","pulipuli","pulir","pulis","pulis bantuk","pulis klirans","pulis sa bantuk","pulisa","pulisiya","pulitika","pulitikanhun","pulitiku","pulka","pulkas","pulkum","pulmun","pulmuniya","pulmunya","pulpitu","pulpug","pulpugan","pulpul","pulrira","pulsiras","pulsu","pulta","pulta mayur","pultahan","pultira","pultiru","pultri","pulu","pulu barung","puluan","pulud","pulug","puluhu","puluhun","pulukuy","pulun","pulun-an","pulun-anan","pulun-un","pulung","pulung [gen.]","pulungpulung","pulungtanun","pulungun","pulupariha","pulupilusupu","pulupurdiyus","pulupusil","puluris","pulus","pulut","puluy-anan","pulyitu","pulyitus","pulyu","pumada","pumapauli","pumipili","pumpung","pumuluyu","pumupuyu","pun-unun","puna","punas","punaw","punawpunaw","punay","punda","pundadur","pundahan","pundar","pundasiyun","pundidu","pundihan","pundihanan","pundilyu","pundir","pundiyu","pundiyuhan","pundu","punduhanan","punduk","pundukpunduk","pundul","pundyi","pung","pung-ul","punga","pungag","pungal","pungangu","punganguhan","pungapunga","pungasi","pungaw","pungdul","pungga","punggak","punggit","punggud","punggut","pungi","pungil","pungingi","pungkay","pungku","pungku sa bilangguan","pungku ug ilung","pungku ug tutuy","pungkul","pungkuy","pungli","pungpung","pungpung lalung","pungpung pyangaw","pungpungaya","pungtanun","pungtud","pungun","pungus","pungut","pungutay","pungutpungut","pungyut","puni","punirarya","punit","punitil","puniyal","punlas","punpal","punpun","punsi","punsisuk","punsiyu pilatu","punsiyun","punsiyunaryu","punsu","punsun","punta","punta blangku","punta daga","punta pitsu","puntada","puntariya","puntik","puntikpuntik","puntikun","puntil","punting","puntinpin","puntiriya","puntiru","puntiruhan","puntiyas","puntu","puntu dibista","puntu ikuma","puntud","puntun","puntus","puntusay","punu","punuan","punugrapu","punuk","punung","punyal","punyimas","punyita","punyiti","punyitira","punyitiru","punyitirus","punyu","punyu sirawu","punyus","pupa","pupanda","puphu","puphuay","pupu","pupu ang pusud","pupug","pupular","pupulasiyun","pupus","pupuy","pupuyu","pur","pur adult","pur ihimplu","pur-","pur-abir","pur-ingkasu","pur-isu","pura","purang","puras","purawundir","puray","purba","purbida","purbinggay","purbingguy","purbisgut","purbista","purbisung","purbitsu","purdiya","purdiyus","purdiyus ipursantu","purdiyus pursantu","purga","purgada","purgadas","purganti","purgas","purgaturyu","purhan","purhisyu","purhwisyu","purigit","purihimplu","purikit","puriku","puril","purin","puringkasu","puririt","puris rindyir","purisu","purk an bins","purk tsap","purki","purluminus","purlun","purma","purmal","purmalidad","purmalin","purmalina","purman","purmas","purmidiyu","purmidiyu sa","purmula","purpabur","purpulyu","pursiakasu","pursigir","pursikasu","pursikasu ug","pursilana","pursilina","pursintu","pursip","pursir","pursiras","pursisyun","pursiyintu","pursusu","pursusu nga anak","pursyut","purtada","purtamunida","purtintusu","purtipayib","purtipayib arpiim","purtiru","purtis","purtuna","puru","puruhan","puruk","puruku","purul","purung","purungpurung","purura","purus","puruspurus","purward","purya","puryut","pus","pus-aw","pus-un","pus-unun","pus-upis","pusa","pusak","pusamanu","pusas","pusaw","pusbutun","pusdak","pusdit","pusditid","pusdu","pusgay","pusgu","pusibilidad","pusibli","pusil","pusilpusil","pusing","pusisit","pusisiyun","pusit","pusitib","pusitibu","pusiyun","puskay","puslan (pudsan) man","pusmastir","pusnga","puspas","puspun","puspurit","puspuru","puspus","puspuygu","pust-upis","pusta","pusta dirikta","pusta ku sa","pustada","pustal","pustal aydi","pustal kard","pusti","pustir","pustisu","pustmastir","pustri","pustura","pusturawu","pusu","pusu artisyanu","pusud","pusung","pusupusu sa bitiis","pusut","pusutpusut","put","put-uk","put-ung","puta","putablis","putad","putahi","putak","putaputa","putbul","puthaw","puti","puti (bakud) ang kiting","puti ang kiting","puti ang tiil","puti nga tabil","puti pay agipu","puti ug","puti ug itlug","puti ug lisik","putian","putianay","putik","putikadu","putikar","puting","puting tabil","putis","putitu tri","putiun","putli","putput","putris","putru","putsiru","putu","putu kutsinta","putu maya","putu nga balanghuy","putu nga binangkung","putu nga pinalutaw","putu sulut","putud","putugrapiku","putugrapu","putuk","putukputuk","putul","putul sa adlaw","putul sa pikas","putul ug tinai","putulputul","putung","putung dayun","putung dinayun","putuputu","putus","putustat","putut","pututun","putyukan","putyukanun","puu","puuhun nga apilyidu","puuk","puul","puung","puut","puwa-","puwak","puwi","puwi-","puwin","puwint","puwis","puwit","puwita","puy-anan","puy-us","puya","puyasut","puyat","puyay","puydi","puydi nga","puydut","puygu","puyit","puyit sa anay","puypuy","puyra","puyra bisita","puyra buyag","puyra dayig","puyra gaba","puyra lus buynus","puyra sa","puyra uluulu","puyrut","puyu","puyuk","puyung","puyupuyu","puyus","pwi","pwidi","pwinti","pwinti usminya","pwintsitya","pwira","pwirsa","pwirsa militar","pwirsa nabal","pwirsa rimidiyu","pwirsa sa kahanginan","pwirsadu","pwirta","pwirti","pwirtu","pwis","pwistu","pwistu sa","pyadu","pyahuk","pyahukun","pyait","pyakpak","pyamrira","pyanga","pyangaw","pyangguy","pyanghaw","pyanghaw midul kard","pyanguk","pyangut","pyanista","pyansa","pyansadu","pyansadur","pyanu","pyanu dikula","pyanunu","pyapi","pyasa","pyasat","pyasut","pyaus","pyi","pyimrira","pyirdi","pyirdigana","pyirnu","pyis","pyis dil patu","pyisa","pyista","pyunggut","pyungku","pyungkut","pyur","pyuriya","pyurus","pyuus","ra","ra ba","ra gani","ra gayud","ra gud","ra hinuun","ra ugud","rabana","rabanit","rabanus","rabatikung","rabir","rabir plant","rabir tri","rabis","rabit","rabuls","rabunit","radar","radikal","radis","radiyu","radiyu baktas","radiyu balagun (kawayan)","radiyu upiritur","radiyugram","radiyupunu","radya","radyaw","ragid","raha","rak-an rul","rak-in rul","raking tsir","rakit","rakrak","ram","rama","rambul","rami","ramids sil","ramus","ran","ran-abawut","ranggu","raning","raning burd","ranir","ransiyu","ransu","rantsu","ranwi","rapal","rapdrap","rapid payir","rapidu","rapir","ras","rasa","rasak","rasiyun","raspa","raspadur","raspahan","rasun","rasunabli","ratatat","ratipikar","ratsada","ratsar","ratu","ratu ug","rauk","raw","rawraw","rawun","rawun rubin","rawundir","rawunrawun","raya","rayadilyu","rayadu","rayban","rayit han","rayit huk","rayna","rayna ilina","rayna sa kalibangan","rayna sa panimalay","rayu ikis","rayuiks","rayuma","rayumahun","rayus","rayus ikis","rayut","rayut gan","rdu.","refined","ri","ri mayur","ri minur","riaksiyun","riay","rib.","ribaha","ribal","riban","ribansa","ribansin","ribawun","ribawunir","ribildi","ribili","ribilyun","ribintadur","ribirb","ribirindu","ribisadu","ribisar","ribisiyun","ribista","ribiti","ribulbir","ribulbir nga sinyurita","ribultu","ribulusiyun","ribulusiyun industriyal","ribulusiyunaryu","ribun","ribun dans","ribunit","ribyu","rid","rid dragun","rid karpit","rid krus","rid kubra","ridhart","ridi","ridi mid","ridiskwintu","ridiyu upiritur","ridyistir","ridyistir-ub dids","ridyistir-up dids","ridyistrar","ridyun","ridyus","ridyuyridyuy","rigadira","rigadur","rigadura","rigalu","rigla","rigla sa panupak","riglamintu","riglamyintu","rigudun","rigudun diunur","rigul","rigular","rigulasiyun","rigur","rigyular","rihas","rihistrada","rihistradu","rihistrar","rihistru","rihiyunal","riiliksiyunista","rik","rikabir","rikadu","rikap","rikargu","rikim","rikisa","rikisisiyun","rikisita","rikisitas","rikisitus","rikiyim","riklamadur","riklamasiyun","riklamu","rikrak","rikta","riktahun","riktanggul","riktanggulu","riktu","riktur","rikubir","rikudu","rikuduhan","rikuhir","rikula","rikulitanu","rikulitu","rikulitus","rikuluta","rikumindadu","rikumindar","rikumindasiyun","rikunsidirasiyun","rikunusir","rikurd","rikurding","rikurida","rikuridas","rikursus naturalis","rikwirdu","rikwisasiyun","rikwisisiyun","rikwisisyun","rikwisitus","rilak","rilaks","rilansi","rilasiyun","rili","rilibu","rilidyun","rilihiyun","rilihiyusa","rilihiyusu","rilikaryu","rilikyas","rilip","rilipan","rilis","rilisiyun","rilu","rilu dibulsa","rilu dipalsu","rilu dipasmu","rilu dipulsu","riluhiriya","riluhiru","rilus","rilyibu","rilyinu","rim","rima","rimas","rimatadu","rimati","rimatsi","rimidiyu","rimidiyuhay","rimin","rimu","rimulatsa","rimurimu","rimurki","rimut kuntrul","rina","rinahayan","rinda","rindidu","rindir","rindirpis","rindyir","ring","ringgiru","ringlis","ringlit","rinigada","rinigadu","rinigar","rinihasan","rinisal","rinisibi","rintas","rintas intirnas","rinyun","rip","rip.","ripa","ripan","riparasiyun","ripasu","ripiki","ripilint","ripinadu","ripir","ripiri","ripitir","ripitisiyun","riplan","ripli","ripli nga dibumba","ripliksiyun","ripliktur","ripling dibumba","ripran","riprap","ripridyiritur","riprisintanti","riprisintar","riprisintasiyun","riprisku","riprismin","riprismin parlur","riprismint","ripu","ripublika","ripulyu","ripurt","ripurtir","rirayit","risada","risal","risayin","risayit","risaytal","risgu","risibi","risibidur","risibu","risididu","risidin sirtipikit","risidins","risidinsiya","risikada","risiku","risintar","risipi","risir","risirba","risirbadu","risirbasiyun","risis","risistinsiya","risistinsiyadu","risita","risma","rispitadu","rispitar","rispitu","rispundi","rispunsabilidad","rispunsabli","rispunsibilidad","rispunsu","rista","ristanti","ristar","ristawran","risulta","risultadu","risulusiyun","risuriksiyun","ritasu","ritatsir","ritayir","ritayird","ritayirmin","ritilir","ritim","riting","ritira","ritmu","ritratar","ritratista","ritratu","ritrit","ritrita","ritru di-","ritruku","ritubada","ritubadu","ritubar","ritukadur","rituki","riturn bawut","riurganisar","riurganisasiyun","riyal","riyal istit","riyalis","riyuma","riyumatismu","riyunyun","rps ","rubada","rubar","rubi","rublis","rubu","ruburubu","rubut","rud-aylan","rugi","rul","ruling","ruling bayan","ruling du","ruling istur","rulir","rulita","rulkul","rulpad","rulyista","rulyu","ruma","rumanista","rumans","rumansa","rumantika","rumantiku","rumanu","rumba","rumblun","rumbu","rumi","rumiru","rumlun","rumpi","rumpi kandadu","run","runda","rundalya","rung","rungkilyu","runiyu","rup gardin","rural","rural duktur","rus","rusa","rusal","rusaryu","rusaryu kantada","rusaryuan","rusaryuhan","rusas","rusas dihapun","rusas dipapil","rusas dipuki","rusitas","ruska","ruskilyus","rusu","ruta","rutisiyun","rutunda","ruyal","ruyal blu","ruyal buki","ruyal iskalira","ruyal midul kard","ruyal pyanghaw","ruyda","sa","sa [noun]?","sa [verb] lamang","sa agaw","sa aktuwal","sa akung bahin","sa amu","sa atay","sa atu pa","sa babayi","sa bakus","sa bituk","sa datu","sa dayun [gen.] nga [verb base]","sa dili pa gayud","sa dinhi","sa gani","sa gihapun","sa hangtud","sa imung —","sa imung (iyang) tungul","sa imung buli","sa imung kahungug","sa imung kunut","sa imung lagus","sa ingun","sa ingun niana","sa ispiritu","sa iyang lagay","sa ka [name]","sa kabuhi","sa kahangturan","sa kanyahay","sa kapi nga","sa kaulahian","sa kaulahiay","sa kunsinsiya","sa lain nga bahin","sa laing (luyung) bahin","sa lakbit","sa limbu","sa mahayag","sa ngalan","sa ngatanan","sa nu","sa pagka karun","sa palu","sa tagu","sa tanan","sa tanang nangamatay","sa tantu nga [verb base]","sa tumuy sa dila","sa una","sa una nga lugar","saa","saad","saag","saang","sab","sab-a","sab-ag","sab-ay","sab-ilay","sab-it","sab-itanan","sab-ung","sab-unganan","sab-uy","saba","saba diha","sabaan","sabad","sabadista","sabadu","sabadu iglurya","sabadu santu","sabak","sabak ug bituun","sabakan","sabakan ni nanak","sabakan sa yuta","sabal","sabana","sabang","sabas","sabat","sabat amin","sabaw","sabay","sabdyik","sabid","sabikil","sabilay","sabin","sablag","sablaw","sablay","sablay sa luwag","sablayan","sabli","sablig","sabligay","sabluk","sabnit","sabsab","sabud","sabug","sabul","sabulag","sabulak","sabun","sabung","sabungira","saburan","saburnu","sabut","sabutahi","sabuwak","sabuy","sabuysabuy","sabwag","sabwagay","sabyag","sabyu","sabyuk","sad","sad-an","sad-ang","sad-ay","sad-ung","sadiya","sadlayin","sadpanan","sadsad","sadsarun","sadtu","saduk","sadyap","sag","sag-ang","sag-ilay","sag-u","sag-ub","sag-ulu","saga","sagabal","sagabay","sagad","sagad sa","sagad sagdi","sagadsad","sagahid","sagakang","sagakay","sagalak","sagalsal","sagalsalun","sagang","sagangat","sagangsagang","sagangsang","sagangsangun","sagansal","sagap","sagapsap","sagarat","sagasa","sagasaun","sagata","sagay","sagayad","sagaysay","sagbat","sagbat saysay","sagbay","sagbuk","sagbut","sagbut sa dagat","sagbutun","saghid","sagib","sagibu","sagibunhun","sagidsid","sagilit","saging","saging pungkul","sagingsaging","sagip-ut","sagiput","sagirit","sagisag","sagisi","sagisihun","sagitsit","sagitsit gu","sagiwsiw","sagka","sagmuku","sagmukuy","sagmun","sagmuyu","sagnunut","sagpa","sagpa baha","sagpang","sagpu","sagrada","sagrada iskritura","sagrada pamilya","sagradu","sagradu kurasun di hisus","sagu","sagubang","sagud","sagudsud","saguksuk","sagukum","sagukuy","sagul","sagulsagul","sagulu","sagum-ut","sagumayun","sagungsung","sagungut","sagunsun","sagunting","saguntu","sagup","saguran","sagut","sagutsut","sagutsutun","saguy","saguysuy","saguyud","sagyad","saha","sahi","sahi pa","sahiay","sahid","sahu","sahug","sahuy","sai","sain","sakit ang dughan","sakit sa kidni","sakit ug","sakramintu","saksak sinagul","saksi ni hiyuba","sakup","sakut","sakuting","sakuung","sakwat","sakyab","sakyud","sal-ak","sal-aksal-ak","sal-ang","sal-angsal-ang","sal-ig","sal-ing","sal-ub","sal-ut","sal-utsal-ut","sala","sala gud","sala nga ikamatay","sala nga urihinal","sala tuud","salaag","salaan","salab","salaban","salabat","salabay","salabtunun","salabutan","salad","saladsalad","salag","salag sa kaminyuun","salag-un","salagma","salagsag","salagunting","salahan","salahid","salak","salakan","salakut","salama","salamabit","salamabits","salamagan","salamangka","salamangkiru","salamat","salamat ha","salamat na lamang","salamat na lamang nga","salamat na lang","salami","salamin","salaminan","salaming","salaminsalamin","salampati","salampati nga mubu ug lupad","salan","salanap","salang panulundun","salanga","salangasag","salangasang","salangkap","salanta","salapang","salapat","salapati","salapi","salapid","salapsap","salaptun","salapwang","salapyaw","salas","salasa","salat","salatan","salaud","salaugan","salauganan","salawaki","salawasid","salawayun","salay","salayan","salaysalay","salaysayun","salba","salbabida","salbadur","salbadur dil mundu","salbahis","salbar","salbaru","salbasiyun","salbid","salbids","salbu","salga","salgu","salguhan","sali","saliabgaw","saliabut","saliat","saliay","salib-ay","salibadyaw","salibag","salibaganan","salibagyaw","salibagyu","salibay","salibu","salibut","salibutbut","salid-ay","salida","salidsid","salig","salig-ang","salig-angun","salig-ay","saligbay","saligsalig","salihukngaw","saliid","saliit","salik","salikan","saliksalik","saliku","salikubkub","salikwaut","salikway","salikyat","salikyaub","salikyaubun nga bulan","salili","salimagaw","salimbagat","salimbangun","salimbung","salimpukut","salimuang","salin","salin sa gubat","salin sa uwak","salindanaw","salindrun","salindut","salindyir","saling-ay","saling-it","saling-uwang","salingawa","salingay","salinggaay","salinggaway","salinggukud","salingkapaw","salingsing","salingtuud","salinrun","salintuud","salinyasi","salip-ang","salip-ing","salip-it","salip-ut","salipi","saliping","salipnu","salipud","salir","salirap","saliring","salisi","salit","salitri","saliut","saliut-ut","saliyab","salmu","salmun","salmunan","salmuniti","salmus","salmut","salngan","salpu","salsa","salsag","salsal","salsalan","salsalanan","salsaliru","salsitsas","salta","saltu","salu","salud","salud sa gaba","saludar","saludu","saludu militar","salug","salugsug","salukgu","saluksuk","salukut","salum","salum sa lubug","saluma","salumabit","salumabits","salumagan","salumsum","salun","salundung","salung","salung lunay","salunggat","salungsung","salungsungun","salunira","salup","salupan","salusalu","salusu","salut","salutaturyan","salutsut","saluwaki","saluwal","saluwasid","saluyut","salwag","salwaki","salya","salyada","sam-ang","sam-id","sam-iran","sama","sama sa lusay","sama ug balhibu","samad","samad nga walay pagkaayu","samag","samagaw","samalabit","samalabits","samaluna","samar","samaran","samarinyu","samarnun","samarun","samasama","samaw","samay","samba","sambag","sambagsambag","sambagul","sambagun","sambara","sambat","sambil","sambilat","sambilay","sambingay","sambiri","sambud","sambug","sambul","sambulak","sambunut","sambunutay","samdan","sami","samilya","samin","saminsamin","samir","samkun","sampablu","sampaday","sampaga","sampagita","sampak","sampaka","sampal","sampaling","sampalita","sampalung","sampan","sampangkung -in-","samparay","samparing","sampay","sampayna","sampaysampay","sampid","sampidru","sampig","sampil","sampila","sampilay","sampiling","sampilingun","sampinit","sampiray","sampit","sampiyad","sampiyun","sampul","sampul balut","sampung","sampungan","sampungun","sampungut","sampura","sampuradu","sampurawu","samput","samsam","samsamun","samsi","samsuy","samtang","samu","samu lang","samual","samuhan","samuk","samuk ra","samukan","samukin","samung","samungsamung","samut","samuyaw","san","san bating","san huwan","san markus","san pidru","san pidru san pablu","san pransisku","san-antun","san-glas","san-u","san-ut","sana","sanad","sanag","sanan","sanap","sanasana","sanaturyum","sanaw","sanay","sanaysanay","sanburn","sandak","sandal","sandalyas","sandanan","sandanaw","sandanay","sandanun","sandaw","sanday","sandayung","sandi skul","sandig","sandig sa kaliwat","sandiganan","sandiya","sandu","sandugu","sanduk","sandul","sanduluy","sandurut","sandusandu","sang","sang-at","sang-atanan","sang-ay","sanga","sanga ang dila","sanga ang tinggil","sanga nga buhatan","sangab","sangad","sangag","sangan","sangasanga","sangat","sangay","sangbat","sangbud","sangburan","sangga","sanggab","sanggabun","sanggaka","sanggarayung","sanggat","sanggi","sanggikit","sanggra","sangguli","sanggurayung","sanggut","sanggutan","sangguwar","sanghan","sanghid","sangi","sangig","sangil","sangit","sangka","sangkad","sangkap","sangkay","sangkayud","sangki","sangkiguy","sangkiig","sangkil","sangkiribut","sangkis","sangkiyud","sangku","sangkung","sangkurayung","sangkuriyung","sangla","sanglad","sanglag","sanglahun","sanglay","sanglit","sanglitanan","sangpit","sangput","sangputan","sangputanan","sangsang","sangu","sangud","sanguhal","sangun","sanguran","sanguwal","sangyad","sangyag","sangyaw","sani","sanib","sanidad","sanilas","sanina","sanipa","sanit","sanitari inspiktur","sankis","sanla","sanpipar","sansan","sansanan","sansiyut","sansut","sansuy","santa","santa bula","santa iglisya","santa klawus","santa krus","santa krusan","santa lana","santa lusiya","santa mariya","santa santita","santa sina","santak","santaku","santal","santan","santas","santiban","santik","santikan","santilmu","santing","santing ang dunggan","santisima","santisima trinidad","santisimu","santisimu sakramintu","santisiyam","santisiyam nga karaan","santita","santitasantita","santitu","santu","santu —","santu intiyiru","santu kristu","santu lana","santu ninyu","santu papa","santu rusaryu","santu santitu","santul","santulun","santunina","santup","santus","santus diyus","santus nga misa","santus nga rusaryu","sanu","sanung","sanusanu","sanuud","sanuuy","sanwit","sanwits","sap-ang","sap-ig","sap-ung","sapa","sapak","sapal","sapalun","sapang","sapar","sapat","sapatilya","sapatiriya","sapatiru","sapatus","sapatus sa kabayu","sapaw","sapay","sapayan","sapayan sa","sapda","saphag","saphid","saphig","sapi","sapian","sapid","sapidpid","sapigad","sapil","sapilis","sapilya","sapilyu","sapin","sapinday","sapinit","sapinu","sapipid","sapiray","sapiring","sapiru","sapisapi","sapiti","sapla","saplag","sapli","saplina","saplu","saplud","saplung","saplut","sapnay","sapnig","sapnut","sapsap","sapsing","sapsiyutir","sapsuy","sapu","sapud","sapul","sapun","sapung","sapunir","sapunul","sapupu","saput","saputi","saputun","sapwang","sapya","sapyag","sapyaw","sapyur","sapyut","sara","sarabya","saragati","sarahintu","sarang","saranggat","sarap","sarasay","sardinas","sargati","sarguylas","sarhintu","sarhintu dimisa","saril","saring","saringan","saringsaring","sarisari","sarlistun","sarsa","sarsaparilya","sarsuyla","sartin","saru","saruk","saruksaruk","sarul","sarung","sarunsuy","sasa","sasag","sasing","sasirduti","sastri","sastririya","satan","satanas","satgan","satin","satispitsu","satsat","satsatay","satsatira","satu","satum","satung","saud","saudsaud","saug","saul","sauli","saulu","saulug","saun","saup","sauy","sauysauy","saw-a","saw-id","saw-it","sawa","sawa nga baksan","sawad","sawali","sawan","sawananan","sawang","sawasid","saway","sawi","sawil","sawilik","sawpan","sawsaw","sawsyung","sawu-","sawun","sawun sirbis","sawut","sawuy","say-a","say-asay-a","saya","saya sa bunga","sayab","sayad","sayag","sayagun","sayal","sayang","sayang umpul","sayans","sayantipiku","sayantis","sayantist","sayasaya","sayaw","sayaw ang kasingkasing","sayawan","sayawanan","sayawsayaw","sayhanan","sayid bit","sayid layin","sayid pakit","sayid tru","sayid-awut","sayidwuk","sayidwuk bindur","sayin","sayin syu buy","sayin syus","sayin-up","sayinburd","sayintist","sayis","sayit","sayitsiing","sayla","saylanan","saylinsir","saylu","saylub","saylusaylu","saynus","saynusun","saysay","saysinta","saytid","sayu","sayud","sayukmu","sayun","sayunsayun","sayup","sayup ang istiping","sayup nga lakang","sayusayu","sayuti","sayutis","si","si bisan kinsa","si kinsa","si pidru","si tru","si-klam","siad","siak","siak sa ulu","siaku","siang","siatab","siaw","siaw sa babayi","siawan","siay","siay-is","sib","sib bay da bil","siba","sibag","sibakung","sibang","sibasid","sibat","sibaun","sibaw","sibay","sibaya","sibaysibay","sibika","sibiku","sibil","sibil sirbis","sibil sirbis tist","sibilisadu","sibilisar","sibilisasiyun","sibilsibil","sibilyan","sibin","sibin pirs","sibin-ilibin","sibinan","sibins grid","sibinti paak","sibinti siks","sibintiit","sibit","sibsib","sibsibanan","sibu","sibug","sibukaw","sibul","sibut","sibuyas","sibuyas amirikanu","sibuyas bisaya","sibuyas bumbay","sibuying","sibya","sid-ing","sid-uk","sida","sidasida","sidbaks","sidhawus","sidi","sidlak","sidlakan","sidlit","sidlut","sidsarun","sidsid","sidsiran","sidula","sig-ang","sig-aw","sig-id","sig-iya","siga","sigabu","sigamnu","sigarilyu","sigarilyu sa ilung","sigarit kis","sigasiga","sigaw","sigay","sigbaw","sigbin","sigbinan","sigi","sigi lamang","sigi lang","sigi na lamang","sigidas","sigidilyas","sigin","sigingsiging","sigisigi","sigisigi gang","sigkat","sigking","sigkit","siglu","sigmit","sigmuk","signal","signit","signunut","signus","sigpat","sigpaw","sigpit","sigsag","sigsag nga makina","sigu","sigun","sigun lamang","sigun sa","sigunda","sigunda manu","sigunda rinda","sigundarya","sigundu","sigundu anyu","sigundu upisyal","siguradu","siguridad","sigurista","siguru","siguru dibida","sigwalu","sigwar","sihag","sihagsihag","sihagsihagan","sihi","sihud","sii","siin","sik lib","sik.","sika","sikad","sikad ang manuk","sikadsikad","sikan","sikan bis","sikan dimusyun","sikan grid","sikan han","sikan hap","sikan klas","sikan plis","sikan plisir","sikan rawun","sikan yir","sikandir","sikapat","sikasika","sikasikaun","sikat","sikaw","sikawalu","sikaysikay","sikbat","sikbit","sikbut","sikdu","sikdul","sikging","siki","sikil","sikit","siklahun","siklap","siklat","siklib","siklista","siklit","siklut","sikma","sikma ug dugu","sikma ug kusahus","sikma ug manintimus","sikmat","sikmul","sikpat","sikpaw","sikrit","sikrit kang","sikrit pakit","sikrita","sikritari","sikritarya","sikritaryal","sikritaryu","sikritu","sikritu diamur","sikritu ug labuk","siks rawundir","siks-uklak","siksbay siks","siksi","siksik","siksirikay","siksiyun","siksrawundir","sikstin kards","sikstinayin","sikstring","sikstu gradu","sikswa","siktur","siku","siku kaputi","siku karabaw","sikuhan","sikulati","sikuluhiya","sikund grid","sikundarya","sikup","sikusiku","sikuy","sikwa","sikwalu","sikwati","sikway","sikyuriti","sikyuriti gard","sil","sil-ing","sil-ingan","sil-inganan","sil-ip","sil-it","sila","sila si","silab","silaba","silabi","silabun","silabun-","silag","silahanun","silahis","silak","silang","silang [name]","silangan","silangga","silanis","silasila","silaub","silaw","silbatu","silbi","silbidur","silbidura","silbir midal","silda","silhig","silhig nga bikug","silhig sa ngipun","sili","sili kay gihangan","sili kulikut","sili nga amirikanu","sili nga ispada","sili nga kaguku","silib","silibaun","silibrar","silibrasiyun","silid","silik","silik-an","silikan","silimana","silimangan","silimbahun","silin","silindru","silindrun","silindrus","siling","siling kulikut","silingan","silinganan","silinsiyu","silinsiyusu","silip","siliri","silisi","silit","silsil","silstuk","silu","silulusa","silung","silunganan","silungsilung","silupin","silus","silusa","silusiya","silusu","silut","siluwid","siluy","silya","silya iliktrika","silyadur","silyadura","silyita","silyu","sim-ung","sima","simaan","simag","simaluna","simana","simana santa","simang","simangan","simanganan","simaniya","simasima","simba","simbahan","simbahan ni pilatu","simbaku","simbaku lagung","simbal","simbasimba","simbu","simbug","simbulu","simburyu","simhut","simik","similya","similyahan","similyahun ug lawas","siminar","siminarista","siminaryu","simintadu","simintiryu","simintu","simirisir","simistir","simistri","simpatika","simpatiku","simpatiya","simpi","simpig","simpin","simpis","simpiyis","simplan","simpli","simpul","simpul libing","simpun","simput","simsim","simtum","simtuma","simuaw","simud","simusimu","simyat","sin","sin-u","sina","sinaaran","sinabadu","sinabas","sinabtanay","sinabunan","sinabut","sinad-ung","sinad-ungan","sinadu","sinadur","sinadura","sinadyap","sinagadsad","sinaging","sinaguga","sinagul","sinagup","sinaguylas","sinahan","sinahug","sinalasa","sinalbahis","sinaligan","sinalikway","sinam-id","sinamay","sinampangkung","sinamuk","sinamuksamuk","sinamun","sinanaw","sinanawan","sinanduluy","sinanggutan","sinanglag","sinanglay","sinanglayan","sinansan","sinaphig","sinapsap","sinarang","sinardinas","sinaryu","sinaryuhan","sinati","sinaw","sinaw ug ulu","sinayaw","sinayawan","sinayuran","sinda","sindalan","sindi","sindidur","sindikatu","sindul","sindurut","sing-al","sing-aling","sing-aw","sing-it","singabut","singan","singani","singari","singba","singdalan","singgaak","singgalung","singgapur","singgarayung","singgil","singgit","singgit awhag","singgit pakitabang","singgul","singgurayung","singhag","singhir","singi","singil","singilugun","singin","singir","singit","singka","singkamas","singkamut","singkaw","singkiribut","singkit","singku","singkul","singkulyagas","singkuribut","singkurung","singkuruyung","singkuung","singkuwinta","singkuy","singlunun","singpi","singpun","singput","singsing","singtanun","singtanun ug utuk","singu","singud","singulu","singut","sini","sinibat","sinibil","sinibit","sinigsagan","siniguylas","sinihan","sinikpan","sinilas","sinilian","sinilihan","sinimana","sinimaskup","sinimpin","sinina","sininaun","sininghagan","siningkahan","sinipak","sinipilya","sinipit","siniryus","sinisini","sinisiru","siniyal","siniyuk","siniyur","siniyur san bisinti","siniyur san pidru","siniyur santu ninyu","siniyurun","sinkamut","sinkuwinta","sinsilyu","sinsiru","sinsitib","sinsitibu","sinsiya","sinsiyu","sinsu","sinsur","sinsuradur","sinsurs","sinsuru","sinsus","sinta","sinta libanta","sintabu","sintabus","sintak","sintas","sintas balatung","sintas nga balatung","sintidu","sintidu kumun","sintimingaw","sintimintal","sintimintalista","sintimintu","sintimiruy","sintimitru","sintimiyut","sintimiyuy","sintimus","sintimyintu","sintinaryu","sintinil","sintinila","sintins","sintinsiya","sintinsiyadu","sintinyal","sintir","sintral","sintripugal","sintripyugal","sintru","sintu-","sintun","sintunadu","sintunawu","sinturira","sinturiyun","sinturun","sinubung","sinud-ad","sinudlan","sinug-ang","sinugatan","sinugba","sinugbuanun","sinugdan","sinugdanan","sinugpungan","sinugu","sinugung","sinuhulan","sinukliay","sinukmagay","sinukud","sinulid","sinulnganay","sinultihan","sinulug","sinumbagay","sinumbung","sinumpayan","sinundug","sinunuban","sinupa","sinursihan","sinuruyan","sinuylas","sinya","sinyadur","sinyal","sinyalan","sinyas","sinyura","sinyurahun","sinyuranhun","sinyuris","sinyurita","sinyuritahun","sinyuritu","sinyurituhun","sip","sip-ak","sip-un","sip-unun","sip-ut","sipa","sipak","sipan","sipanan","sipara","siparar","siparasiyun ligal","sipat","siphag","siphagay","sipi","sipii","sipii luyir","sipilin","sipilis","sipilya","sipilyu","siping","sipingan","sipir","sipit","sipit ug dipluma","sipla","siplaag","siplagay","siplat","siplin","siplit","sipra","sipris","sipsayid","sipsip","sipsip butu","sipt.","sipti","siptimbri","siptimu gradu","siptinaryu","sipu","sipuk","sipukadu","sipukar","sipukawu","sipukun","sipul","sipulkru","sipultiru","sipung","sipungun","sipungunun","sipur","sipuy","sipya","sipyat","sir","sira","sira gana","sira tilun","sira ug dugu","siradu","siradura","siragana","sirali","siramiks","sirapinis","sirbandu","sirbatu","sirbi","sirbidur","sirbidura","sirbilyita","sirbis","sirbis diluks","sirbisa","sirbisahay","sirbisyawu","sirbisyu","sirbisyu sibil","sirbiyinta","sirbiyinti","sirbyinta","sirbyinti","sirguylas","siriguylas","sirikinya","siril","sirimunyas","sirina","sirinata","siring","siringsiring","sirinu","sirip","siripinti","siris","sirit","sirkadur","sirkadura","sirkira","sirkiru","sirku","sirkul","sirkular","sirkulasiyun","sirkulu","sirkumpirinsiya","sirkumstansiya","sirkus","sirmun","sirpinti","sirta","sirtipay","sirtipikadu","sirtipikar","sirtipiku","sirtipiku sa kandidatura","sirtu","siru","siruhanu","siruk","siruks","sirul","sirumsirum","sirung","sirutsu","sirutsu para laras","siryal","siryal nambir","siryus","siryusa","siryusu","sis","sisariyan","sisi","sisig","sisik","sisinta","sisip","sista","sisti","sistim","sistima","sistimatiku","sistu","sistusumyasis","sisu","sisyun","sit","sita","sitar","sitasiyun","sithaw","siti","siti birnis","siti dukturis","siti palabras","siti paris","sitihul","sitinta","sitlayit","sitru","sitsaru","sitsarun","sitsirika","sitsiriku","sitsiriya","sitsiriyas","sitsit","situn","sitwasiyun","sityu","siu","siudi","siug","siut","siutsiut","siwag","siwagkang","siwakug","siwang","siwasid","siwil","siwit","siwitsiwit","siwsiw","siya","siya ditirminalis","siya minay","siya nga kira","siya pa","siyam","siyam pa sa kamut","siyap","siyap sa makina","siyasiya","siyatsiyat","siyin","siyuk","siyun","siyung","siyut","siyutsiyut","stabus","sts.","su","suag","sub","suba","subad","subad nga way paun","subad ug way paun","subadsubad","subak","suban-un","subang","subangan","subangsubang","subasku","subasta","subaw","subay","subdibayid","subdibisyun","subid","subida","subidahun","subidsubid","subidu","subing","subir","subiran","subirbiya","subirbiyu","subisubi","subli","submarinu","submasinggan","submit","submitir","subpina","subra","subra ibasta","subra ra","subra sa ginhawa","subra ug dugu","subraanay","subri","subrikama","subrikargu","subsik.","subsub","subu","subuk","subuksubuk sa mais","subukun","subul","subung","suburnu","subut","subwak","sud","sud-an","sud-anun","sud-ip","sud-ipan","sud-uk","sud-ung","suda","suda krakirs","sudiya","sudiyang","sudlanan","sudlay","sudlayng sisik","sudlunun","sudlut","sudsud","suduy","sug-ang","sug-angan","sug-u","suga","suga nga dikumbati","sugabin","sugabu","sugakud","sugal","sugala","sugalan","sugamak","sugang dikumbati","sugapa","sugarul","sugarul nga tahur","sugasuga","sugat","sugata","sugatsugat","sugba","sugbaanan","sugbu","sugbuanun","sugi","sugid","sugigi","sugilagming","sugilakbit","sugilambung","sugilanun","sugilanun nga purtada","sugilun","sugkay","suglib","sugmat","sugmaw","sugmuy","sugnib","sugnud","sugpa","sugpu","sugpung","sugput","sugpuy","sugsug","sugu","sugu sa diyus napulu","sugu sa lawas","sugu sa pagbati","sugu sa palad","sugu sa panahun","sugu sa papil","sugua ku ninyu","sugub","sugud","sugudsugud","suguk","suguk sa dugu","sugung","sugut","sugwak","sugyut","suha","suhi","suhid","suhildu","suhiran","suhitu","suhul","suhung","suhup","suhupsuhup","suhut","suhut bagun","suhutanan","suhutsuhut","suik","suka","suka hibulus","suka kalibang","sukad","sukad mabaki","sukad masukad","sukad sa [dat.]","sukalsukal","sukalu","sukam-ag","sukamang","sukamud","sukaran","sukaran nga bastus","sukaranan","sukarap","sukat","sukbut","sukdanan","sukdip","suki","sukib","sukihan","sukip","sukit","sukitsukit","suklat","suklay","sukli","sukmag","sukmagay","sukmat","sukmil","sukna","suknib","suksuk","suku","sukub","sukud","sukul","sukul dagan","sukul sa kabu","sukut","sukutsukut","sukwahi","sul","sul-anun","sul-ub","sul-ung","sul-ungsul-ung","sul-ut","sul-utsul-ut","sula","sulab","sulabi","sulabi ug","sulad","suladnun","sulagma","sulahan","sulambi","sulaminti","sulampatid","sulang","sulangga","sulangun","sulapid","sulapid ang dila","sular","sulat","sulatanan","sulatuk","sulaw","sulay","sulaybagyu","sulbad","sulbar","sulbaran","sulbung","sulda","suldadu","suldadur","suli","sulib","sulibag","sulid","sulikat","sulimaw","sulimbad","sulimni","sulindir","suling","sulinga","sulingsuling","sulip-it","sulipat","suliping","sulirab","suliran","sulirap","sulirat","sulisilit","sulisit","sulisitadur","sulisitar","sulisitur hiniral","sulisuli","sulit","sulitaryu","suliut","suliyaw","sulnganay","sulpa","sulput","sulsul","sultada","sultadur","sultan","sultana","sulti","sultianan","sultianay","sultid bins","sultihanay","sultihunun","sulting dugmuk","sultira","sultiru","sultisulti","sulu","sulu alun","sulu playit","sulud","sulud gula","sulud guwa","sulud sa bulsa","sulud sa buyut","sulud sa ulu","suludsulud","sulug","sulugsulug","sulugsulugan","suluguun","suluha","suluksuluk","sulul-an","sulum","sulumilyu","sulundun","sulung","sulup","suluran","sulusalamin","sulusimana","sulusiyun","sulusulu","sulut","suluwist","suluwista","sulya","sum","sum-uk","sum-ul","sum-ul ug nawung","suma","sumad","sumad nga lunis","sumada","sumadsumad","sumagang","sumahi","sumala","sumala [gen.]","sumalabit","sumalabits","suman","suman nga hilaw","sumangil","sumarinu","sumat","sumatin","sumay","sumaysumay","sumbag","sumbagay","sumbagay ang kwarta","sumbagsumbag","sumbalihuk","sumbalik","sumbalik dasdas","sumbaling","sumban","sumbanan","sumbanun","sumbi","sumbil","sumbingay","sumbriya","sumbuhan","sumbung","sumbungira","sumbungiru","sumikad","sumil","sumilimba","sumitir","sumpa","sumpaki","sumpay","sumpit","sumpu","sumpung","sumput","sumsum","sumsuman","sumsumay","sumu","sumusunud","sun-ad","sun-an","sun-arun","sun-uk","sun-un","sun-ut","suna","sunanuy","sunata","sunaup","sunda","sundalisa","sundalu","sundang","sundanun","sunding","sundug","sung","sung-ad","sung-ag","sung-anay","sung-ay","sung-un","sung-unun","sungad","sungag","sungasung","sungay","sungayan","sungban","sunggal","sunggat","sunggaw","sunggu","sunghan","sunghit","sunghits","sungi","sungil","sungisuk","sungka","sungkab","sungkaban","sungkad","sungkaran","sungkat","sungkil","sungkip","sungkit","sungkiub","sungku","sungku sa","sungkud","sungkudsungkud","sungkul","sungkuran","sunglug","sunglugan","sungpit","sungput","sungputay","sungsung","sungu","sungug","sungusungu sa mais","sungut","sungutan","sunguy","sunitu","sunluk","sunlut","sunlutan","sunsun","sunting","suntuk","suntukay","sunu","sunub","sunud","sunud ug kasal","sunudsunud","sunug","sunugan","sunuy","sup dringk","sup-ak","sup-ut","supa","supak","supakira","supakiru","supan","supang","supas","supat","supatun","supbul","supi","supil","supir istar","supira","supirbaysing","supirbaysur","supirbisar","supirbisiyun","supirbisur","supirbisuri","supirbisyun","supirintindint","supirintindinti","supiriyur","supirmarkit","supiryura","supla","suplada","supladu","suplagay","suplimintu","suplir","supliti","suprimu","suprir","supsup","supsup butu","supsupun","supu","supukar","supurtar","supurtir","suput","sur","sura","surab","suraban","surambaw","surangsurang","surbi","surbiti","surbitiru","surbitis","surbiyur","surihir","suriksurik","surindir","suringiw","surisu","surisu di bilbaw","surisu sa insik","surit","suritsurit","surku","surkuhunun","surpan","surplas","surprisa","sursi","sursi tapak","surtidus","surtpan","suru","suruk","surup","surusuru","suruy","suruy bagduy","suruysuruy","sus","sus maryusip","sus-an","susa","susayid","susi","susisusi","suskribir","suskrisiyun","suskritur","susmariya","suspi","suspindir","suspinsu","suspiru","suspiru dimani","suspirus","suspitsa","suspitsar","suspitsu","suspitsusa","suspitsusu","sustansiya","sustinidu","sustinir","sustintu","susu","susug agta","susun","susut","susyadu","susyal","susyalayit","susyidad","susyu","sut","suta","sutana","sutanan","sutanghun","sutil","sutsut","sutuy","suub","suud","suudsuud","suuk","suul","suul sa iru","suun","suung","suungsuung","suup","suut","suuy","suwa","suwa-","suwal","suwasuwa","suwat","suway bagyu","suwing gam","suwits","suy bins","suya","suyagit","suyak","suyla","suylan","suylas","suysuy","suyud","suyup","swa","swab","swabi","swagir","swagit","swaing","swakan","swaki","swangit","swapang","swasid","swibil","swildadu","swildu","swilduanan","swiltu","swing","swipir","swipirunun","swipstik","swirti","swirti dikasahus","swirtiswirti","swis linin","swit","swit myusik","switik","switir","switu","syagit","syakuy","syalan","syampu","syanga","syaping","syapirun","syapu","syapul","syarap","syarpsyutir","syaru","syaru [name","syaru ug","syaru usab","syat","syatdawun","syatgan","syatir","syauk","syawir","syawir parti","syiding","syilak","syimpri","syinapul","syinsiya","syintipiku","syintu","syintus","syiring","syirtu","syista","syiti","syuap","syudad","syudad sa sugbu","syudadnun","syugar dadi","syugar magnit","syukang kaw","syuktung","syuldir bag","syumuy","syupaw","syurt pants","syurthan","syurtkat","syurts","syut","syuting","syutis","ta","ta ikaw","ta ka","ta kamu","taak","taal","taan","taantaan","taas","taas ug atug","taas ug ilung","taas ug lupad","taas ug silung","taas ug tinuntu","taay","tab","tab-ak","tab-ang","tab-angan","tab-ung","taba","tabagak","tabaghak","tabagnul","tabagnulun","tabagsak","tabagsuy","tabak","tabakalira","tabaku","tabakuan","tabakun-an","tabal","tabal-ak","taban","tabanaw","tabang","tabangay","tabangka","tabangku","tabangtabang","tabanug","tabas","tabas sa nawung","tabatsuy","tabaw","tabawung","tabay","tabayag","tabi","tabi iskina","tabian","tabibi","tabid","tabig","tabigi","tabiki","tabikung","tabil","tabilawan","tabili","tabili sa dagat","tabilis","tabilung","tabilus","tabing","tabirak","tabirnakulu","tabirwak","tabisay","tabiwis","tabla","tabla ug tungku","tabladu","tablaw","tablita","tablitas","tabliya","tablug","tablugtablug","tablun","tablung","tabtab","tabu","tabuan","tabudlung","tabudyus","tabug","tabugsuk","tabugtabug","tabuguk","tabuk","tabukanan","tabukanun","tabukaw","tabuli","tabun","tabun sa layag","tabung","tabuntabun","tabunuk","tabunun","tabunus","taburiti","tabutabu","tabuylug","tabyayung","tabyug","tabyun","tabyus","tad","tadhan","tadiya","tadiyaw","tadlas","tadlasan","tadlip","tadluk","tadlung","tadlungan","tadluy","tadtad","tadtaran","tadyak","tadyaw","tadyus","tadyutu","tag","tag-","tag-an","tag-antag-an","tag-as ug lakang","tag-ingun","tag-iya","tag-iyahan","tag-upat","tag-usa","taga","taga-","taga-(→)","tagaabad","tagaamu","tagaanan","tagaatu","tagabanwa","tagabukid","tagabuklad","tagabung","tagad","tagad ka na man","tagadanan","tagadtad","tagahawak","tagainyu","tagak","tagak ang kwarta","tagakan","tagakana","tagaktagak","tagaktak","tagakustum","tagal","tagala","tagaliug","tagalubi","tagalug","tagalula","tagaluyu","tagam","tagamandaluyung","tagamtam","tagana","taganas","tagapangmantala","tagaranan","tagas","tagasak","tagasalut","tagasanta","tagasantu","tagatuhud","tagaubus","tagauk","tagaunun","tagaw","tagawtaw","tagawtawan","tagay","tagayan","tagaylu","tagaytay","tagbabayin-an","tagbagu","tagbak","tagbalay","tagbaw","tagbaya","tagbayahun","tagbayi","tagbayin-an","tagbu","tagbuanan","tagbutagbu","tagdaku","tagdalagan","tagdanay","tagdiyu","tagdiyut","tagdiyutay","tagduk","tagduy","tagdyaw","taggama","taggamay","taggatus","tagginatus","taghap","taghaptaghap","taghikay","taghubad","taghud","taghuy","tagibalangay","tagibanwa","tagibaryu","tagidiyu","tagidiyut","tagihangad","tagik","tagiktik","tagilapaw","tagilawas","tagilhaw","tagilhus","tagilma","tagilpu","tagiltil","tagilumbuy","tagiluyluy","tagima","tagimata","tagimtim","tagingting","taginhus","tagiptip","tagiptipun","tagitagi","tagiti","tagiwalu","tagkapin","tagkus","taglaki","taglakin-an","taglalakin-an","taglawas","taglimata","taglugar","tagluyuan","tagluyung","tagmanaku","tagmanggatus","tagmaya","tagming","tagmugna","tagmuk","tagna","tagning","tagnipa","tagnipis","tagnuk","tagpas","tagpila","tagpilahun","tagpilaw","tagpis","tagpitu","tagpiyung","tagpud","tagpuyu","tagsa","tagsa ray pulung","tagsala","tagsatagsa","tagsaun","tagsikan","tagsimana","tagsip","tagsuk","tagsulat","tagtris","tagtrisun","tagtukud","tagtulu","tagtungud","tagu","tagu ug kasingkasing","tagu ug mata","taguanan","taguangkan","tagubtub","tagud","tagudtagud","tagudtud","taguk","taguktuk","tagukun","tagul-ul","tagulaki","tagulhus","tagulilung","tagultul","tagum","tagumata","tagumbul","tagumun","tagun","tagungtung","taguntun","tagup-at","taguralaki","taguran","tagurha","tagustus","tagutagu","tagutaguay","tagutlu","tagutu","tagutungan","taguun","tagwala","tagwalu","tagyaw","tagyum","tagyuta","taha","tahada","tahal","tahan","tahap","tahas","tahi","tahianan","tahirig","tahiru","tahisyan","tahisyan bird","tahiunun","tahu","tahud","tahudtahud","tahum","tahung","tahup","tahupun","tahur","tahuray","tahuri","tahuris","tahusyu","tahutahu","tahuy","tai","tai ang buhat","taihun","taitai","tak-al","tak-ang","tak-ang sa kulun","tak-anganan","tak-anun","tak-in","tak-um","tak-up","taka","takaba","takad","takal","takam","takamtakam","takandal","takang","takas","takba","takbas","takbuy","takda","takdaan","takdanan","takdang","takdas","takdu","takdu ang buwan","takdul","takduy","takgus","takiang","takig","takigrapiya","takigrapu","takigun","takihud","takilid","takiling","takilpu","takilya","takilyira","takilyiru","takin","takinding","takingking","takinhud","takip","takla","taklaba","taklap","taklas","taklay","takli","takliad","taklid","taklima","taklub","taklubu","taklung","taklus","takmag","takmu","takmul","takna","taknaan","taksanan","taksay","taksi","taksian","taksikab","taksinilya","taksip","taktak","taktakan","taktakun","taktika","taktikal","taktikal inspiksiyun","taku","takuan","takub","takuban","takubu","takud","takug","takugan","takukung","takul","takulahaw","takuling","takulingun","takumba","takun","takung","takungtakung","takup","takupis","takuri","takus","takut","takutun","takuyan","takwahaw","takwal","takwar","takway","takyab","takyan","takyap","tal","tal-up","tala","tala na","talaadlawan","talaan","talab","talaba","talaban","talabanug","talabukun","talabun","talabung","talad","taladru","talagaan","talagabung","talagaun","talagbagu","talagsa","talagsaun","talagsaun ra pud","talagsay bungut","talagtag","talaguy","talahib","talahurun","talaid","talakituk","talakpun","talaksan","talalak","talamakan","talamayun","talambagun","talambuan","talamdan","talamdun","talamnanan","talampad","talamunu","talan-aw","talandaan","talandugun","talang","talangigu","talantar","talantun","talapya","talas","talatala","talauk","talaw","talawagun","talawan","talawgun","talay","talaytay","talayung","talha","talhanan","talhung","tali","tali-","taliabut","taliadlaw","talianak","talib","talibagyu","talibud","talibugsuk","talibuhat","talibwag","talidalagan","talidhay","talidngan","talidungan","taligama","taligatus","taligkahuy","taligmata","taligngan","taligrama","taligsik","taligsuy","taliis","talikala","talikitiki","talikud","talilakat","taliluhud","talimughat","talimunu","talinga","talingab","talinggab","talinghug","talingting","talingtingun","talinis","talinis magluyu","talinis ug luyug luyu","talinisun","talintu","talinugu","talinum","talinupsan","talinutinu","talip","talipauli","talipsay","taliptip","talirungan","talis","talisalup","talisay","talisayun","talisik","talithi","taliti","talitiun","taliudtu","taliulan","taliuli","taliunduk","taliwala","taliwala sa kamay","taliwan","taliwtiw","taliwtiwun","taliyir","taliyuk","talku","taltag","taltagan","taltal","talu","talubig","taludtud","talukbuy","taluktuk","taluktukan","talulu","talumbang","talumtum","talumtumun","talumus","talun","talung","talungan","talungtalung","talungun","talunung","talupi","talusi","talutalu","taluthu","talutu","taluun","taluut","talyada","talyir","tam dyuns","tam-ak","tam-is","tam-ug","tam-uk","tama","tama na","tamaan","tamad","tamaing","tamak","tamak sa dungug","tamala","tamalis","taman","taman na","taman sa ginhawa","tamaran","tamaraw","tamarindu","tamarinduhun","tamarung","tamas","tamasak","tamasuk","tamatis","tamay","tamba","tambag","tambagisa","tambak","tambakan","tambal","tambalan","tambalanan","tambaligay","tambaliyug","tambaliyung","tambalulu","tambaluslus","tamban","tambangungu","tambasakan","tambauli","tambaw","tambawu","tambayawan","tambayayung","tambid","tambilagaw","tambiray","tambis","tambis nga puti","tambisun","tambiyulu","tambling","tambu","tambuanan","tambubu","tambubuan","tambubukag","tambud","tambug","tambuk","tambuk nga nagdag luib","tambuk ug","tambukaka","tambukikuy","tambuku","tambul","tambula","tambuli","tambulingaw","tambuliru","tambuluk","tambun","tambunan","tambung","tambur","tamburabug","tamburabuy","tamburin","tambutsu","tamdanan","tamhan","tamhang","tamhangan","tamhung","tami","tamiaw","tamihid","tamili","tamiluk","taming","tamislat","tamiun","tamla","tampa","tampad","tampak","tampal","tampalas","tampalasan","tampaling","tampalung","tamparay","tamparus","tampi","tampihak","tampikas","tampil","tamping","tampipi","tampird","tampiri","tampu","tampuhan","tampuhay","tampuk","tampuk sa","tampulung","tampung","tampuug","tampuuk","tampuung","tampuy","tamsi","tamsihun","tamsitamsi","tamstak","tamsun","tamtaks","tamtam","tamud","tamudlaw","tamug","tamulu","tamus","tamus sa tudlu","tamuy","tan","tan birinu","tan-aw","tan-awa ra","tan-ug","tan-us","tana","tanaman","tanan","tanda","tandang","tanday","tandayag","tandi","tanding","tandu","tandug","tanduktanduk","tang-an","tang-ug","tang-un","tanga","tangad","tangag","tangagan","tangali","tangantangan","tangas","tangasun","tangaun","tangay","tangaytangay","tangba","tangbid","tangbu","tangday","tangdayan","tangdayanay","tangdayay","tangdi","tangdiay","tangding","tangdu","tangdutangdu","tanggab","tanggal","tanggili","tanggu","tanggu kriminal","tanggub","tanggung","tanggungan","tanghag","tanghaga","tanghal","tanghun","tangi","tangigi","tangil","tangingi","tangis","tangitang","tangka","tangkag","tangkal","tangkalu","tangkas","tangki","tangkig","tangkihud","tangkil","tangkiyu","tangku","tangkuan","tangkub","tangkuban","tangkud","tangkugu","tangkul","tangkulan","tangkung","tanglad","tanglas","tangpi","tangsa","tangsi","tangsu","tangsutangsu","tangtang","tangtang utang","tangu","tangu sa baliw","tangud","tangul","tangul-ul","tangunan","tangway","tangwayanan","tangyad","taniag","tanil","taning","tanlad","tanlag","tanlak","tanlas","tansan","tansil","tantan","tantiya","tantiyar","tantu","tanud","tanug","tanuk","tanum","tanungan","tanus","tanyag","tap","tap-ak","tap-an","tap-il","tap-ilay","tap-ing","tap-ung","tap-us","tapa","tapad","tapahan","tapak","tapakun","tapal","tapaludu","tapan","tapang","tapangku","tapar","taparan","tapas","tapat","tapay","tapayan","tapaytapay","tapdagan","tapdagay","tapdas","tapdawun","taphanan","taphaw","tapi","tapig","tapiganan","tapigas","tapik","tapindas","taping","tapir wir","tapiri","tapis","tapita","tapitapi","tapiti","tapiun","taplud","tapluding","tapnatsir","tapsay","tapsing","taptanan","taptap","taptin","tapu","tapuk","tapuktapuk","tapuku","tapul","tapulan","tapun","tapun-ug","tapuruk","tapus","tapus dayun","tapusuk","taput","taput lawas","taput sa pamilya","tapuy","tapwak","tapya","tapyahan","tapyanan","tapyas","tara","tarabahu","tarabisiya","taraha","tarak","taraktarak","taral","taraltaral","tarangka","taranta","tarantadu","tarantar","taras","tarbahu","tardang","tardi","targit","targit praktis","targittargit","tarha","tarhita","tari","tarik","tariki","tarima","taringtaring","taripa","taririt","tariun","tariya","tarsan","tarsin","tartanilya","taru","tarug","tarughuy","tarugsuy","tarugu","taruk","taruktaruk","tarung","tarungan","tarungtarung","tarurut","taruti","tarutut","tarutuy","taruy","tasa","tasadu","tasadur","tasal","tasar","tasasiyun","tasik","taslak","taslakan","taslup","tasnga","taspuk","taspukan","tastas","tata","tataan","tatak","tatang","tataw","tatay","tatha","tating","tatsa","tatsadur","tatsadura","tatsar","tatsing","tatsu","tatu","tatut","tatuwa","taub","taubun","taud","taudtaud","tauk","taun","taunduk","taup","tausduk","taw-an","tawa","tawag","tawak","tawakun","tawal","tawas","tawatawa","tawgi","tawhana","tawhanun","tawhay","tawid","tawiltawil","tawngun","tawsi","tawsug","tawsyu","tawu","tawu-","tawugtawug","tawun","tawung bagduy","tawung dikantidad","tawung matuud","tawuntawun","tawutawu","tawutawu sa mata","tay-ug","taya","tayada","tayakan","tayam","tayaun","taydal wib","taygir","taygir urkid","tayhad","tayhup","tayid","tayils","tayim","tayim awut","tayim pa","tayim-awut","tayimkipir","tayip","tayiprayting","tayipraytir","taylan","tayming","taypist","taytay","taytayan","taytul","taytul payit","tayubung","tayun","tayupi","tayutu","tb","ti","ti minur","tiad","tiadlaw","tiagak","tiamtiam","tiamu","tiaw","tiaw (ba)y","tiaw mu ba","tiaw mu kana","tiaw mu ugud nga","tiawan","tiawtiaw","tiayun","tib-ug","tib-ul","tiba","tibadtibad","tibadtibaran","tibagnul","tibagnulun","tibagsuy","tibak","tibaknul","tibakun","tibalas","tibas","tibaw","tibawas","tibhang","tibhangtibhang","tibhung","tibi","tibihun","tibin","tibis","tibiwis","tiblanan","tibtib","tibu","tibuagsa","tibuagya","tibud","tibug-uk","tibug-ul","tibugsuk","tibugul","tibugun","tibuk-ul","tibukul","tibul","tibulaag","tibulanan","tibutibu","tibuuk","tibuuk ang hunahuna","tibwaag","tibwagsa","tibwanay","tibway","tibway ug","tidisin","tidit","tidiyum","tidlum","tidlung","tidlup","tidyuwin","tig-","tig-a","tig-ab","tig-akuaku","tig-ik","tig-insiyur","tig-ipis","tig-l-","tig-r-","tig(←)","tigaan","tigalbung","tigaman","tigas","tigasub","tigaw","tigayun","tigbabaw","tigbak","tigbakay","tigbalayun","tigbas","tigbasa","tigbayun","tigbung","tiggama","tighapun","tighaya","tighayang","tighik","tighikay","tighud","tighulug","tighumran","tigi","tigiay","tigib","tigidig","tigidig bangbang","tigihun","tigis","tigistigis","tigkahuy","tigkul","tigkung","tiglayug","tigma","tigman","tigmantala","tigmaya","tigmi","tigmimyugrap","tigmu","tigmugna","tigni","tigpamaba","tigpamulung","tigpangutaw","tigpaniid","tigpasiugda","tigpud","tigri","tigritigri","tigsik","tigsikan","tigsu","tigsuk","tigsun","tigtulak","tigul","tigulang","tigulang ikman","tigulang sa higtanan","tigulutaw","tigum","tigumtigum","tigwala","tigway","tihad","tihap","tihaw","tihaytihay","tihib","tihik","tihiktihik","tihiras","tihitihi","tihul","tiid","tiil","tiilan","tiing","tiingan","tiiya","tik","tik wan","tik-ibis","tik-um","tik-up","tika","tikab","tikabtikab","tikad","tikalbu","tikalbung","tikang","tikangan","tikanganan","tikangkang","tikarul","tikaruy","tikas","tikasan","tikasira","tikasiru","tikasub","tikatika","tikaw","tikawtikaw","tikay-ang","tikayhang","tikba","tikbas","tikbasay","tikbil","tikbu","tikbung","tikdul","tikdultikdul","tiki","tiki nga kwanggul","tikig","tikig ug liug","tikiltikil","tiking balad-un","tikit","tikitiki","tikitira","tikiu","tikla","tikladu","tiklaub","tikling","tiklingun","tiklu","tikluhud","tiklup","tikluptiklup","tikmitikmi","tikni kulur","tiknik","tiknika","tiknikal","tiknikal nak-awut","tiknikal pawul","tikniku","tiknikulur","tiknisyan","tiknuludyi","tiksas","tikstu","tiktak","tiktik","tiktik ug","tiktikun","tikub","tikubu","tikud","tikug","tikugas","tikugkug","tikugkugun","tikuka","tikuku","tikulub","tikung","tikungkung","tikup","tikus","tikuskus","tikutkut","tikuy","tikwa","tikwang","tikwi","tikyaub","tikyup","til-ag","til-as","til-is","til-ug","til-ug sa hilanat","til-ugun","tila","tila mitalika","tila ug hap","tilab","tilabhu","tilad","tiladtilad","tilagak","tilambu","tilang","tilangu","tilap","tilapya","tilapya sa mamala","tilaran","tilaub","tilauk","tilaukan","tilaw","tilhung","tiliawan","tilib","tilibisyun","tiligrama","tiligrapiku","tiligrapista","tiligrapu","tiliis","tilik","tilikangan","tilim","tilimad-un","tilingtiling","tilip","tilipasan","tilipunista","tilipunu","tiliskupyu","tilitayip","tilitul","tiltil","tilu","tilub","tiluk","tilun","tiluniru","tiluring","tilus","tim","tim-an","tim-aw","tim-us","tima","timaan","timaan ug buut","timahu","timailhan","timan-anay","timang","timatima","timaud","timawa","timayud","timba","timbakuwas","timbalung","timbang","timbang ug kugus (pangugus)","timbangan","timbangtimbang","timbaruk","timbaya","timbri","timbrira","timbul","timbungan","timbuwad","timbuy","timgas","timgasun","timhung","timi","timian","timik","timing","timitimi","timpag","timpasaw","timpiramintu","timpiratura","timpla","timplada","timpladu","timpladur","timplit","timpliti","timplu","timpranu","timpu","timpuraryu","timputimpu","timrira","tims","timsung","timtim","timtisyun","timu","timug","timun","timuna","timunil","timuri","timus","timutimu","timwurk","tin-aw","tin-aw ug ihi","tin-away","tin-idyir","tin.","tina","tinaan","tinab-ungan","tinabal","tinabal-ak","tinabangay","tinabasan","tinabid","tinabik","tinabilis","tinabla","tinabliya","tinabuan","tinabuylu","tinabuylug","tinadiyaw","tinadtad","tinagaan","tinagad","tinagak","tinagalug","tinagasak","tinagbuan","tinagdan","tinagdanay","tinagidiyu","tinagidiyut","tinagpila","tinagsa","tinagsip","tinagu","tinaguan","tinagup-at","tinagurha","tinagutu","tinai","tinai sa kawayan","tinakduan","tinakgusan","tinaksanay","tinaksi","tinakumba","tinamakan","tinamban","tinambid","tinambid saging","tinambul","tinampukan","tinamsi","tinamud","tinan-away","tinan-ug","tinan-ugan","tinangdayay","tinanuk","tinap-anan","tinapa","tinapakan","tinapay","tinapigan","tinapul","tinapulan","tinarsan","tinatina","tinaw-awan","tinawu","tinawutawu","tinayip","tinda","tindahan","tindahan nga bulanti","tindak","tindakan","tindakanan","tindaw","tinday","tindida","tindir","tindira","tindiru","tindug","tindugun","tinduk","tinduktinduk","ting-","ting-ab","ting-adlaw","ting-init","tinga","tingabngab","tingag","tingal","tingala","tingalaw","tingali","tingalngal","tinganga","tingayi","tingbadlis","tingbanan","tingbanay","tingbitay sa iru","tingbuak","tingbunga","tingdagdag","tingga","tinggalung","tingganay","tinggatingga","tinggaun","tinggaun ug kamut","tinggil","tinggu","tinghab","tinghaga","tinghak","tinghaya","tinghimudlay","tinghulaw","tinghumay","tinghuy","tingi","tingil","tingkad","tingkag","tingkagul","tingkal","tingkalag","tingkalu","tingkap","tingkarul","tingkas","tingkiri","tingkiyu","tingku","tingkubu","tingkuy","tingpamihud","tingpamuhi","tingpamuklad","tingpamulak","tingpanwildu","tingpuasa","tingpukdaw","tingpukgaw","tingpulugas","tingsi","tingsian","tingswildu","tingting","tingtugnaw","tingtugnus","tingub","tingud","tingudlut","tingug","tinguha","tingulan","tingusbawan","tinib-anay","tiniblas","tinidur","tinidur dilibru","tinidur sa yuta","tinigbung","tinigib","tinigri","tinigum","tiniil","tinikangan","tinikasan","tinikbasay","tinikbung","tinikling","tinilab","tinindak","tinindugan","tiningub","tininti","tininti dil baryu","tininuud","tinipigan","tinipsing","tinipun","tinipung bansa","tinir","tinis","tinis kurt","tinis pliyir","tinisan","tinor saks","tinrawundir","tinsiyun","tinta","tinta sa lumayagan","tintal","tintasiyun","tintin","tintiru","tintiruhan","tintu","tintu dulsi","tintu siku","tintura","tintura arnika","tintura diyudu","tintura yudu","tinu","tinuasik","tinubagan","tinubagay","tinubdan","tinublihan","tinubuan","tinud-anay","tinud-ay","tinudlu","tinughung","tinugyanan","tinugyanan sa balaud","tinuhaban","tinuhiban","tinuhuan","tinuig","tinukmaan","tinukmud","tinukudtukud","tinula","tinulu","tinulutulu","tinumbaga","tinumbaga nga kampana","tinundu","tinunga","tinungkaan","tinuntu","tinunuan","tinupsan","tinur","tinuryu","tinustus","tinutinu","tinutub","tinutukay","tinutuwa","tinuud","tinuuhan","tinuuray","tinuwatuwa","tinuyu","tinuyuan","tinyaplaba","tinyinti","tinyinti dil baryu","tip","tip rikurd","tip rikurding","tip rikurdir","tipak","tipaka","tipal-u","tipanu","tipas","tipasak","tipasan","tipasanan","tipasaw","tipasi","tipasiun","tipay","tipdas","tipi","tipig","tipiganan","tipik","tipiyu","tiplas","tipli","tipmisyur","tiprikurd","tipsing","tiptip","tipu","tipuan","tipug-uk","tipuhan","tipuk","tipuk-ul","tipuknul","tipuksul","tipuku","tipuli","tipulu","tipun","tipun-ug","tipuntipun","tipus","tipusa","tipusu","tipuy","tipyas","tira","tira pasagad","tira pula","tirada","tiradur","tirana","tiranti","tirar","tiras","tirasa","tirasis","tiratira","tirbis","tirbisiya","tirbistirbis","tirdrap","tiribli","tiriktirik","tiriring","tiriringun","tiririt","tiris","tirituryu","tirmina","tirminal","tirminalis","tirminar","tirminisyun pi","tirminit","tirminu","tirmumitru","tirmus","tirnu","tirsira","tirsira klasi","tirsiru","tirsiya parti","tirsiyu","tirsiyupilu","tirtin","tirtin kards","tirtin tils","tiru","tirung","tirungan","tiruray","tirurismu","tirus","tiruti","tis","tisa","tisar","tisas","tisay","tisiku","tisirt","tisis","tisisun","tiskug","tiskwir","tislang","tislaub","tislub","tislup","tisngi","tispipar","tist","tistamintu","tistar","tistigus","tistimunyu","tisting","tistir","tistis","tistisan","tistisanay","tistisay","tisu","tisuk","tisun","tisurira","tisuririya","tisuriru","tisuy","tisyirt","tita","titanus","titatita","tithi","titi","titik","titip","titit","tits","titsir","titu","titulada","tituladu","titulu","titulu turins","titurun","tiudtiud","tiug","tiuk","tiun","tiunay","tiuruk","tiuruk sa buhat","tiurus","tius-us","tiwangwang","tiwas","tiwsan","tiwtiw","tiwtiwan","tiya","tiyan","tiyanun","tiyu","tl","tling","trabahadur","trabahadura","trabahanti","trabahu","trabiling","trabiling bag","trabiling nga sinihan","trabilirs tri","trabisiya","trabungku","tradisiyun","traha","trahi","trahi dibayli","trahi dibuda","trahi sa kasal","trahidiya","trak","trak dikarga","trak dipasahiru","traking","trakitu","trakituk","traktur","traktura","trakuma","trambiya","trambutsu","trampas","trampit","trampitir","trangka","trangkadu","trangkahan","trangkasu","trangkilya","transaksiyun","transistur","transkrip","transmisyun","transmit","transmitir","transpigurasiyun","transpir","transpurmir","transpurtasiyun","transpurti","trantadu","trapal","trapik","trapiku","trapu","traski","traspiri","traspirir","traspurti","tratadu","tratamyintu","tratar","tratsi","tratu","trayal","trayanggul","trayanggulu","traydur","trayinta","trayintay-utsu","trayintaydus","trayir","traysikul","trayu","tri sikans","tribu","tribukar","tribunal","tribusun","trid-in","tridayminsiyun","trigu","trim","trimistral","trimistri","trin","tringka","trini","trinir","trinsas","trinsiras","trip","tripilya","tripilyas","triplikadu","triplit","tripulanti","tris","tris andanas","tris anyus","tris bandas","tris kantus","tris kwartas","tris mariyas","tris nuybis","tris puyra","tris unus","tris-adus","tris-idus","trisahiyu","trisay","trisi","trisi kartas","trisi klasis","trisiklu","trisikulu","trisipilu","trisir","trisir bulit","tristi","trisun","trisurira","triyanggulu","triyu","trubinayis","trubinayus","trubul","trubul syuting","trubul syutir","trukis","truling","trumbun","trumpa","trumpit","trumpita","trumpiti","trunsal","trunu","trupa","trupi","trupiku","trupiya","trupiyu","trusu","tsa","tsaliku","tsalit","tsamba","tsampaka","tsampaka sa insik","tsampiyun","tsampuradu","tsampuy","tsans","tsans pasindyir","tsansing","tsapa","tsapirun","tsaplin","tsapstik","tsapsuy","tsaptir","tsardying","tsarira","tsariti","tsarlistun","tsarming","tsarmingun","tsart","tsarul","tsatsa","tsatsuy","tsaw","tsawu","tsaynamut","tsaynis","tsaynis bambu","tsaynis bras","tsaynis guld","tsaynis gwaba","tsaynis payil","tsaynis pitsay","tsaynis tsikir","tsi","tsibay","tsibay wakang","tsik","tsik-ap","tsik-awut","tsik-in","tsika","tsikala","tsiki","tsikin","tsikin pid","tsikin salad","tsikinini","tsikir","tsikird","tsikitilya","tsiku","tsiku kaputi","tsiku karabaw","tsikus","tsikut","tsimaniya","tsina","tsindying","tsindying gips","tsindying paybut","tsinilas","tsining","tsining bar","tsinu","tsip","tsipi","tsipun","tsiris","tsirman","tsis","tsis burd","tsisir","tsismis","tsismusa","tsismusu","tsit","tsitsa","tsitsirika","tsitsiriyas","tsk","tsu","tsug","tsuk","tsukir","tsuktsuk","tsukulati","tsukulit","tsulitas","tsunggu","tsup","tsupa","tsupir","tsupun","tsura","tsurisu","tsuwing gam","tsuwinggam","tsuwit","tsuy","tu","tua","tua na","tuab","tuagsik","tuak","tuaktuak","tuali","tualya","tuang","tuangtuang","tuaruk","tuasik","tuaw","tuay","tub-as","tub-us","tuba","tuba nga bakud","tuba nga balintung","tuba nga way hakhak","tubaan","tubag","tubag pangutana","tubag singgit","tubagtubag","tubas","tubatuba","tubatubang muradu","tubaun","tubaw","tubay","tubig","tubig sa butung","tubig sa ulu","tubignun","tubigtubig","tubigtubigan","tubil","tubiltubil","tubitubi","tubitubiun","tublag","tubli","tubluk","tubtub","tubu","tubu sa kunhud","tubud","tubug","tubuk","tubul","tubung","tubung lumhan","tubung palina","tubung pula","tubung puti","tuburan","tubus","tubutubu","tubuy","tud-an","tuda","tudas","tudasan","tudasay","tudastudas","tudkan","tudling","tudling pulung","tudlis","tudlis sa tabaku","tudlu","tudlu dalaga","tudlu datu","tudlu sa tiil","tudluk","tudlun datu","tudlus","tudlutudlu","tudtud","tudu pudirusu","tudu pung","tudu pung plasis","tudu pung ul-ap","tudu pung uldawun","tuduk","tudulukyiri","tudus","tudus lus santus","tudutut","tudyuk","tug-ab","tug-an","tug-ud","tug-ud sa buli","tug-ut","tuga","tugabang","tugabung","tugahala","tugahuk","tugal","tugalbung","tugalhab","tugan","tugas","tugastugas","tugasub","tugauk","tugaw","tugbabaw","tugbang","tugbang pulung","tugbaw","tugbu","tugbung","tugda","tugdan","tugdang","tugduk","tugdun","tugdunanan","tughang","tughaw","tughu","tughuk","tughung","tughuy","tugkad","tugkalan","tugkan","tugkaran","tugkay","tugmadan","tugna","tugnaw","tugnub","tugnus","tugpa","tugpahanan","tugpu","tugsad","tugsaw","tugsuk","tugsuy","tugtug","tugub","tugun","tugut","tugway","tugwayanan","tugyan","tuhab","tuhak","tuhaw","tuhay","tuhi","tuhib","tuhik","tuhil","tuhu","tuhud","tuhug","tuhug sa ilung","tuhugan","tuhugtuhug","tuhuktuhuk","tuhun","tuhup","tuhus","tuhuun","tuhuy","tuig","tuigtuig","tuis","tuis sa palad","tuk","tuk-ab","tuk-ung","tuka","tukab","tukabtukab","tukad","tukadur","tukag","tukal","tukaltukal","tukamud","tukang","tukar","tukarul","tukas","tukatuka","tukaw","tukaya","tukayu","tukbil","tukbu","tukbunun","tukbuy","tukdab","tukdug","tukgaw","tukhi","tuki","tukib","tukig","tukika","tukiki","tukis","tukistukis","tuklang","tuklas","tukli","tuklid","tukling","tuklu","tuklud","tuklung","tuklus","tukma","tukmu","tukmud","tuknul","tukpaw","tukpawtukpaw","tuksi","tuksu","tuktugauk","tuktuk","tuktur","tuku","tukub","tukud","tukudtukud","tukug","tukul","tukun","tukung","tukuy","tukwa","tukwang","tukway","tul","tul-an","tul-id","tula","tulabhu","tulabung","tulag","tulak","tulakhang","tulaki","tulakig","tulala","tulandus","tulapus","tulas","tulawug","tulay","tulbuk","tulbung","tulda","tuli","tuli andaw","tulibag","tulibagbag","tulilik","tulilikay","tulimbang","tulin","tulin pa sa alas kwatru","tulin pa sa manatad","tulindaw","tulingan","tulingi","tulingig","tulipsay","tulis","tulisan","tulisanis","tulisuk","tulitul","tuliyuk","tulma","tulpuk","tulpuktulpuk","tultug","tultul","tulu","tulubagun","tulubilun","tulud","tulud batang","tuludtulud","tulug","tulugkarun","tulugtulug","tuluhakan","tuluhuan","tuluk","tulukbilun","tulukbilun ug buut","tulukibun","tulumanun","tulun","tulun lamuy","tulung","tulung-an","tulung-un","tulungan","tulunggan","tulunggun","tulunghaan","tulus","tulut","tulutaginhus","tulutapindas","tulutigulang","tulutimbang","tulutingali","tuluy","tuma","tuma pusisiyun","tumahun","tumalagu","tumalup","tuman","tumar","tumar ug aksiyun","tumar ug nutisya","tumatagu","tumataliwan","tumatan-aw","tumatapus","tumatub","tumaw","tumba","tumba lubu","tumbaga","tumbalay","tumbalik","tumbaling","tumbanan","tumbas","tumbatumba","tumbaya","tumbuk","tumbuy","tumindug","tuminduk","tumitindug","tumitinduk","tumitusus","tumpag","tumpang","tumpawak","tumpi","tumpil","tumu","tumud","tumug","tumuk","tumung","tumur","tumuran","tumus","tumutub","tumutumu","tumutumuan","tumuy","tun-as","tun-ug","tuna","tunaan","tunada","tunaw","tunaw ug gatas","tunawan","tunay","tunayit","tundaan","tundag","tundan","tundu","tunduk","tundukan","tung","tung-uy","tunga","tungab","tungan","tungang gabii","tungas","tungasun","tungatunga","tungaw","tungay","tungbalay","tungdan","tungdunun","tungga","tunggal","tungganan","tunggul","tungguy","tungguytungguy","tungha","tungha ang bisita","tunghak","tunghaktunghak","tungina","tunginahan","tungir","tungka","tungkaan","tungkahal","tungkalu","tungki","tungku","tungkud","tungkun","tunglu","tungtung","tungu","tungud","tungud kay","tungudtungud","tungug","tunguk","tungul","tungup","tunguptungup","tunhay","tunhay ang ugat","tunik","tuniku","tunil","tunilada","tunlan","tunlu","tunluan","tunluanan","tunlub","tunlud","tunsil","tuntu","tuntun","tunu","tunu ug pasiyun","tunub","tunub ug kasikas","tunud","tunug","tunuk","tunuk sa isda","tunukun","tunul","tunung","tunuun","tunuy","tunyu nu","tupa","tupad","tupas","tupay","tupi","tupiku","tupit","tuplak","tuplas","tupluk","tuptup","tupu","tupuk","tupung","tupung ang tiil","tupus","tuputupu","tupwak","turagas","tural","turatuy","turay","turban","turdbis","turi","turi nga tipusa","turik","turiki","turil","turins","turiru","turista","turiti","turiyal","turiyu","turka","turku","turnilyadur","turnilyu","turniru","turniyu","turnu","turnuhan","turnuhay","turnus","turnuturnu","turpada","turpi","turpi ang dila","turpidu","tursi","turta","turtilya","turtilyas","turtur","turu","turu nga baka","turuk","turuk banwa","turukturuk","turun","turun diman","turun dipili","turung","turungturung","turunis","tururut","turus","turut","turuturu","turutut","turutuy","tus","tus-ap","tusak","tusaktusak","tusdik","tusik","tusinu","tusir","tuskig","tuskig ug liug","tuslak","tuslikanan","tuslu","tuslub","tuslud","tusluk","tusmaw","tusmud","tusnub","tusnud","tustadu","tustar","tustus","tusu","tusud","tusug","tusuk","tusup","tusuy","tutal","tutbras","tuthu","tutpik","tutu","tutub","tutug","tutuk","tutul","tutulu","tutunlan","tutut","tutuy","tutyan","tutyanan","tuu","tuu nga kamut","tuub","tuud","tuud man","tuug","tuuhun","tuuk","tuun","tuunanan","tuung","tuung ang tutunlan","tuutuu","tuuy","tuwa","tuwad","tuwad tuali","tuwadtuwad","tuwag","tuwak","tuwang","tuwangan","tuwangtuwang","tuwangtuwang nga silya","tuwas","tuwatuwa","tuwaw","tuway","tuwaytuway","tuwayun","tuwittuwit","tuy","tuy-ud","tuya","tuyang","tuyarug","tuyatuy","tuyatuya","tuybu","tuyhad","tuyhakaw","tuyhud","tuytuy","tuytuyan","tuyu","tuyu kay","tuyub","tuyuk","tuyukan","tuyuktuyuk nga silya","tuyuktuyuk ug pangita","tuyukun","tuyuun","twagsik","twakdug","twasik","twilb-uklak","twirka","twis","twist","tyabaw","tyagu","tyagu nu","tyali","tyanak","tyangaw","tyanggi","tyanggihan","tyatru","tyimpu","tyinda","tyubibu","tyuning purk","tyupi","tyuriya","tyusupiya","tyutur","u","u bin","u biyin","u byin","ua","ub-ub","ubak","uban","uban ang","uban sa","uban sa lupad","uban-uban","ubanun","ubaryu","ubas","ubaub","ubaug","ubay","ubay-ubay","ubi","ubi nga gataw","ubi nga kinampay","ubihan","ubihas","ubir","ubir drap","ubir dus","ubir hid","ubir hit","ubir hul","ubir kut","ubir lan","ubir lap","ubir sis","ubir tik","ubir ul","ubirispiding","ubirludid","ubirnayit","ubirnayit bag","ubirprayis","ubirtayim","ubispadu","ubispu","ubligadu","ubligar","ubligasiyun","ublung","ubp.","ubra","ubra maistra","ubrahunun","ubras publikas","ubriru","ubrirus","ubsirbadu","ubsirbar","ubsirbasiyun","ubsirbaturyu","ubu","ubud","ubud ituhun","ubug","ubul-ubul","uburun","ubus","ubus balauranan","ubuub","ubuubu","ud","ud-ud","uday","udhak","udhan","udhanun","udiyu","udiyung","udiyungun","udlut","udlutan","udtu","udtu nga laruk","udtuhan","udtuhun","udtung katin","udtung lunud ang buwan","udtung tutuk","udtuudtu","udu","uduy","ug","ug dugu","ug ila","ug imu","ug iya","ug lumban","ug maayu","ug makalisud","ug taman","ug tubu","ug unsa pa kadtu","ug-ug","uga","uga ang tutunlan","ugahip","ugahip likuslikus","ugahipun","ugaling","ugam","ugang","ugangan","uganganun","ugat","ugat mayur","ugat-ugat","ugatun","ugauga","ugay","ugba","ugbati","ugbp.","ugbuk","ugbuk ang","ugbun","ugbus","ugda","ugdang","ugdaw","ugdu","ugduk","ugdul","ugdung","ughad","ughak","ugingut","ugis","ugiut","ugkad","ugkal","ugkat","ugkay","ugma","ugma damlag","ugma puhun (paabutun pa)","ugmad","ugmaran","ugmaugma","ugnat","ugnuk","ugnut","ugpak","ugpas","ugpu","ugpung","ugput","ugpuugpu","ugsad","ugsad-ugsad","ugsud","ugsud-ugsud","ugsuk","ugtad","ugtak","ugtas","ugtud","ugtuk","ugtus","ugud","ugud ba","uguk","ugum","ugung","ugut","ugut-ugut","uguy","uguy-uguy","uguy-uguy blus","ugwad","ugwad-ugwad","ugyab","uha","uhag","uhaldris","uhalis","uhang","uhang-uhang","uhas","uhas bulantis","uhaw","uhawun","uhay","uhipan","uhu","uhu pa","uhun","uhung","uhungan","uhut","ui","uiks u","uk","uk-uk","uk-uk ang butbut","uk-uk ang dila","uka","ukab","ukab-ukab","ukabhang","ukadyang","ukal","ukang","ukas","ukasiyun","ukat","ukay","ukba","ukban","ukhab","uki","ukiduk","ukiduki","ukika","ukit","ukit-ukitan","ukit-ukitun","ukiuk","ukiut","uklab","uklaba","ukmil","uknul","uknul-uknul","ukpaw","ukpaw-ukpaw","ukra","uksidyin","uksihina","uksihinada","uksihinu","uksilyu","uksinada","uksirbar","uksu","ukt.","uktaba","uktubri","uku","ukub","ukul","ukun-ukun","ukupadu","ukupar","ukupasiyun","ukut","ukuy","ukyab","ukyu","ukyut","ul-ap","ul-ug","ul-ul","ula","ulag","ulag-ulag","ulagan","ulagun","ulahi","ulahipan","ulahipan sa baybayun","ulalag","ulan","ulan-ulan","ulandis","ulang","ulang ug pitu ka lawud","ulang-ulang","ulang-ulang sa ilung","ulapi","ulasiman","ulat","ulatiw","ulatun","ulaw","ulaw-ulaw","ulawan","ulay","ulbu","uld istak","uldawun","uldug","ulhi","ulhus","uli","uli ang lisinsiya","uli balay","ulian","ulianun","ulib","ulib drab","ulib uwil","uliba","ulibu","uligark","ulihad","ulihi","ulilang","ulimpikir","ulimpiyan","ulin","uling","ulingi","ulingig","ulingun","ulipad","ulipad ang tinan-awan","uliping","ulipun","ulipun sa tamala","ulisi","ulit","ulitawhay","ulitawu","uliuli kalag","uliunun","uliut","ulput","ulput ang kabuhi","ulsir","ulsira","ulsirun","ultima","ultima ura","ultimatum","ultimu","ultimu [noun]","ultimu prisyu","ulu","ulu nga buhatan","ulu sa bagyu","ulu sa baha","ulu sa hilanat","ulu sa sakit","ulu sa sibuyas","ulu ug amu","ulualagad","uluasawa","ulub","ulubrahun","ulud","ulud-ulud","ulug","ulug-ulug","ulug-ulugan","ulugnan","uluhan","uluk","uluk sa kasing","uluk-uluk","ulun","ulun sa halas","ulun-ulun","ulunan","ulung","ulunglan","ulungnan","ulunlan","ulup","ulus","ulusahun","ulusiman","ulusingun","uluswahan","ulut","ulut-ulut","ulutanun","ulutawun","ulutgan","uluulu","uluuluhan","uluy","ulyahut","ulyap","um","um-um","um-um ug kalibutan","uma","umaabut","umaadtu","umaadtuay","umaagi","umaanak","umag","umagad","umagak","umagarun","umahan","umalabut","umalagi","umang","umang sus-an","umapun","umari ka","umat","umaw","umay-umay","umay-umayan","umbabasa","umbalasa","umbangul","umbaw","umbihas","umhan","umid","umidu","umigas","umil","umintadu","umintu","umintu sa kunhud","umnis","umpas","umpaw","umpu","umpul","umu-um","umud","umud ang nawung","umug","umuk","umul","umulan","umung","umuntul nga humay","umuuli","umuy","un","un yur marts","un-un","una","una sa tanan","una sin utra","unahan","unanut","unap","unas","unasis","unat","unauna","unaunahun","unaw","unawup","unay","unay sa lawas","unay-unay","undag","undak","undan","undan sa buut","undang","undang-undang","undanun","undaunda","undayag","undayun","undu","unduk","undul","unduy","undyan","ung","ung-ung","unga","ungab","ungad","ungal","ungas","ungat-ungat","ungaug","ungaunga","ungaw","ungdan","ungga","unggal","unggaungga","unggu","ungguwintu","ungguy","ungguy nga nahapunan","ungguy-ungguy","ungkad","ungkag","ungkat","unglan","unglu","ungnan","ungu","ungud","ungul","ungus-ungus","ungut","ungut ang baba","unguy","unguy-unguy","unguy-unguyan","unguyan","unibirsidad","unidu","uniduru","unipurmi","unir","unkuwartu","unlan","unlud","unminutu","unmumintu","unra","unras","unras bihilya","unsa","unsa ba","unsa ka-[adj.]?","unsa may anaa niana","unsa may atu","unsa may naa niana","unsa na","unsa na kaha","unsa nang urasa","unsa nga [time]-a","unsa pay but-un?","unsaay","unsang pagkabutanga","unsas","unsaun man nga","unsay [noun]-un","unsay aku?","unsay imu [dat.]","unsay kalaki","unsay kalibutan [gen.]","unsay ngalan gud","unsay sakit sa kiting","unsi","unsingalan","unsiunsi","unsiyalan","unsuy","unta","unta kay","untu","untul","untul-untul","untup","untuy","unu","unu lus dus","unu puyra","unu ug igu","unud","unud sa imung","unudnun","unudnung tinguha","unugan","unuk-unuk","unum","unung","unungan","unur","unurabli","unurabul","unurari","unuraryu","unus","unus sa kinabuhi","unus-unus","unut","unya","unya nga [word referring to time]","unya sa [day of week","unyas","unyaunya","unyun","unyur","up","up bit","up-up","upa","upak","upal","upanay (pa) unta","upas","upat","upat ang tiil","upat ug (ang) mata","upaup","upaw","upay","uphag","uphak","upin","upin kang","upin kard","upin tsik","upiniyun","upira","upirarya","upiraryu","upirasiyunu","upiratik","upirisyun","upirit","upirita","upiritur","upirturyu","upis","upisina","upisir","upisiyal","upisiyalis","upisiyun","upisyal militar","upisyu","upluk","uprisar","uprisir","ups","uptikal","uptiku","upu","upud","upung","upung-upung","upunir","upurtunista","upus","upusisiyun","upuy-upuy","upyu","ura pru nubis","urabang","uradur","urakan","urakulu","ural","uran","uran-uran","urang-utan","urang-utang","uraray","uraryu","uras","urasan","urasanta","urasiyun","urasiyunan","uray","urbanidad","urbanisar","urdin","urdinansa","urdinansahun","urdinar","urdinaryu","urdinasiyun","urdir","urgan","urgandi","urganisar","urganisasiyun","urganista","urgansa","urganu","urhinti","urig","urihinal","urimaw","urimus","urins","urins dyus","urinula","urit","urkid","urkid tri","urkilyas","urkista","urkistra","urkiyu","urlun","urna","ursa","urti","urtikarya","urtiurti walay urti","uru","uru tsina","urud","urug","urug-urug","uruk","urul","urum","urumun","urung","urung-urung","urupa","urus","urus-urus","uruy","uruy-uruy","us","us-us","us-us ang","usa","usa ka","usa ka butang","usa ka daku","usa ka pa","usa ka simana","usa nga","usa niana ka","usa niana ka [word referring to time]","usa pa","usa pa diay","usa ug usa","usa usab","usab","usad","usadu","usahay","usamud","usap","usar","usausa","usbaw","usbung","usbunun","usdak","usdak ang tiil","usdu","usdug","usdung","usig","usik","usik ang","usikan","usisa","uska","uslub","usminya","usminyista","usmud","usngad","uspag","uspital","ustiya","ustiyas","usu","usub","usuk","usung","usura","usurira","usuriru","usuus","uswa","uswag","usyus","usyusa","usyusu","ut-ut","utak","utak brin","utan","utang","utang (sa hari)","utang buut","utang kabubut-un","utang-utang","utangan","utangunun","utanun","utap","utas","utasan","utaw","utaw-utaw","utawan","utawan nga kinabayu","utawunun","utay-utay","utbu","utbung","utik","utika","utikahun","util","utin","utin-utin","utinan","utingkad","utingkag","utingkay","utitud","utiturun","utiut","utlanan","utlub","utmil","utnga","utra","utrabis","utru","utsing","utsinta","utsu","utud","utug","utuk","utuk sa bukug","utuk ug bulinaw","utuk ug kinumu","utukan","utul","utul sa adlaw","utul sa pikas","utul ug tinai","utul-utul","utung","utut","utut [gen.]","utut ug bapur","utwang","uu","uu walay tiil","uun","uwag","uwag-uwag","uwahi","uwak","uwak gibalikas","uwandis","uwang-uwang","uwapay","uwaping","uway","uway palasan","uwidu","uwigik","uwil","uwil ab wintirgrin","uy","uy-ug","uyab","uyabad","uyabang","uyag","uyagak","uyakut","uyamut","uyang","uyap","uyas","uyat","uyat-uyat","uyauya","uyit","uylab","uylap","uyuan","uyug","uyug ug utuk","uyuk","uyukan","uyun","uyun ug baba","uyun-uyun","uyung","verb]","wa","wa hislung","wa ku niana","wa kuy sinsilyu","wa magtupung ang tudlu","wa makabungul","wa nay ata","wa pa mahuman ang syuting","wa singu","wa tay amigu","waay","waay gid","wabul","wadwad","wagas","wagat","wagtang","wagut","wagutun","wagwag","wahi","wahig","wahigwahig","wahing","wahingwahing","wais","wait","wak","wakag","wakal","wakang","wakanga","wakat","wakay","wakaywakay","wakis","waklay","wakli","wakling","wakwak","wakwakun","wala","wala (dili) lamang ... kun dili ...","wala ang markit","wala bintaha","wala dungug","wala gayud","wala himuyu","wala ik","wala ila","wala kabana","wala kabirkabir","wala kuy barku","wala mabulis","wala madugay","wala mahitsura","wala nay [doubled verb] pa","wala pa","wala pay","wala ra","wala sa buut","wala sa ginhawa","wala sa kulumingking","wala sa tipsing","wala sukad","wala sulaminti","wala timik","wala ug tuu","wala yamu","walaswasan","walawala","walay","walay [doubled verb base or culu-verb base]","walay [noun] [nom.]","walay [verb base + (→)]","walay a","walay ala","walay alamag","walay angay","walay apil [subject]","walay arti","walay asin","walay bali","walay balita","walay bawut","walay bugtu","walay bukug","walay bukug ang dila","walay buut","walay dapat","walay data","walay diki","walay dyiwil","walay gilagut","walay gunuk","walay hagu","walay hamung","walay hinis","walay hitsura","walay ikaduha","walay ilung","walay ingun","walay ispiransa","walay ispiritu","walay kabilinggan","walay kahangturan","walay kalag","walay kalaki","walay kalibutan","walay kanghu","walay karat","walay kulang","walay kwinta","walay lahay","walay lain kun dili","walay laing daplin","walay lamuy","walay lana","walay ligu","walay lubut","walay lupig","walay mahay","walay makumbini","walay malay","walay mapili","walay mausa","walay misik","walay mismu","walay nada","walay nahangul","walay nahut","walay palad","walay panugid","walay plitnambir","walay praktis","walay puas","walay pulus","walay rawun","walay sabud","walay sapayan","walay sirbi","walay subu","walay suhut (ang baling)","walay talib","walay timik","walay tudasan","walay tugaw","walay ulaw","walay undang","walay unsaunsa","walay unu","walay urti","waldas","waldaswaldas","walhun","walhun nga tiki","wali","waling","walingwaling","walingwaling urkid","walis","walis ang kahilum","walts","walu","walug","walug sa ginluhaan","walup","waluwalu","walwag","walwal","wan tu tri","wan-a","wan-an-ihap","wan-aydyak","wanang","wandag","wandas","wandirin dyu","wandiring dyu","wandug","wandugwandug","wanggu","wangi","wangis","wangiwangi","wangkata","wangluwanglu","wangsa","wangsat","wangsi","wangtigu","wangut","wangwang","wani","wanklik","wantayim","wantid","wanwi","wap-a","waping","wapir","warak","warakwarak","waraswaras","warawara","waray","waray gid","waraynun","waraywaray","ward","wardabahu","wardamids klim","wardas","wardin","wardiwardi","wargung","wari","warian","warm-ap","warning","warning bil","warung","was-anwir","wasa","wasag","wasak","wasakwasak","wasawasa","wasay","wasaywasay","wasdak","wasi","wasigwasig","wasing","wasiwasi","waslik","waslik sa tabuk","wasnga","wasngi","wasu","waswas","waswit","wat","watag","watakwatak","wataswatas","wati","wating","watir","watir damids sil","watir kan","watir kulur","watir milun","watir pam","watir puls","watir sarasay","watir sil","watsamara","watsinanggu","watsir","watsumara","watsung","watusi","watusi bam","watwat","waw","waw sabaw","wawa","waway","wawug","wawugwawug","way adris","way andu","way batanas","way byu","way dapa","way digu","way diyus","way diyut","way du","way gamu","way gid","way ginuu","way hakhak","way hamunghamung","way hanaw","way hinungdan","way hunung","way iba ug di maaslum","way ipik","way ispiransa","way ka-un","way kadlit","way kamug","way kasu","way kubir","way kumu","way kusing","way kuydawu","way labilabi","way lasmu","way lig-un","way limpiya","way sawun","way taya ang bulsa","way trapik","way urbanidad","waya","wayawaya","wayir","wayir gids","wayis","wayis gay","wayit dragun","wayit guld","wayit sayidwul","wayitdab urkid","waypir","wayring","wayway","wib","wibing","wibing lusyun","widing","widing anibirsari","widir byuru","widu","wig","wigik","wigun","wik","wik-ind","wiktan","wilding","wilga","wilgista","wili","wili sa tuguntugun","wilik","wiliwili","wilkam","wilkam adris","wilkam parti","wiltsir","wilwig","winaray","winblun","wind","windusyaping","wingig","wings","wingwing","winildingan","winirwinir","winsild","wintirgrin","wir-anwir","wiraw","wirawwiraw","wiris","wiriswiris","wiriwiri","wis baskit","wisdam","wisdam tut","wisik","wisiwisi","wiski","wislayin","wislik","wispuwin","wist","wist baskit","wist layin","wist puwin","wisti","wistirn","witik","witing","witing lis","witing syid","witingan","witir","witkan","witris","witwit","witwitan","wiwi","wudrus","wuk-awut","wukatun","wuking","wukir","wukituki","wul","wulplawir","wungwung","wurding","wurking","wurking istiyudint","wurking istyudint","wuswus","wutir","wutir kulur","wutir prup","wutir ripilint","wutir sarasay","wuyuwuyu","x ba y ba","y","y-","ya","yaak","yaakyaak","yaangyaang","yab-u","yabag","yabagun","yabagyabag","yabana","yabi","yabi ditubu","yabi tubu","yabihanan","yabing baliku","yabira","yabiru","yabu","yabun","yabunyabun","yabyab","yad-ak","yad-uk","yadakadtu","yadba","yadbut","yadtu","yag-aw","yagabyab","yagatyat","yagatyatun","yagaw","yagawyaw","yagawyawun","yagayaga","yagayagaun","yagbun","yagbut","yagkaw","yagpis","yagpisun","yagubhub","yagubyub","yagungyung","yaguyagu","yaguyu","yagyag","yahat","yahigyahig","yahung","yaka","yakal","yakbut","yakmu","yakmuun","yakub","yakubyakub","yam-ang","yam-angan","yam-id","yam-iran","yam-is","yam-isun","yamada","yaman","yamar","yamas","yamat","yamatyamat","yamayama","yamayamaun","yamba","yambi","yamhang","yamhangan","yamihid","yamiid","yamis","yamitak","yampungad","yamtak","yamu","yamu ug","yamug","yamuk","yamukat","yamukmuk","yamumu","yamutyamut","yamyam","yamyamunun","yana","yanang","yandak","yangag","yanggak","yanghag","yangkaw","yangu","yangud","yangungu","yanguyangu","yanta","yantak","yantas","yanu","yanuyanu","yanyan","yapa","yapak","yapakun","yapayapa","yapu","yapyap","yarda","yari","yaruk","yasa","yasmi","yasyas","yatak","yatap","yati","yati ra","yatihan","yatis","yatis ra","yatut","yatyat","yaub","yausa","yawa","yawa ra","yawan","yawan-un","yawas","yawat","yawat bangil tinggutum","yaway","yawayawa","yawi","yawis","yawit","yawyaw","yawyawan","yay","yaya","yayay","yayha","yayu","yayung","yayung ang bulan","yayung ug tuig","year]","yiba","yibar","yibu","yilu","yilu bil","yiluhun","yima","yinasyasan","yipi","yir bar","yirba buyna","yirs-uld","yiru","yist","yu","yuad","yubit","yubitan","yudipurmu","yudkap","yudu","yudupurmu","yudyud","yuga","yugkap","yugkung","yugkungyugkung","yugtu","yugu","yugut","yugyug","yuhu","yuhum","yuhut","yuhutyuhut","yuin","yuka","yukab","yukalili","yukaliptus","yukaristika","yukaristiku","yukayu","yukbu","yuki","yukilili","yukman","yuku","yukug","yukum","yukuyuku sa buktun","yukyuk","yumu","yumud","yumudyumud","yumuran","yumyum","yumyumay","yuna","yuna pa","yunanimus","yungatyungat","yungib","yungit","yungki","yungyung","yunik","yunipurmi","yunuyunu","yunyun","yupis","yupu","yupyup","yupyupanan","yusa","yusapi","yusi","yusig","yusyus","yuta","yuta sa mga saad","yutaan","yutan-un","yutang tabunun","yutawhan","yutawhanun","yutayuta","yutik","yuturn","yutyut","yutyutun","yuyu"])},function(a,u,i){"use strict";function n(a){return(0,t.removeDiacritics)(a).toLowerCase().replace(/z/,"s").replace(/ce/,"si").replace(/ci/,"si").replace(/gui/,"gi").replace(/qui/,"ki").replace(/c/,"k").replace(/j/,"h").replace(/f/g,"p").replace(/v/g,"b").replace(/o/g,"u").replace(/e/g,"i")}Object.defineProperty(u,"__esModule",{value:!0}),u.normalize=n;var t=i(11);u.default=n},function(a,u,i){"use strict";function n(a,u){return!a||a.isRootWord(u)}Object.defineProperty(u,"__esModule",{value:!0}),u.isRootWord=n},function(a,u,i){"use strict";function n(a){return"<pattern pattern='"+a.pattern+"' root='"+a.root+"'/>\n"}function t(a,u){var i=a.compiledPattern;if(i)return g(a,u)?u.replace(new RegExp(i,"g"),a.root||""):void 0;throw new Error("Pattern was not compiled")}function g(a,u){var i=a.compiledPattern;if(i)return new RegExp(i,"g").test(u);throw new Error("Pattern was not compiled")}function s(a,u){for(var i=0,n=["^"],t=k.exec(u.pattern);t;){var g=t[1],s=a[g];if(!s)throw new Error("Constant map did not contain entry for "+g);n.push(u.pattern.substring(i,t.index)),n.push(s),i=t.index+t[0].length,t=k.exec(u.pattern)}n.push(u.pattern.substring(i)+"$"),u.compiledPattern=n.join("")}function l(a,u){a.forEach(s.bind(void 0,u))}Object.defineProperty(u,"__esModule",{value:!0}),u.toXmlAffixPattern=n,u.stripPattern=t,u.patternApplies=g,u.compilePattern=s,u.compilePatterns=l;var k=/{(\w+)}/g},function(a,u,i){"use strict";function n(a,u){a.affixes.forEach(function(a){return(0,g.compileAffix)(a,u)})}function t(a){var u=["\n<group name='"+a.name+"'>\n"];return a.affixes.forEach(function(a){return u.push((0,g.toXmlAffix)(a))}),u.push("</group>\n"),u.join("")}Object.defineProperty(u,"__esModule",{value:!0}),u.compileGroup=n,u.toXmlGroup=t;var g=i(0)},function(a,u,i){"use strict";function n(a,u){a.groups.push(u),a.compiled=!1}function t(a){var u=!0,i=!1,n=void 0;try{for(var t,g=a.groups[Symbol.iterator]();!(u=(t=g.next()).done);u=!0){var s=t.value;(0,p.compileGroup)(s,a.constants)}}catch(a){i=!0,n=a}finally{try{!u&&g.return&&g.return()}finally{if(i)throw n}}a.compiled=!0}function g(a,u,i){if(a.constants[u]&&i!==a.constants[u])throw new Error(u+" was already set with "+a.constants[u]+", tried to set it with "+i);a.constants[u]=i}function s(a,u,i){return u.compiled||t(u),l(a,u,i,{},0)}function l(a,u,i,n,t){var g=void 0;if(u.groups.length<=t){if(g=[],!n[i]&&(0,b.isRootWord)(a,i)){var s=[],k={root:i,affixes:s};g.push(k),n[i]=!0}return g}g=l(a,u,i,n,t+1);var p=u.groups[t],m=p.affixes,d=!0,y=!1,h=void 0;try{for(var w,e=m[Symbol.iterator]();!(d=(w=e.next()).done);d=!0){var o=w.value,c=(0,r.rootCandidates)(i,o.patterns),$=!0,f=!1,P=void 0;try{for(var O,z=c[Symbol.iterator]();!($=(O=z.next()).done);$=!0){var v=O.value;if(!n[v]&&(0,b.isRootWord)(a,v)){var T=[],D={root:v,affixes:T};D.affixes.push(o),g.push(D),n[v]=!0}var j=l(a,u,v,n,t+1),E=!0,A=!1,x=void 0;try{for(var S,_=j[Symbol.iterator]();!(E=(S=_.next()).done);E=!0){var R=S.value;R.affixes.push(o),g.push(R)}}catch(a){A=!0,x=a}finally{try{!E&&_.return&&_.return()}finally{if(A)throw x}}}}catch(a){f=!0,P=a}finally{try{!$&&z.return&&z.return()}finally{if(f)throw P}}}}catch(a){y=!0,h=a}finally{try{!d&&e.return&&e.return()}finally{if(y)throw h}}return g}function k(a){var u=["<stemmer language='"+a.language+"'>"];for(var i in a.constants)if(a.constants.hasOwnProperty(i)){var n=a.constants[i];u.push("\n<constant name='"+i+"' value='"+n+"'/>")}var t=!0,g=!1,s=void 0;try{for(var l,k=a.groups[Symbol.iterator]();!(t=(l=k.next()).done);t=!0){var r=l.value;u.push((0,p.toXmlGroup)(r))}}catch(a){g=!0,s=a}finally{try{!t&&k.return&&k.return()}finally{if(g)throw s}}return u.push("</stemmer>\n"),u.join("")}Object.defineProperty(u,"__esModule",{value:!0}),u.addGroup=n,u.compileStemmer=t,u.addConstant=g,u.findDerivations=s,u.innerFindDerivations=l,u.toString=k;var p=i(6),r=i(0),b=i(4)},function(a,u,i){"use strict";Object.defineProperty(u,"__esModule",{value:!0});u.cebuanoStemmer={language:"ceb",compiled:!0,constants:{letter:"[a-z]",vowel:"[aeiou]",consonant:"[bcdfghjklmnpqrstvwxyz]"},groups:[{name:"linkers",affixes:[{form:"-ng",label:"NGA",patterns:[{pattern:"({letter}+)ng",root:"$1",compiledPattern:"^([a-z]+)ng$"},{pattern:"({letter}+)ng",root:"$1n",compiledPattern:"^([a-z]+)ng$"}]},{form:"-y",label:"Y",patterns:[{pattern:"({letter}+)y",root:"$1",compiledPattern:"^([a-z]+)y$"}]},{form:"-yng",label:"Y NGA",patterns:[{pattern:"({letter}+)yng",root:"$1",compiledPattern:"^([a-z]+)yng$"}]}]},{name:"declensions",affixes:[{form:"ga-",label:"TODO",rootType:"v",patterns:[{pattern:"ga({letter}+)",root:"$1",compiledPattern:"^ga([a-z]+)$"}]},{form:"gi-",label:"TODO",rootType:"v",patterns:[{pattern:"gi({letter}+)",root:"$1",compiledPattern:"^gi([a-z]+)$"}]},{form:"i-",label:"INST.PAS",rootType:"v",patterns:[{pattern:"i({letter}+)",root:"$1",compiledPattern:"^i([a-z]+)$"}]},{form:"ig-",label:"TODO",rootType:"vn",patterns:[{pattern:"ig({letter}+)",root:"$1",compiledPattern:"^ig([a-z]+)$"},{pattern:"ig-({vowel}{letter}*)",root:"$1",compiledPattern:"^ig-([aeiou][a-z]*)$"}]},{form:"iga-",label:"REL",rootType:"vna",patterns:[{pattern:"iga({letter}+)",root:"$1",compiledPattern:"^iga([a-z]+)$"}]},{form:"ma-",label:"FUT.AF",rootType:"vna",patterns:[{pattern:"ma({letter}+)",root:"$1",compiledPattern:"^ma([a-z]+)$"}]},{form:"mi-",label:"TODO",rootType:"v",patterns:[{pattern:"mi({letter}+)",root:"$1",compiledPattern:"^mi([a-z]+)$"}]},{form:"mu-",label:"TODO",rootType:"v",patterns:[{pattern:"mu({letter}+)",root:"$1",compiledPattern:"^mu([a-z]+)$"}]},{form:"maka-",label:"FUT.POT",rootType:"v",patterns:[{pattern:"maka({letter}+)",root:"$1",compiledPattern:"^maka([a-z]+)$"}]},{form:"mag-",label:"TODO",rootType:"v",patterns:[{pattern:"mag({letter}+)",root:"$1",compiledPattern:"^mag([a-z]+)$"}]},{form:"maN-",label:"PLUR",rootType:"v",patterns:[{pattern:"mam({letter}+)",root:"b$1",compiledPattern:"^mam([a-z]+)$"},{pattern:"man({letter}+)",root:"d$1",compiledPattern:"^man([a-z]+)$"},{pattern:"man({letter}+)",root:"s$1",compiledPattern:"^man([a-z]+)$"},{pattern:"man({letter}+)",root:"t$1",compiledPattern:"^man([a-z]+)$"},{pattern:"mang({letter}+)",root:"k$1",compiledPattern:"^mang([a-z]+)$"},{pattern:"mang({letter}+)",root:"$1",compiledPattern:"^mang([a-z]+)$"}]},{form:"na-",label:"PP.AF",rootType:"v",patterns:[{pattern:"na({letter}+)",root:"$1",compiledPattern:"^na([a-z]+)$"}]},{form:"naka-",label:"PP.POT",rootType:"v",patterns:[{pattern:"naka({letter}+)",root:"$1",compiledPattern:"^naka([a-z]+)$"}]},{form:"nag-",label:"TODO",rootType:"v",patterns:[{pattern:"nag({letter}+)",root:"$1",compiledPattern:"^nag([a-z]+)$"}]},{form:"ni-",label:"TODO",rootType:"v",patterns:[{pattern:"ni({letter}+)",root:"$1",compiledPattern:"^ni([a-z]+)$"}]},{form:"naN-",label:"TODO",rootType:"v",patterns:[{pattern:"nam({letter}+)",root:"b$1",compiledPattern:"^nam([a-z]+)$"},{pattern:"nan({letter}+)",root:"d$1",compiledPattern:"^nan([a-z]+)$"},{pattern:"nan({letter}+)",root:"s$1",compiledPattern:"^nan([a-z]+)$"},{pattern:"nan({letter}+)",root:"t$1",compiledPattern:"^nan([a-z]+)$"},{pattern:"nang({letter}+)",root:"k$1",compiledPattern:"^nang([a-z]+)$"},{pattern:"nang({letter}+)",root:"$1",compiledPattern:"^nang([a-z]+)$"}]},{form:"pag-",label:"TODO",patterns:[{pattern:"pag({letter}+)",root:"$1",compiledPattern:"^pag([a-z]+)$"},{pattern:"pag-({vowel}{letter}*)",root:"$1",compiledPattern:"^pag-([aeiou][a-z]*)$"}]},{form:"-um-",label:"TODO",patterns:[{pattern:"({consonant}?)um({letter}+)",root:"$1$2",compiledPattern:"^([bcdfghjklmnpqrstvwxyz]?)um([a-z]+)$"}]},{form:"-a",label:"SPEC",patterns:[{pattern:"({letter}+)ra",root:"$1d",compiledPattern:"^([a-z]+)ra$"},{pattern:"({letter}+{vowel})ha",root:"$1",compiledPattern:"^([a-z]+[aeiou])ha$"},{pattern:"({letter}+)a",root:"$1",compiledPattern:"^([a-z]+)a$"}]},{form:"-an",label:"TODO",patterns:[{pattern:"({letter}+)ran",root:"$1d",compiledPattern:"^([a-z]+)ran$"},{pattern:"({letter}+{vowel})han",root:"$1",compiledPattern:"^([a-z]+[aeiou])han$"},{pattern:"({letter}+)an",root:"$1",compiledPattern:"^([a-z]+)an$"}]},{form:"-i",label:"TODO",patterns:[{pattern:"({letter}+)ri",root:"$1d",compiledPattern:"^([a-z]+)ri$"},{pattern:"({letter}+{vowel})hi",root:"$1",compiledPattern:"^([a-z]+[aeiou])hi$"},{pattern:"({letter}+)i",root:"$1",compiledPattern:"^([a-z]+)i$"}]},{form:"-un",label:"TODO",patterns:[{pattern:"({letter}+)run",root:"$1d",compiledPattern:"^([a-z]+)run$"},{pattern:"({letter}+{vowel})hun",root:"$1",compiledPattern:"^([a-z]+[aeiou])hun$"},{pattern:"({letter}+)un",root:"$1",compiledPattern:"^([a-z]+)un$"}]}]},{name:"wordformation",affixes:[{form:"gai-",label:"TODO",patterns:[{pattern:"gai({letter}+)",root:"$1",compiledPattern:"^gai([a-z]+)$"}]},{form:"gaipa-",label:"TODO",patterns:[{pattern:"gaipa({letter}+)",root:"$1",compiledPattern:"^gaipa([a-z]+)$"}]},{form:"gaka-",label:"TODO",patterns:[{pattern:"gaka({letter}+)",root:"$1",compiledPattern:"^gaka([a-z]+)$"}]},{form:"gapa-",label:"TODO",patterns:[{pattern:"gapa({letter}+)",root:"$1",compiledPattern:"^gapa([a-z]+)$"}]},{form:"gapan-",label:"TODO",patterns:[{pattern:"gapan({letter}+)",root:"$1",compiledPattern:"^gapan([a-z]+)$"}]},{form:"gapang-",label:"TODO",patterns:[{pattern:"gapang({letter}+)",root:"$1",compiledPattern:"^gapang([a-z]+)$"}]},{form:"gihi-",label:"TODO",patterns:[{pattern:"gihi({letter}+)",root:"$1",compiledPattern:"^gihi([a-z]+)$"}]},{form:"gika-",label:"PAS.PERF",rootType:"v",patterns:[{pattern:"gika({letter}+)",root:"$1",compiledPattern:"^gika([a-z]+)$"}]},{form:"gikahi-",label:"PAS.PERF",patterns:[{pattern:"gikahi({letter}+)",root:"$1",compiledPattern:"^gikahi([a-z]+)$"}]},{form:"gikapa-",label:"PAS.PERF",patterns:[{pattern:"gikapa({letter}+)",root:"$1",compiledPattern:"^gikapa([a-z]+)$"}]},{form:"gim-",label:"PAS.PERF",patterns:[{pattern:"gim({letter}+)",root:"$1",compiledPattern:"^gim([a-z]+)$"}]},{form:"gin-",label:"PAS.PERF",patterns:[{pattern:"gin({letter}+)",root:"$1",compiledPattern:"^gin([a-z]+)$"}]},{form:"gina-",label:"PAS.PERF",rootType:"v",patterns:[{pattern:"gina({letter}+)",root:"$1",compiledPattern:"^gina([a-z]+)$"}]},{form:"ginapa-",label:"PAS.PERF",patterns:[{pattern:"ginapa({letter}+)",root:"$1",compiledPattern:"^ginapa([a-z]+)$"}]},{form:"ginapag-",label:"PAS.PERF",patterns:[{pattern:"ginapag({letter}+)",root:"$1",compiledPattern:"^ginapag([a-z]+)$"}]},{form:"ginapaha-",label:"PAS.PERF",patterns:[{pattern:"ginapaha({letter}+)",root:"$1",compiledPattern:"^ginapaha([a-z]+)$"}]},{form:"ginapaka-",label:"PAS.PERF",patterns:[{pattern:"ginapaka({letter}+)",root:"$1",compiledPattern:"^ginapaka([a-z]+)$"}]},{form:"ginapang-",label:"PAS.PERF",patterns:[{pattern:"ginapang({letter}+)",root:"$1",compiledPattern:"^ginapang([a-z]+)$"}]},{form:"ginapanghi-",label:"PAS.PERF",patterns:[{pattern:"ginapanghi({letter}+)",root:"$1",compiledPattern:"^ginapanghi([a-z]+)$"}]},{form:"ging-",label:"PAS.PERF",patterns:[{pattern:"ging({letter}+)",root:"$1",compiledPattern:"^ging([a-z]+)$"}]},{form:"gipa-",label:"PAS.PERF",rootType:"v",patterns:[{pattern:"gipa({letter}+)",root:"$1",compiledPattern:"^gipa([a-z]+)$"}]},{form:"gipaha-",label:"PAS.PERF",patterns:[{pattern:"gipaha({letter}+)",root:"$1",compiledPattern:"^gipaha([a-z]+)$"}]},{form:"gipahi-",label:"PAS.PERF",patterns:[{pattern:"gipahi({letter}+)",root:"$1",compiledPattern:"^gipahi([a-z]+)$"}]},{form:"gipaka-",label:"PAS.PERF",patterns:[{pattern:"gipaka({letter}+)",root:"$1",compiledPattern:"^gipaka([a-z]+)$"}]},{form:"gipaki-",label:"PAS.PERF",patterns:[{pattern:"gipaki({letter}+)",root:"$1",compiledPattern:"^gipaki([a-z]+)$"}]},{form:"gipakig-",label:"PAS.PERF",patterns:[{pattern:"gipakig({letter}+)",root:"$1",compiledPattern:"^gipakig([a-z]+)$"}]},{form:"gipan-",label:"PAS.PERF",patterns:[{pattern:"gipan({letter}+)",root:"$1",compiledPattern:"^gipan([a-z]+)$"}]},{form:"gipanag-",label:"PAS.PERF",patterns:[{pattern:"gipanag({letter}+)",root:"$1",compiledPattern:"^gipanag([a-z]+)$"}]},{form:"gipang-",label:"PAS.PERF",patterns:[{pattern:"gipang({letter}+)",root:"$1",compiledPattern:"^gipang([a-z]+)$"}]},{form:"gipanghi-",label:"PAS.PERF",patterns:[{pattern:"gipanghi({letter}+)",root:"$1",compiledPattern:"^gipanghi([a-z]+)$"}]},{form:"gipanig-",label:"PAS.PERF",patterns:[{pattern:"gipanig({letter}+)",root:"$1",compiledPattern:"^gipanig([a-z]+)$"}]},{form:"gipatig-",label:"PAS.PERF",patterns:[{pattern:"gipatig({letter}+)",root:"$1",compiledPattern:"^gipatig([a-z]+)$"}]},{form:"ha-",label:"PAS.PERF",patterns:[{pattern:"ha({letter}+)",root:"$1",compiledPattern:"^ha([a-z]+)$"}]},{form:"hi-",label:"PAS.PERF",patterns:[{pattern:"hi({letter}+)",root:"$1",compiledPattern:"^hi([a-z]+)$"}]},{form:"hika-",label:"PAS.PERF",patterns:[{pattern:"hika({letter}+)",root:"$1",compiledPattern:"^hika([a-z]+)$"}]},{form:"hima-",label:"PAS.PERF",patterns:[{pattern:"hima({letter}+)",root:"$1",compiledPattern:"^hima([a-z]+)$"}]},{form:"hinga-",label:"PAS.PERF",patterns:[{pattern:"hinga({letter}+)",root:"$1",compiledPattern:"^hinga([a-z]+)$"}]},{form:"hipang-",label:"PAS.PERF",patterns:[{pattern:"hipang({letter}+)",root:"$1",compiledPattern:"^hipang([a-z]+)$"}]},{form:"hingka-",label:"PAS.PERF",patterns:[{pattern:"hingka({letter}+)",root:"$1",compiledPattern:"^hingka([a-z]+)$"}]},{form:"hiN-",label:"FONDNESS",rootType:"vn",patterns:[{pattern:"him({letter}+)",root:"b$1",compiledPattern:"^him([a-z]+)$"},{pattern:"hin({letter}+)",root:"d$1",compiledPattern:"^hin([a-z]+)$"},{pattern:"hin({letter}+)",root:"s$1",compiledPattern:"^hin([a-z]+)$"},{pattern:"hin({letter}+)",root:"t$1",compiledPattern:"^hin([a-z]+)$"},{pattern:"hing({letter}+)",root:"k$1",compiledPattern:"^hing([a-z]+)$"},{pattern:"hing({letter}+)",root:"$1",compiledPattern:"^hing([a-z]+)$"}]},{form:"igaha-",label:"TODO",patterns:[{pattern:"igaha({letter}+)",root:"$1",compiledPattern:"^igaha([a-z]+)$"}]},{form:"igaka-",label:"TODO",patterns:[{pattern:"igaka({letter}+)",root:"$1",compiledPattern:"^igaka([a-z]+)$"}]},{form:"igapa-",label:"TODO",patterns:[{pattern:"igapa({letter}+)",root:"$1",compiledPattern:"^igapa([a-z]+)$"}]},{form:"igapaha-",label:"TODO",patterns:[{pattern:"igapaha({letter}+)",root:"$1",compiledPattern:"^igapaha([a-z]+)$"}]},{form:"igapahi-",label:"TODO",patterns:[{pattern:"igapahi({letter}+)",root:"$1",compiledPattern:"^igapahi([a-z]+)$"}]},{form:"igapaka-",label:"TODO",patterns:[{pattern:"igapaka({letter}+)",root:"$1",compiledPattern:"^igapaka([a-z]+)$"}]},{form:"igapang-",label:"TODO",patterns:[{pattern:"igapang({letter}+)",root:"$1",compiledPattern:"^igapang([a-z]+)$"}]},{form:"igapasi-",label:"TODO",patterns:[{pattern:"igapasi({letter}+)",root:"$1",compiledPattern:"^igapasi([a-z]+)$"}]},{form:"igka-",label:"TODO",patterns:[{pattern:"igka-({letter}+)",root:"$1",compiledPattern:"^igka-([a-z]+)$"}]},{form:"igkasi-",label:"REL",patterns:[{pattern:"igkasi({letter}+)",root:"$1",compiledPattern:"^igkasi([a-z]+)$"}]},{form:"igpa-",label:"TODO",patterns:[{pattern:"igpa-({letter}+)",root:"$1",compiledPattern:"^igpa-([a-z]+)$"}]},{form:"igpang-",label:"TODO",patterns:[{pattern:"igpang-({letter}+)",root:"$1",compiledPattern:"^igpang-([a-z]+)$"}]},{form:"ihi-",label:"TODO",patterns:[{pattern:"ihi({letter}+)",root:"$1",compiledPattern:"^ihi([a-z]+)$"}]},{form:"ika-",label:"ORD.NUM",rootType:"va",patterns:[{pattern:"ika({letter}+)",root:"$1",compiledPattern:"^ika([a-z]+)$"}]},{form:"ikag-",label:"ORD.NUM",rootType:"va",patterns:[{pattern:"ikag({letter}+)",root:"$1",compiledPattern:"^ikag([a-z]+)$"}]},{form:"ikahi-",label:"TODO",patterns:[{pattern:"ikahi({letter}+)",root:"$1",compiledPattern:"^ikahi([a-z]+)$"}]},{form:"ikapa-",label:"TODO",patterns:[{pattern:"ikapa({letter}+)",root:"$1",compiledPattern:"^ikapa([a-z]+)$"}]},{form:"ikapakama-",label:"TODO",patterns:[{pattern:"ikapakama-({letter}+)",root:"$1",compiledPattern:"^ikapakama-([a-z]+)$"}]},{form:"ikapang-",label:"TODO",patterns:[{pattern:"ikapang({letter}+)",root:"$1",compiledPattern:"^ikapang([a-z]+)$"}]},{form:"ikapanig-",label:"TODO",patterns:[{pattern:"ikapanig({letter}+)",root:"$1",compiledPattern:"^ikapanig([a-z]+)$"}]},{form:"ikapasig-",label:"TODO",patterns:[{pattern:"ikapasig({letter}+)",root:"$1",compiledPattern:"^ikapasig([a-z]+)$"}]},{form:"ipa-",label:"TODO",rootType:"v",patterns:[{pattern:"ipa({letter}+)",root:"$1",compiledPattern:"^ipa([a-z]+)$"}]},{form:"ipaha-",label:"TODO",patterns:[{pattern:"ipaha({letter}+)",root:"$1",compiledPattern:"^ipaha([a-z]+)$"}]},{form:"ipahi-",label:"TODO",patterns:[{pattern:"ipahi({letter}+)",root:"$1",compiledPattern:"^ipahi([a-z]+)$"}]},{form:"ipaka-",label:"TODO",patterns:[{pattern:"ipaka({letter}+)",root:"$1",compiledPattern:"^ipaka([a-z]+)$"}]},{form:"ipaki-",label:"TODO",patterns:[{pattern:"ipaki({letter}+)",root:"$1",compiledPattern:"^ipaki([a-z]+)$"}]},{form:"ipakig-",label:"TODO",patterns:[{pattern:"ipakig({letter}+)",root:"$1",compiledPattern:"^ipakig([a-z]+)$"}]},{form:"ipam-",label:"TODO",patterns:[{pattern:"ipam({letter}+)",root:"$1",compiledPattern:"^ipam([a-z]+)$"}]},{form:"ipampa-",label:"TODO",patterns:[{pattern:"ipampa({letter}+)",root:"$1",compiledPattern:"^ipampa([a-z]+)$"}]},{form:"ipang-",label:"TODO",patterns:[{pattern:"ipang({letter}+)",root:"$1",compiledPattern:"^ipang([a-z]+)$"}]},{form:"ipanghi-",label:"TODO",patterns:[{pattern:"ipanghi({letter}+)",root:"$1",compiledPattern:"^ipanghi([a-z]+)$"}]},{form:"ipanig-",label:"TODO",patterns:[{pattern:"ipanig({letter}+)",root:"$1",compiledPattern:"^ipanig([a-z]+)$"}]},{form:"ipasig-",label:"TODO",patterns:[{pattern:"ipasig({letter}+)",root:"$1",compiledPattern:"^ipasig([a-z]+)$"}]},{form:"ipatig-",label:"TODO",patterns:[{pattern:"ipatig({letter}+)",root:"$1",compiledPattern:"^ipatig([a-z]+)$"}]},{form:"isig-",label:"TODO",rootType:"v",patterns:[{pattern:"isig({letter}+)",root:"$1",compiledPattern:"^isig([a-z]+)$"}]},{form:"isigka-",label:"TODO",rootType:"n",patterns:[{pattern:"isigka({letter}+)",root:"$1",compiledPattern:"^isigka([a-z]+)$"}]},{form:"itag-",label:"TODO",patterns:[{pattern:"itag({letter}+)",root:"$1",compiledPattern:"^itag([a-z]+)$"}]},{form:"inig-",label:"TODO",rootType:"v",patterns:[{pattern:"inig({letter}+)",root:"$1",compiledPattern:"^inig([a-z]+)$"}]},{form:"inigka-",label:"TODO",rootType:"va",patterns:[{pattern:"inigka({letter}+)",root:"$1",compiledPattern:"^inigka([a-z]+)$"}]},{form:"ka-",label:"FUT.POT",rootType:"nva",patterns:[{pattern:"ka({letter}+)",root:"$1",compiledPattern:"^ka([a-z]+)$"}]},{form:"katagi-",label:"COM.PLACE",rootType:"n",patterns:[{pattern:"katagi({letter}+)",root:"$1",compiledPattern:"^katagi([a-z]+)$"}]},{form:"makapa-",label:"TODO",rootType:"v",patterns:[{pattern:"makapa({letter}+)",root:"$1",compiledPattern:"^makapa([a-z]+)$"}]},{form:"maki-",label:"TODO",rootType:"vna",patterns:[{pattern:"maki({letter}+)",root:"$1",compiledPattern:"^maki([a-z]+)$"}]},{form:"makig-",label:"TODO",rootType:"v",patterns:[{pattern:"makig({letter}+)",root:"$1",compiledPattern:"^makig([a-z]+)$"}]},{form:"magka-",label:"TODO",rootType:"av",patterns:[{pattern:"magka({letter}+)",root:"$1",compiledPattern:"^magka([a-z]+)$"}]},{form:"magpa-",label:"TODO",rootType:"v",patterns:[{pattern:"magpa({letter}+)",root:"$1",compiledPattern:"^magpa([a-z]+)$"}]},{form:"magpaka-",label:"TODO",rootType:"n",patterns:[{pattern:"magpaka({letter}+)",root:"$1",compiledPattern:"^magpaka([a-z]+)$"}]},{form:"magpaki-",label:"TODO",rootType:"n",patterns:[{pattern:"magpaki({letter}+)",root:"$1",compiledPattern:"^magpaki([a-z]+)$"}]},{form:"maha-",label:"TODO",rootType:"v",patterns:[{pattern:"maha({letter}+)",root:"$1",compiledPattern:"^maha([a-z]+)$"}]},{form:"mahi-",label:"TODO",rootType:"v",patterns:[{pattern:"mahi({letter}+)",root:"$1",compiledPattern:"^mahi([a-z]+)$"}]},{form:"manag-",label:"TODO",rootType:"v",patterns:[{pattern:"manag({letter}+)",root:"$1",compiledPattern:"^manag([a-z]+)$"}]},{form:"manga-",label:"TODO",rootType:"v",patterns:[{pattern:"manga({letter}+)",root:"$1",compiledPattern:"^manga([a-z]+)$"}]},{form:"mapa-",label:"TODO",rootType:"n",patterns:[{pattern:"mapa({letter}+)",root:"$1",compiledPattern:"^mapa([a-z]+)$"}]},{form:"masig-",label:"TODO",rootType:"v",patterns:[{pattern:"masig({letter}+)",root:"$1",compiledPattern:"^masig([a-z]+)$"}]},{form:"masigka-",label:"TODO",rootType:"n",patterns:[{pattern:"masigka({letter}+)",root:"$1",compiledPattern:"^masigka([a-z]+)$"}]},{form:"makipaN-",label:"PLUR",rootType:"v",patterns:[{pattern:"makipam({letter}+)",root:"b$1",compiledPattern:"^makipam([a-z]+)$"},{pattern:"makipan({letter}+)",root:"d$1",compiledPattern:"^makipan([a-z]+)$"},{pattern:"makipan({letter}+)",root:"s$1",compiledPattern:"^makipan([a-z]+)$"},{pattern:"makipan({letter}+)",root:"t$1",compiledPattern:"^makipan([a-z]+)$"},{pattern:"makipang({letter}+)",root:"k$1",compiledPattern:"^makipang([a-z]+)$"},{pattern:"makipang({letter}+)",root:"$1",compiledPattern:"^makipang([a-z]+)$"}]},{form:"nakag-",label:"TODO",rootType:"v",patterns:[{pattern:"nakag({letter}+)",root:"$1",compiledPattern:"^nakag([a-z]+)$"}]},{form:"nakig-",label:"TODO",rootType:"v",patterns:[{pattern:"nakig({letter}+)",root:"$1",compiledPattern:"^nakig([a-z]+)$"}]},{form:"nakapa-",label:"TODO",rootType:"v",patterns:[{pattern:"nakapa({letter}+)",root:"$1",compiledPattern:"^nakapa([a-z]+)$"}]},{form:"nagka-",label:"TODO",rootType:"av",patterns:[{pattern:"nagka({letter}+)",root:"$1",compiledPattern:"^nagka([a-z]+)$"}]},{form:"nagpa-",label:"TODO",rootType:"v",patterns:[{pattern:"nagpa({letter}+)",root:"$1",compiledPattern:"^nagpa([a-z]+)$"}]},{form:"nagpaka-",label:"TODO",rootType:"anv",patterns:[{pattern:"nagpaka({letter}+)",root:"$1",compiledPattern:"^nagpaka([a-z]+)$"}]},{form:"nagpaki-",label:"TODO",rootType:"anv",patterns:[{pattern:"nagpaki({letter}+)",root:"$1",compiledPattern:"^nagpaki([a-z]+)$"}]},{form:"nagpasi-",label:"TODO",rootType:"anv",patterns:[{pattern:"nagpasi({letter}+)",root:"$1",compiledPattern:"^nagpasi([a-z]+)$"}]},{form:"naha-",label:"TODO",rootType:"anv",patterns:[{pattern:"naha({letter}+)",root:"$1",compiledPattern:"^naha([a-z]+)$"}]},{form:"nahag-",label:"TODO",rootType:"anv",patterns:[{pattern:"nahag({letter}+)",root:"$1",compiledPattern:"^nahag([a-z]+)$"}]},{form:"nahi-",label:"TODO",rootType:"anv",patterns:[{pattern:"nahi({letter}+)",root:"$1",compiledPattern:"^nahi([a-z]+)$"}]},{form:"nahig-",label:"TODO",rootType:"anv",patterns:[{pattern:"nahig({letter}+)",root:"$1",compiledPattern:"^nahig([a-z]+)$"}]},{form:"nanag-",label:"TODO",rootType:"v",patterns:[{pattern:"nanag({letter}+)",root:"$1",compiledPattern:"^nanag([a-z]+)$"}]},{form:"nanga-",label:"TODO",rootType:"v",patterns:[{pattern:"nanga({letter}+)",root:"$1",compiledPattern:"^nanga([a-z]+)$"}]},{form:"nasig-",label:"TODO",rootType:"v",patterns:[{pattern:"nasig({letter}+)",root:"$1",compiledPattern:"^nasig([a-z]+)$"}]},{form:"pa-",label:"TODO",rootType:"nv",patterns:[{pattern:"pa({letter}+)",root:"$1",compiledPattern:"^pa([a-z]+)$"}]},{form:"paka-",label:"TODO",patterns:[{pattern:"paka({letter}+)",root:"$1",compiledPattern:"^paka([a-z]+)$"}]},{form:"paki-",label:"TODO",patterns:[{pattern:"paki({letter}+)",root:"$1",compiledPattern:"^paki([a-z]+)$"}]},{form:"pakih-",label:"TODO",patterns:[{pattern:"pakig({letter}+)",root:"$1",compiledPattern:"^pakig([a-z]+)$"}]},{form:"pagka-",label:"TODO",patterns:[{pattern:"pagka({letter}+)",root:"$1",compiledPattern:"^pagka([a-z]+)$"}]},{form:"pagpa-",label:"TODO",patterns:[{pattern:"pagpa({letter}+)",root:"$1",compiledPattern:"^pagpa([a-z]+)$"}]},{form:"pagpaka-",label:"TODO",patterns:[{pattern:"pagpaka({letter}+)",root:"$1",compiledPattern:"^pagpaka([a-z]+)$"}]},{form:"pala-",label:"TODO",patterns:[{pattern:"pala({letter}+)",root:"$1",compiledPattern:"^pala([a-z]+)$"}]},{form:"panga-",label:"TODO",patterns:[{pattern:"panga({letter}+)",root:"$1",compiledPattern:"^panga([a-z]+)$"}]},{form:"pasi-",label:"TODO",patterns:[{pattern:"pasi({letter}+)",root:"$1",compiledPattern:"^pasi([a-z]+)$"}]},{form:"paN-",label:"CAUSATIVE",patterns:[{pattern:"pam({letter}+)",root:"b$1",compiledPattern:"^pam([a-z]+)$"},{pattern:"pan({letter}+)",root:"d$1",compiledPattern:"^pan([a-z]+)$"},{pattern:"pan({letter}+)",root:"s$1",compiledPattern:"^pan([a-z]+)$"},{pattern:"pan({letter}+)",root:"t$1",compiledPattern:"^pan([a-z]+)$"},{pattern:"pang({letter}+)",root:"k$1",compiledPattern:"^pang([a-z]+)$"},{pattern:"pang({letter}+)",root:"$1",compiledPattern:"^pang([a-z]+)$"}]},{form:"tag-",label:"TODO",patterns:[{pattern:"tag({letter}+)",root:"$1",compiledPattern:"^tag([a-z]+)$"}]},{form:"taga-",label:"TODO",patterns:[{pattern:"taga({letter}+)",root:"$1",compiledPattern:"^taga([a-z]+)$"}]},{form:"tagi-",label:"TODO",patterns:[{pattern:"tagi({letter}+)",root:"$1",compiledPattern:"^tagi([a-z]+)$"}]},{form:"tali-",label:"TODO",patterns:[{pattern:"tali({letter}+)",root:"$1",compiledPattern:"^tali([a-z]+)$"}]},{form:"tig-",label:"TODO",patterns:[{pattern:"tig({letter}+)",root:"$1",compiledPattern:"^tig([a-z]+)$"}]},{form:"ting-",label:"TODO",patterns:[{pattern:"ting({letter}+)",root:"$1",compiledPattern:"^ting([a-z]+)$"}]},{form:"uma-",label:"TODO",patterns:[{pattern:"uma({letter}+)",root:"$1",compiledPattern:"^uma([a-z]+)$"}]},{form:"-in-",label:"TODO",patterns:[{pattern:"({consonant}?)in({letter}+)",root:"$1$2",compiledPattern:"^([bcdfghjklmnpqrstvwxyz]?)in([a-z]+)$"}]},{form:"-il-",label:"TODO",patterns:[{pattern:"({consonant}?)il({letter}+)",root:"$1$2",compiledPattern:"^([bcdfghjklmnpqrstvwxyz]?)il([a-z]+)$"}]},{form:"-anan",label:"TODO",patterns:[{pattern:"({letter}+)ranan",root:"$1d",compiledPattern:"^([a-z]+)ranan$"},{pattern:"({letter}+{vowel})hanan",root:"$1",compiledPattern:"^([a-z]+[aeiou])hanan$"},{pattern:"({letter}+)anan",root:"$1",compiledPattern:"^([a-z]+)anan$"}]},{form:"-anang",label:"TODO",patterns:[{pattern:"({letter}+)ranang",root:"$1d",compiledPattern:"^([a-z]+)ranang$"},{pattern:"({letter}+{vowel})hanang",root:"$1",compiledPattern:"^([a-z]+[aeiou])hanang$"},{pattern:"({letter}+)anang",root:"$1",compiledPattern:"^([a-z]+)anang$"}]},{form:"-anay",label:"TODO",patterns:[{pattern:"({letter}+)ranay",root:"$1d",compiledPattern:"^([a-z]+)ranay$"},{pattern:"({letter}+{vowel})hanay",root:"$1",compiledPattern:"^([a-z]+[aeiou])hanay$"},{pattern:"({letter}+)anay",root:"$1",compiledPattern:"^([a-z]+)anay$"}]},{form:"-anun",label:"TODO",patterns:[{pattern:"({letter}+)ranun",root:"$1d",compiledPattern:"^([a-z]+)ranun$"},{pattern:"({letter}+{vowel})hanun",root:"$1",compiledPattern:"^([a-z]+[aeiou])hanun$"},{pattern:"({letter}+)anun",root:"$1",compiledPattern:"^([a-z]+)anun$"}]},{form:"-ay",label:"TODO",patterns:[{pattern:"({letter}+)ray",root:"$1d",compiledPattern:"^([a-z]+)ray$"},{pattern:"({letter}+{vowel})hay",root:"$1",compiledPattern:"^([a-z]+[aeiou])hay$"},{pattern:"({letter}+)ay",root:"$1",compiledPattern:"^([a-z]+)ay$"}]},{form:"-ayg",label:"TODO",patterns:[{pattern:"({letter}+)rayg",root:"$1d",compiledPattern:"^([a-z]+)rayg$"},{pattern:"({letter}+{vowel})hayg",root:"$1",compiledPattern:"^([a-z]+[aeiou])hayg$"},{pattern:"({letter}+)ayg",root:"$1",compiledPattern:"^([a-z]+)ayg$"}]},{form:"-du",label:"TODO",patterns:[{pattern:"({letter}+)du",root:"$1",compiledPattern:"^([a-z]+)du$"}]},{form:"-dur",label:"TODO",patterns:[{pattern:"({letter}+)dur",root:"$1",compiledPattern:"^([a-z]+)dur$"}]},{form:"-g",label:"TODO",patterns:[{pattern:"({letter}+)g",root:"$1",compiledPattern:"^([a-z]+)g$"}]},{form:"-ira",label:"TODO",patterns:[{pattern:"({letter}+{vowel})hira",root:"$1",compiledPattern:"^([a-z]+[aeiou])hira$"},{pattern:"({letter}+)ira",root:"$1",compiledPattern:"^([a-z]+)ira$"}]},{form:"-iru",label:"TODO",patterns:[{pattern:"({letter}+{vowel})hiru",root:"$1",compiledPattern:"^([a-z]+[aeiou])hiru$"},{pattern:"({letter}+)iru",root:"$1",compiledPattern:"^([a-z]+)iru$"}]},{form:"-nun",label:"TODO",patterns:[{pattern:"({letter}+)nun",root:"$1",compiledPattern:"^([a-z]+)nun$"}]},{form:"-unun",label:"TODO",patterns:[{pattern:"({letter}+)runun",root:"$1d",compiledPattern:"^([a-z]+)runun$"},{pattern:"({letter}+{vowel})hunun",root:"$1",compiledPattern:"^([a-z]+[aeiou])hunun$"},{pattern:"({letter}+)unun",root:"$1",compiledPattern:"^([a-z]+)unun$"}]},{form:"ka-an",label:"TODO",patterns:[{pattern:"ka({letter}+)ran",root:"$1d",compiledPattern:"^ka([a-z]+)ran$"},{pattern:"ka({letter}+{vowel})han",root:"$1",compiledPattern:"^ka([a-z]+[aeiou])han$"},{pattern:"ka({letter}+)an",root:"$1",compiledPattern:"^ka([a-z]+)an$"}]},{form:"ka-un",label:"TODO",patterns:[{pattern:"ka({letter}+)run",root:"$1d",compiledPattern:"^ka([a-z]+)run$"},{pattern:"ka({letter}+{vowel})hun",root:"$1",compiledPattern:"^ka([a-z]+[aeiou])hun$"},{pattern:"ka({letter}+)un",root:"$1",compiledPattern:"^ka([a-z]+)un$"}]},{form:"hi-an",label:"TODO",patterns:[{pattern:"hi({letter}+)ran",root:"$1d",compiledPattern:"^hi([a-z]+)ran$"},{pattern:"hi({letter}+{vowel})han",root:"$1",compiledPattern:"^hi([a-z]+[aeiou])han$"},{pattern:"hi({letter}+)an",root:"$1",compiledPattern:"^hi([a-z]+)an$"}]},{form:"hi-un",label:"TODO",patterns:[{pattern:"hi({letter}+)run",root:"$1d",compiledPattern:"^hi([a-z]+)run$"},{pattern:"hi({letter}+{vowel})hun",root:"$1",compiledPattern:"^hi([a-z]+[aeiou])hun$"},{pattern:"hi({letter}+)un",root:"$1",compiledPattern:"^hi([a-z]+)un$"}]},{form:"ma-un",label:"TODO",patterns:[{pattern:"ma({letter}+)run",root:"$1d",compiledPattern:"^ma([a-z]+)run$"},{pattern:"ma({letter}+{vowel})hun",root:"$1",compiledPattern:"^ma([a-z]+[aeiou])hun$"},{pattern:"ma({letter}+)un",root:"$1",compiledPattern:"^ma([a-z]+)un$"}]},{form:"mag-ay",label:"TODO",patterns:[{pattern:"mag({letter}+)ray",root:"$1d",compiledPattern:"^mag([a-z]+)ray$"},{pattern:"mag({letter}+{vowel})hay",root:"$1",compiledPattern:"^mag([a-z]+[aeiou])hay$"},{pattern:"mag({letter}+)ay",root:"$1",compiledPattern:"^mag([a-z]+)ay$"}]},{form:"pag-a",label:"TODO",patterns:[{pattern:"pag({letter}+)ra",root:"$1d",compiledPattern:"^pag([a-z]+)ra$"},{pattern:"pag({letter}+{vowel})ha",root:"$1",compiledPattern:"^pag([a-z]+[aeiou])ha$"},{pattern:"pag({letter}+)a",root:"$1",compiledPattern:"^pag([a-z]+)a$"}]},{form:"paga-an",label:"TODO",patterns:[{pattern:"paga({letter}+)ran",root:"$1d",compiledPattern:"^paga([a-z]+)ran$"},{pattern:"paga({letter}+{vowel})han",root:"$1",compiledPattern:"^paga([a-z]+[aeiou])han$"},{pattern:"paga({letter}+)an",root:"$1",compiledPattern:"^paga([a-z]+)an$"}]},{form:"paga-un",label:"TODO",patterns:[{pattern:"paga({letter}+)run",root:"$1d",compiledPattern:"^paga([a-z]+)run$"},{pattern:"paga({letter}+{vowel})hun",root:"$1",compiledPattern:"^paga([a-z]+[aeiou])hun$"},{pattern:"paga({letter}+)un",root:"$1",compiledPattern:"^paga([a-z]+)un$"}]}]}]}},function(a,u,i){a.exports=i(10)},function(a,u,i){"use strict";Object.defineProperty(u,"__esModule",{value:!0});var n=i(1);Object.keys(n).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return n[a]}})});var t=i(3);Object.keys(t).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return t[a]}})});var g=i(4);Object.keys(g).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return g[a]}})});var s=i(12);Object.keys(s).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return s[a]}})});var l=i(2);Object.keys(l).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return l[a]}})});var k=i(0);Object.keys(k).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return k[a]}})});var p=i(6);Object.keys(p).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return p[a]}})});var r=i(5);Object.keys(r).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return r[a]}})});var b=i(13);Object.keys(b).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return b[a]}})});var m=i(7);Object.keys(m).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return m[a]}})});var d=i(8);Object.keys(d).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return d[a]}})});var y=i(14);Object.keys(y).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return y[a]}})});var h=i(15);Object.keys(h).forEach(function(a){"default"!==a&&"__esModule"!==a&&Object.defineProperty(u,a,{enumerable:!0,get:function(){return h[a]}})})},function(a,u,i){"use strict";function n(a){return a.replace(/[^\u0000-\u007e]/g,function(a){return g[a]||a})}Object.defineProperty(u,"__esModule",{value:!0}),u.removeDiacritics=n;for(var t=[{base:" ",chars:" "},{base:"0",chars:"߀"},{base:"A",chars:"ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"},{base:"AA",chars:"Ꜳ"},{base:"AE",chars:"ÆǼǢ"},{base:"AO",chars:"Ꜵ"},{base:"AU",chars:"Ꜷ"},{base:"AV",chars:"ꜸꜺ"},{base:"AY",chars:"Ꜽ"},{base:"B",chars:"ⒷＢḂḄḆɃƁ"},{base:"C",chars:"ⒸＣꜾḈĆCĈĊČÇƇȻ"},{base:"D",chars:"ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"},{base:"Dh",chars:"Ð"},{base:"DZ",chars:"ǱǄ"},{base:"Dz",chars:"ǲǅ"},{base:"E",chars:"ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"},{base:"F",chars:"ꝼⒻＦḞƑꝻ"},{base:"G",chars:"ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"},{base:"H",chars:"ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"},{base:"I",chars:"ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"},{base:"J",chars:"ⒿＪĴɈȷ"},{base:"K",chars:"ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"},{base:"L",chars:"ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"},{base:"LJ",chars:"Ǉ"},{base:"Lj",chars:"ǈ"},{base:"M",chars:"ⓂＭḾṀṂⱮƜϻ"},{base:"N",chars:"ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"},{base:"NJ",chars:"Ǌ"},{base:"Nj",chars:"ǋ"},{base:"O",chars:"ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"},{base:"OE",chars:"Œ"},{base:"OI",chars:"Ƣ"},{base:"OO",chars:"Ꝏ"},{base:"OU",chars:"Ȣ"},{base:"P",chars:"ⓅＰṔṖƤⱣꝐꝒꝔ"},{base:"Q",chars:"ⓆＱꝖꝘɊ"},{base:"R",chars:"ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"},{base:"S",chars:"ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"},{base:"T",chars:"ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"},{base:"Th",chars:"Þ"},{base:"TZ",chars:"Ꜩ"},{base:"U",chars:"ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"},{base:"V",chars:"ⓋＶṼṾƲꝞɅ"},{base:"VY",chars:"Ꝡ"},{base:"W",chars:"ⓌＷẀẂŴẆẄẈⱲ"},{base:"X",chars:"ⓍＸẊẌ"},{base:"Y",chars:"ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"},{base:"Z",chars:"ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"},{base:"a",chars:"ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"},{base:"aa",chars:"ꜳ"},{base:"ae",chars:"æǽǣ"},{base:"ao",chars:"ꜵ"},{base:"au",chars:"ꜷ"},{base:"av",chars:"ꜹꜻ"},{base:"ay",chars:"ꜽ"},{base:"b",chars:"ⓑｂḃḅḇƀƃɓƂ"},{base:"compileAffix",chars:"ｃⓒćĉċčçḉƈȼꜿↄ"},{base:"d",chars:"ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"},{base:"dh",chars:"ð"},{base:"dz",chars:"ǳǆ"},{base:"e",chars:"ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"},{base:"f",chars:"ⓕｆḟƒ"},{base:"ff",chars:"ﬀ"},{base:"fi",chars:"ﬁ"},{base:"fl",chars:"ﬂ"},{base:"ffi",chars:"ﬃ"},{base:"ffl",chars:"ﬄ"},{base:"g",chars:"ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"},{base:"h",chars:"ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"},{base:"hv",chars:"ƕ"},{base:"i",chars:"ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"},{base:"j",chars:"ⓙｊĵǰɉ"},{base:"k",chars:"ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"},{base:"l",chars:"ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"},{base:"lj",chars:"ǉ"},{base:"m",chars:"ⓜｍḿṁṃɱɯ"},{base:"n",chars:"ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"},{base:"nj",chars:"ǌ"},{base:"o",chars:"ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"},{base:"oe",chars:"œ"},{base:"oi",chars:"ƣ"},{base:"oo",chars:"ꝏ"},{base:"ou",chars:"ȣ"},{base:"p",chars:"ⓟｐṕṗƥᵽꝑꝓꝕρ"},{base:"q",chars:"ⓠｑɋꝗꝙ"},{base:"r",chars:"ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"},{base:"s",chars:"ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"},{base:"ss",chars:"ß"},{base:"t",chars:"ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"},{base:"th",chars:"þ"},{base:"tz",chars:"ꜩ"},{base:"u",chars:"ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"},{base:"v",chars:"ⓥｖṽṿʋꝟʌ"},{base:"vy",chars:"ꝡ"},{base:"w",chars:"ⓦｗẁẃŵẇẅẘẉⱳ"},{base:"x",chars:"ⓧｘẋẍ"},{base:"y",chars:"ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"},{base:"z",chars:"ⓩｚźẑżžẓẕƶȥɀⱬꝣ"}],g={},s=0;s<t.length;s+=1)for(var l=t[s].chars,k=0;k<l.length;k+=1)g[l[k]]=t[s].base;u.replacementList=t,u.diacriticsMap=g},function(a,u,i){"use strict";Object.defineProperty(u,"__esModule",{value:!0});u.prefixes=["di","dili","ga","gai","gaipa","gaka","gapa","gapan","gapang","gi","gihi","gika","gikahi","gikapa","gina","ginapa","ginapaha","ginapaka","ginapag","ginapang","ginapanghi","gipa","gipaha","gipahi","gipaka","gipaki","gipakig","gipanag","gipanag","gipanig","gipatig","gipan","gipang","gipanghi","gim","gin","ging","ha","hi","hika","hima","hinga","hipang","hin","hing","hingka","i","iga","igaha","igaka","igapa","igapaha","igapahi","igapaka","igapasi","igapang","ihi","ika","ikahi","ikapa","ikapakama","ikapanig","ikapasig","ikapang","ikag","inig","inighi","inigka","inigpa","inigpang","inigpanghi","ipa","ipaha","ipahi","ipaka","ipaki","ipakig","ipanig","ipasig","ipatig","ipam","ipampa","ipang","ipanghi","isig","isigka","itag","ig","igka","igpa","igpang","ing","ka","kaha","kahi","kahing","kama","kapa","kapanig","kapasi","kapang","kataga","katagi","katigi","kina","ma","maga","magaka","magama","magapa","magapaha","magapahi","magapaka","magapaki","magapakig","magapan","magapang","maha","mahag","mahi","mai","maipa","maipang","maka","makahi","makapa","makapaha","makapahi","makapan","makapang","makapanghi","makag","maki","makipag","makig","makigpa","makigpang","manag","managka","managpa","managpaka","managpaki","managpan","managpang","manga","mangaha","manging","mangim","mangin","mani","manig","manim","mapa","mapahi","mapanag","mapasig","mapang","masig","masigka","matag","mag","maghi","magka","magkahi","magkina","magma","magpa","magpahi","magpahing","magpaka","magpaki","magpakig","magpasig","magpang","mam","man","mang","manggi","manghi","mi","mihi","mikapa","mipa","mipaha","mipahi","mipaka","mipatig","mipanghi","misag","ming","mingpa","mingpaha","mo","mohi","mopa","mopahi","mopasig","mopatig","na","naga","nagaha","nagahi","nagaka","nagakahi","nagama","nagapa","nagapaha","nagapahi","nagapaka","nagapaki","nagapakig","nagapan","nagapang","nagapanghi","naha","nahapa","nahag","nahi","nahipa","nai","naipa","naipang","naka","nakahi","nakapa","nakapaha","nakapahi","nakapahi","nakapakig","nakapasig","nakapan","nakapang","nakapanghi","nakag","naki","nakipag","nakig","nakighi","nakigpa","nakigpang","nanag","nanagka","nanagpa","nanagpahi","nanagpaka","nanagpaki","nanagpakig","nanagpan","nanagpang","nanagpangha","nanagpanghi","nanang","nanga","nangaha","nangaka","nangag","nangin","nani","nanig","nanim","naning","napa","napahi","napasig","napang","nasig","nag","naghi","naghing","nagisig","nagka","nagkahi","nagkina","nagma","nagni","nagpa","nagpaha","nagpahi","nagpahing","nagpaka","nagpaki","nagpakig","nagpanga","nagpaning","nagpasig","nagpatig","nagpan","nagpang","nagtika","nagtig","nan","nang","nanggi","nanghi","nanghing","ni","nikapa","nipa","nipaka","nipatig","nipanghi","ning","ningpa","pa","paga","pagahi","pagaka","pagapa","pagapaka","pagapang","paha","pahi","pahig","paka","paki","pakig","pakigpa","pala","panag","panagka","panga","pangang","pangin","pani","panig","panim","papang","para","parag","pasi","pasig","pasing","pati","patig","pag","paghi","paghig","pag","i","pag","ipa","pagka","pagkadi","pagkadili","pagkaha","pagkahi","pagkama","pagkawalay","pagkaway","pagkig","pagma","pagna","pagni","pagpa","pagpaha","pagpahi","pagpaka","pagpaki","pagpakig","pagpanag","pagpanga","pagpangin","pagpanim","pagpasi","pagpasig","pagpasing","pagpan","pagpang","pagpanghi","pam","pampa","pan","pang","panggi","panghi","pangpa","pangpaka","pangpang","pina","pinaka","sika","taga","tagi","tali","tag","tagma","tagmang","tagpa","tinag","tig","tigpa","tigpaha","tigpahi","tigpaka","tigpaki","tigpang","tigpanghi","ting","tingpa","tingpanga","tingpang","wa","wala","walay","way"],u.infixes=["in","um","al","il","ul"],u.suffixes=["a","ado","an","anan","anang","anay","ang","anon","anong","ay","ayg","ayng","do","dor","g","ha","hag","han","hana","hanan","hanay","hang","hanon","hanong","hay","hi","hig","hing","hon","hona","hong","honon","i","ig","ing","ira","irang","iro","irong","n","ng","nhan","nhon","nhong","nhonon","non","nong","on","onan","ong","onon","onong","y","yng"]},function(a,u,i){"use strict";function n(a){var u=[],i=!0,n=!1,t=void 0;try{for(var g,s=a.affixes[Symbol.iterator]();!(i=(g=s.next()).done);i=!0){var l=g.value;u.push(l.form+" + ")}}catch(a){n=!0,t=a}finally{try{!i&&s.return&&s.return()}finally{if(n)throw t}}return u.push(a.root),u.join("")}Object.defineProperty(u,"__esModule",{value:!0}),u.toStringDervation=n},function(a,u,i){"use strict";Object.defineProperty(u,"__esModule",{value:!0});u.stopwords=new Set(["ako","kita","amua","ato","ikaw","imong","imo","iyang","kaugalingon","siya","iya","kaniya","kini","mismo","sila","ila","ilang","unsa","nga","kinsa","kini","kana","mga","mahimong","nahimo","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","lamang","pareho","busa","kay","pud","kaayo"])},function(a,u,i){"use strict";function n(a){return(0,t.findDerivations)(g.DictionaryDatabase,s.cebuanoStemmer,(0,l.normalize)(a))}Object.defineProperty(u,"__esModule",{value:!0}),u.normalizeAndStem=n;var t=i(7),g=i(1),s=i(8),l=i(3)}])});
//# sourceMappingURL=cebuano-stemmer.min.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var emptyObject = __webpack_require__(24);
var _invariant = __webpack_require__(0);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(108);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(118);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(0);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(5);

var createArrayFromMixed = __webpack_require__(111);
var getMarkupWrap = __webpack_require__(113);
var invariant = __webpack_require__(0);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(5);

var invariant = __webpack_require__(0);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(115);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(117);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(126);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(127);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(56);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(123);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(94)(module)))

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(0);
var ReactPropTypesSecret = __webpack_require__(60);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var ReactPropTypesSecret = __webpack_require__(60);
var checkPropTypes = __webpack_require__(131);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(4);

var focusNode = __webpack_require__(54);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(20);
var ExecutionEnvironment = __webpack_require__(5);
var FallbackCompositionState = __webpack_require__(142);
var SyntheticCompositionEvent = __webpack_require__(179);
var SyntheticInputEvent = __webpack_require__(182);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(61);
var ExecutionEnvironment = __webpack_require__(5);
var ReactInstrumentation = __webpack_require__(7);

var camelizeStyleName = __webpack_require__(109);
var dangerousStyleValue = __webpack_require__(188);
var hyphenateStyleName = __webpack_require__(116);
var memoizeStringOnly = __webpack_require__(119);
var warning = __webpack_require__(1);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(19);
var EventPropagators = __webpack_require__(20);
var ExecutionEnvironment = __webpack_require__(5);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);
var SyntheticEvent = __webpack_require__(10);

var inputValueTracking = __webpack_require__(77);
var getEventTarget = __webpack_require__(47);
var isEventSupported = __webpack_require__(48);
var isTextInputElement = __webpack_require__(79);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(13);
var ExecutionEnvironment = __webpack_require__(5);

var createNodesFromMarkup = __webpack_require__(112);
var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(0);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(20);
var ReactDOMComponentTree = __webpack_require__(4);
var SyntheticMouseEvent = __webpack_require__(26);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(12);

var getTextContentAccessor = __webpack_require__(76);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(14);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(15);

var instantiateReactComponent = __webpack_require__(78);
var KeyEscapeUtils = __webpack_require__(39);
var shouldUpdateReactComponent = __webpack_require__(49);
var traverseAllChildren = __webpack_require__(81);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(87);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(35);
var ReactDOMIDOperations = __webpack_require__(152);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var React = __webpack_require__(16);
var ReactComponentEnvironment = __webpack_require__(41);
var ReactCurrentOwner = __webpack_require__(11);
var ReactErrorUtils = __webpack_require__(42);
var ReactInstanceMap = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(7);
var ReactNodeTypes = __webpack_require__(71);
var ReactReconciler = __webpack_require__(15);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(24);
var invariant = __webpack_require__(0);
var shallowEqual = __webpack_require__(33);
var shouldUpdateReactComponent = __webpack_require__(49);
var warning = __webpack_require__(1);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(4);
var ReactDefaultInjection = __webpack_require__(160);
var ReactMount = __webpack_require__(70);
var ReactReconciler = __webpack_require__(15);
var ReactUpdates = __webpack_require__(9);
var ReactVersion = __webpack_require__(173);

var findDOMNode = __webpack_require__(189);
var getHostComponentFromComposite = __webpack_require__(75);
var renderSubtreeIntoContainer = __webpack_require__(196);
var warning = __webpack_require__(1);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var AutoFocusUtils = __webpack_require__(135);
var CSSPropertyOperations = __webpack_require__(137);
var DOMLazyTree = __webpack_require__(13);
var DOMNamespaces = __webpack_require__(36);
var DOMProperty = __webpack_require__(14);
var DOMPropertyOperations = __webpack_require__(63);
var EventPluginHub = __webpack_require__(19);
var EventPluginRegistry = __webpack_require__(37);
var ReactBrowserEventEmitter = __webpack_require__(25);
var ReactDOMComponentFlags = __webpack_require__(64);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMInput = __webpack_require__(153);
var ReactDOMOption = __webpack_require__(154);
var ReactDOMSelect = __webpack_require__(65);
var ReactDOMTextarea = __webpack_require__(157);
var ReactInstrumentation = __webpack_require__(7);
var ReactMultiChild = __webpack_require__(166);
var ReactServerRenderingTransaction = __webpack_require__(171);

var emptyFunction = __webpack_require__(6);
var escapeTextContentForBrowser = __webpack_require__(28);
var invariant = __webpack_require__(0);
var isEventSupported = __webpack_require__(48);
var shallowEqual = __webpack_require__(33);
var inputValueTracking = __webpack_require__(77);
var validateDOMNesting = __webpack_require__(50);
var warning = __webpack_require__(1);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(50);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var DOMLazyTree = __webpack_require__(13);
var ReactDOMComponentTree = __webpack_require__(4);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(35);
var ReactDOMComponentTree = __webpack_require__(4);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var DOMPropertyOperations = __webpack_require__(63);
var LinkedValueUtils = __webpack_require__(40);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var React = __webpack_require__(16);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMSelect = __webpack_require__(65);

var warning = __webpack_require__(1);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

var getNodeForCharacterOffset = __webpack_require__(193);
var getTextContentAccessor = __webpack_require__(76);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var DOMChildrenOperations = __webpack_require__(35);
var DOMLazyTree = __webpack_require__(13);
var ReactDOMComponentTree = __webpack_require__(4);

var escapeTextContentForBrowser = __webpack_require__(28);
var invariant = __webpack_require__(0);
var validateDOMNesting = __webpack_require__(50);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(40);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactUpdates = __webpack_require__(9);
var Transaction = __webpack_require__(27);

var emptyFunction = __webpack_require__(6);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(134);
var BeforeInputEventPlugin = __webpack_require__(136);
var ChangeEventPlugin = __webpack_require__(138);
var DefaultEventPluginOrder = __webpack_require__(140);
var EnterLeaveEventPlugin = __webpack_require__(141);
var HTMLDOMPropertyConfig = __webpack_require__(143);
var ReactComponentBrowserEnvironment = __webpack_require__(145);
var ReactDOMComponent = __webpack_require__(148);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMEmptyComponent = __webpack_require__(150);
var ReactDOMTreeTraversal = __webpack_require__(158);
var ReactDOMTextComponent = __webpack_require__(156);
var ReactDefaultBatchingStrategy = __webpack_require__(159);
var ReactEventListener = __webpack_require__(163);
var ReactInjection = __webpack_require__(164);
var ReactReconcileTransaction = __webpack_require__(169);
var SVGDOMPropertyConfig = __webpack_require__(174);
var SelectEventPlugin = __webpack_require__(175);
var SimpleEventPlugin = __webpack_require__(176);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(19);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var EventListener = __webpack_require__(53);
var ExecutionEnvironment = __webpack_require__(5);
var PooledClass = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(9);

var getEventTarget = __webpack_require__(47);
var getUnboundedScrollPosition = __webpack_require__(114);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(14);
var EventPluginHub = __webpack_require__(19);
var EventPluginUtils = __webpack_require__(38);
var ReactComponentEnvironment = __webpack_require__(41);
var ReactEmptyComponent = __webpack_require__(66);
var ReactBrowserEventEmitter = __webpack_require__(25);
var ReactHostComponent = __webpack_require__(68);
var ReactUpdates = __webpack_require__(9);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(187);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactComponentEnvironment = __webpack_require__(41);
var ReactInstanceMap = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(7);

var ReactCurrentOwner = __webpack_require__(11);
var ReactReconciler = __webpack_require__(15);
var ReactChildReconciler = __webpack_require__(144);

var emptyFunction = __webpack_require__(6);
var flattenChildren = __webpack_require__(190);
var invariant = __webpack_require__(0);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(62);
var PooledClass = __webpack_require__(12);
var ReactBrowserEventEmitter = __webpack_require__(25);
var ReactInputSelection = __webpack_require__(69);
var ReactInstrumentation = __webpack_require__(7);
var Transaction = __webpack_require__(27);
var ReactUpdateQueue = __webpack_require__(43);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(167);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(12);
var Transaction = __webpack_require__(27);
var ReactInstrumentation = __webpack_require__(7);
var ReactServerUpdateQueue = __webpack_require__(172);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(43);

var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(20);
var ExecutionEnvironment = __webpack_require__(5);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInputSelection = __webpack_require__(69);
var SyntheticEvent = __webpack_require__(10);

var getActiveElement = __webpack_require__(55);
var isTextInputElement = __webpack_require__(79);
var shallowEqual = __webpack_require__(33);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var EventListener = __webpack_require__(53);
var EventPropagators = __webpack_require__(20);
var ReactDOMComponentTree = __webpack_require__(4);
var SyntheticAnimationEvent = __webpack_require__(177);
var SyntheticClipboardEvent = __webpack_require__(178);
var SyntheticEvent = __webpack_require__(10);
var SyntheticFocusEvent = __webpack_require__(181);
var SyntheticKeyboardEvent = __webpack_require__(183);
var SyntheticMouseEvent = __webpack_require__(26);
var SyntheticDragEvent = __webpack_require__(180);
var SyntheticTouchEvent = __webpack_require__(184);
var SyntheticTransitionEvent = __webpack_require__(185);
var SyntheticUIEvent = __webpack_require__(22);
var SyntheticWheelEvent = __webpack_require__(186);

var emptyFunction = __webpack_require__(6);
var getEventCharCode = __webpack_require__(45);
var invariant = __webpack_require__(0);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(26);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(22);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(22);

var getEventCharCode = __webpack_require__(45);
var getEventKey = __webpack_require__(191);
var getEventModifierState = __webpack_require__(46);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(22);

var getEventModifierState = __webpack_require__(46);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(10);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(26);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(61);
var warning = __webpack_require__(1);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(11);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstanceMap = __webpack_require__(21);

var getHostComponentFromComposite = __webpack_require__(75);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(39);
var traverseAllChildren = __webpack_require__(81);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(87);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(45);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(5);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(28);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(70);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(51);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(202);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(83);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(83);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(85);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(203);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(51);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(23);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(207);
var ReactElement = __webpack_require__(17);

var emptyFunction = __webpack_require__(6);
var traverseAllChildren = __webpack_require__(217);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(17);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(17),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(58);

module.exports = factory(isValidElement);

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(86),
    Component = _require.Component;

var _require2 = __webpack_require__(17),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(89);
var factory = __webpack_require__(107);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(23);

var ReactElement = __webpack_require__(17);

var invariant = __webpack_require__(0);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(23);

var ReactCurrentOwner = __webpack_require__(11);
var REACT_ELEMENT_TYPE = __webpack_require__(88);

var getIteratorFn = __webpack_require__(213);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(206);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(91);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(93);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(222);


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(223);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(94)(module)))

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// js/app.js